"use client";
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/Typography/typographyStyles.module.css
var typographyStyles_default = {
  contrast: "typographyStyles_contrast",
  a: "typographyStyles_a",
  "a--margins": "typographyStyles_a--margins",
  "a--external": "typographyStyles_a--external",
  "a--visited": "typographyStyles_a--visited",
  "body-xsmall": "typographyStyles_body-xsmall",
  "body-xsmall--margins": "typographyStyles_body-xsmall--margins",
  "body-small": "typographyStyles_body-small",
  "body-small--margins": "typographyStyles_body-small--margins",
  "body-medium": "typographyStyles_body-medium",
  "body-medium--margins": "typographyStyles_body-medium--margins",
  "body-large": "typographyStyles_body-large",
  "body-large--margins": "typographyStyles_body-large--margins",
  "lead-medium": "typographyStyles_lead-medium",
  "lead-medium--margins": "typographyStyles_lead-medium--margins",
  "heading-xxsmall": "typographyStyles_heading-xxsmall",
  "heading-xxsmall--margins": "typographyStyles_heading-xxsmall--margins",
  "heading-xsmall": "typographyStyles_heading-xsmall",
  "heading-xsmall--margins": "typographyStyles_heading-xsmall--margins",
  "heading-small": "typographyStyles_heading-small",
  "heading-small--margins": "typographyStyles_heading-small--margins",
  "heading-medium": "typographyStyles_heading-medium",
  "heading-medium--margins": "typographyStyles_heading-medium--margins",
  "heading-large": "typographyStyles_heading-large",
  "heading-large--margins": "typographyStyles_heading-large--margins",
  "heading-xlarge": "typographyStyles_heading-xlarge",
  "heading-xlarge--margins": "typographyStyles_heading-xlarge--margins",
  "heading-xxlarge": "typographyStyles_heading-xxlarge",
  "heading-xxlarge--margins": "typographyStyles_heading-xxlarge--margins",
  "label-medium": "typographyStyles_label-medium",
  "label-medium--margins": "typographyStyles_label-medium--margins",
  legend: "typographyStyles_legend",
  "caption--withMargins": "typographyStyles_caption--withMargins",
  bold: "typographyStyles_bold",
  italic: "typographyStyles_italic",
  underline: "typographyStyles_underline",
  "text-color--default": "typographyStyles_text-color--default",
  "text-color--medium": "typographyStyles_text-color--medium",
  "text-color--subtle": "typographyStyles_text-color--subtle",
  "text-color--on-inverse": "typographyStyles_text-color--on-inverse"
};

// src/components/helpers/styling/utilStyles.module.css
var scrollbar = "utilStyles_scrollbar";
var invisible = "utilStyles_invisible";
var utilStyles_default = {
  "remove-list-styling": "utilStyles_remove-list-styling",
  "remove-button-styling": "utilStyles_remove-button-styling",
  "normalize-button": "utilStyles_normalize-button",
  "hide-input": "utilStyles_hide-input",
  "inherit-link-styling": "utilStyles_inherit-link-styling",
  scrollbar,
  "scrollable-y": "utilStyles_scrollable-y",
  "visibility-transition": "utilStyles_visibility-transition",
  "visibility-transition--open": "utilStyles_visibility-transition--open",
  "visibility-transition--closed": "utilStyles_visibility-transition--closed",
  "visually-hidden": "utilStyles_visually-hidden",
  invisible,
  "center-absolute": "utilStyles_center-absolute",
  "center-absolute-y": "utilStyles_center-absolute-y",
  "center-absolute-x": "utilStyles_center-absolute-x"
};

// src/components/helpers/Backdrop/Backdrop.utils.tsx
var isVerticalScrollbarDisplayed = (container2) => container2.clientHeight > window.innerHeight;
function handleElementWithBackdropMount(container2) {
  if (isVerticalScrollbarDisplayed(container2)) {
    const scrollY = Math.round(window.scrollY);
    container2.style.overflowY = "scroll";
    container2.style.position = "fixed";
    container2.style.top = `-${scrollY}px`;
  }
}
function handleElementWithBackdropUnmount(container2) {
  const scrollY = parseInt(document.body.style.top);
  container2.style.removeProperty("overflow-y");
  container2.style.removeProperty("position");
  container2.style.removeProperty("top");
  if (isNaN(scrollY)) {
    return;
  }
  window.scrollTo(0, scrollY * -1);
}

// src/components/helpers/Backdrop/Backdrop.module.css
var Backdrop_default = {
  backdrop: "Backdrop_backdrop",
  drawer: "Backdrop_drawer",
  modal: "Backdrop_modal",
  "backdrop--visible": "Backdrop_backdrop--visible",
  "backdrop--hidden": "Backdrop_backdrop--hidden"
};

// src/utils/color.tsx
var textColors = {
  textOnAction: "var(--dds-color-text-on-action)",
  textOnInverse: "var(--dds-color-text-on-inverse)",
  textOnStatusDefault: "var(--dds-color-text-on-status-default)",
  textOnStatusStrong: "var(--dds-color-text-on-status-strong)",
  textActionResting: "var(--dds-color-text-action-resting)",
  textActionHover: "var(--dds-color-text-action-hover)",
  textActionVisited: "var(--dds-color-text-action-visited)",
  textDefault: "var(--dds-color-text-default)",
  textRequiredfield: "var(--dds-color-text-requiredfield)",
  textSubtle: "var(--dds-color-text-subtle)",
  textMedium: "var(--dds-color-text-medium)",
  textOnNotification: "var(--dds-color-text-on-notification)",
  iconOnAction: "var(--dds-color-icon-on-action)",
  iconOnInfoDefault: "var(--dds-color-icon-on-info-default)",
  iconOnSuccessDefault: "var(--dds-color-icon-on-success-default)",
  iconOnDangerDefault: "var(--dds-color-icon-on-danger-default)",
  iconOnWarningDefault: "var(--dds-color-icon-on-warning-default)",
  iconOnInfoStrong: "var(--dds-color-icon-on-info-strong)",
  iconOnSuccessStrong: "var(--dds-color-icon-on-success-strong)",
  iconOnDangerStrong: "var(--dds-color-icon-on-danger-strong)",
  iconOnWarningStrong: "var(--dds-color-icon-on-warning-strong)",
  iconOnInverse: "var(--dds-color-icon-on-inverse)",
  iconActionResting: "var(--dds-color-icon-action-resting)",
  iconActionHover: "var(--dds-color-icon-action-hover)",
  iconDefault: "var(--dds-color-icon-default)",
  iconSubtle: "var(--dds-color-icon-subtle)",
  iconMedium: "var(--dds-color-icon-medium)"
};
var textColorsArray = [
  "textOnAction",
  "textOnInverse",
  "textOnStatusDefault",
  "textOnStatusStrong",
  "textActionResting",
  "textActionHover",
  "textActionVisited",
  "textDefault",
  "textRequiredfield",
  "textSubtle",
  "textMedium",
  "textOnNotification",
  "iconOnAction",
  "iconOnInfoDefault",
  "iconOnSuccessDefault",
  "iconOnDangerDefault",
  "iconOnWarningDefault",
  "iconOnInfoStrong",
  "iconOnSuccessStrong",
  "iconOnDangerStrong",
  "iconOnWarningStrong",
  "iconOnInverse",
  "iconActionResting",
  "iconActionHover",
  "iconDefault",
  "iconSubtle",
  "iconMedium"
];
function isTextColor(color) {
  return textColorsArray.indexOf(color) !== -1;
}
var getTextColor = (color) => {
  if (isTextColor(color)) return textColors[color];
  return color;
};

// src/utils/combineHandlers.tsx
var combineHandlers = (handler1, handler2) => {
  const callback = (event) => {
    handler1 && handler1(event);
    handler2 && handler2(event);
  };
  return callback;
};

// src/utils/dom.ts
function cn(...classNames) {
  return classNames.filter(Boolean).join(" ");
}
function convertCamelToHyphen(value) {
  return value.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([a-z])([0-9])/g, "$1-$2").toLowerCase();
}

// src/utils/getFocusableElements.ts
function getFocusableElements(elementRef) {
  return elementRef && elementRef.current ? elementRef.current.querySelectorAll(
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
  ) : [];
}

// src/utils/icon.ts
var getFormInputIconSize = (componentSize) => {
  switch (componentSize) {
    case "medium":
      return "medium";
    case "small":
      return "medium";
    case "xsmall":
      return "small";
  }
};

// src/utils/idGenerator.tsx
var derivativeIdGenerator = (prefix2, suffix) => `${prefix2}-${suffix}`;
var spaceSeparatedIdListGenerator = (values) => {
  const filtered = values.filter(Boolean);
  return filtered.length > 0 ? filtered.join(" ") : void 0;
};

// src/utils/object.tsx
var isEmpty = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

// src/utils/readonlyEventHandlers.tsx
var readOnlyMouseDownHandler = (readOnly, onMouseDown) => {
  return (evt) => {
    if (readOnly) {
      evt.preventDefault();
      evt.target.focus();
    } else onMouseDown && onMouseDown(evt);
  };
};
var readOnlyKeyDownHandler = (type, readOnly, onKeyDown) => {
  return (evt) => {
    if (readOnly) {
      if (type === "select" && ["ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft", " "].includes(
        evt.key
      )) {
        evt.preventDefault();
      } else if (type === "selectionControl" && evt.key === " ") {
        evt.preventDefault();
      }
    } else onKeyDown && onKeyDown(evt);
  };
};
var readOnlyChangeHandler = (readOnly, onChange) => {
  return (evt) => {
    if (readOnly) {
      return;
    }
    onChange && onChange(evt);
  };
};
var readOnlyClickHandler = (readOnly, onClick) => {
  return (evt) => {
    if (readOnly) {
      evt.preventDefault();
      return;
    }
    onClick && onClick(evt);
  };
};

// src/utils/searchFilter.tsx
function escapeRegexCharacters(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
function searchFilter(text, query) {
  const searchFilterRegex = new RegExp(
    `(?:^|[\\s-(])${escapeRegexCharacters(query.toLowerCase())}`
  );
  return searchFilterRegex.test(text.toLowerCase());
}

// src/utils/RequiredMarker/RequiredMarker.module.css
var RequiredMarker_default = {
  wrapper: "RequiredMarker_wrapper"
};

// src/utils/RequiredMarker/RequiredMarker.tsx
import { jsx } from "react/jsx-runtime";
var RequiredMarker = () => /* @__PURE__ */ jsx("span", { className: RequiredMarker_default.wrapper, children: "*" });

// src/utils/useElementHeight.ts
import { useEffect, useState } from "react";
function useElementHeight(element) {
  const [height, setHeight] = useState(null);
  useEffect(() => {
    if (!element) return;
    const resizeObserver = new ResizeObserver(() => {
      setHeight(element.offsetHeight);
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [element]);
  return height;
}

// src/components/helpers/Backdrop/Backdrop.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Backdrop = ({ isMounted, zIndex, ...props }) => {
  const isMountedCn = isMounted ? "visible" : "hidden";
  return /* @__PURE__ */ jsx2(
    "div",
    {
      className: cn(
        Backdrop_default.backdrop,
        Backdrop_default[zIndex],
        Backdrop_default[`backdrop--${isMountedCn}`]
      ),
      ...props
    }
  );
};
Backdrop.displayName = "Backdrop";

// src/components/helpers/Chevron/Chevron.module.css
var Chevron_default = {
  svg: "Chevron_svg",
  group: "Chevron_group",
  "group--up": "Chevron_group--up",
  "group--down": "Chevron_group--down",
  left: "Chevron_left",
  "left--up": "Chevron_left--up",
  "left--down": "Chevron_left--down",
  right: "Chevron_right",
  "right--up": "Chevron_right--up",
  "right--down": "Chevron_right--down"
};

// src/components/helpers/Chevron/AnimatedChevronUpDown.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var svgChevronLeftPath = "M 1 0 L 5 4 C 5 4 5 4 5 4 L 4 5 C 4 5 4 5 4 5 C 4 5 4 5 4 5 L 0 1 C 0 1 0 1 0 1 L 1 0 C 1 0 1 0 1 0 C 1 0 1 0 1 0 L 1 0 Z";
var svgChevronRightPath = "M 3 4 L 7 0 L 8 1 C 8 1 8 1 8 1 L 4 5 L 3 4 C 3 4 3 4 3 4 L 3 4 Z";
var AnimatedChevronUpDown = ({
  isUp,
  height = "5px",
  width = "8px"
}) => {
  const stateCn = isUp ? "up" : "down";
  return /* @__PURE__ */ jsx3(
    "svg",
    {
      viewBox: "0 0 8 5",
      fill: "currentColor",
      className: cn(Chevron_default.svg),
      style: { height, width },
      children: /* @__PURE__ */ jsxs("g", { className: cn(Chevron_default.group, Chevron_default[`group--${stateCn}`]), children: [
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: svgChevronLeftPath,
            className: cn(Chevron_default.left, Chevron_default[`left--${stateCn}`])
          }
        ),
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: svgChevronRightPath,
            className: cn(Chevron_default.right, Chevron_default[`right--${stateCn}`])
          }
        )
      ] })
    }
  );
};

// src/components/helpers/ElementAs/ElementAs.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var ElementAs = ({
  as = "div",
  ref,
  children,
  ...props
}) => {
  const Component = as;
  return /* @__PURE__ */ jsx4(Component, { ref, ...props, children });
};

// src/components/helpers/HiddenInput/HiddenInput.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var HiddenInput = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx5("input", { className: cn(className, utilStyles_default["hide-input"]), ...rest });

// src/components/helpers/Input/Input.module.css
var Input_default = {
  container: "Input_container",
  "input-group": "Input_input-group",
  input: "Input_input",
  disabled: "Input_disabled",
  "read-only": "Input_read-only",
  "input--stateful": "Input_input--stateful",
  "input--hover": "Input_input--hover",
  "input--stateful-danger": "Input_input--stateful-danger",
  "input--medium": "Input_input--medium",
  "input--small": "Input_input--small",
  "input--xsmall": "Input_input--xsmall",
  "input--with-affix": "Input_input--with-affix",
  label: "Input_label",
  "char-counter": "Input_char-counter",
  "input-group__absolute-element": "Input_input-group__absolute-element"
};

// src/components/helpers/styling/focus.module.css
var focusable = "focus_focusable";
var focus_default = {
  focused: "focus_focused",
  focusable,
  "focusable-within": "focus_focusable-within",
  "has-focusable-input": "focus_has-focusable-input",
  "focusable-sibling": "focus_focusable-sibling",
  "focus-styled-sibling": "focus_focus-styled-sibling",
  "focusable--inset": "focus_focusable--inset"
};

// src/components/helpers/Input/Input.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var Input = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx6("input", { className: cn(className, Input_default.input, focusable), ...rest });
Input.displayName = "Input";
var StatefulInput = ({
  className,
  componentSize = "medium",
  hasErrorMessage,
  ...rest
}) => /* @__PURE__ */ jsx6(
  Input,
  {
    className: cn(
      className,
      Input_default["input--stateful"],
      Input_default[`input--${componentSize}`],
      typographyStyles_default[`body-${componentSize}`],
      hasErrorMessage && Input_default["input--stateful-danger"]
    ),
    ...rest
  }
);
StatefulInput.displayName = "StatefulInput";

// src/components/helpers/Input/CharCounter.tsx
import { useId } from "react";

// src/types/BaseComponentProps.ts
var getBaseHTMLProps = (id, htmlPropsOrClassName, htmlPropsOrUnknownProps, unknownPropsOrUndefined) => {
  if (typeof htmlPropsOrClassName === "string" || unknownPropsOrUndefined != void 0) {
    const {
      id: idFromHtmlProps,
      className: classNameFromHtmlProps,
      ...restHTMLProps
    } = htmlPropsOrUnknownProps != null ? htmlPropsOrUnknownProps : {};
    const propId = id != null ? id : idFromHtmlProps;
    const propClassName = cn(
      htmlPropsOrClassName,
      classNameFromHtmlProps
    );
    return {
      ...unknownPropsOrUndefined,
      ...restHTMLProps,
      ...propClassName && { className: propClassName },
      ...propId && { id: propId }
    };
  } else {
    const {
      id: htmlPropsId,
      className: htmlPropsClassName,
      ...restHTMLProps
    } = htmlPropsOrClassName != null ? htmlPropsOrClassName : {};
    const propId = id != null ? id : htmlPropsId;
    return {
      ...htmlPropsOrUnknownProps,
      ...restHTMLProps,
      ...htmlPropsClassName && { className: htmlPropsClassName },
      ...propId && { id: propId }
    };
  }
};

// src/types/Surface.tsx
var BORDER_RADII = [
  "button",
  "input",
  "surface",
  "chip",
  "rounded",
  "0"
];
var ELEVATIONS = [1, 2, 3, 4];
var BORDER_COLORS = [
  "border-default",
  "border-subtle",
  "border-inverse",
  "border-action-default",
  "border-action-hover",
  "border-success",
  "border-warning",
  "border-danger",
  "border-info",
  "border-on-action"
];
var BACKGROUNDS = [
  "surface-subtle",
  "surface-medium",
  "surface-inverse-default",
  "surface-danger-default",
  "surface-danger-strong",
  "surface-success-default",
  "surface-success-strong",
  "surface-warning-default",
  "surface-warning-strong",
  "surface-info-default",
  "surface-info-strong",
  "surface-paper-default",
  "surface-notification",
  "brand-primary-default",
  "brand-primary-subtle",
  "brand-primary-medium",
  "brand-primary-strong",
  "brand-secondary-default",
  "brand-secondary-subtle",
  "brand-secondary-medium",
  "brand-secondary-strong",
  "brand-tertiary-default",
  "brand-tertiary-subtle",
  "brand-tertiary-medium",
  "brand-tertiary-strong"
];
var isPaperBackground = (value) => {
  return typeof value === "string" && BACKGROUNDS.includes(value);
};
var isBorderColor = (value) => {
  return typeof value === "string" && BORDER_COLORS.includes(value);
};
var isBorderRadius = (value) => {
  return typeof value === "string" && BORDER_RADII.includes(value);
};
var isElevation = (value) => {
  return typeof value === "number" && ELEVATIONS.includes(value);
};

// src/components/Typography/Typography/TextOverflowEllipsis/TextOverflowEllipsis.module.css
var TextOverflowEllipsis_default = {
  wrapper: "TextOverflowEllipsis_wrapper",
  inner: "TextOverflowEllipsis_inner"
};

// src/components/Typography/Typography/TextOverflowEllipsis/TextOverflowEllipsis.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
function TextOverflowEllipsisWrapper({
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx7("span", { ...rest, className: cn(className, TextOverflowEllipsis_default.wrapper) });
}
function TextOverflowEllipsisInner({
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx7("span", { ...rest, className: cn(className, TextOverflowEllipsis_default.inner) });
}

// src/components/Typography/Typography/Typography.module.css
var Typography_default = {
  container: "Typography_container"
};

// src/components/Typography/Typography/Typography.utils.ts
var defaultTypographyType = "bodyMedium";
var defaultTypographyTypeClassName = "body-medium";
var getElementType = (element) => {
  switch (element) {
    case "a":
      return "a";
    case "headingXxsmall":
      return "h6";
    case "headingXsmall":
      return "h5";
    case "headingSmall":
      return "h4";
    case "headingMedium":
      return "h3";
    case "headingLarge":
      return "h2";
    case "headingXlarge":
    case "headingXxlarge":
      return "h1";
    case "labelMedium":
      return "label";
    case "bodyXsmall":
    case "bodySmall":
    case "bodyMedium":
    case "bodyLarge":
    case "leadMedium":
    default:
      return "p";
  }
};
var isHeading = (type) => {
  return true;
};
var isLegend = (as) => {
  return as === "legend";
};
var isCaption = (as) => {
  return as === "caption";
};
var inlineElements = [
  "a",
  "abbr",
  "audio",
  "b",
  "bdi",
  "bdo",
  "big",
  "br",
  "button",
  "canvas",
  "cite",
  "code",
  "data",
  "datalist",
  "del",
  "dfn",
  "em",
  "embed",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "map",
  "mark",
  "meter",
  "noscript",
  "object",
  "output",
  "picture",
  "progress",
  "q",
  "ruby",
  "s",
  "samp",
  "script",
  "select",
  "slot",
  "small",
  "span",
  "strong",
  "sub",
  "sup",
  "svg",
  "template",
  "textarea",
  "time",
  "u",
  "var",
  "video",
  "wbr"
];
var isInlineElement = (as) => inlineElements.indexOf(as) !== -1;
function getTypographyCn(value) {
  return convertCamelToHyphen(value);
}

// src/components/Icon/Icon.tsx
var getSize = (iconSize) => {
  switch (iconSize) {
    case "small":
      return "var(--dds-icon-size-small)";
    case "medium":
      return "var(--dds-icon-size-medium)";
    case "large":
      return "var(--dds-icon-size-large)";
    case "inherit":
      return "1em";
    default:
      return "var(--dds-icon-size-medium)";
  }
};
function Icon(props) {
  const {
    id,
    iconSize = "medium",
    color = "currentcolor",
    icon,
    className,
    htmlProps = {},
    ...rest
  } = props;
  const { title, "aria-hidden": ariaHidden = true } = htmlProps;
  const size2 = getSize(iconSize);
  return icon({
    ...getBaseHTMLProps(id, className, htmlProps, rest),
    title,
    height: size2,
    width: size2,
    fill: color,
    "aria-hidden": ariaHidden
  });
}
Icon.displayName = "Icon";

// src/components/Icon/Icon.module.css
var Icon_default = {
  svg: "Icon_svg"
};

// src/components/Icon/utils/SvgWrapper.tsx
import { jsx as jsx8, jsxs as jsxs2 } from "react/jsx-runtime";
var size = 24;
var sizeCSS = "var(--dds-icon-size-medium)";
function SvgWrapper({
  height,
  width,
  fill = "currentColor",
  className,
  title,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs2(
    "svg",
    {
      ...props,
      fill: getTextColor(fill),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: `0 0 ${size} ${size}`,
      className: cn(className, Icon_default.svg),
      style: {
        height: height ? height : sizeCSS,
        width: width ? width : sizeCSS
      },
      children: [
        title && /* @__PURE__ */ jsx8("title", { children: title }),
        children
      ]
    }
  );
}

// src/components/Icon/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  AddressShieldedIcon: () => AddressShieldedIcon,
  AgreementIcon: () => AgreementIcon,
  AppsIcon: () => AppsIcon,
  ArchiveIcon: () => ArchiveIcon,
  ArrowDownIcon: () => ArrowDownIcon,
  ArrowLeftIcon: () => ArrowLeftIcon,
  ArrowRightIcon: () => ArrowRightIcon,
  ArrowUpIcon: () => ArrowUpIcon,
  AttachmentIcon: () => AttachmentIcon,
  BarChartBoxedIcon: () => BarChartBoxedIcon,
  BarChartIcon: () => BarChartIcon,
  BlockIcon: () => BlockIcon,
  BookIcon: () => BookIcon,
  BuildCircledIcon: () => BuildCircledIcon,
  BuildIcon: () => BuildIcon,
  CalendarIcon: () => CalendarIcon,
  CalendarMonthIcon: () => CalendarMonthIcon,
  CalendarViewDayIcon: () => CalendarViewDayIcon,
  CalendarViewMonthIcon: () => CalendarViewMonthIcon,
  CalendarViewWeekIcon: () => CalendarViewWeekIcon,
  CallIcon: () => CallIcon,
  CaringIcon: () => CaringIcon,
  ChatIcon: () => ChatIcon,
  CheckCircledIcon: () => CheckCircledIcon,
  CheckIcon: () => CheckIcon,
  ChecklistIcon: () => ChecklistIcon,
  ChevronDownIcon: () => ChevronDownIcon,
  ChevronFirstIcon: () => ChevronFirstIcon,
  ChevronLargeLeftIcon: () => ChevronLargeLeftIcon,
  ChevronLargeRightIcon: () => ChevronLargeRightIcon,
  ChevronLastIcon: () => ChevronLastIcon,
  ChevronLeftIcon: () => ChevronLeftIcon,
  ChevronRightIcon: () => ChevronRightIcon,
  ChevronUpIcon: () => ChevronUpIcon,
  CloseCircledIcon: () => CloseCircledIcon,
  CloseIcon: () => CloseIcon,
  CloseSmallIcon: () => CloseSmallIcon,
  CloudIcon: () => CloudIcon,
  CollapseIcon: () => CollapseIcon,
  CommentIcon: () => CommentIcon,
  CopyIcon: () => CopyIcon,
  CourtIcon: () => CourtIcon,
  DateRangeIcon: () => DateRangeIcon,
  DeathsIcon: () => DeathsIcon,
  DoubleChevronLeftIcon: () => DoubleChevronLeftIcon,
  DoubleChevronRightIcon: () => DoubleChevronRightIcon,
  DownloadDoneIcon: () => DownloadDoneIcon,
  DownloadIcon: () => DownloadIcon,
  DragHandleIcon: () => DragHandleIcon,
  EditIcon: () => EditIcon,
  ErrorIcon: () => ErrorIcon,
  ExclaimIcon: () => ExclaimIcon,
  ExpandIcon: () => ExpandIcon,
  FacebookIcon: () => FacebookIcon,
  FamilyIcon: () => FamilyIcon,
  FeedbackIcon: () => FeedbackIcon,
  FileAddIcon: () => FileAddIcon,
  FileIcon: () => FileIcon,
  FileShieldedIcon: () => FileShieldedIcon,
  FileTextIcon: () => FileTextIcon,
  FilterIcon: () => FilterIcon,
  FilterListIcon: () => FilterListIcon,
  FilterListOffIcon: () => FilterListOffIcon,
  FilterOffIcon: () => FilterOffIcon,
  FindInPageIcon: () => FindInPageIcon,
  FlickrIcon: () => FlickrIcon,
  FolderAddIcon: () => FolderAddIcon,
  FolderIcon: () => FolderIcon,
  FolderShieldedIcon: () => FolderShieldedIcon,
  FullscreenExitIcon: () => FullscreenExitIcon,
  FullscreenIcon: () => FullscreenIcon,
  GavelIcon: () => GavelIcon,
  GuardianIcon: () => GuardianIcon,
  HelpFilledIcon: () => HelpFilledIcon,
  HelpIcon: () => HelpIcon,
  HelpSimpleIcon: () => HelpSimpleIcon,
  HomeIcon: () => HomeIcon,
  HourglassBottomIcon: () => HourglassBottomIcon,
  HourglassDisabledIcon: () => HourglassDisabledIcon,
  HourglassEmptyIcon: () => HourglassEmptyIcon,
  HourglassFullIcon: () => HourglassFullIcon,
  HourglassTopIcon: () => HourglassTopIcon,
  ImageIcon: () => ImageIcon,
  InfoIcon: () => InfoIcon,
  InstagramIcon: () => InstagramIcon,
  JordskifterettIcon: () => JordskifterettIcon,
  JordskiftesakIcon: () => JordskiftesakIcon,
  KeyIcon: () => KeyIcon,
  LagmannsrettIcon: () => LagmannsrettIcon,
  LanguageIcon: () => LanguageIcon,
  LibraryAddIcon: () => LibraryAddIcon,
  LineChartIcon: () => LineChartIcon,
  LinkIcon: () => LinkIcon,
  LinkOffIcon: () => LinkOffIcon,
  LinkedInIcon: () => LinkedInIcon,
  ListAltIcon: () => ListAltIcon,
  ListIcon: () => ListIcon,
  LocationIcon: () => LocationIcon,
  LockIcon: () => LockIcon,
  LockOpenIcon: () => LockOpenIcon,
  LoginIcon: () => LoginIcon,
  LogoutIcon: () => LogoutIcon,
  MailIcon: () => MailIcon,
  MailOpenIcon: () => MailOpenIcon,
  MenuIcon: () => MenuIcon,
  MinusCirledIcon: () => MinusCirledIcon,
  MinusIcon: () => MinusIcon,
  MoreHorizontalIcon: () => MoreHorizontalIcon,
  MoreVerticalIcon: () => MoreVerticalIcon,
  NotarialIcon: () => NotarialIcon,
  NotificationsIcon: () => NotificationsIcon,
  NotificationsOffIcon: () => NotificationsOffIcon,
  OnlineMeetingIcon: () => OnlineMeetingIcon,
  OpenExternalIcon: () => OpenExternalIcon,
  PayoutIcon: () => PayoutIcon,
  PdfIcon: () => PdfIcon,
  PersonAddIcon: () => PersonAddIcon,
  PersonIcon: () => PersonIcon,
  PersonShieldedIcon: () => PersonShieldedIcon,
  PinIcon: () => PinIcon,
  PlusCircledIcon: () => PlusCircledIcon,
  PlusIcon: () => PlusIcon,
  PowerOfAttorneyIcon: () => PowerOfAttorneyIcon,
  PrintIcon: () => PrintIcon,
  PropertyIcon: () => PropertyIcon,
  PublishIcon: () => PublishIcon,
  QuestionAnswerIcon: () => QuestionAnswerIcon,
  ReceiptIcon: () => ReceiptIcon,
  RedoIcon: () => RedoIcon,
  RefreshIcon: () => RefreshIcon,
  ReplayIcon: () => ReplayIcon,
  SearchIcon: () => SearchIcon,
  SettingsIcon: () => SettingsIcon,
  SmsIcon: () => SmsIcon,
  StarFilledIcon: () => StarFilledIcon,
  StarHalfFilled: () => StarHalfFilled,
  StarIcon: () => StarIcon,
  SyncIcon: () => SyncIcon,
  ThumbDownFilledIcon: () => ThumbDownFilledIcon,
  ThumbDownIcon: () => ThumbDownIcon,
  ThumbUpFilledIcon: () => ThumbUpFilledIcon,
  ThumbUpIcon: () => ThumbUpIcon,
  TimeIcon: () => TimeIcon,
  TingrettIcon: () => TingrettIcon,
  TipIcon: () => TipIcon,
  TrashIcon: () => TrashIcon,
  TrendingDownIcon: () => TrendingDownIcon,
  TrendingUpIcon: () => TrendingUpIcon,
  UndoIcon: () => UndoIcon,
  UnfoldLessIcon: () => UnfoldLessIcon,
  UnfoldMoreIcon: () => UnfoldMoreIcon,
  UploadIcon: () => UploadIcon,
  VisibilityOffIcon: () => VisibilityOffIcon,
  VisibilityOnIcon: () => VisibilityOnIcon,
  WarningIcon: () => WarningIcon,
  WebexIcon: () => WebexIcon,
  XIcon: () => XIcon,
  ZoomInIcon: () => ZoomInIcon,
  ZoomOutIcon: () => ZoomOutIcon
});

// src/components/Icon/icons/addressShielded.tsx
import { jsx as jsx9, jsxs as jsxs3 } from "react/jsx-runtime";
function AddressShieldedIcon(props) {
  return /* @__PURE__ */ jsxs3(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx9("path", { d: "M19 4V10H16.7889L12 5.69L7 10.19V18H9V12H14V14H11V20H5V12H2L12 3L16 6.6V4H19Z" }),
    /* @__PURE__ */ jsx9("path", { d: "M10 10H14C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10Z" }),
    /* @__PURE__ */ jsx9("path", { d: "M20 15V14C20 12.9 19.1 12 18 12C16.9 12 16 12.9 16 14V15C15.45 15 15 15.45 15 16V19C15 19.55 15.45 20 16 20H20C20.55 20 21 19.55 21 19V16C21 15.45 20.55 15 20 15ZM17 15V14C17 13.45 17.45 13 18 13C18.55 13 19 13.45 19 14V15H17Z" })
  ] });
}

// src/components/Icon/icons/agreement.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function AgreementIcon(props) {
  return /* @__PURE__ */ jsx10(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx10("path", { d: "M12.22 19.85c-.18.18-.5.21-.71 0-.18-.18-.21-.5 0-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.19.2-.51.19-.71 0-.21-.21-.18-.53 0-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.18.18-.5.21-.71 0-.19-.19-.19-.51 0-.71l3.39-3.39-1.42-1.41-3.39 3.39c-.18.18-.5.21-.71 0-.19-.2-.19-.51 0-.71L9.52 8.4l1.87 1.86c.95.95 2.59.94 3.54 0 .98-.98.98-2.56 0-3.54l-1.86-1.86.28-.28c.78-.78 2.05-.78 2.83 0l4.24 4.24c.78.78.78 2.05 0 2.83l-8.2 8.2zm9.61-6.78c1.56-1.56 1.56-4.09 0-5.66l-4.24-4.24c-1.56-1.56-4.09-1.56-5.66 0l-.28.28-.28-.28c-1.56-1.56-4.09-1.56-5.66 0L2.17 6.71C.75 8.13.62 10.34 1.77 11.9l1.45-1.45c-.39-.75-.26-1.7.37-2.33l3.54-3.54c.78-.78 2.05-.78 2.83 0l3.56 3.56c.18.18.21.5 0 .71-.21.21-.53.18-.71 0L9.52 5.57l-5.8 5.79c-.98.97-.98 2.56 0 3.54.39.39.89.63 1.42.7.07.52.3 1.02.7 1.42.4.4.9.63 1.42.7.07.52.3 1.02.7 1.42.4.4.9.63 1.42.7.07.54.31 1.03.7 1.42.47.47 1.1.73 1.77.73.67 0 1.3-.26 1.77-.73l8.21-8.19z" }) });
}

// src/components/Icon/icons/apps.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
function AppsIcon(props) {
  return /* @__PURE__ */ jsx11(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx11("path", { d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" }) });
}

// src/components/Icon/icons/archive.tsx
import { jsx as jsx12, jsxs as jsxs4 } from "react/jsx-runtime";
function ArchiveIcon(props) {
  return /* @__PURE__ */ jsxs4(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx12("path", { d: "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z" }),
    /* @__PURE__ */ jsx12("path", { d: "M9 12h6v2H9v-2z" })
  ] });
}

// src/components/Icon/icons/arrowDown.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
function ArrowDownIcon(props) {
  return /* @__PURE__ */ jsx13(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx13("path", { d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" }) });
}

// src/components/Icon/icons/arrowLeft.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function ArrowLeftIcon(props) {
  return /* @__PURE__ */ jsx14(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx14("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" }) });
}

// src/components/Icon/icons/arrowRight.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
function ArrowRightIcon(props) {
  return /* @__PURE__ */ jsx15(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx15("path", { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" }) });
}

// src/components/Icon/icons/arrowUp.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
function ArrowUpIcon(props) {
  return /* @__PURE__ */ jsx16(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx16("path", { d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" }) });
}

// src/components/Icon/icons/attachment.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
function AttachmentIcon(props) {
  return /* @__PURE__ */ jsx17(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx17("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 115 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" }) });
}

// src/components/Icon/icons/block.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
function BlockIcon(props) {
  return /* @__PURE__ */ jsx18(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx18("path", { d: "M12 2C6.489 2 2 6.489 2 12s4.489 10 10 10 10-4.489 10-10S17.511 2 12 2zm0 2c4.43 0 8 3.57 8 8 0 1.853-.63 3.55-1.682 4.904L7.096 5.682A7.965 7.965 0 0112 4zM5.682 7.096l11.222 11.222A7.965 7.965 0 0112 20c-4.43 0-8-3.57-8-8 0-1.853.63-3.55 1.682-4.904z" }) });
}

// src/components/Icon/icons/book.tsx
import { jsx as jsx19, jsxs as jsxs5 } from "react/jsx-runtime";
function BookIcon(props) {
  return /* @__PURE__ */ jsxs5(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx19("path", { d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.95 0-4.05.4-5.5 1.5v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" }),
    /* @__PURE__ */ jsx19("path", { d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm4.5 1.84c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z" })
  ] });
}

// src/components/Icon/icons/build.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
function BuildIcon(props) {
  return /* @__PURE__ */ jsx20(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx20("path", { d: "M7.5 1c-.873 0-1.707.176-2.467.488l-1.388.57L7.585 6 6 7.586 2.059 3.645l-.57 1.388A6.474 6.474 0 001 7.5C1 11.078 3.922 14 7.5 14c.619 0 1.181-.183 1.748-.346l8.908 8.907a1.514 1.514 0 002.121 0l2.285-2.288a1.516 1.516 0 00-.002-2.119l-8.906-8.906c.162-.567.346-1.13.346-1.748C14 3.922 11.078 1 7.5 1zm0 2C9.998 3 12 5.002 12 7.5c0 .607-.122 1.182-.34 1.713l-.252.617 9.385 9.385-1.576 1.578-9.387-9.387-.617.254c-.53.219-1.105.34-1.713.34A4.484 4.484 0 013 7.5c0-.026.013-.047.014-.072L6 10.414 10.414 6 7.428 3.014c.025 0 .046-.014.072-.014z" }) });
}

// src/components/Icon/icons/buildCircled.tsx
import { jsx as jsx21, jsxs as jsxs6 } from "react/jsx-runtime";
function BuildCircledIcon(props) {
  return /* @__PURE__ */ jsxs6(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      }
    ),
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.49 11.38c.43-1.22.17-2.64-.81-3.62a3.468 3.468 0 00-4.1-.59l2.35 2.35-1.41 1.41-2.35-2.35c-.71 1.32-.52 2.99.59 4.1.98.98 2.4 1.24 3.62.81l3.41 3.41c.2.2.51.2.71 0l1.4-1.4c.2-.2.2-.51 0-.71l-3.41-3.41z"
      }
    )
  ] });
}

// src/components/Icon/icons/calendar.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function CalendarIcon(props) {
  return /* @__PURE__ */ jsx22(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx22("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" }) });
}

// src/components/Icon/icons/calendarMonth.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
function CalendarMonthIcon(props) {
  return /* @__PURE__ */ jsx23(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx23("path", { d: "M19.6 3.2h-1.1V1h-2.2v2.2H7.5V1H5.3v2.2H4.2a2.19 2.19 0 00-2.189 2.2L2 20.8A2.2 2.2 0 004.2 23h15.4c1.21 0 2.2-.99 2.2-2.2V5.4c0-1.21-.99-2.2-2.2-2.2zm0 17.6H4.2v-11h15.4v11zm0-13.2H4.2V5.4h15.4v2.2zm-11 6.6H6.4V12h2.2v2.2zm4.4 0h-2.2V12H13v2.2zm4.4 0h-2.2V12h2.2v2.2zm-8.8 4.4H6.4v-2.2h2.2v2.2zm4.4 0h-2.2v-2.2H13v2.2zm4.4 0h-2.2v-2.2h2.2v2.2z" }) });
}

// src/components/Icon/icons/calendarViewDay.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
function CalendarViewDayIcon(props) {
  return /* @__PURE__ */ jsx24(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx24("path", { d: "M3 17h18v2H3v-2zm16-5v1H5v-1h14zm2-2H3v5h18v-5zM3 6h18v2H3V6z" }) });
}

// src/components/Icon/icons/calendarViewMonth.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
function CalendarViewMonthIcon(props) {
  return /* @__PURE__ */ jsx25(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx25("path", { d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H4V6h4v5zm6 0h-4V6h4v5zm6 0h-4V6h4v5zM8 18H4v-5h4v5zm6 0h-4v-5h4v5zm6 0h-4v-5h4v5z" }) });
}

// src/components/Icon/icons/calendarViewWeek.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
function CalendarViewWeekIcon(props) {
  return /* @__PURE__ */ jsx26(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx26("path", { d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z" }) });
}

// src/components/Icon/icons/call.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
function CallIcon(props) {
  return /* @__PURE__ */ jsx27(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx27("path", { d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51zm9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19zM7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z" }) });
}

// src/components/Icon/icons/caring.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
function CaringIcon(props) {
  return /* @__PURE__ */ jsx28(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx28("path", { d: "M16 13c3.09-2.81 6-5.44 6-7.7C22 3.45 20.55 2 18.7 2c-1.04 0-2.05.49-2.7 1.25C15.34 2.49 14.34 2 13.3 2 11.45 2 10 3.45 10 5.3c0 2.26 2.91 4.89 6 7.7zm-2.7-9c.44 0 .89.21 1.18.55L16 6.34l1.52-1.79c.29-.34.74-.55 1.18-.55.74 0 1.3.56 1.3 1.3 0 1.12-2.04 3.17-4 4.99-1.96-1.82-4-3.88-4-4.99 0-.74.56-1.3 1.3-1.3zM19 16h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM3 20v-7h2v7H3zm10.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z" }) });
}

// src/components/Icon/icons/chat.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
function ChatIcon(props) {
  return /* @__PURE__ */ jsx29(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx29("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" }) });
}

// src/components/Icon/icons/check.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
function CheckIcon(props) {
  return /* @__PURE__ */ jsx30(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx30("path", { d: "M20.293 5.293L9 16.586l-4.293-4.293-1.414 1.414L9 19.414 21.707 6.707l-1.414-1.414z" }) });
}

// src/components/Icon/icons/checkCircled.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
function CheckCircledIcon(props) {
  return /* @__PURE__ */ jsx31(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx31("path", { d: "M12 2C6.467 2 2 6.467 2 12s4.467 10 10 10 10-4.467 10-10S17.533 2 12 2zm0 2c4.467 0 8 3.533 8 8 0 4.467-3.533 8-8 8-4.467 0-8-3.533-8-8 0-4.467 3.533-8 8-8zm4.293 4.293L10 14.586l-2.293-2.293-1.414 1.414L10 17.414l7.707-7.707-1.414-1.414z" }) });
}

// src/components/Icon/icons/checklist.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
function ChecklistIcon(props) {
  return /* @__PURE__ */ jsx32(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx32("path", { d: "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z" }) });
}

// src/components/Icon/icons/chevronDown.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
function ChevronDownIcon(props) {
  return /* @__PURE__ */ jsx33(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx33("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }) });
}

// src/components/Icon/icons/chevronFirst.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
function ChevronFirstIcon(props) {
  return /* @__PURE__ */ jsx34(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx34("path", { d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z" }) });
}

// src/components/Icon/icons/chevronLargeLeft.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
function ChevronLargeLeftIcon(props) {
  return /* @__PURE__ */ jsx35(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx35("path", { d: "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" }) });
}

// src/components/Icon/icons/chevronLargeRight.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
function ChevronLargeRightIcon(props) {
  return /* @__PURE__ */ jsx36(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx36("path", { d: "M6.49 20.13l1.77 1.77 9.9-9.9-9.9-9.9-1.77 1.77L14.62 12l-8.13 8.13z" }) });
}

// src/components/Icon/icons/chevronLast.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
function ChevronLastIcon(props) {
  return /* @__PURE__ */ jsx37(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx37("path", { d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z" }) });
}

// src/components/Icon/icons/chevronLeft.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
function ChevronLeftIcon(props) {
  return /* @__PURE__ */ jsx38(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx38("path", { d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" }) });
}

// src/components/Icon/icons/chevronRight.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
function ChevronRightIcon(props) {
  return /* @__PURE__ */ jsx39(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx39("path", { d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" }) });
}

// src/components/Icon/icons/chevronUp.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
function ChevronUpIcon(props) {
  return /* @__PURE__ */ jsx40(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx40("path", { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" }) });
}

// src/components/Icon/icons/close.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
function CloseIcon(props) {
  return /* @__PURE__ */ jsx41(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx41("path", { d: "M4.707 3.293L3.293 4.707 10.586 12l-7.293 7.293 1.414 1.414L12 13.414l7.293 7.293 1.414-1.414L13.414 12l7.293-7.293-1.414-1.414L12 10.586 4.707 3.293z" }) });
}

// src/components/Icon/icons/closeSmall.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
function CloseSmallIcon(props) {
  return /* @__PURE__ */ jsx42(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx42("path", { d: "M7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293-1.414-1.414L10.586 12 7.293 8.707z" }) });
}

// src/components/Icon/icons/closeCircled.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
function CloseCircledIcon(props) {
  return /* @__PURE__ */ jsx43(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx43("path", { d: "M12 2C6.467 2 2 6.467 2 12s4.467 10 10 10 10-4.467 10-10S17.533 2 12 2zm0 2c4.467 0 8 3.533 8 8 0 4.467-3.533 8-8 8-4.467 0-8-3.533-8-8 0-4.467 3.533-8 8-8zM8.707 7.293L7.293 8.707 10.586 12l-3.293 3.293 1.414 1.414L12 13.414l3.293 3.293 1.414-1.414L13.414 12l3.293-3.293-1.414-1.414L12 10.586 8.707 7.293z" }) });
}

// src/components/Icon/icons/cloud.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
function CloudIcon(props) {
  return /* @__PURE__ */ jsx44(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx44("path", { d: "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.47 5.47 0 0112 6zm0-2C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4z" }) });
}

// src/components/Icon/icons/collapse.tsx
import { jsx as jsx45 } from "react/jsx-runtime";
function CollapseIcon(props) {
  return /* @__PURE__ */ jsx45(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx45("path", { d: "M22 3.41L16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z" }) });
}

// src/components/Icon/icons/comment.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
function CommentIcon(props) {
  return /* @__PURE__ */ jsx46(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx46("path", { d: "M4 4h16v12H5.17L4 17.17V4zm0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z" }) });
}

// src/components/Icon/icons/copy.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
function CopyIcon(props) {
  return /* @__PURE__ */ jsx47(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx47("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" }) });
}

// src/components/Icon/icons/court.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
function CourtIcon(props) {
  return /* @__PURE__ */ jsx48(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx48("path", { d: "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74zm0-2.26L2 6v2h19V6l-9.5-5z" }) });
}

// src/components/Icon/icons/dateRange.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
function DateRangeIcon(props) {
  return /* @__PURE__ */ jsx49(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx49("path", { d: "M6.4 10.9h2.2v2.2H6.4v-2.2zm15.4-5.5v15.4c0 1.21-.99 2.2-2.2 2.2H4.2A2.2 2.2 0 012 20.8l.011-15.4c0-1.21.968-2.2 2.189-2.2h1.1V1h2.2v2.2h8.8V1h2.2v2.2h1.1c1.21 0 2.2.99 2.2 2.2zM4.2 7.6h15.4V5.4H4.2v2.2zm15.4 13.2v-11H4.2v11h15.4zm-4.4-7.7h2.2v-2.2h-2.2v2.2zm-4.4 0H13v-2.2h-2.2v2.2z" }) });
}

// src/components/Icon/icons/deaths.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
function DeathsIcon(props) {
  return /* @__PURE__ */ jsx50(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx50("path", { d: "M16.5 3c-.96 0-1.9.25-2.73.69L12 9h3l-3 10 1-9h-3l1.54-5.39C10.47 3.61 9.01 3 7.5 3 4.42 3 2 5.42 2 8.5c0 4.13 4.16 7.18 10 12.5 5.47-4.94 10-8.26 10-12.5C22 5.42 19.58 3 16.5 3zm-6.26 13.73C6.45 13.34 4 11 4 8.5 4 6.54 5.54 5 7.5 5c.59 0 1.19.15 1.73.42L7.35 12h3.42l-.53 4.73zm4.89-1.2L17.69 7h-2.91l.61-1.82c.36-.12.74-.18 1.11-.18C18.46 5 20 6.54 20 8.5c0 2.21-2.02 4.43-4.87 7.03z" }) });
}

// src/components/Icon/icons/doubleChevronLeft.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
function DoubleChevronLeftIcon(props) {
  return /* @__PURE__ */ jsx51(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx51("path", { d: "M 18.414,7.41398L 17,6L 11,12L 17,18L 18.414,16.586L 13.828,12L 18.414,7.41398 Z M 12.414,7.41398L 11,6L 5.00001,12L 11,18L 12.414,16.586L 7.82801,12L 12.414,7.41398 Z " }) });
}

// src/components/Icon/icons/doubleChevronRight.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
function DoubleChevronRightIcon(props) {
  return /* @__PURE__ */ jsx52(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx52("path", { d: "M 5.586,7.41398L 7,6L 13,12L 7,18L 5.586,16.586L 10.172,12L 5.586,7.41398 Z M 11.586,7.41399L 13,6.00001L 19,12L 13,18L 11.586,16.586L 16.172,12L 11.586,7.41399 Z " }) });
}

// src/components/Icon/icons/download.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
function DownloadIcon(props) {
  return /* @__PURE__ */ jsx53(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx53("path", { d: "M13 5v6h1.17L12 13.17 9.83 11H11V5h2zm2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z" }) });
}

// src/components/Icon/icons/downloadDone.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
function DownloadDoneIcon(props) {
  return /* @__PURE__ */ jsx54(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx54("path", { d: "M20.13 5.41L18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66 10.6-10.61zM5 18h14v2H5v-2z" }) });
}

// src/components/Icon/icons/dragHandle.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
function DragHandleIcon(props) {
  return /* @__PURE__ */ jsx55(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx55("path", { d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z" }) });
}

// src/components/Icon/icons/edit.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
function EditIcon(props) {
  return /* @__PURE__ */ jsx56(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx56("path", { d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" }) });
}

// src/components/Icon/icons/error.tsx
import { jsx as jsx57 } from "react/jsx-runtime";
function ErrorIcon(props) {
  return /* @__PURE__ */ jsx57(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx57("path", { d: "M12 5.99L19.53 19H4.47L12 5.99zM12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" }) });
}

// src/components/Icon/icons/exclaim.tsx
import { jsx as jsx58 } from "react/jsx-runtime";
function ExclaimIcon(props) {
  return /* @__PURE__ */ jsx58(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx58("path", { d: "M12 21a2 2 0 100-4 2 2 0 000 4zM10 3h4v12h-4V3z" }) });
}

// src/components/Icon/icons/expand.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
function ExpandIcon(props) {
  return /* @__PURE__ */ jsx59(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx59("path", { d: "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10L21 11z" }) });
}

// src/components/Icon/icons/facebook.tsx
import { jsx as jsx60 } from "react/jsx-runtime";
function FacebookIcon(props) {
  return /* @__PURE__ */ jsx60(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx60("path", { d: "M20.625 2.625H3.375a.75.75 0 00-.75.75v17.25c0 .415.335.75.75.75h17.25a.75.75 0 00.75-.75V3.375a.75.75 0 00-.75-.75zm-2.166 5.473h-1.497c-1.175 0-1.402.557-1.402 1.378v1.807h2.803l-.365 2.829H15.56v7.263h-2.923v-7.26h-2.444v-2.832h2.444V9.197c0-2.421 1.48-3.74 3.64-3.74 1.036 0 1.925.077 2.185.112v2.529h-.003z" }) });
}

// src/components/Icon/icons/family.tsx
import { jsx as jsx61 } from "react/jsx-runtime";
function FamilyIcon(props) {
  return /* @__PURE__ */ jsx61(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx61("path", { d: "M8.66 13.07c.15 0 .29-.01.43-.03A3.15 3.15 0 0012 15c1.31 0 2.44-.81 2.91-1.96a3.144 3.144 0 003.57-3.11c0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93a3.144 3.144 0 00-3.57-3.11A3.15 3.15 0 0012 1c-1.31 0-2.44.81-2.91 1.96a3.145 3.145 0 00-3.57 3.11c0 .71.25 1.39.67 1.93-.43.54-.68 1.22-.68 1.93 0 1.73 1.41 3.14 3.15 3.14zM12 13c-.62 0-1.12-.49-1.14-1.1l.12-1.09c.32.12.66.19 1.02.19s.71-.07 1.03-.19l.11 1.09c-.02.61-.52 1.1-1.14 1.1zm3.34-1.93c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM8.66 4.93c.24 0 .46.07.64.2l.81.56c-.55.45-.94 1.09-1.06 1.83l-.88-.42c-.4-.2-.66-.59-.66-1.03 0-.63.52-1.14 1.15-1.14zM8.17 8.9l.88-.42c.12.74.51 1.38 1.07 1.83l-.81.55c-.2.13-.42.2-.65.2-.63 0-1.14-.51-1.14-1.14-.01-.43.25-.82.65-1.02zM12 22a9 9 0 009-9 9 9 0 00-9 9zm2.44-2.44c.71-1.9 2.22-3.42 4.12-4.12a7.04 7.04 0 01-4.12 4.12zM3 13a9 9 0 009 9 9 9 0 00-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12a7.04 7.04 0 01-4.12-4.12z" }) });
}

// src/components/Icon/icons/feedback.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
function FeedbackIcon(props) {
  return /* @__PURE__ */ jsx62(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx62("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2v-2zm0-6h2v4h-2V6z" }) });
}

// src/components/Icon/icons/file.tsx
import { jsx as jsx63 } from "react/jsx-runtime";
function FileIcon(props) {
  return /* @__PURE__ */ jsx63(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx63("path", { d: "M6 2c-1.094 0-2 .906-2 2v16c0 1.094.906 2 2 2h12c1.094 0 2-.906 2-2V8l-6-6H6zm0 2h7v5h5v11H6V4z" }) });
}

// src/components/Icon/icons/fileAdd.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
function FileAddIcon(props) {
  return /* @__PURE__ */ jsx64(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx64("path", { d: "M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3v-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" }) });
}

// src/components/Icon/icons/fileShielded.tsx
import { jsx as jsx65, jsxs as jsxs7 } from "react/jsx-runtime";
function FileShieldedIcon(props) {
  return /* @__PURE__ */ jsxs7(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx65("path", { d: "M13 2H5C3.9 2 3 2.9 3 4V20C3 21.1 3.89 22 4.99 22H13V20H5V4H12V9H17V12H19V8L13 2Z" }),
    /* @__PURE__ */ jsx65("path", { d: "M20 17V16C20 14.9 19.1 14 18 14C16.9 14 16 14.9 16 16V17C15.45 17 15 17.45 15 18V21C15 21.55 15.45 22 16 22H20C20.55 22 21 21.55 21 21V18C21 17.45 20.55 17 20 17ZM17 17V16C17 15.45 17.45 15 18 15C18.55 15 19 15.45 19 16V17H17Z" })
  ] });
}

// src/components/Icon/icons/fileText.tsx
import { jsx as jsx66 } from "react/jsx-runtime";
function FileTextIcon(props) {
  return /* @__PURE__ */ jsx66(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx66("path", { d: "M8 16h8v2H8v-2zm0-4h8v2H8v-2zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" }) });
}

// src/components/Icon/icons/filter.tsx
import { jsx as jsx67 } from "react/jsx-runtime";
function FilterIcon(props) {
  return /* @__PURE__ */ jsx67(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx67("path", { d: "M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0018.95 4H5.04c-.83 0-1.3.95-.79 1.61z" }) });
}

// src/components/Icon/icons/filterList.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
function FilterListIcon(props) {
  return /* @__PURE__ */ jsx68(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx68("path", { d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" }) });
}

// src/components/Icon/icons/filterListOff.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
function FilterListOffIcon(props) {
  return /* @__PURE__ */ jsx69(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx69("path", { d: "M10.83 8H21V6H8.83l2 2zm5 5H18v-2h-4.17l2 2zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L14 16.83z" }) });
}

// src/components/Icon/icons/filterOff.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
function FilterOffIcon(props) {
  return /* @__PURE__ */ jsx70(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx70("path", { d: "M16.95 6l-3.57 4.55 1.43 1.43c1.03-1.31 4.98-6.37 4.98-6.37A.998.998 0 0019 4H6.83l2 2h8.12zM2.81 2.81L1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z" }) });
}

// src/components/Icon/icons/findInPage.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
function FindInPageIcon(props) {
  return /* @__PURE__ */ jsx71(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx71("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 4h7l5 5v8.58l-1.84-1.84a4.992 4.992 0 00-.64-6.28A4.96 4.96 0 0012 8a5 5 0 00-4.612 3.077A4.98 4.98 0 008.47 16.51a4.982 4.982 0 006.28.63L17.6 20H6V4zm8.11 11.1c-.56.56-1.31.88-2.11.88-.8 0-1.55-.31-2.11-.88-.56-.56-.88-1.31-.88-2.11 0-.8.31-1.55.88-2.11.56-.57 1.31-.88 2.11-.88.8 0 1.55.31 2.11.88.56.56.88 1.31.88 2.11 0 .8-.31 1.55-.88 2.11z" }) });
}

// src/components/Icon/icons/flickr.tsx
import { jsx as jsx72 } from "react/jsx-runtime";
function FlickrIcon(props) {
  return /* @__PURE__ */ jsx72(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx72("path", { d: "M19.8571 2H4.14286C2.95982 2 2 2.95982 2 4.14286V19.8571C2 21.0402 2.95982 22 4.14286 22H19.8571C21.0402 22 22 21.0402 22 19.8571V4.14286C22 2.95982 21.0402 2 19.8571 2ZM8.45089 14.8125C6.88393 14.8125 5.61607 13.5446 5.61607 11.9777C5.61607 10.4107 6.88393 9.14286 8.45089 9.14286C10.0179 9.14286 11.2857 10.4107 11.2857 11.9777C11.2857 13.5446 10.0179 14.8125 8.45089 14.8125ZM15.5491 14.8125C13.9821 14.8125 12.7143 13.5446 12.7143 11.9777C12.7143 10.4107 13.9821 9.14286 15.5491 9.14286C17.1161 9.14286 18.3839 10.4107 18.3839 11.9777C18.3839 13.5446 17.1161 14.8125 15.5491 14.8125Z" }) });
}

// src/components/Icon/icons/folder.tsx
import { jsx as jsx73 } from "react/jsx-runtime";
function FolderIcon(props) {
  return /* @__PURE__ */ jsx73(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx73("path", { d: "M4 4c-1.094 0-2 .906-2 2v12c0 1.094.906 2 2 2h16c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2h-8l-2-2H4zm0 2h5.172l2 2H20v10H4V6z" }) });
}

// src/components/Icon/icons/folderAdd.tsx
import { jsx as jsx74 } from "react/jsx-runtime";
function FolderAddIcon(props) {
  return /* @__PURE__ */ jsx74(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx74("path", { d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2v2z" }) });
}

// src/components/Icon/icons/folderShielded.tsx
import { jsx as jsx75, jsxs as jsxs8 } from "react/jsx-runtime";
function FolderShieldedIcon(props) {
  return /* @__PURE__ */ jsxs8(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx75("path", { d: "M1 6C1 4.90575 1.90575 4 3 4H9L11 6H19C20.0943 6 21 6.90575 21 8V10H19V8H10.1719L8.17188 6H3V18H15V20H3C1.90575 20 1 19.0943 1 18V6Z" }),
    /* @__PURE__ */ jsx75("path", { d: "M22 15V14C22 12.9 21.1 12 20 12C18.9 12 18 12.9 18 14V15C17.45 15 17 15.45 17 16V19C17 19.55 17.45 20 18 20H22C22.55 20 23 19.55 23 19V16C23 15.45 22.55 15 22 15ZM19 15V14C19 13.45 19.45 13 20 13C20.55 13 21 13.45 21 14V15H19Z" })
  ] });
}

// src/components/Icon/icons/fullsceenExit.tsx
import { jsx as jsx76 } from "react/jsx-runtime";
function FullscreenExitIcon(props) {
  return /* @__PURE__ */ jsx76(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx76("path", { d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" }) });
}

// src/components/Icon/icons/fullscreen.tsx
import { jsx as jsx77 } from "react/jsx-runtime";
function FullscreenIcon(props) {
  return /* @__PURE__ */ jsx77(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx77("path", { d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" }) });
}

// src/components/Icon/icons/gavel.tsx
import { jsx as jsx78, jsxs as jsxs9 } from "react/jsx-runtime";
function GavelIcon(props) {
  return /* @__PURE__ */ jsxs9(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx78(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.112 15.528L3.302 9.86l1.393-1.43 5.81 5.669-1.393 1.429zM15.385 9.097L9.575 3.43 10.967 2l5.81 5.668-1.393 1.43zM21.606 21.44l-9.095-8.87 1.394-1.43L23 20.012l-1.394 1.429zM10.802 12.993L5.75 8.066l3.485-3.573 5.052 4.929-3.485 3.572zM3.998 18.686h8.984v1.996H3.998v-1.996z"
      }
    ),
    /* @__PURE__ */ jsx78(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 20.183h10.98v1.997H3v-1.997z"
      }
    )
  ] });
}

// src/components/Icon/icons/guardian.tsx
import { jsx as jsx79, jsxs as jsxs10 } from "react/jsx-runtime";
function GuardianIcon(props) {
  return /* @__PURE__ */ jsxs10(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx79("path", { d: "M15.225 14.275C15.7084 14.7583 16.3 15 17 15C17.7 15 18.2916 14.7583 18.775 14.275C19.2583 13.7917 19.5 13.2 19.5 12.5C19.5 11.8 19.2583 11.2083 18.775 10.725C18.2916 10.2417 17.7 10 17 10C16.3 10 15.7084 10.2417 15.225 10.725C14.7417 11.2083 14.5 11.8 14.5 12.5C14.5 13.2 14.7417 13.7917 15.225 14.275Z" }),
    /* @__PURE__ */ jsx79("path", { d: "M12 18.6V20H22V18.8371C21.1597 18.9446 20.2638 18.635 19.6233 18.0638C19.0679 17.5685 18.6862 16.8599 18.6017 16.1281C18.0706 16.0427 17.5366 16 17 16C16.3507 16.0007 15.705 16.0633 15.063 16.188C14.421 16.3127 13.8 16.5 13.2 16.75C12.8174 16.9007 12.5216 17.1467 12.313 17.488C12.1044 17.8293 12 18.2 12 18.6Z" }),
    /* @__PURE__ */ jsx79(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.17505 10.825C7.95837 11.6083 8.90002 12 10 12C11.1 12 12.0416 11.6083 12.825 10.825C13.6083 10.0417 14 9.10001 14 8C14 6.89999 13.6083 5.95834 12.825 5.17499C12.0416 4.39166 11.1 4 10 4C8.90002 4 7.95837 4.39166 7.17505 5.17499C6.39172 5.95834 6 6.89999 6 8C6 9.10001 6.39172 10.0417 7.17505 10.825ZM11.413 9.41299C11.021 9.80432 10.55 10 10 10C9.45068 10.0007 8.97998 9.80499 8.58801 9.41299C8.19604 9.021 8 8.54999 8 8C8.00061 7.45065 8.19666 6.98001 8.58801 6.58801C8.97937 6.19601 9.44995 6 10 6C10.5507 6.00067 11.0216 6.19666 11.413 6.58801C11.8043 6.97934 12 7.45001 12 8C12.0006 8.55066 11.8051 9.02167 11.413 9.41299Z"
      }
    ),
    /* @__PURE__ */ jsx79("path", { d: "M2 17.2V20H10V18H4V17.2C4 17.0167 4.04163 16.85 4.125 16.7C4.20837 16.55 4.33337 16.4333 4.5 16.35C5.34937 15.9167 6.23669 15.5833 7.16199 15.35C8.08728 15.1167 9.03333 15 10 15C10.3 15.0007 10.6 15.0133 10.9 15.038C11.2 15.0627 11.5 15.1167 11.8 15.2L13.5 13.5C12.9166 13.3667 12.3334 13.25 11.75 13.15C11.1666 13.05 10.5834 13 10 13C8.88403 13 7.78833 13.1333 6.71301 13.4C5.6377 13.6667 4.59998 14.05 3.59998 14.55C3.09998 14.8007 2.70837 15.1633 2.42505 15.638C2.14172 16.1127 2 16.6333 2 17.2Z" }),
    /* @__PURE__ */ jsx79("path", { d: "M20.1512 17.1838C20.1947 17.2298 20.2406 17.2744 20.2889 17.3175C21.0617 18.0067 22.1565 18.0404 22.7341 17.3927C23.1146 16.9662 23.0624 16.4776 22.7617 15.9968C22.6629 15.8389 22.5373 15.6817 22.3913 15.5279C22.307 15.439 22.2159 15.3513 22.1193 15.2652C21.3465 14.5759 20.5132 14.249 19.9355 14.8967C19.4786 15.4091 19.4821 16.1943 19.886 16.8413C19.9608 16.9611 20.0493 17.0761 20.1512 17.1838Z" })
  ] });
}

// src/components/Icon/icons/help.tsx
import { jsx as jsx80 } from "react/jsx-runtime";
function HelpIcon(props) {
  return /* @__PURE__ */ jsx80(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx80("path", { d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" }) });
}

// src/components/Icon/icons/helpFilled.tsx
import { jsx as jsx81 } from "react/jsx-runtime";
function HelpFilledIcon(props) {
  return /* @__PURE__ */ jsx81(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx81("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" }) });
}

// src/components/Icon/icons/home.tsx
import { jsx as jsx82 } from "react/jsx-runtime";
function HomeIcon(props) {
  return /* @__PURE__ */ jsx82(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx82("path", { d: "M12 2.1L1 12h3v9h7v-6h2v6h7v-9h3L12 2.1zm0 2.691l6 5.4V19h-3v-6H9v6H6v-8.809l6-5.4z" }) });
}

// src/components/Icon/icons/hourglassBottom.tsx
import { jsx as jsx83 } from "react/jsx-runtime";
function HourglassBottomIcon(props) {
  return /* @__PURE__ */ jsx83(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx83("path", { d: "m18 22-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z" }) });
}

// src/components/Icon/icons/hourglassDisabled.tsx
import { jsx as jsx84 } from "react/jsx-runtime";
function HourglassDisabledIcon(props) {
  return /* @__PURE__ */ jsx84(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx84("path", { d: "M8 4h8v3.5l-2.84 2.84 1.25 1.25L18 8.01 17.99 8H18V2H6v1.17l2 2zM2.1 2.1.69 3.51l8.9 8.9L6 16l.01.01H6V22h12v-1.17l2.49 2.49 1.41-1.41L2.1 2.1zM16 20H8v-3.5l2.84-2.84L16 18.83V20z" }) });
}

// src/components/Icon/icons/hourglassEmpty.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
function HourglassEmptyIcon(props) {
  return /* @__PURE__ */ jsx85(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx85("path", { d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5-4-4V4h8v3.5l-4 4z" }) });
}

// src/components/Icon/icons/hourglassFull.tsx
import { jsx as jsx86 } from "react/jsx-runtime";
function HourglassFullIcon(props) {
  return /* @__PURE__ */ jsx86(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx86("path", { d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z" }) });
}

// src/components/Icon/icons/hourglassTop.tsx
import { jsx as jsx87 } from "react/jsx-runtime";
function HourglassTopIcon(props) {
  return /* @__PURE__ */ jsx87(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx87("path", { d: "m6 2 .01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z" }) });
}

// src/components/Icon/icons/image.tsx
import { jsx as jsx88 } from "react/jsx-runtime";
function ImageIcon(props) {
  return /* @__PURE__ */ jsx88(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx88("path", { d: "M19 5v14H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86L11 16l-2-2.86L6 17h12l-3.86-5.14z" }) });
}

// src/components/Icon/icons/info.tsx
import { jsx as jsx89 } from "react/jsx-runtime";
function InfoIcon(props) {
  return /* @__PURE__ */ jsx89(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx89("path", { d: "M12 2C6.489 2 2 6.489 2 12s4.489 10 10 10 10-4.489 10-10S17.511 2 12 2zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8zm-1 3v2h2V7h-2zm0 4v6h2v-6h-2z" }) });
}

// src/components/Icon/icons/instagram.tsx
import { jsx as jsx90 } from "react/jsx-runtime";
function InstagramIcon(props) {
  return /* @__PURE__ */ jsx90(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx90("path", { d: "M12 7.193A4.8 4.8 0 007.193 12 4.8 4.8 0 0012 16.807 4.8 4.8 0 0016.807 12 4.8 4.8 0 0012 7.193zm0 7.931A3.13 3.13 0 018.876 12 3.13 3.13 0 0112 8.876 3.13 3.13 0 0115.124 12 3.13 3.13 0 0112 15.124zm5.004-9.248a1.121 1.121 0 100 2.245A1.12 1.12 0 0018.04 6.57a1.122 1.122 0 00-1.037-.693zM21.37 12c0-1.294.012-2.576-.06-3.867-.073-1.5-.415-2.831-1.512-3.928-1.1-1.1-2.428-1.44-3.928-1.512-1.294-.073-2.576-.061-3.868-.061-1.293 0-2.575-.012-3.867.061-1.5.073-2.831.415-3.928 1.512-1.1 1.099-1.439 2.428-1.512 3.928-.072 1.294-.06 2.576-.06 3.867s-.012 2.576.06 3.867c.073 1.5.415 2.831 1.512 3.928 1.1 1.1 2.428 1.44 3.928 1.512 1.294.073 2.576.061 3.867.061 1.294 0 2.576.012 3.867-.061 1.5-.073 2.832-.415 3.929-1.512 1.099-1.099 1.439-2.428 1.511-3.928.075-1.291.061-2.573.061-3.867zm-2.062 5.527A2.978 2.978 0 0118.6 18.6c-.33.33-.647.537-1.073.708-1.233.49-4.16.38-5.527.38-1.366 0-4.296.11-5.529-.378a2.98 2.98 0 01-1.073-.708 2.999 2.999 0 01-.708-1.073c-.488-1.235-.378-4.163-.378-5.529 0-1.366-.11-4.296.378-5.529.17-.426.377-.745.708-1.073A3.03 3.03 0 016.47 4.69c1.233-.488 4.163-.377 5.529-.377 1.366 0 4.296-.11 5.529.377.427.17.745.377 1.073.708.33.33.537.647.708 1.073.488 1.233.378 4.163.378 5.529 0 1.366.11 4.294-.38 5.527z" }) });
}

// src/components/Icon/icons/jordskifterett.tsx
import { jsx as jsx91 } from "react/jsx-runtime";
function JordskifterettIcon(props) {
  return /* @__PURE__ */ jsx91(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx91("circle", { cx: "12", cy: "12", r: "6" }) });
}

// src/components/Icon/icons/jordskiftesak.tsx
import { jsx as jsx92, jsxs as jsxs11 } from "react/jsx-runtime";
function JordskiftesakIcon(props) {
  return /* @__PURE__ */ jsxs11(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx92(
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M20.5257 1.14935C20.8205 1.33156 21 1.65342 21 2V10L19 9V3.61804L15 5.61803V10L13 11V5.61803L9 3.61804V14.4648L11.5 16.154V18.5L7.92816 16.154L2.44721 18.8944C2.13723 19.0494 1.76909 19.0329 1.47427 18.8507C1.17945 18.6684 1 18.3466 1 18V5C1 4.62123 1.214 4.27497 1.55279 4.10557L7.55279 1.10557C7.83431 0.96481 8.16569 0.96481 8.44721 1.10557L14 3.88197L19.5528 1.10557C19.8628 0.95058 20.2309 0.967144 20.5257 1.14935ZM7 14.382V3.61804L3 5.61804V16.382L7 14.382Z"
      }
    ),
    /* @__PURE__ */ jsx92("path", { d: "M18.6667 17.8008C20.0261 17.3203 21 16.0239 21 14.5C21 12.567 19.433 11 17.5 11C15.567 11 14 12.567 14 14.5C14 16.0239 14.9739 17.3204 16.3333 17.8008V23H18.6667L18.6667 17.8008Z" })
  ] });
}

// src/components/Icon/icons/key.tsx
import { jsx as jsx93 } from "react/jsx-runtime";
function KeyIcon(props) {
  return /* @__PURE__ */ jsx93(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx93("path", { d: "M21 10h-8.35A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" }) });
}

// src/components/Icon/icons/lagmannsrett.tsx
import { jsx as jsx94 } from "react/jsx-runtime";
function LagmannsrettIcon(props) {
  return /* @__PURE__ */ jsx94(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx94("path", { d: "M4 10h15.65v3.913H4z" }) });
}

// src/components/Icon/icons/language.tsx
import { jsx as jsx95 } from "react/jsx-runtime";
function LanguageIcon(props) {
  return /* @__PURE__ */ jsx95(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx95("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" }) });
}

// src/components/Icon/icons/link.tsx
import { jsx as jsx96 } from "react/jsx-runtime";
function LinkIcon(props) {
  return /* @__PURE__ */ jsx96(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx96("path", { d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8v-2z" }) });
}

// src/components/Icon/icons/linkedIn.tsx
import { jsx as jsx97 } from "react/jsx-runtime";
function LinkedInIcon(props) {
  return /* @__PURE__ */ jsx97(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx97(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 2.838A1.838 1.838 0 012.838 1H21.16A1.836 1.836 0 0123 2.838V21.16A1.838 1.838 0 0121.161 23H2.838A1.839 1.839 0 011 21.161V2.838zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634 3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708V9.388zm-5.5 10.403h3.208V9.25H4.208V19.791zM7.875 5.812a2.063 2.063 0 11-4.125.09 2.063 2.063 0 014.125-.09z"
    }
  ) });
}

// src/components/Icon/icons/linkOff.tsx
import { jsx as jsx98 } from "react/jsx-runtime";
function LinkOffIcon(props) {
  return /* @__PURE__ */ jsx98(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx98("path", { d: "M14.39 11L16 12.61V11h-1.61zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0022 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z" }) });
}

// src/components/Icon/icons/list.tsx
import { jsx as jsx99 } from "react/jsx-runtime";
function ListIcon(props) {
  return /* @__PURE__ */ jsx99(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx99("path", { d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" }) });
}

// src/components/Icon/icons/listAlt.tsx
import { jsx as jsx100 } from "react/jsx-runtime";
function ListAltIcon(props) {
  return /* @__PURE__ */ jsx100(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx100("path", { d: "M11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6v-2zM7 7h2v2H7V7zm0 4h2v2H7v-2zm0 4h2v2H7v-2zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z" }) });
}

// src/components/Icon/icons/location.tsx
import { jsx as jsx101 } from "react/jsx-runtime";
function LocationIcon(props) {
  return /* @__PURE__ */ jsx101(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx101("path", { d: "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z" }) });
}

// src/components/Icon/icons/lock.tsx
import { jsx as jsx102, jsxs as jsxs12 } from "react/jsx-runtime";
function LockIcon(props) {
  return /* @__PURE__ */ jsxs12(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx102("path", { d: "M14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z" }),
    /* @__PURE__ */ jsx102("path", { d: "M11 15H13V18H11V15Z" }),
    /* @__PURE__ */ jsx102(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 10V20H18V10H6ZM5 8.00001C4.44772 8.00001 4 8.44772 4 9.00001V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V9.00001C20 8.44772 19.5523 8.00001 19 8.00001H5Z"
      }
    ),
    /* @__PURE__ */ jsx102(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.36753 4.80798C7.83895 5.96255 7.8442 7.49987 8.03406 8.8771L6.25092 9.12291C6.04866 7.6557 5.98267 5.69302 6.73089 4.0587C7.11485 3.22001 7.71599 2.46272 8.61205 1.92286C9.50288 1.38615 10.6256 1.10001 12 1.10001C13.3437 1.10001 14.4487 1.38826 15.331 1.92478C16.2165 2.46328 16.8195 3.21672 17.2117 4.05013C17.9784 5.67948 17.9537 7.6385 17.749 9.12292L15.9659 8.8771C16.1534 7.51707 16.1286 5.97609 15.583 4.81655C15.319 4.25552 14.9377 3.79229 14.3957 3.46273C13.8506 3.1312 13.0851 2.90001 12 2.90001C10.8744 2.90001 10.0909 3.1333 9.54096 3.46465C8.99622 3.79285 8.62196 4.25222 8.36753 4.80798Z"
      }
    )
  ] });
}

// src/components/Icon/icons/lockOpen.tsx
import { jsx as jsx103, jsxs as jsxs13 } from "react/jsx-runtime";
function LockOpenIcon(props) {
  return /* @__PURE__ */ jsxs13(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx103("path", { d: "M14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z" }),
    /* @__PURE__ */ jsx103("path", { d: "M11 15H13V18H11V15Z" }),
    /* @__PURE__ */ jsx103(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 10V20H18V10H6ZM5 8.00001C4.44772 8.00001 4 8.44772 4 9.00001V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V9.00001C20 8.44772 19.5523 8.00001 19 8.00001H5Z"
      }
    ),
    /* @__PURE__ */ jsx103(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.41702 3.54352C8.86392 3.91502 8.49455 4.43767 8.25766 5.07353L6.57091 4.44514C6.91347 3.52561 7.49133 2.6686 8.4134 2.04928C9.33221 1.43216 10.5198 1.10001 12 1.10001C13.3437 1.10001 14.4487 1.38826 15.331 1.92478C16.2165 2.46328 16.8195 3.21672 17.2117 4.05013C17.9784 5.67948 17.9537 7.6385 17.749 9.12292L15.9659 8.8771C16.1534 7.51707 16.1286 5.97609 15.583 4.81655C15.319 4.25551 14.9377 3.79229 14.3957 3.46273C13.8506 3.1312 13.0851 2.90001 12 2.90001C10.789 2.90001 9.9734 3.16983 9.41702 3.54352Z"
      }
    )
  ] });
}

// src/components/Icon/icons/login.tsx
import { jsx as jsx104 } from "react/jsx-runtime";
function LoginIcon(props) {
  return /* @__PURE__ */ jsx104(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx104("path", { d: "M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z" }) });
}

// src/components/Icon/icons/logout.tsx
import { jsx as jsx105 } from "react/jsx-runtime";
function LogoutIcon(props) {
  return /* @__PURE__ */ jsx105(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx105("path", { d: "M17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z" }) });
}

// src/components/Icon/icons/mail.tsx
import { jsx as jsx106 } from "react/jsx-runtime";
function MailIcon(props) {
  return /* @__PURE__ */ jsx106(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx106("path", { d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" }) });
}

// src/components/Icon/icons/mailOpen.tsx
import { jsx as jsx107 } from "react/jsx-runtime";
function MailOpenIcon(props) {
  return /* @__PURE__ */ jsx107(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx107("path", { d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-2 0v.01L12 13 4 8l8-4.68L19.99 8zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z" }) });
}

// src/components/Icon/icons/menu.tsx
import { jsx as jsx108 } from "react/jsx-runtime";
function MenuIcon(props) {
  return /* @__PURE__ */ jsx108(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx108("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" }) });
}

// src/components/Icon/icons/minus.tsx
import { jsx as jsx109 } from "react/jsx-runtime";
function MinusIcon(props) {
  return /* @__PURE__ */ jsx109(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx109("path", { d: "M19 12.998H5v-2h14v2z" }) });
}

// src/components/Icon/icons/minusCircled.tsx
import { jsx as jsx110 } from "react/jsx-runtime";
function MinusCirledIcon(props) {
  return /* @__PURE__ */ jsx110(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx110("path", { d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" }) });
}

// src/components/Icon/icons/moreHorizontal.tsx
import { jsx as jsx111 } from "react/jsx-runtime";
function MoreHorizontalIcon(props) {
  return /* @__PURE__ */ jsx111(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx111("path", { d: "M16 12a2 2 0 114 0 2 2 0 01-4 0zm-6 0a2 2 0 114 0 2 2 0 01-4 0zm-6 0a2 2 0 114 0 2 2 0 01-4 0z" }) });
}

// src/components/Icon/icons/moreVertical.tsx
import { jsx as jsx112 } from "react/jsx-runtime";
function MoreVerticalIcon(props) {
  return /* @__PURE__ */ jsx112(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx112("path", { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }) });
}

// src/components/Icon/icons/notarial.tsx
import { jsx as jsx113 } from "react/jsx-runtime";
function NotarialIcon(props) {
  return /* @__PURE__ */ jsx113(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx113("path", { d: "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2zm14 2H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4z" }) });
}

// src/components/Icon/icons/notifications.tsx
import { jsx as jsx114 } from "react/jsx-runtime";
function NotificationsIcon(props) {
  return /* @__PURE__ */ jsx114(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx114("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" }) });
}

// src/components/Icon/icons/notificationsOff.tsx
import { jsx as jsx115 } from "react/jsx-runtime";
function NotificationsOffIcon(props) {
  return /* @__PURE__ */ jsx115(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx115("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z" }) });
}

// src/components/Icon/icons/onlineMeeting.tsx
import { jsx as jsx116 } from "react/jsx-runtime";
function OnlineMeetingIcon(props) {
  return /* @__PURE__ */ jsx116(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx116("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7v-2.4z" }) });
}

// src/components/Icon/icons/openExternal.tsx
import { jsx as jsx117 } from "react/jsx-runtime";
function OpenExternalIcon(props) {
  return /* @__PURE__ */ jsx117(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx117("path", { d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" }) });
}

// src/components/Icon/icons/payout.tsx
import { jsx as jsx118 } from "react/jsx-runtime";
function PayoutIcon(props) {
  return /* @__PURE__ */ jsx118(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx118("path", { d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v4h5v12H6zm5-1h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4v-2h-2V9h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1z" }) });
}

// src/components/Icon/icons/pdf.tsx
import { jsx as jsx119 } from "react/jsx-runtime";
function PdfIcon(props) {
  return /* @__PURE__ */ jsx119(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx119("path", { d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm12 6V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zm4 2h1v-1h-1V9h1V8h-2v5h1v-2zm-8 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z" }) });
}

// src/components/Icon/icons/person.tsx
import { jsx as jsx120 } from "react/jsx-runtime";
function PersonIcon(props) {
  return /* @__PURE__ */ jsx120(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx120("path", { d: "M12 5.9a2.1 2.1 0 110 4.199A2.1 2.1 0 0112 5.9zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1zM12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" }) });
}

// src/components/Icon/icons/personAdd.tsx
import { jsx as jsx121 } from "react/jsx-runtime";
function PersonAddIcon(props) {
  return /* @__PURE__ */ jsx121(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx121("path", { d: "M20 9V6h-2v3h-3v2h3v3h2v-3h3V9h-3zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C13.71 13.7 11.53 13 9 13s-4.71.7-6.39 1.56A2.97 2.97 0 001 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 18H3v-.78c0-.38.2-.72.52-.88C4.71 15.73 6.63 15 9 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18z" }) });
}

// src/components/Icon/icons/personShielded.tsx
import { jsx as jsx122, jsxs as jsxs14 } from "react/jsx-runtime";
function PersonShieldedIcon(props) {
  return /* @__PURE__ */ jsxs14(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx122("path", { d: "M12 5.9C12.2758 5.9 12.5489 5.95432 12.8036 6.05985C13.0584 6.16539 13.2899 6.32007 13.4849 6.51508C13.6799 6.71008 13.8346 6.94158 13.9401 7.19636C14.0457 7.45115 14.1 7.72422 14.1 8C14.1 8.27578 14.0457 8.54885 13.9401 8.80364C13.8346 9.05842 13.6799 9.28992 13.4849 9.48492C13.2899 9.67993 13.0584 9.83461 12.8036 9.94015C12.5489 10.0457 12.2758 10.1 12 10.1C11.443 10.1 10.9089 9.87875 10.5151 9.48492C10.1212 9.0911 9.9 8.55695 9.9 8C9.9 7.44305 10.1212 6.9089 10.5151 6.51508C10.9089 6.12125 11.443 5.9 12 5.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4Z" }),
    /* @__PURE__ */ jsx122("path", { d: "M5.9 18.1V17C5.9 16.36 9.03 14.9 12 14.9C12.3329 14.9 12.6677 14.9183 13 14.9518V13.0517C12.6402 13.0173 12.303 13 12 13C9.33 13 4 14.34 4 17V20H12V18.1H5.9Z" }),
    /* @__PURE__ */ jsx122("path", { d: "M19 15V14C19 12.9 18.1 12 17 12C15.9 12 15 12.9 15 14V15C14.45 15 14 15.45 14 16V19C14 19.55 14.45 20 15 20H19C19.55 20 20 19.55 20 19V16C20 15.45 19.55 15 19 15ZM16 15V14C16 13.45 16.45 13 17 13C17.55 13 18 13.45 18 14V15H16Z" })
  ] });
}

// src/components/Icon/icons/pin.tsx
import { jsx as jsx123 } from "react/jsx-runtime";
function PinIcon(props) {
  return /* @__PURE__ */ jsx123(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx123("path", { d: "M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4zm3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z" }) });
}

// src/components/Icon/icons/plus.tsx
import { jsx as jsx124 } from "react/jsx-runtime";
function PlusIcon(props) {
  return /* @__PURE__ */ jsx124(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx124("path", { d: "M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6v2z" }) });
}

// src/components/Icon/icons/plusCircled.tsx
import { jsx as jsx125 } from "react/jsx-runtime";
function PlusCircledIcon(props) {
  return /* @__PURE__ */ jsx125(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx125("path", { d: "M12 2C6.467 2 2 6.467 2 12s4.467 10 10 10 10-4.467 10-10S17.533 2 12 2zm0 2c4.467 0 8 3.533 8 8 0 4.467-3.533 8-8 8-4.467 0-8-3.533-8-8 0-4.467 3.533-8 8-8zm-1 3v4H7v2h4v4h2v-4h4v-2h-4V7h-2z" }) });
}

// src/components/Icon/icons/powerOfAttorney.tsx
import { jsx as jsx126, jsxs as jsxs15 } from "react/jsx-runtime";
function PowerOfAttorneyIcon(props) {
  return /* @__PURE__ */ jsxs15(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx126("path", { d: "M4 4C4 2.90575 4.90575 2 6 2H14L20 8V12H18V9H13V4H6V16H4V4Z" }),
    /* @__PURE__ */ jsx126("path", { d: "M5 19.5652V20.2609L10.7143 22L15.7143 20.6783V21.6522H20V14H14.2857L9.85714 15.6C9.14286 15.8783 8.57143 16.6435 8.57143 17.4783H7.14286C5.92857 17.4783 5 18.3826 5 19.5652ZM17.1429 20.2609V15.3913H18.5714V20.2609H17.1429ZM6.5 19.287C6.64286 19.0087 6.85714 18.8696 7.14286 18.8696H11C11.3571 18.8696 11.7857 18.8 12.1429 18.7304L13.7857 18.1739L13.3571 16.8522L11.6429 17.4087C11.4286 17.4087 10 17.4783 10 17.4783C10 17.2 10.1429 16.9913 10.4286 16.9217L14.5714 15.3913H15.7143V19.2174L10.7143 20.5391L6.5 19.287Z" })
  ] });
}

// src/components/Icon/icons/print.tsx
import { jsx as jsx127, jsxs as jsxs16 } from "react/jsx-runtime";
function PrintIcon(props) {
  return /* @__PURE__ */ jsxs16(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx127("path", { d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z" }),
    /* @__PURE__ */ jsx127("path", { d: "M18 12.5a1 1 0 100-2 1 1 0 000 2z" })
  ] });
}

// src/components/Icon/icons/property.tsx
import { jsx as jsx128, jsxs as jsxs17 } from "react/jsx-runtime";
function PropertyIcon(props) {
  return /* @__PURE__ */ jsxs17(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx128("path", { d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h6v-6h2v6h6v-8h3l-3-2.7zM17 18h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" }),
    /* @__PURE__ */ jsx128("path", { d: "M10 10h4c0-1.1-.9-2-2-2s-2 .9-2 2z" })
  ] });
}

// src/components/Icon/icons/publish.tsx
import { jsx as jsx129 } from "react/jsx-runtime";
function PublishIcon(props) {
  return /* @__PURE__ */ jsx129(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx129("path", { d: "M5 4h14v2H5V4zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z" }) });
}

// src/components/Icon/icons/questionAnswer.tsx
import { jsx as jsx130 } from "react/jsx-runtime";
function QuestionAnswerIcon(props) {
  return /* @__PURE__ */ jsx130(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx130("path", { d: "M15 4v7H5.17l-.59.59-.58.58V4h11zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z" }) });
}

// src/components/Icon/icons/receipt.tsx
import { jsx as jsx131 } from "react/jsx-runtime";
function ReceiptIcon(props) {
  return /* @__PURE__ */ jsx131(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx131("path", { d: "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6v-2zm0-4h12v2H6v-2zm0-4h12v2H6V7z" }) });
}

// src/components/Icon/icons/redo.tsx
import { jsx as jsx132 } from "react/jsx-runtime";
function RedoIcon(props) {
  return /* @__PURE__ */ jsx132(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx132("path", { d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" }) });
}

// src/components/Icon/icons/refresh.tsx
import { jsx as jsx133 } from "react/jsx-runtime";
function RefreshIcon(props) {
  return /* @__PURE__ */ jsx133(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx133("path", { d: "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" }) });
}

// src/components/Icon/icons/replay.tsx
import { jsx as jsx134 } from "react/jsx-runtime";
function ReplayIcon(props) {
  return /* @__PURE__ */ jsx134(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx134("path", { d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" }) });
}

// src/components/Icon/icons/search.tsx
import { jsx as jsx135 } from "react/jsx-runtime";
function SearchIcon(props) {
  return /* @__PURE__ */ jsx135(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx135("path", { d: "M9 2C5.146 2 2 5.146 2 9s3.146 7 7 7a6.958 6.958 0 004.574-1.719l.426.426V16l6 6 2-2-6-6h-1.293l-.426-.426A6.958 6.958 0 0016 9c0-3.854-3.146-7-7-7zm0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5z" }) });
}

// src/components/Icon/icons/settings.tsx
import { jsx as jsx136 } from "react/jsx-runtime";
function SettingsIcon(props) {
  return /* @__PURE__ */ jsx136(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx136("path", { d: "M9.666 2l-.451 2.477.014-.006.128-.041c-.05.012-.093.033-.142.047-.918.26-1.639.741-2.256 1.255l-.033.03h-.002l-2.389-.758-2.297 3.982 1.873 1.762.008-.045.01-.045C3.99 11.21 4 11.7 4 12c0 .3-.001.796.12 1.396l-.013-.064-1.882 1.66 2.328 4.035 2.39-.869.02.02.082.054c.643.429 1.388.856 2.162 1.188l.004.002L9.658 22h4.676l.451-2.477-.014.006-.128.041c.05-.012.093-.033.142-.047.918-.26 1.639-.741 2.256-1.255l.033-.03h.002l2.4.764 2.29-4.12-1.873-1.652-.012.067-.01.045C20.01 12.79 20 12.3 20 12c0-.3.01-.79-.129-1.342l.006.026 1.898-1.676-2.328-4.035-2.39.869-.02-.02-.082-.054a13.73 13.73 0 00-2.162-1.188l-.004-.002L14.342 2H9.666zm1.668 2h1.324l.352 2.021 1.02.407-.024-.008c.605.26 1.234.62 1.78.978l.757.76 2.01-.732.672 1.166-1.502 1.326.197 1.186.01.039c.062.247.07.557.07.857 0 .3-.008.61-.07.857l-.006.024-.217 1.088 1.527 1.35-.71 1.28-2-.636-.778.777c-.543.451-.983.738-1.588.889l-.066.017-1.076.43-.35 1.924h-1.324l-.352-2.021-1.02-.407.024.008c-.605-.26-1.234-.62-1.78-.978l-.757-.76-2.01.732-.672-1.166 1.518-1.34-.213-1.064C6 12.604 6 12.3 6 12c0-.3.008-.61.07-.857l.006-.024.213-1.066-1.527-1.44.703-1.217 2.012.641.777-.777c.543-.451.983-.738 1.588-.889l.066-.017 1.076-.43.35-1.924zM12 8c-1.25 0-2.315.505-2.998 1.273C8.319 10.043 8 11.028 8 12s.319 1.958 1.002 2.727C9.685 15.495 10.75 16 12 16c1.25 0 2.315-.505 2.998-1.273C15.681 13.957 16 12.972 16 12s-.319-1.958-1.002-2.727C14.315 8.505 13.25 8 12 8zm0 2c.75 0 1.185.245 1.502.602.317.356.498.87.498 1.398 0 .528-.181 1.042-.498 1.398-.317.357-.752.602-1.502.602s-1.185-.245-1.502-.602C10.181 13.042 10 12.528 10 12c0-.528.181-1.042.498-1.398.317-.357.752-.602 1.502-.602z" }) });
}

// src/components/Icon/icons/sms.tsx
import { jsx as jsx137 } from "react/jsx-runtime";
function SmsIcon(props) {
  return /* @__PURE__ */ jsx137(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx137("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7V9zm8 0h2v2h-2V9zm-4 0h2v2h-2V9z" }) });
}

// src/components/Icon/icons/star.tsx
import { jsx as jsx138 } from "react/jsx-runtime";
function StarIcon(props) {
  return /* @__PURE__ */ jsx138(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx138("path", { d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" }) });
}

// src/components/Icon/icons/starFilled.tsx
import { jsx as jsx139 } from "react/jsx-runtime";
function StarFilledIcon(props) {
  return /* @__PURE__ */ jsx139(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx139("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" }) });
}

// src/components/Icon/icons/starHalfFilled.tsx
import { jsx as jsx140 } from "react/jsx-runtime";
function StarHalfFilled(props) {
  return /* @__PURE__ */ jsx140(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx140("path", { d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" }) });
}

// src/components/Icon/icons/sync.tsx
import { jsx as jsx141 } from "react/jsx-runtime";
function SyncIcon(props) {
  return /* @__PURE__ */ jsx141(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx141("path", { d: "M12 0L8 4l4 4V5c3.859 0 7 3.14 7 7 0 .88-.17 1.72-.469 2.496l1.516 1.514A8.931 8.931 0 0021 12c0-4.962-4.037-9-9-9V0zM3.953 7.99A8.931 8.931 0 003 12c0 4.962 4.037 9 9 9v3l4-4-4-4v3c-3.859 0-7-3.14-7-7 0-.88.17-1.72.469-2.496L3.953 7.99z" }) });
}

// src/components/Icon/icons/thumbdown.tsx
import { jsx as jsx142 } from "react/jsx-runtime";
function ThumbDownIcon(props) {
  return /* @__PURE__ */ jsx142(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx142("path", { d: "m10.89 18.28.57-2.89c.12-.59-.04-1.2-.42-1.66-.38-.46-.94-.73-1.54-.73H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84l-4.11 4.1M10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z" }) });
}

// src/components/Icon/icons/thumbdownFilled.tsx
import { jsx as jsx143 } from "react/jsx-runtime";
function ThumbDownFilledIcon(props) {
  return /* @__PURE__ */ jsx143(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx143("path", { d: "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z" }) });
}

// src/components/Icon/icons/thumbup.tsx
import { jsx as jsx144 } from "react/jsx-runtime";
function ThumbUpIcon(props) {
  return /* @__PURE__ */ jsx144(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx144("path", { d: "m13.11 5.72-.57 2.89c-.12.59.04 1.2.42 1.66.38.46.94.73 1.54.73H20v1.08L17.43 18H9.34c-.18 0-.34-.16-.34-.34V9.82l4.11-4.1M14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z" }) });
}

// src/components/Icon/icons/thumbupFilled.tsx
import { jsx as jsx145 } from "react/jsx-runtime";
function ThumbUpFilledIcon(props) {
  return /* @__PURE__ */ jsx145(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx145("path", { d: "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84C7 18.95 8.05 20 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z" }) });
}

// src/components/Icon/icons/time.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
function TimeIcon(props) {
  return /* @__PURE__ */ jsx146(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx146("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" }) });
}

// src/components/Icon/icons/tingrett.tsx
import { jsx as jsx147 } from "react/jsx-runtime";
function TingrettIcon(props) {
  return /* @__PURE__ */ jsx147(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx147("path", { d: "M12 16.615c4.418 0 8-3.857 8-8.615H4c0 4.758 3.582 8.615 8 8.615z" }) });
}

// src/components/Icon/icons/tip.tsx
import { jsx as jsx148 } from "react/jsx-runtime";
function TipIcon(props) {
  return /* @__PURE__ */ jsx148(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx148("path", { d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z" }) });
}

// src/components/Icon/icons/trash.tsx
import { jsx as jsx149 } from "react/jsx-runtime";
function TrashIcon(props) {
  return /* @__PURE__ */ jsx149(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx149("path", { d: "M16 9v10H8V9h8zm-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z" }) });
}

// src/components/Icon/icons/undo.tsx
import { jsx as jsx150 } from "react/jsx-runtime";
function UndoIcon(props) {
  return /* @__PURE__ */ jsx150(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx150("path", { d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" }) });
}

// src/components/Icon/icons/unfoldLess.tsx
import { jsx as jsx151 } from "react/jsx-runtime";
function UnfoldLessIcon(props) {
  return /* @__PURE__ */ jsx151(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx151("path", { d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z" }) });
}

// src/components/Icon/icons/unfoldMore.tsx
import { jsx as jsx152 } from "react/jsx-runtime";
function UnfoldMoreIcon(props) {
  return /* @__PURE__ */ jsx152(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx152("path", { d: "M11.59 18.17L8.42 15l-1.41 1.41L11.59 21l4.59-4.59L14.76 15l-3.17 3.17zm0-12.34L14.76 9l1.41-1.41L11.59 3 7 7.59 8.42 9l3.17-3.17z" }) });
}

// src/components/Icon/icons/upload.tsx
import { jsx as jsx153 } from "react/jsx-runtime";
function UploadIcon(props) {
  return /* @__PURE__ */ jsx153(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx153("path", { d: "M9 16h6v-6h4l-7-7-7 7h4v6zm2-2V8H9.828L12 5.828 14.172 8H13v6h-2zm-6 4h14v2H5v-2z" }) });
}

// src/components/Icon/icons/visibilityOff.tsx
import { jsx as jsx154 } from "react/jsx-runtime";
function VisibilityOffIcon(props) {
  return /* @__PURE__ */ jsx154(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx154("path", { d: "M12 6a9.77 9.77 0 018.82 5.5 9.648 9.648 0 01-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.04 7.841 1.766 9.55 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 01-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 00-.36 1.78 4.507 4.507 0 006.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 01-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z" }) });
}

// src/components/Icon/icons/visibilityOn.tsx
import { jsx as jsx155 } from "react/jsx-runtime";
function VisibilityOnIcon(props) {
  return /* @__PURE__ */ jsx155(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx155("path", { d: "M12 6a9.77 9.77 0 018.82 5.5A9.77 9.77 0 0112 17a9.77 9.77 0 01-8.82-5.5A9.77 9.77 0 0112 6zm0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" }) });
}

// src/components/Icon/icons/warning.tsx
import { jsx as jsx156, jsxs as jsxs18 } from "react/jsx-runtime";
function WarningIcon(props) {
  return /* @__PURE__ */ jsxs18(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx156("path", { d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z" }),
    /* @__PURE__ */ jsx156("path", { d: "M12 17a1 1 0 100-2 1 1 0 000 2zM11 7h2v7h-2V7z" })
  ] });
}

// src/components/Icon/icons/webex.tsx
import { jsx as jsx157, jsxs as jsxs19 } from "react/jsx-runtime";
function WebexIcon(props) {
  return /* @__PURE__ */ jsxs19(SvgWrapper, { ...props, children: [
    /* @__PURE__ */ jsx157("path", { d: "M7.16445 3.02741C5.37251 3.2006 4.00929 4.54287 3.55167 5.19235C5.71934 5.89286 5.1413 9.08924 5.71934 10.6047C6.00836 9.73873 6.65866 7.71812 7.67024 7.71812C10.3525 7.71812 9.18761 21.2516 16.3409 20.9964C22.4104 20.7799 24 10.0274 24 8.00678C24 5.83103 21.8323 5.6975 21.8323 5.6975C21.8323 5.6975 23.2325 7.80594 22.5 9.73872C21.7039 11.8393 19.3034 11.615 18.9421 11.3985C18.5086 13.1305 17.5693 16.3057 16.3409 16.3057C14.5 16.3057 14.1251 8.65625 12.1501 5.6975C10.9458 3.89338 9.40437 2.81091 7.16445 3.02741Z" }),
    /* @__PURE__ */ jsx157("path", { d: "M16.2687 3.0274C14.1732 3.18241 12.9449 4.20609 12.3669 4.83152C14 6.5 14.679 10.6047 14.679 10.6047C14.8958 9.30573 15.4714 7.64595 16.2687 7.64595C17.0659 7.64595 17.3525 8.00677 18.0028 9.73872C18.5644 11.2344 22.6151 11.0722 21.9046 7.79027C21.3265 5.12018 18.6531 2.851 16.2687 3.0274Z" }),
    /* @__PURE__ */ jsx157("path", { d: "M8.03151 20.9243C9.91016 20.9243 11.4998 19.1923 11.4998 19.1923C9.98242 16.883 9.33212 13.6356 9.33212 13.6356C9.33212 13.6356 8.75685 16.3057 7.81475 16.3057C5.93611 16.3057 4.82819 10.4844 4.34648 7.35728C4.12972 6.41914 3.306 5.42327 1.74528 5.76966C0.184558 6.11605 -0.0611107 7.54972 0.0111449 8.22326C0.251997 10.6288 0.950471 15.0068 3.04588 18.2542C4.62908 20.7078 6.36963 20.9243 8.03151 20.9243Z" })
  ] });
}

// src/components/Icon/icons/x.tsx
import { jsx as jsx158 } from "react/jsx-runtime";
function XIcon(props) {
  return /* @__PURE__ */ jsx158(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx158("path", { d: "M17.7508 3H20.8175L14.1175 10.6583L22 21.0775H15.8283L10.995 14.7575L5.46333 21.0775H2.395L9.56167 12.8858L2 3.00083H8.32833L12.6975 8.7775L17.7508 3ZM16.675 19.2425H18.3742L7.405 4.73917H5.58167L16.675 19.2425Z" }) });
}

// src/components/Icon/icons/zoomIn.tsx
import { jsx as jsx159 } from "react/jsx-runtime";
function ZoomInIcon(props) {
  return /* @__PURE__ */ jsx159(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx159("path", { d: "M15.5 14h-.79l-.28-.27A6.47 6.47 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2V7z" }) });
}

// src/components/Icon/icons/zoomOut.tsx
import { jsx as jsx160 } from "react/jsx-runtime";
function ZoomOutIcon(props) {
  return /* @__PURE__ */ jsx160(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx160("path", { d: "M15.5 14h-.79l-.28-.27A6.47 6.47 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7V9z" }) });
}

// src/components/Icon/icons/barChart.tsx
import { jsx as jsx161 } from "react/jsx-runtime";
function BarChartIcon(props) {
  return /* @__PURE__ */ jsx161(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx161("path", { d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z" }) });
}

// src/components/Icon/icons/barChartBoxed.tsx
import { jsx as jsx162 } from "react/jsx-runtime";
function BarChartBoxedIcon(props) {
  return /* @__PURE__ */ jsx162(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx162("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7v-7zm4-3h2v10h-2V7zm4 6h2v4h-2v-4z" }) });
}

// src/components/Icon/icons/lineChart.tsx
import { jsx as jsx163 } from "react/jsx-runtime";
function LineChartIcon(props) {
  return /* @__PURE__ */ jsx163(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx163("path", { d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z" }) });
}

// src/components/Icon/icons/trendingUp.tsx
import { jsx as jsx164 } from "react/jsx-runtime";
function TrendingUpIcon(props) {
  return /* @__PURE__ */ jsx164(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx164("path", { d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z" }) });
}

// src/components/Icon/icons/trendingDown.tsx
import { jsx as jsx165 } from "react/jsx-runtime";
function TrendingDownIcon(props) {
  return /* @__PURE__ */ jsx165(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx165("path", { d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z" }) });
}

// src/components/Icon/icons/libraryAdd.tsx
import { jsx as jsx166 } from "react/jsx-runtime";
function LibraryAddIcon(props) {
  return /* @__PURE__ */ jsx166(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx166("path", { d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3v3z" }) });
}

// src/components/Icon/icons/helpSimple.tsx
import { jsx as jsx167 } from "react/jsx-runtime";
function HelpSimpleIcon(props) {
  return /* @__PURE__ */ jsx167(SvgWrapper, { ...props, children: /* @__PURE__ */ jsx167("path", { d: "M13.25 21H10.75V18.5714H13.25V21ZM15.8375 11.5893L14.7125 12.7064C13.8125 13.5929 13.25 14.3214 13.25 16.1429H10.75V15.5357C10.75 14.2 11.3125 12.9857 12.2125 12.0993L13.7625 10.5693C14.225 10.1321 14.5 9.525 14.5 8.85714C14.5 7.52143 13.375 6.42857 12 6.42857C10.625 6.42857 9.5 7.52143 9.5 8.85714H7C7 6.17357 9.2375 4 12 4C14.7625 4 17 6.17357 17 8.85714C17 9.92571 16.55 10.8971 15.8375 11.5893Z" }) });
}

// src/components/Typography/Typography/Typography.tsx
import { jsx as jsx168, jsxs as jsxs20 } from "react/jsx-runtime";
var isAnchorProps = (props) => props.typographyType === "a";
var Typography = (props) => {
  const {
    typographyType = "bodyMedium",
    as: propAs,
    children,
    bold,
    underline,
    italic,
    style,
    id,
    withMargins,
    color,
    className,
    htmlProps = {},
    ...rest
  } = props;
  const { style: htmlPropsStyle, ...restHtmlProps } = htmlProps;
  const as = propAs ? propAs : getElementType(typographyType);
  const typographyCn = getTypographyCn(typographyType);
  let relProp;
  let targetProp;
  let externalLinkProp;
  if (isAnchorProps(props)) {
    const { externalLink, target } = props;
    relProp = as === "a" ? "noopener noreferer" : void 0;
    targetProp = as !== "a" ? void 0 : externalLink ? "_blank" : target;
    externalLinkProp = as === "a" && externalLink ? externalLink : void 0;
  }
  return /* @__PURE__ */ jsxs20(
    ElementAs,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Typography_default.container,
          externalLinkProp && typographyStyles_default["a--external"],
          typographyStyles_default[typographyCn],
          withMargins && typographyStyles_default[`${typographyCn}--margins`],
          isLegend(as) && typographyStyles_default.legend,
          isCaption(as) && withMargins && typographyStyles_default["caption--withMargins"],
          bold && typographyStyles_default.bold,
          underline && typographyStyles_default.underline,
          italic && typographyStyles_default.italic,
          as === "a" && focusable
        ),
        restHtmlProps,
        rest
      ),
      as,
      style: {
        ...htmlPropsStyle,
        ...style,
        color: color && getTextColor(color)
      },
      rel: relProp,
      target: targetProp,
      children: [
        children,
        externalLinkProp && /* @__PURE__ */ jsx168(Icon, { icon: OpenExternalIcon, iconSize: "inherit" })
      ]
    }
  );
};
Typography.displayName = "Typography";

// src/components/Typography/Caption/Caption.tsx
import { jsx as jsx169 } from "react/jsx-runtime";
var Caption = ({
  id,
  className,
  htmlProps,
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsx169(
    Typography,
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      typographyType: "headingLarge",
      as: "caption",
      children
    }
  );
};
Caption.displayName = "Caption";

// src/components/Typography/Heading/Heading.tsx
import { jsx as jsx170 } from "react/jsx-runtime";
var getHeadingElement = (level) => `h${level}`;
var getDefaultTypographyType = (h) => {
  switch (h) {
    case "h1":
      return "headingXlarge";
    case "h2":
      return "headingLarge";
    case "h3":
      return "headingMedium";
    case "h4":
      return "headingSmall";
    case "h5":
      return "headingXsmall";
    case "h6":
      return "headingXxsmall";
    default:
      return "headingXlarge";
  }
};
var Heading = ({
  id,
  className,
  htmlProps,
  children,
  typographyType,
  level,
  ...rest
}) => {
  const headingElement = getHeadingElement(level);
  const standardTypographyType = typographyType != null ? typographyType : getDefaultTypographyType(headingElement);
  return /* @__PURE__ */ jsx170(
    Typography,
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      typographyType: standardTypographyType,
      as: headingElement,
      children
    }
  );
};
Heading.displayName = "Heading";

// src/components/Typography/Label/Label.module.css
var Label_default = {
  "read-only": "Label_read-only",
  "read-only__icon": "Label_read-only__icon"
};

// src/components/Typography/Label/Label.tsx
import { jsx as jsx171, jsxs as jsxs21 } from "react/jsx-runtime";
var Label = ({
  showRequiredStyling,
  readOnly,
  id,
  className,
  htmlProps,
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs21(
    Typography,
    {
      ...getBaseHTMLProps(
        id,
        cn(className, readOnly && Label_default["read-only"]),
        htmlProps,
        rest
      ),
      typographyType: "labelMedium",
      children: [
        readOnly && /* @__PURE__ */ jsx171(
          Icon,
          {
            icon: LockIcon,
            iconSize: "small",
            className: Label_default["read-only__icon"]
          }
        ),
        children,
        showRequiredStyling && /* @__PURE__ */ jsx171(RequiredMarker, {})
      ]
    }
  );
};
Label.displayName = "Label";

// src/components/Typography/Legend/Legend.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
var Legend = ({
  id,
  className,
  htmlProps,
  typographyType = "headingLarge",
  ...rest
}) => {
  return /* @__PURE__ */ jsx172(
    Typography,
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      as: "legend",
      typographyType
    }
  );
};
Legend.displayName = "Legend";

// src/components/Typography/Link/Link.tsx
import { jsx as jsx173, jsxs as jsxs22 } from "react/jsx-runtime";
var Link = ({
  id,
  className,
  htmlProps,
  children,
  typographyType,
  withMargins,
  withVisited,
  external,
  target,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs22(
    "a",
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          typographyStyles_default.a,
          external && typographyStyles_default["a--external"],
          withVisited && typographyStyles_default["a--visited"],
          typographyType && typographyStyles_default[getTypographyCn(typographyType)],
          typographyType && withMargins && typographyStyles_default[`${getTypographyCn(typographyType)}--margins`],
          focusable
        ),
        htmlProps,
        rest
      ),
      ...rest,
      rel: "noopener noreferer",
      target: external ? "_blank" : target,
      children: [
        children,
        external && /* @__PURE__ */ jsx173(Icon, { iconSize: "inherit", icon: OpenExternalIcon })
      ]
    }
  );
};
Link.displayName = "Link";

// src/components/Typography/Paragraph/Paragraph.tsx
import { jsx as jsx174 } from "react/jsx-runtime";
var Paragraph = ({
  id,
  className,
  htmlProps,
  children,
  typographyType = "bodyMedium",
  ...rest
}) => {
  return /* @__PURE__ */ jsx174(
    Typography,
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      typographyType,
      children
    }
  );
};
Paragraph.displayName = "Paragraph";

// src/components/helpers/Input/CharCounter.tsx
import { jsx as jsx175, jsxs as jsxs23 } from "react/jsx-runtime";
function CharCounter(props) {
  const { current, max, id, className, htmlProps, ...rest } = props;
  const generatedId = useId();
  const uniqueId = id != null ? id : `${generatedId}-characterCounter`;
  return /* @__PURE__ */ jsxs23(
    Typography,
    {
      ...getBaseHTMLProps(
        uniqueId,
        cn(className, Input_default["char-counter"]),
        htmlProps,
        rest
      ),
      as: "div",
      typographyType: "bodyXsmall",
      color: "textSubtle",
      "aria-label": `${current} av ${max} tegn skrevet`,
      children: [
        current,
        "/",
        max
      ]
    }
  );
}
var renderCharCounter = (id, isShown, textLength, maxLength) => {
  if (!!maxLength && Number.isInteger(maxLength) && maxLength > 0 && isShown)
    return /* @__PURE__ */ jsx175(CharCounter, { id, max: maxLength, current: textLength });
};

// src/components/helpers/Input/Input.utils.tsx
function getDefaultText(value, defaultValue) {
  if (typeof value === "string") {
    return value;
  }
  if (typeof defaultValue === "string") {
    return defaultValue;
  }
  return "";
}
function getInputWidth(width, defaultW) {
  return width ? width : defaultW ? defaultW : "var(--dds-input-default-width)";
}

// src/hooks/useCombinedRefs.tsx
import { useCallback } from "react";
function useCombinedRef(...refs) {
  return useCallback((element) => {
    refs.filter(Boolean).forEach((ref) => {
      if (typeof ref === "function") ref(element);
      else if (ref && typeof ref === "object")
        ref.current = element;
    });
  }, refs);
}

// src/hooks/useFloatPosition.tsx
import {
  arrow,
  autoUpdate,
  flip,
  offset as floatingOffset,
  shift,
  useFloating
} from "@floating-ui/react-dom";
var defaultOffset = 8;
var useFloatPosition = (arrowRef, options = {}) => {
  const {
    animationFrame = true,
    offset = defaultOffset,
    placement = "bottom"
  } = options;
  const middleware = [
    floatingOffset(offset),
    flip(),
    shift(),
    // Only add arrow(...) if arrowRef is set
    ...arrowRef ? [arrow({ element: arrowRef })] : []
  ];
  const {
    x,
    y,
    strategy,
    middlewareData,
    placement: actualPlacement,
    refs
  } = useFloating({
    placement,
    middleware,
    whileElementsMounted: (reference, floating, update) => autoUpdate(reference, floating, update, { animationFrame })
  });
  return {
    refs,
    styles: {
      floating: {
        position: strategy,
        top: y != null ? y : "",
        left: x != null ? x : ""
      },
      arrow: middlewareData.arrow ? getArrowStyling(strategy, actualPlacement, middlewareData.arrow) : void 0
    }
  };
};
function getArrowStyling(strategy, placement, arrow2) {
  var _a, _b;
  const arrowPlacement = placementToArrowPlacement(placement);
  const arrowPlacementOffset = {
    top: "-15px",
    bottom: "-15px",
    right: "-21px",
    left: "-21px"
  }[arrowPlacement];
  const rotateArrow = {
    top: "rotate(180deg)",
    right: "rotate(-90deg)",
    bottom: "",
    left: "rotate(90deg)"
  }[arrowPlacement];
  return {
    position: strategy,
    top: (_a = arrow2 == null ? void 0 : arrow2.y) != null ? _a : "",
    left: (_b = arrow2 == null ? void 0 : arrow2.x) != null ? _b : "",
    [arrowPlacement]: arrowPlacementOffset,
    transform: rotateArrow
  };
}
function placementToArrowPlacement(placement) {
  switch (placement) {
    case "top":
    case "top-start":
    case "top-end":
      return "bottom";
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      return "top";
    case "left":
    case "left-start":
    case "left-end":
      return "right";
    case "right":
    case "right-start":
    case "right-end":
      return "left";
  }
}

// src/hooks/useFocusTrap.tsx
import { useEffect as useEffect2, useRef } from "react";
function useFocusTrap(active, initialFocusRef = void 0) {
  const elementRef = useRef(null);
  useEffect2(() => {
    function handleFocus(e) {
      if (e.key !== "Tab" || !active || !elementRef.current) return;
      const focusableElements = getFocusableElements(elementRef);
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
      if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      }
    }
    const element = elementRef.current;
    if (element && active) {
      if (initialFocusRef == null ? void 0 : initialFocusRef.current) {
        initialFocusRef.current.focus();
      } else {
        element.focus();
        element.addEventListener("keydown", handleFocus);
      }
    }
    return () => {
      element == null ? void 0 : element.removeEventListener("keydown", handleFocus);
    };
  }, [active]);
  return elementRef;
}

// src/hooks/useIsMounted.ts
import { useCallback as useCallback2, useEffect as useEffect3, useRef as useRef2 } from "react";
var useIsMounted = () => {
  const isMounted = useRef2(false);
  useEffect3(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return useCallback2(() => isMounted.current, []);
};

// src/hooks/useMountTransition.tsx
import { useEffect as useEffect4, useState as useState2 } from "react";
var useMountTransition = (isMounted, unmountDelay) => {
  const [hasTransitionedIn, setHasTransitionedIn] = useState2(false);
  useEffect4(() => {
    let timeoutId;
    if (isMounted && !hasTransitionedIn) setHasTransitionedIn(true);
    else if (!isMounted && hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(false), unmountDelay);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [unmountDelay, isMounted, hasTransitionedIn]);
  return hasTransitionedIn;
};

// src/hooks/useOnClickOutside.tsx
import { useEffect as useEffect5 } from "react";
function useOnClickOutside(element, handler) {
  useEffect5(() => {
    const listener = (event) => {
      const elements = Array.isArray(element) ? element : [element].filter(Boolean);
      const hasClickedInside = elements.some(
        (el) => el == null ? void 0 : el.contains(event.target)
      );
      const clickedOnSomethingInDocument = document.contains(
        event.target
      );
      if (hasClickedInside || !clickedOnSomethingInDocument) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [element, handler]);
}

// src/hooks/useOnKeyDown.tsx
import { useEffect as useEffect6 } from "react";
var useOnKeyDown = (key, handler) => {
  useEffect6(() => {
    const listener = (event) => {
      const keys = Array.isArray(key) ? key : [key];
      if (keys.indexOf(event.key) !== -1) {
        handler(event);
      }
    };
    document.addEventListener("keydown", listener, true);
    return () => {
      document.removeEventListener("keydown", listener, true);
    };
  }, [handler]);
};

// src/hooks/useReturnFocusOnBlur.ts
import { useEffect as useEffect7, useRef as useRef3 } from "react";
function useReturnFocusOnBlur(active, onBlur, triggerElement) {
  const elementRef = useRef3(null);
  useEffect7(() => {
    function handleFocus(e) {
      if (e.key !== "Tab" || !active || !elementRef.current || !triggerElement)
        return;
      const focusableElements = getFocusableElements(elementRef);
      const lastElement = focusableElements[focusableElements.length - 1];
      const firstElement = focusableElements[0];
      if (!e.shiftKey && document.activeElement === lastElement || e.shiftKey && document.activeElement === firstElement || e.shiftKey && document.activeElement === element) {
        triggerElement.focus();
        e.preventDefault();
        onBlur();
      }
    }
    const element = elementRef.current;
    if (element && active) {
      element.focus();
      element.addEventListener("keydown", handleFocus);
    }
    return () => {
      element == null ? void 0 : element.removeEventListener("keydown", handleFocus);
    };
  }, [active]);
  return elementRef;
}

// src/hooks/useRoveFocus.tsx
import {
  useCallback as useCallback3,
  useEffect as useEffect8,
  useState as useState3
} from "react";
var isKeyboardEvent = (e) => e.key !== void 0;
function useRoveFocus(size2, active, direction = "column", noWrap) {
  const [currentFocusIndex, setCurrentFocusIndex] = useState3(-1);
  const nextKey = direction === "row" ? "ArrowRight" : "ArrowDown";
  const previousKey = direction === "row" ? "ArrowLeft" : "ArrowUp";
  const handleKeyDown = useCallback3(
    (e) => {
      if (!size2 || !isKeyboardEvent(e)) return;
      if (e.key === nextKey) {
        e.preventDefault();
        setCurrentFocusIndex((prev) => {
          if (prev === size2 - 1) return noWrap ? prev : 0;
          return prev + 1;
        });
      } else if (e.key === previousKey) {
        e.preventDefault();
        setCurrentFocusIndex((prev) => {
          if (prev === -1 || prev === 0) return noWrap ? prev : size2 - 1;
          return prev - 1;
        });
      }
    },
    [size2, setCurrentFocusIndex, direction, noWrap]
  );
  useEffect8(() => {
    if (!active) {
      setCurrentFocusIndex(-1);
      return;
    }
    document.addEventListener("keydown", handleKeyDown, false);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, false);
    };
  }, [handleKeyDown, active]);
  return [currentFocusIndex, setCurrentFocusIndex];
}

// src/hooks/useScreenSize.tsx
import { useEffect as useEffect9, useState as useState4 } from "react";
var ScreenSize = /* @__PURE__ */ ((ScreenSize2) => {
  ScreenSize2[ScreenSize2["XSmall"] = 0] = "XSmall";
  ScreenSize2[ScreenSize2["Small"] = 1] = "Small";
  ScreenSize2[ScreenSize2["Medium"] = 2] = "Medium";
  ScreenSize2[ScreenSize2["Large"] = 3] = "Large";
  ScreenSize2[ScreenSize2["XLarge"] = 4] = "XLarge";
  return ScreenSize2;
})(ScreenSize || {});
var screenSizesAndMediaQueries = [
  [
    4 /* XLarge */,
    /** var(--dds-breakpoint-xl) */
    `only screen and (min-width: 1920px)`
  ],
  [
    3 /* Large */,
    /** var(--dds-breakpoint-lg) */
    `only screen and (min-width: 1280px)`
  ],
  [
    2 /* Medium */,
    /** var(--dds-breakpoint-md) */
    `only screen and (min-width: 960px)`
  ],
  [
    1 /* Small */,
    /** var(--dds-breakpoint-sm) */
    `only screen and (min-width: 600px)`
  ],
  [
    0 /* XSmall */,
    /** var(--dds-breakpoint-xs) */
    `only screen and (min-width: 1px)`
  ]
];
var useScreenSize = function() {
  const [screenSize, setScreenSize] = useState4(3 /* Large */);
  useEffect9(() => {
    function listener() {
      for (const [screenSize2, mediaQuery] of screenSizesAndMediaQueries) {
        if (window.matchMedia(mediaQuery).matches) {
          setScreenSize(screenSize2);
          return;
        }
      }
    }
    listener();
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, []);
  return screenSize;
};

// src/hooks/useWindowResize.tsx
import { useEffect as useEffect10 } from "react";
var useWindowResize = (handler) => {
  useEffect10(() => {
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [handler]);
};

// src/components/helpers/ScreenSize/ScreenSize.utils.tsx
var getLiteralScreenSize = (screenSize) => {
  switch (screenSize) {
    case 4 /* XLarge */:
      return "xl";
    case 3 /* Large */:
      return "lg";
    case 2 /* Medium */:
      return "md";
    case 1 /* Small */:
      return "sm";
    case 0 /* XSmall */:
      return "xs";
  }
};

// src/components/helpers/StylelessList/StylelessList.tsx
import { jsx as jsx176 } from "react/jsx-runtime";
var StylelessList = ({ className, ...rest }) => /* @__PURE__ */ jsx176("ul", { ...rest, className: cn(className, utilStyles_default["remove-list-styling"]) });
var StylelessOList = ({ className, ...rest }) => /* @__PURE__ */ jsx176("ol", { ...rest, className: cn(className, utilStyles_default["remove-list-styling"]) });

// src/components/helpers/styling/utils.ts
var outlineOffset = "var(--dds-spacing-x0-125)";
var outlineInset = "calc(var(--dds-spacing-x0-125) * -1)";
var focusVisible = {
  outline: "var(--dds-color-focus-outside) 2px solid",
  outlineOffset,
  boxShadow: "0 0 0 2px var(--dds-color-focus-inside)"
};
var focusVisibleTransitionValue = "outline-offset 0.2s";
var focusVisibleInset = {
  outline: "var(--dds-color-focus-outside) 2px solid",
  outlineOffset: outlineInset
};
var scrollbarWidth = "thin";
var scrollbarStyling = {
  scrollbarColor: "var(--dds-color-surface-scrollbar) transparent",
  scrollbarWidth,
  /* Safari styling. TODO: fjernes når scrollbar styling blir standardisert */
  /* width */
  "&::-webkit-scrollbar": {
    width: "var(--dds-spacing-x0-5)",
    height: "var(--dds-spacing-x0-5)"
  },
  /* Track */
  "&::-webkit-scrollbar-track": {
    background: "transparent"
  },
  /* Handle */
  "&::-webkit-scrollbar-thumb": {
    background: "var(--dds-color-surface-scrollbar)"
  }
};
var visibilityTransition = (open) => {
  return `
      @media (prefers-reduced-motion: no-preference) {
        transition:
          visibility 0.4s,
          opacity 0.2s;
      }
      visibility: ${open ? "visible" : "hidden"};
      opacity: ${open ? 1 : 0};
    `;
};
var hideInput = {
  clip: "rect(0 0 0 0)",
  position: "absolute",
  height: "1px",
  width: "1px",
  margin: 0
};
var inheritLinkStyling = {
  color: "inherit",
  textDecoration: "inherit"
};
var removeButtonStyling = {
  background: "none",
  color: "inherit",
  border: "none",
  padding: 0,
  font: "inherit",
  cursor: "pointer",
  outline: "inherit"
};
var removeListStyling = {
  listStyle: "none",
  padding: 0,
  margin: 0
};
var normalizeButton = {
  margin: 0,
  textTransform: "none"
};

// src/components/layout/common/layout.module.css
var layout_default = {
  "dds-p": "layout_dds-p",
  "dds-p-i": "layout_dds-p-i",
  "dds-p-b": "layout_dds-p-b",
  "dds-m": "layout_dds-m",
  "dds-m-i": "layout_dds-m-i",
  "dds-m-b": "layout_dds-m-b",
  "dds-h": "layout_dds-h",
  "dds-max-h": "layout_dds-max-h",
  "dds-min-h": "layout_dds-min-h",
  "dds-w": "layout_dds-w",
  "dds-max-w": "layout_dds-max-w",
  "dds-min-w": "layout_dds-min-w",
  "dds-pos": "layout_dds-pos",
  "dds-l": "layout_dds-l",
  "dds-r": "layout_dds-r",
  "dds-t": "layout_dds-t",
  "dds-b": "layout_dds-b",
  "dds-o": "layout_dds-o",
  "dds-o-x": "layout_dds-o-x",
  "dds-o-y": "layout_dds-o-y",
  "dds-display": "layout_dds-display",
  "dds-text-align": "layout_dds-text-align",
  "dds-flex-dir": "layout_dds-flex-dir",
  "dds-gap": "layout_dds-gap",
  "dds-c-gap": "layout_dds-c-gap",
  "dds-r-gap": "layout_dds-r-gap",
  "dds-a-i": "layout_dds-a-i",
  "dds-a-c": "layout_dds-a-c",
  "dds-j-i": "layout_dds-j-i",
  "dds-j-c": "layout_dds-j-c",
  "dds-wrap": "layout_dds-wrap",
  "dds-basis": "layout_dds-basis",
  "dds-flow": "layout_dds-flow"
};

// src/components/layout/common/Responsive.types.tsx
var BREAKPOINTS = ["xs", "sm", "md", "lg", "xl"];
var SPACING_SCALES = [
  "x0",
  "x0.125",
  "x0.25",
  "x0.5",
  "x0.75",
  "x1",
  "x1.5",
  "x2",
  "x2.5",
  "x3",
  "x4",
  "x6",
  "x10"
];

// src/components/layout/common/utils.tsx
function isBreakpointObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
var isSpacingScale = (value) => {
  return typeof value === "string" && SPACING_SCALES.includes(value);
};
var isRelativeGridColumn = (type) => {
  return type === "all" || type === "firstHalf" || type === "secondHalf";
};
function spacingPropToToken(value) {
  return value.replace(/\./g, "-");
}
var getSpacingToken = (v) => `var(--dds-spacing-${spacingPropToToken(v)})`;
var getColorToken = (v) => `var(--dds-color-${v})`;
var relativeGridColumnToken = (v, bp) => {
  if (v === "all") return "1 / -1";
  if (!bp) return "";
  return v === "firstHalf" ? `1 / calc(var(--dds-grid-${bp}-count) / 2 + 1)` : `calc(var(--dds-grid-${bp}-count) / 2 + 1) / -1`;
};
var getValue = (v, bp) => {
  if (isPaperBackground(v) || isBorderColor(v)) return getColorToken(v);
  if (isSpacingScale(v)) return getSpacingToken(v);
  if (isRelativeGridColumn(v)) return relativeGridColumnToken(v, bp);
  return v;
};
var convertMultiValue = (value, bp) => value.split(" ").map((v) => getValue(v, bp)).join(" ");
function getResponsiveCSSProperties(property, prefix2, suffix) {
  if (!property) return;
  const properties = {};
  const pPrefix = `--dds-${prefix2}`;
  const pSuffix = suffix ? `-${suffix}` : "";
  if (isBreakpointObject(property)) {
    BREAKPOINTS.forEach((bp) => {
      if (property[bp]) {
        properties[`${pPrefix}-${bp}${pSuffix}`] = convertMultiValue(property[bp].toString(), bp);
      }
    });
  } else {
    properties[`${pPrefix}${pSuffix}`] = convertMultiValue(property.toString());
  }
  return properties;
}
function applyResponsiveStyle(p, bp, largeScreenP) {
  if (!bp) return largeScreenP;
  const bpIndex = BREAKPOINTS.indexOf(bp);
  return BREAKPOINTS.reduce((acc, curr, index) => {
    return { ...acc, [curr]: index <= bpIndex ? p : largeScreenP };
  }, {});
}

// src/components/layout/common/display.module.css
var display_default = {
  "xs-hide-below": "display_xs-hide-below",
  "sm-hide-below": "display_sm-hide-below",
  "md-hide-below": "display_md-hide-below",
  "lg-hide-below": "display_lg-hide-below",
  "xl-hide-below": "display_xl-hide-below",
  "xs-hide-above": "display_xs-hide-above",
  "sm-hide-above": "display_sm-hide-above",
  "md-hide-above": "display_md-hide-above",
  "lg-hide-above": "display_lg-hide-above"
};

// src/components/layout/ShowHide/ShowHide.tsx
import { jsx as jsx177 } from "react/jsx-runtime";
var ShowHide = ({
  hideBelow,
  showBelow,
  className,
  htmlProps,
  id,
  ...rest
}) => /* @__PURE__ */ jsx177(
  ElementAs,
  {
    ...getBaseHTMLProps(
      id,
      cn(
        className,
        hideBelow && display_default[`${hideBelow}-hide-below`],
        showBelow && showBelow !== "xl" && display_default[`${showBelow}-hide-above`]
      ),
      htmlProps,
      rest
    )
  }
);
ShowHide.displayName = "ShowHide";

// src/components/layout/Box/Box.tsx
import { jsx as jsx178 } from "react/jsx-runtime";
var Box = ({
  id,
  className,
  style,
  padding,
  paddingInline,
  paddingBlock,
  margin,
  marginInline,
  marginBlock,
  height,
  maxHeight,
  minHeight,
  width,
  maxWidth,
  minWidth,
  position,
  left,
  right,
  bottom,
  top,
  overflow,
  overflowX,
  overflowY,
  display,
  textAlign,
  flexDirection,
  gap,
  columnGap,
  rowGap,
  alignItems,
  alignContent,
  justifyItems,
  justifyContent,
  flexWrap,
  flexBasis,
  flexFlow,
  htmlProps,
  ...rest
}) => {
  const responsiveStyles = {
    ...getResponsiveCSSProperties(padding, "r", "p"),
    ...getResponsiveCSSProperties(paddingInline, "r", "p-i"),
    ...getResponsiveCSSProperties(paddingBlock, "r", "p-b"),
    ...getResponsiveCSSProperties(margin, "r", "m"),
    ...getResponsiveCSSProperties(marginInline, "r", "m-i"),
    ...getResponsiveCSSProperties(marginBlock, "r", "m-b"),
    ...getResponsiveCSSProperties(height, "r", "h"),
    ...getResponsiveCSSProperties(maxHeight, "r", "max-h"),
    ...getResponsiveCSSProperties(minHeight, "r", "min-h"),
    ...getResponsiveCSSProperties(width, "r", "w"),
    ...getResponsiveCSSProperties(maxWidth, "r", "max-w"),
    ...getResponsiveCSSProperties(minWidth, "r", "min-w"),
    ...getResponsiveCSSProperties(position, "r", "pos"),
    ...getResponsiveCSSProperties(left, "r", "l"),
    ...getResponsiveCSSProperties(right, "r", "r"),
    ...getResponsiveCSSProperties(top, "r", "t"),
    ...getResponsiveCSSProperties(bottom, "r", "b"),
    ...getResponsiveCSSProperties(overflow, "r", "o"),
    ...getResponsiveCSSProperties(overflowX, "r", "o-x"),
    ...getResponsiveCSSProperties(overflowY, "r", "o-y"),
    ...getResponsiveCSSProperties(display, "r", "display"),
    ...getResponsiveCSSProperties(textAlign, "r", "text-align"),
    ...getResponsiveCSSProperties(flexDirection, "r", "flex-dir"),
    ...getResponsiveCSSProperties(gap, "r", "gap"),
    ...getResponsiveCSSProperties(columnGap, "r", "c-gap"),
    ...getResponsiveCSSProperties(rowGap, "r", "r-gap"),
    ...getResponsiveCSSProperties(alignItems, "r", "a-i"),
    ...getResponsiveCSSProperties(alignContent, "r", "a-c"),
    ...getResponsiveCSSProperties(justifyItems, "r", "j-i"),
    ...getResponsiveCSSProperties(justifyContent, "r", "j-c"),
    ...getResponsiveCSSProperties(flexWrap, "r", "wrap"),
    ...getResponsiveCSSProperties(flexBasis, "r", "basis"),
    ...getResponsiveCSSProperties(flexFlow, "r", "flow")
  };
  return /* @__PURE__ */ jsx178(
    ShowHide,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          padding && layout_default["dds-p"],
          paddingInline && layout_default["dds-p-i"],
          paddingBlock && layout_default["dds-p-b"],
          margin && layout_default["dds-m"],
          marginInline && layout_default["dds-m-i"],
          marginBlock && layout_default["dds-m-b"],
          height && layout_default["dds-h"],
          maxHeight && layout_default["dds-max-h"],
          minHeight && layout_default["dds-min-h"],
          width && layout_default["dds-w"],
          maxWidth && layout_default["dds-max-w"],
          minWidth && layout_default["dds-min-w"],
          position && layout_default["dds-pos"],
          left && layout_default["dds-l"],
          right && layout_default["dds-r"],
          top && layout_default["dds-t"],
          bottom && layout_default["dds-b"],
          overflow && layout_default["dds-o"],
          overflowX && layout_default["dds-o-x"],
          overflowY && layout_default["dds-o-y"],
          display && layout_default["dds-display"],
          textAlign && layout_default["dds-text-align"],
          flexDirection && layout_default["dds-flex-dir"],
          gap && layout_default["dds-gap"],
          columnGap && layout_default["dds-c-gap"],
          rowGap && layout_default["dds-r-gap"],
          alignContent && layout_default["dds-a-c"],
          alignItems && layout_default["dds-a-i"],
          justifyContent && layout_default["dds-j-c"],
          justifyItems && layout_default["dds-j-i"],
          flexWrap && layout_default["dds-wrap"],
          flexBasis && layout_default["dds-basis"],
          flexFlow && layout_default["dds-flow"]
        ),
        htmlProps,
        rest
      ),
      style: { ...style, ...responsiveStyles }
    }
  );
};
Box.displayName = "Box";

// src/components/layout/Grid/Grid.module.css
var Grid_default = {
  "dds-grid-template-columns": "Grid_dds-grid-template-columns",
  "dds-grid-column": "Grid_dds-grid-column",
  "dds-grid-row": "Grid_dds-grid-row",
  "dds-j-self": "Grid_dds-j-self",
  "child--first-half": "Grid_child--first-half",
  "child--second-half": "Grid_child--second-half",
  "child-col-count": "Grid_child-col-count"
};

// src/components/layout/Grid/Grid.tsx
import { jsx as jsx179 } from "react/jsx-runtime";
var Grid = ({
  id,
  className,
  htmlProps,
  gridTemplateColumns = {
    xs: "repeat(var(--dds-grid-xs-count), minmax(0, 1fr))",
    sm: "repeat(var(--dds-grid-sm-count), minmax(0, 1fr))",
    md: "repeat(var(--dds-grid-md-count), minmax(0, 1fr))",
    lg: "repeat(var(--dds-grid-lg-count), minmax(0, 1fr))",
    xl: "repeat(var(--dds-grid-xl-count), minmax(0, 1fr))"
  },
  columnGap = {
    xs: "var(--dds-grid-xs-gutter-size)",
    sm: "var(--dds-grid-sm-gutter-size)",
    md: "var(--dds-grid-md-gutter-size)",
    lg: "var(--dds-grid-lg-gutter-size)",
    xl: "var(--dds-grid-xl-gutter-size)"
  },
  rowGap = {
    xs: "var(--dds-grid-xs-gutter-size)",
    sm: "var(--dds-grid-sm-gutter-size)",
    md: "var(--dds-grid-md-gutter-size)",
    lg: "var(--dds-grid-lg-gutter-size)",
    xl: "var(--dds-grid-xl-gutter-size)"
  },
  marginInline = { xs: "x2", sm: "x2", md: "x4", lg: "x6", xl: "x10" },
  style,
  ...rest
}) => {
  const styleVariables = {
    ...getResponsiveCSSProperties(
      gridTemplateColumns,
      "r",
      "grid-template-columns"
    )
  };
  return /* @__PURE__ */ jsx179(
    Box,
    {
      display: "grid",
      ...getBaseHTMLProps(
        id,
        cn(className, Grid_default["dds-grid-template-columns"]),
        htmlProps,
        rest
      ),
      marginInline,
      columnGap,
      rowGap,
      style: { ...style, ...styleVariables }
    }
  );
};
Grid.displayName = "Grid";

// src/components/layout/Grid/GridChild.tsx
import { jsx as jsx180 } from "react/jsx-runtime";
var GridChild = ({
  id,
  className,
  htmlProps,
  style,
  gridRow,
  justifySelf,
  columnsOccupied,
  ...rest
}) => {
  const styleVariables = {
    ...getResponsiveCSSProperties(gridRow, "r", "grid-row"),
    ...getResponsiveCSSProperties(justifySelf, "r", "j-self"),
    ...getResponsiveCSSProperties(columnsOccupied, "r", "grid-column")
  };
  return /* @__PURE__ */ jsx180(
    Box,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Grid_default["child-col-count"],
          gridRow && Grid_default["dds-grid-row"],
          justifySelf && Grid_default["dds-j-self"],
          columnsOccupied && Grid_default["dds-grid-column"],
          columnsOccupied === "firstHalf" && Grid_default["child--first-half"],
          columnsOccupied === "secondHalf" && Grid_default["child--second-half"]
        ),
        htmlProps,
        rest
      ),
      style: { ...style, ...styleVariables }
    }
  );
};
GridChild.displayName = "GridChild";

// src/components/layout/Paper/Paper.module.css
var Paper_default = {
  background: "Paper_background",
  border: "Paper_border",
  container: "Paper_container",
  "shadow--1": "Paper_shadow--1",
  "shadow--2": "Paper_shadow--2",
  "shadow--3": "Paper_shadow--3",
  "shadow--4": "Paper_shadow--4",
  "border-radius--button": "Paper_border-radius--button",
  "border-radius--surface": "Paper_border-radius--surface",
  "border-radius--chip": "Paper_border-radius--chip",
  "border-radius--input": "Paper_border-radius--input",
  "border-radius--rounded": "Paper_border-radius--rounded",
  "border-radius--0": "Paper_border-radius--0"
};

// src/components/layout/Paper/Paper.tsx
import { jsx as jsx181 } from "react/jsx-runtime";
var Paper = ({
  id,
  elevation,
  border,
  borderRadius = "surface",
  background = "surface-paper-default",
  className,
  htmlProps,
  style,
  ...rest
}) => {
  const styleVariables = {
    ...getResponsiveCSSProperties(background, "paper-background"),
    ...getResponsiveCSSProperties(border, "paper-border")
  };
  return /* @__PURE__ */ jsx181(
    Box,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Paper_default.container,
          elevation && Paper_default[`shadow--${elevation}`],
          borderRadius && Paper_default[`border-radius--${borderRadius}`],
          Paper_default.background,
          border && Paper_default.border
        ),
        htmlProps,
        rest
      ),
      style: { ...style, ...styleVariables }
    }
  );
};

// src/components/layout/Stack/VStack/VStack.tsx
import { jsx as jsx182 } from "react/jsx-runtime";
var VStack = ({
  id,
  className,
  htmlProps,
  ...rest
}) => {
  return /* @__PURE__ */ jsx182(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      ...getBaseHTMLProps(id, className, htmlProps, rest)
    }
  );
};
VStack.displayName = "VStack";

// src/components/layout/Stack/HStack/HStack.tsx
import { jsx as jsx183 } from "react/jsx-runtime";
var HStack = ({
  id,
  className,
  htmlProps,
  ...rest
}) => {
  return /* @__PURE__ */ jsx183(
    Box,
    {
      display: "flex",
      flexDirection: "row",
      ...getBaseHTMLProps(id, className, htmlProps, rest)
    }
  );
};
HStack.displayName = "HStack";

// src/components/Accordion/Accordion.module.css
var Accordion_default = {
  container: "Accordion_container",
  "header-button": "Accordion_header-button",
  body: "Accordion_body"
};

// src/components/helpers/AccordionBase/useAccordion.tsx
import {
  useCallback as useCallback4,
  useEffect as useEffect11,
  useId as useId2,
  useLayoutEffect,
  useRef as useRef4,
  useState as useState5
} from "react";

// src/components/helpers/AccordionBase/AccordionBase.module.css
var AccordionBase_default = {
  "header-button": "AccordionBase_header-button",
  "header-container": "AccordionBase_header-container",
  header__content: "AccordionBase_header__content",
  header__chevron: "AccordionBase_header__chevron",
  body: "AccordionBase_body",
  "body--animated": "AccordionBase_body--animated",
  "body--hidden": "AccordionBase_body--hidden"
};

// src/components/helpers/AccordionBase/useAccordion.tsx
var useAccordion = ({
  initiallyExpanded = false,
  onChange,
  id
}) => {
  var _a;
  const [isExpanded, setIsExpanded] = useState5(initiallyExpanded);
  const generatedId = useId2();
  const accordionId = id != null ? id : `${generatedId}-accordion`;
  const openAccordion = () => {
    setIsExpanded(true);
  };
  const closeAccordion = () => {
    setIsExpanded(false);
  };
  useEffect11(() => {
    setIsExpanded(isExpanded);
  }, [isExpanded]);
  const toggleExpanded = useCallback4(() => {
    setIsExpanded((prevExpanded) => {
      const newExpanded = !prevExpanded;
      if (onChange) {
        onChange(newExpanded);
      }
      return newExpanded;
    });
  }, [onChange]);
  const bodyContentRef = useRef4(null);
  const [animate, setAnimate] = useState5(false);
  const isMounted = useIsMounted();
  const height = useElementHeight(bodyContentRef.current);
  const [initialExpandedHeight, setIntialExpandedHeight] = useState5(null);
  useLayoutEffect(() => {
    if (bodyContentRef.current && isExpanded) {
      setIntialExpandedHeight(bodyContentRef.current.scrollHeight);
    }
  }, []);
  useEffect11(() => {
    if (isMounted()) {
      setAnimate(true);
    }
  }, [isMounted]);
  const headerProps = {
    id: `${accordionId}-header`,
    onClick: toggleExpanded,
    "aria-expanded": isExpanded,
    "aria-controls": `${accordionId}-body`
  };
  const bodyProps = {
    id: `${accordionId}-body`,
    role: "region",
    "aria-labelledby": `${accordionId}-header`,
    "aria-hidden": !isExpanded,
    className: cn(
      AccordionBase_default.body,
      !isExpanded && AccordionBase_default["body--hidden"],
      animate && AccordionBase_default["body--animated"]
    ),
    height: (_a = height != null ? height : initialExpandedHeight) != null ? _a : 0
  };
  return {
    id: accordionId,
    isExpanded,
    setIsExpanded,
    openAccordion,
    closeAccordion,
    toggleExpanded,
    bodyContentRef,
    headerProps,
    bodyProps
  };
};

// src/components/helpers/AccordionBase/AccordionContext.tsx
import {
  createContext,
  useContext
} from "react";
import { jsx as jsx184 } from "react/jsx-runtime";
var AccordionContext = createContext({});
var AccordionContextProvider = ({
  children,
  ...values
}) => {
  return /* @__PURE__ */ jsx184(AccordionContext, { value: values, children });
};
var useAccordionContext = () => {
  const context = useContext(AccordionContext);
  if (isEmpty(context)) {
    throw new Error(
      "useAccordionContext must be used within a AccordionContextProvider. Have you wrapped <AccordionHeader> and <AccordionBody> inside a <Accordion>, or <CardAccordionHeader> and <CardAccordionBody> inside a <CardAccordion>?"
    );
  }
  return context;
};

// src/components/Accordion/Accordion.tsx
import { jsx as jsx185 } from "react/jsx-runtime";
var Accordion = ({
  isExpanded = false,
  onChange,
  id,
  children,
  className,
  htmlProps,
  ...rest
}) => {
  const {
    id: accordionId,
    isExpanded: expanded,
    toggleExpanded,
    bodyContentRef,
    headerProps,
    bodyProps
  } = useAccordion({ initiallyExpanded: isExpanded, onChange, id });
  return /* @__PURE__ */ jsx185(
    "div",
    {
      ...getBaseHTMLProps(
        accordionId,
        cn(className, Accordion_default.container),
        htmlProps,
        rest
      ),
      children: /* @__PURE__ */ jsx185(
        AccordionContextProvider,
        {
          headerProps,
          bodyProps,
          isExpanded: expanded,
          toggleExpanded,
          bodyContentRef,
          children
        }
      )
    }
  );
};
Accordion.displayName = "Accordion";

// src/components/Accordion/AccordionHeader.tsx
import { jsx as jsx186, jsxs as jsxs24 } from "react/jsx-runtime";
var AccordionHeader = ({
  children,
  className,
  htmlProps,
  typographyType = "headingMedium",
  bold,
  ...rest
}) => {
  const { isExpanded, headerProps } = useAccordionContext();
  const { id, ...restHeaderProps } = headerProps != null ? headerProps : {};
  return /* @__PURE__ */ jsxs24(
    Box,
    {
      as: "button",
      padding: "x1 x1.5 x1 x1",
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Accordion_default["header-button"],
          AccordionBase_default["header-button"],
          utilStyles_default["normalize-button"],
          utilStyles_default["remove-button-styling"],
          focusable,
          AccordionBase_default["header-container"]
        ),
        htmlProps,
        rest
      ),
      ...restHeaderProps,
      children: [
        /* @__PURE__ */ jsx186(
          Box,
          {
            as: "span",
            marginInline: "x0 x0.5",
            className: AccordionBase_default.header__chevron,
            children: /* @__PURE__ */ jsx186(
              AnimatedChevronUpDown,
              {
                width: "var(--dds-icon-size-medium)",
                height: "var(--dds-spacing-x0-5)",
                isUp: isExpanded
              }
            )
          }
        ),
        /* @__PURE__ */ jsx186(
          "div",
          {
            className: cn(
              AccordionBase_default.header__content,
              typographyStyles_default[getTypographyCn(typographyType)],
              bold && typographyStyles_default.bold
            ),
            children
          }
        )
      ]
    }
  );
};
AccordionHeader.displayName = "AccordionHeader";

// src/components/Accordion/AccordionBody.tsx
import { jsx as jsx187 } from "react/jsx-runtime";
var AccordionBody = ({
  children,
  className,
  htmlProps,
  ...rest
}) => {
  const { bodyContentRef, bodyProps } = useAccordionContext();
  const {
    className: bodyContextCn,
    id,
    height,
    ...restBodyProps
  } = bodyProps != null ? bodyProps : {};
  const styleVariables = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-card-accordion-body-height"]: height + "px"
  };
  return /* @__PURE__ */ jsx187(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, Accordion_default.body, bodyContextCn),
        htmlProps,
        rest
      ),
      ...restBodyProps,
      style: { ...htmlProps == null ? void 0 : htmlProps.style, ...styleVariables },
      children: /* @__PURE__ */ jsx187(Box, { ref: bodyContentRef, padding: "x0.5 x1.5 x2 x1", children })
    }
  );
};
AccordionBody.displayName = "AccordionBody";

// src/components/BackLink/BackLink.module.css
var BackLink_default = {
  icon: "BackLink_icon"
};

// src/components/BackLink/BackLink.tsx
import { jsx as jsx188, jsxs as jsxs25 } from "react/jsx-runtime";
var BackLink = ({ label, ref, ...rest }) => {
  return /* @__PURE__ */ jsx188("nav", { ref, "aria-label": "G\xE5 tilbake", children: /* @__PURE__ */ jsxs25(Link, { ...rest, children: [
    /* @__PURE__ */ jsx188(Icon, { icon: ArrowLeftIcon, iconSize: "inherit", className: BackLink_default.icon }),
    label
  ] }) });
};
BackLink.displayName = "BackLink";

// src/components/Breadcrumbs/Breadcrumb.tsx
import { jsx as jsx189 } from "react/jsx-runtime";
var isAnchorTypographyProps = (props) => {
  return props.href != void 0;
};
var Breadcrumb = ({ children, ref, ...rest }) => {
  if (isAnchorTypographyProps(rest)) {
    return /* @__PURE__ */ jsx189(Link, { ref, htmlProps: rest, children });
  }
  return /* @__PURE__ */ jsx189("span", { ref, ...rest, children });
};
Breadcrumb.displayName = "Breadcrumb";

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { Children, isValidElement as isValidElement2 } from "react";

// src/components/Breadcrumbs/Breadcrumbs.module.css
var Breadcrumbs_default = {
  icon: "Breadcrumbs_icon"
};

// src/components/Button/Button.module.css
var Button_default = {
  button: "Button_button",
  "button--is-loading": "Button_button--is-loading",
  "button--full-width": "Button_button--full-width",
  "just-icon": "Button_just-icon",
  "just-text": "Button_just-text",
  "with-text-and-icon": "Button_with-text-and-icon",
  "with-icon-left": "Button_with-icon-left",
  "button--xsmall": "Button_button--xsmall",
  "with-icon-right": "Button_with-icon-right",
  "no-content": "Button_no-content",
  icon: "Button_icon",
  "button--small": "Button_button--small",
  "button--medium": "Button_button--medium",
  "button--large": "Button_button--large",
  "spinner-wrapper--absolute": "Button_spinner-wrapper--absolute",
  "icon-wrapper": "Button_icon-wrapper",
  "button--primary": "Button_button--primary",
  "button--secondary": "Button_button--secondary",
  "button--tertiary": "Button_button--tertiary",
  "button--danger": "Button_button--danger"
};

// src/components/ButtonGroup/ButtonGroup.context.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
var ButtonGroupContext = createContext2({});
var useButtonGroupContext = () => useContext2(ButtonGroupContext);

// src/components/Spinner/Spinner.tsx
import { useId as useId3, useRef as useRef5 } from "react";

// src/components/Spinner/Spinner.module.css
var Spinner_default = {
  svg: "Spinner_svg",
  rotate: "Spinner_rotate",
  circle: "Spinner_circle",
  dash: "Spinner_dash"
};

// src/components/Spinner/Spinner.tsx
import { jsx as jsx190, jsxs as jsxs26 } from "react/jsx-runtime";
function Spinner(props) {
  const {
    size: size2 = "var(--dds-icon-size-medium)",
    color = "iconActionResting",
    tooltip = "Innlasting p\xE5g\xE5r",
    id,
    className,
    htmlProps,
    ...rest
  } = props;
  const mountTime = useRef5(Date.now());
  const outerAnimationDelay = -(mountTime.current % 2e3);
  const innerAnimationDelay = -(mountTime.current % 1500);
  const generatedId = useId3();
  const uniqueId = `${generatedId}-spinnerTitle`;
  return /* @__PURE__ */ jsxs26(
    "svg",
    {
      viewBox: "0 0 50 50",
      role: "progressbar",
      "aria-labelledby": uniqueId,
      ...getBaseHTMLProps(id, cn(className, Spinner_default.svg), htmlProps, rest),
      style: {
        ...htmlProps == null ? void 0 : htmlProps.style,
        animationDelay: outerAnimationDelay + "ms",
        width: size2,
        height: size2
      },
      children: [
        /* @__PURE__ */ jsx190("title", { id: uniqueId, children: tooltip }),
        /* @__PURE__ */ jsx190(
          "circle",
          {
            className: cn(Spinner_default.circle),
            style: {
              animationDelay: innerAnimationDelay + "ms"
            },
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none",
            stroke: getTextColor(color),
            strokeWidth: "4"
          }
        )
      ]
    }
  );
}
Spinner.displayName = "Spinner";

// src/components/Button/Button.tsx
import { Fragment, jsx as jsx191, jsxs as jsxs27 } from "react/jsx-runtime";
var Button = ({
  children,
  purpose = "primary",
  size: size2 = "medium",
  iconPosition = "left",
  href,
  target,
  loading = false,
  loadingTooltip = "Lagring p\xE5g\xE5r",
  fullWidth = false,
  icon,
  onClick,
  onFocus,
  onBlur,
  id,
  ref,
  className,
  htmlProps = {},
  ...rest
}) => {
  const { purpose: groupPurpose, size: groupSize } = useButtonGroupContext();
  const hasLabel = !!children;
  const hasIcon = !!icon;
  const hasLabelAndIcon = hasIcon && hasLabel;
  const isIconButton = !hasLabel && hasIcon;
  const isTextButton = hasLabel && !hasIcon;
  const noContent = !hasLabel && !hasIcon;
  const buttonCn = cn(
    className,
    Button_default.button,
    Button_default[`button--${groupPurpose ? groupPurpose : purpose}`],
    Button_default[`button--${groupSize ? groupSize : size2}`],
    isTextButton && Button_default["just-text"],
    ...hasLabelAndIcon ? [Button_default["with-text-and-icon"], Button_default[`with-icon-${iconPosition}`]] : [],
    isIconButton && Button_default["just-icon"],
    noContent && Button_default["no-content"],
    fullWidth && Button_default["button--full-width"],
    loading && Button_default["button--is-loading"],
    typographyStyles_default[`body-${size2}`],
    focusable
  );
  const iconElement = hasIcon && /* @__PURE__ */ jsx191(
    Icon,
    {
      icon,
      iconSize: "inherit",
      className: cn(Button_default.icon, loading && invisible)
    }
  );
  const content = /* @__PURE__ */ jsxs27(Fragment, { children: [
    hasLabel && /* @__PURE__ */ jsxs27(Fragment, { children: [
      iconPosition === "left" && iconElement,
      /* @__PURE__ */ jsx191("span", { "aria-hidden": loading, className: cn(loading && invisible), children }),
      iconPosition === "right" && iconElement
    ] }),
    isIconButton && iconElement,
    loading && /* @__PURE__ */ jsx191("span", { className: cn(!noContent && Button_default["spinner-wrapper--absolute"]), children: /* @__PURE__ */ jsx191(
      Spinner,
      {
        size: "calc(var(--dds-font-lineheight-x1) * 1em)",
        color: purpose === "primary" || purpose === "danger" ? "iconOnAction" : "iconDefault",
        tooltip: loadingTooltip,
        className: Button_default.icon
      }
    ) })
  ] });
  if (!href)
    return /* @__PURE__ */ jsx191(
      "button",
      {
        ref,
        ...getBaseHTMLProps(id, buttonCn, htmlProps, rest),
        onClick: loading ? void 0 : onClick,
        onFocus,
        onBlur,
        "aria-disabled": loading,
        children: content
      }
    );
  else if (href)
    return /* @__PURE__ */ jsx191(
      "a",
      {
        ref,
        ...getBaseHTMLProps(
          id,
          buttonCn,
          //TODO: fikse types ordentlig
          htmlProps,
          rest
        ),
        onClick: loading ? void 0 : (
          //TODO: fikse types ordentlig
          onClick
        ),
        onFocus,
        onBlur,
        href,
        rel: "noreferrer noopener",
        target,
        children: content
      }
    );
};
Button.displayName = "Button";

// src/components/OverflowMenu/OverflowMenu.tsx
import { useEffect as useEffect13 } from "react";

// src/components/OverflowMenu/OverflowMenu.context.tsx
import {
  createContext as createContext3,
  useContext as useContext3,
  useEffect as useEffect12,
  useState as useState6
} from "react";
import { jsx as jsx192 } from "react/jsx-runtime";
var OverflowMenuContext = createContext3({
  isOpen: false,
  registerItem: () => null,
  unregisterItem: () => null
});
function OverflowMenuContextProvider({
  children,
  ...rest
}) {
  const [items, setItems] = useState6(
    []
  );
  const [focusIndex] = useRoveFocus(items.length, rest.isOpen);
  useEffect12(() => {
    var _a, _b;
    (_b = (_a = items[focusIndex]) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
  }, [focusIndex]);
  return /* @__PURE__ */ jsx192(
    OverflowMenuContext,
    {
      value: {
        ...rest,
        registerItem: (ref) => setItems((prev) => [...prev, ref]),
        unregisterItem: (ref) => setItems((prev) => prev.filter((item) => item !== ref)),
        focusedRef: items[focusIndex]
      },
      children
    }
  );
}
var useOverflowMenuContext = () => {
  return useContext3(OverflowMenuContext);
};

// src/components/OverflowMenu/OverflowMenu.module.css
var OverflowMenu_default = {
  container: "OverflowMenu_container",
  list: "OverflowMenu_list",
  list__item: "OverflowMenu_list__item",
  default: "OverflowMenu_default",
  danger: "OverflowMenu_danger",
  "list__item--link": "OverflowMenu_list__item--link",
  icon: "OverflowMenu_icon",
  "button-loading": "OverflowMenu_button-loading"
};

// src/components/OverflowMenu/OverflowMenu.tsx
import { jsx as jsx193 } from "react/jsx-runtime";
var OverflowMenu = ({
  placement = "bottom-end",
  offset = 2,
  className,
  htmlProps = {},
  ref,
  ...rest
}) => {
  const { isOpen, floatStyling, setFloatOptions, menuRef, menuId } = useOverflowMenuContext();
  useEffect13(() => {
    setFloatOptions == null ? void 0 : setFloatOptions({ placement, offset });
  }, [placement, offset]);
  const { style = {}, ...restHTMLProps } = htmlProps;
  const openCn = isOpen ? "open" : "closed";
  return /* @__PURE__ */ jsx193(
    Paper,
    {
      overflowY: "auto",
      minWidth: "180px",
      maxWidth: "300px",
      ref: useCombinedRef(menuRef, ref),
      ...getBaseHTMLProps(
        menuId,
        cn(
          className,
          OverflowMenu_default.container,
          utilStyles_default.scrollbar,
          utilStyles_default["visibility-transition"],
          utilStyles_default[`visibility-transition--${openCn}`]
        ),
        restHTMLProps,
        rest
      ),
      role: "menu",
      "aria-hidden": !isOpen,
      elevation: 1,
      border: "border-default",
      style: { ...style, ...floatStyling }
    }
  );
};
OverflowMenu.displayName = "OverflowMenu";

// src/components/OverflowMenu/components/OverflowMenuButton.tsx
import { useEffect as useEffect14, useRef as useRef6, useState as useState7 } from "react";
import { jsx as jsx194, jsxs as jsxs28 } from "react/jsx-runtime";
var OverflowMenuButton = ({
  id,
  icon,
  children,
  className,
  onClick,
  onClickAsync,
  purpose = "default",
  loading,
  loadingTooltip,
  "aria-disabled": ariaDisabled,
  ref,
  ...rest
}) => {
  const itemRef = useRef6(null);
  const combinedRef = useCombinedRef(ref, itemRef);
  const { onClose, registerItem, unregisterItem, focusedRef } = useOverflowMenuContext();
  const [internalLoading, setInternalLoading] = useState7(false);
  const isLoading = loading || internalLoading;
  useEffect14(() => {
    registerItem(itemRef);
    return () => unregisterItem(itemRef);
  }, []);
  const handleClick = async (e) => {
    if (isLoading) return;
    if (onClickAsync) {
      setInternalLoading(true);
      try {
        await onClickAsync(e);
      } finally {
        setInternalLoading(false);
        onClose == null ? void 0 : onClose();
      }
    } else {
      onClick == null ? void 0 : onClick(e);
      onClose == null ? void 0 : onClose();
    }
  };
  return /* @__PURE__ */ jsx194("li", { children: /* @__PURE__ */ jsxs28(
    "button",
    {
      ref: combinedRef,
      role: "menuitem",
      id,
      className: cn(
        className,
        OverflowMenu_default.list__item,
        OverflowMenu_default[purpose],
        typographyStyles_default["body-small"],
        OverflowMenu_default["list__item--link"],
        focus_default["focusable--inset"],
        loading && OverflowMenu_default["button-loading"]
      ),
      onClick: (e) => handleClick(e),
      "aria-disabled": isLoading ? true : ariaDisabled ? ariaDisabled : void 0,
      ...rest,
      tabIndex: focusedRef === itemRef ? 0 : -1,
      children: [
        isLoading && /* @__PURE__ */ jsx194("span", { className: cn(utilStyles_default["center-absolute"]), children: /* @__PURE__ */ jsx194(
          Spinner,
          {
            size: "var(--dds-icon-size-medium)",
            tooltip: loadingTooltip
          }
        ) }),
        icon && /* @__PURE__ */ jsx194(
          Icon,
          {
            className: cn(isLoading && invisible),
            iconSize: "inherit",
            icon
          }
        ),
        /* @__PURE__ */ jsx194("span", { className: cn(isLoading && invisible), children })
      ]
    }
  ) });
};
OverflowMenuButton.displayName = "OverflowMenuButton";

// src/components/OverflowMenu/components/OverflowMenuLink.tsx
import { useEffect as useEffect15, useRef as useRef7 } from "react";
import { jsx as jsx195, jsxs as jsxs29 } from "react/jsx-runtime";
var OverflowMenuLink = ({
  id,
  href,
  icon,
  className,
  onClick,
  children,
  ref,
  purpose = "default",
  ...rest
}) => {
  const itemRef = useRef7(null);
  const combinedRef = useCombinedRef(ref, itemRef);
  const { onClose, registerItem, unregisterItem, focusedRef } = useOverflowMenuContext();
  useEffect15(() => {
    registerItem(itemRef);
    return () => unregisterItem(itemRef);
  }, []);
  return /* @__PURE__ */ jsx195("li", { children: /* @__PURE__ */ jsxs29(
    "a",
    {
      ref: combinedRef,
      role: "menuitem",
      id,
      className: cn(
        className,
        OverflowMenu_default.list__item,
        OverflowMenu_default[purpose],
        typographyStyles_default["body-small"],
        OverflowMenu_default["list__item--link"],
        focus_default["focusable--inset"]
      ),
      href,
      onClick: (e) => {
        onClick == null ? void 0 : onClick(e);
        onClose == null ? void 0 : onClose();
      },
      ...rest,
      tabIndex: focusedRef === itemRef ? 0 : -1,
      children: [
        icon && /* @__PURE__ */ jsx195(Icon, { iconSize: "inherit", icon }),
        children
      ]
    }
  ) });
};
OverflowMenuLink.displayName = "OverflowMenuLink";

// src/components/Divider/Divider.module.css
var Divider_default = {
  divider: "Divider_divider",
  "divider--default": "Divider_divider--default",
  "divider--subtle": "Divider_divider--subtle",
  "divider--on-inverse": "Divider_divider--on-inverse"
};

// src/components/Divider/Divider.tsx
import { jsx as jsx196 } from "react/jsx-runtime";
var Divider = ({
  color = "default",
  id,
  className,
  htmlProps,
  ...rest
}) => {
  return /* @__PURE__ */ jsx196(
    "hr",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, Divider_default.divider, Divider_default[`divider--${color}`]),
        htmlProps,
        rest
      )
    }
  );
};

// src/components/OverflowMenu/components/OverflowMenuDivider.tsx
import { jsx as jsx197 } from "react/jsx-runtime";
var OverflowMenuDivider = ({
  id,
  className,
  htmlProps,
  ...rest
}) => {
  return /* @__PURE__ */ jsx197(
    Box,
    {
      as: Divider,
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      marginInline: "x0.5",
      marginBlock: "x0",
      color: "subtle"
    }
  );
};
OverflowMenuDivider.displayName = "OverflowMenuDivider";

// src/components/OverflowMenu/components/OverflowMenuList.tsx
import { jsx as jsx198 } from "react/jsx-runtime";
var OverflowMenuList = (props) => /* @__PURE__ */ jsx198(StylelessList, { ...props });

// src/components/OverflowMenu/components/OverflowMenuSpan.tsx
import { jsx as jsx199, jsxs as jsxs30 } from "react/jsx-runtime";
var OverflowMenuSpan = ({
  icon,
  children,
  className,
  purpose = "default",
  ...rest
}) => /* @__PURE__ */ jsx199("li", { children: /* @__PURE__ */ jsxs30(
  "span",
  {
    className: cn(
      className,
      OverflowMenu_default.list__item,
      OverflowMenu_default[purpose],
      typographyStyles_default["body-small"]
    ),
    ...rest,
    children: [
      icon && /* @__PURE__ */ jsx199(Icon, { iconSize: "inherit", icon }),
      children
    ]
  }
) });
OverflowMenuSpan.displayName = "OverflowMenuSpan";

// src/components/OverflowMenu/components/OverflowMenuListHeader.tsx
import { jsx as jsx200 } from "react/jsx-runtime";
var OverflowMenuListHeader = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx200(
  Box,
  {
    as: "h2",
    paddingInline: "x0.75",
    paddingBlock: "x0.75 0",
    ...rest,
    className: cn(className, typographyStyles_default["heading-xxsmall"])
  }
);
OverflowMenuListHeader.displayName = "OverflowMenuListHeader";

// src/components/OverflowMenu/OverflowMenuGroup.tsx
import {
  Children as ReactChildren,
  cloneElement,
  isValidElement,
  useId as useId4,
  useRef as useRef8,
  useState as useState8
} from "react";
import { jsx as jsx201 } from "react/jsx-runtime";
var OverflowMenuGroup = ({
  children,
  onClose,
  onOpen,
  setIsOpen: propSetIsOpen,
  isOpen: propIsOpen,
  isInitiallyOpen = false,
  overflowMenuId
}) => {
  const [internalIsOpen, internalSetIsOpen] = useState8(isInitiallyOpen);
  const [isOpen, setIsOpen] = [
    propIsOpen != null ? propIsOpen : internalIsOpen,
    propSetIsOpen != null ? propSetIsOpen : internalSetIsOpen
  ];
  const toggle = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const generatedId = useId4();
  const uniqueOverflowMenuId = overflowMenuId != null ? overflowMenuId : `${generatedId}-overflowMenu`;
  const [floatOptions, setFloatOptions] = useState8();
  const { refs, styles: positionStyles } = useFloatPosition(null, floatOptions);
  const buttonRef = useRef8(null);
  const anchorRef = refs.setReference;
  const combinedAnchorRef = useCombinedRef(buttonRef, anchorRef);
  const menuRef = useRef8(null);
  const floatingRef = refs.setFloating;
  const combinedMenuRef = useCombinedRef(menuRef, floatingRef);
  const handleClose = () => {
    if (isOpen) {
      onClose && onClose();
      close();
    }
  };
  const handleToggle = () => {
    !isOpen && (onOpen == null ? void 0 : onOpen());
    isOpen && (onClose == null ? void 0 : onClose());
    toggle();
  };
  useOnClickOutside([menuRef.current, buttonRef.current], () => {
    handleClose();
  });
  useOnKeyDown(["Esc", "Escape"], () => {
    var _a;
    if (isOpen) {
      onClose && onClose();
      close();
      (_a = buttonRef.current) == null ? void 0 : _a.focus();
    }
  });
  useOnKeyDown(["Tab"], () => {
    handleClose();
  });
  const Children7 = ReactChildren.map(children, (child, childIndex) => {
    return isValidElement(child) && (childIndex === 0 ? cloneElement(child, {
      "aria-haspopup": "menu",
      "aria-controls": uniqueOverflowMenuId,
      "aria-expanded": isOpen,
      onClick: handleToggle,
      ref: combinedAnchorRef
    }) : child);
  });
  return /* @__PURE__ */ jsx201(
    OverflowMenuContextProvider,
    {
      isOpen,
      onClose: handleClose,
      menuRef: combinedMenuRef,
      setFloatOptions,
      floatStyling: positionStyles.floating,
      menuId: uniqueOverflowMenuId,
      children: Children7
    }
  );
};
OverflowMenuGroup.displayName = "OverflowMenuGroup";

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { Fragment as Fragment2, jsx as jsx202, jsxs as jsxs31 } from "react/jsx-runtime";
var Breadcrumbs = ({
  children,
  smallScreenBreakpoint,
  id,
  className,
  htmlProps,
  ...rest
}) => {
  const chevronIcon = /* @__PURE__ */ jsx202(
    Icon,
    {
      className: cn(Breadcrumbs_default.icon),
      iconSize: "inherit",
      icon: ChevronRightIcon
    }
  );
  const childrenArray = Children.toArray(children);
  const responsiveLiProps = {
    as: "li",
    alignItems: "center",
    gap: "x0.5",
    padding: "x0"
  };
  const breadcrumbChildren = childrenArray.map((item, index) => {
    return /* @__PURE__ */ jsxs31(
      HStack,
      {
        ...responsiveLiProps,
        padding: "x0.125 0",
        children: [
          index !== 0 && chevronIcon,
          item
        ]
      },
      `breadcrumb-${index}`
    );
  });
  const breadcrumbChildrenTruncated = childrenArray.length > 2 ? childrenArray.slice(1, childrenArray.length - 1).map((item, index) => {
    if (isValidElement2(item)) {
      if (isAnchorTypographyProps(item.props)) {
        return /* @__PURE__ */ jsx202(OverflowMenuLink, { href: item.props.href, children: item.props.children }, index);
      } else
        return /* @__PURE__ */ jsx202(OverflowMenuSpan, { children: item.props.children }, index);
    }
  }) : [];
  const breadcrumbChildrenSmallScreen = /* @__PURE__ */ jsxs31(Fragment2, { children: [
    /* @__PURE__ */ jsx202(HStack, { ...responsiveLiProps, children: childrenArray[0] }),
    breadcrumbChildrenTruncated.length > 0 && /* @__PURE__ */ jsxs31(HStack, { ...responsiveLiProps, children: [
      chevronIcon,
      /* @__PURE__ */ jsxs31(OverflowMenuGroup, { children: [
        /* @__PURE__ */ jsx202(
          Button,
          {
            size: "xsmall",
            icon: MoreHorizontalIcon,
            purpose: "tertiary",
            "aria-label": `Vis br\xF8dsmulesti br\xF8dsmule 2 ${breadcrumbChildrenTruncated.length > 1 && `til ${breadcrumbChildren.length - 1}`}`
          }
        ),
        /* @__PURE__ */ jsx202(OverflowMenu, { children: /* @__PURE__ */ jsx202(OverflowMenuList, { children: breadcrumbChildrenTruncated }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs31(HStack, { ...responsiveLiProps, children: [
      chevronIcon,
      childrenArray[childrenArray.length - 1]
    ] })
  ] });
  const hasSmallScreenBreakpoint = !!smallScreenBreakpoint;
  const responsiveListProps = {
    as: StylelessList,
    flexWrap: "wrap",
    alignItems: "center",
    gap: "x0.5"
  };
  return /* @__PURE__ */ jsxs31(
    "nav",
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      "aria-label": "br\xF8dsmulesti",
      children: [
        /* @__PURE__ */ jsx202(
          HStack,
          {
            ...responsiveListProps,
            hideBelow: hasSmallScreenBreakpoint ? smallScreenBreakpoint : void 0,
            children: breadcrumbChildren
          }
        ),
        hasSmallScreenBreakpoint && /* @__PURE__ */ jsx202(HStack, { ...responsiveListProps, showBelow: smallScreenBreakpoint, children: breadcrumbChildrenSmallScreen })
      ]
    }
  );
};
Breadcrumbs.displayName = "Breadcrumbs";

// src/components/ButtonGroup/ButtonGroup.module.css
var ButtonGroup_default = {
  group: "ButtonGroup_group",
  "group--column": "ButtonGroup_group--column",
  "group--row": "ButtonGroup_group--row"
};

// src/components/ButtonGroup/ButtonGroup.tsx
import { jsx as jsx203 } from "react/jsx-runtime";
var ButtonGroup = ({
  children,
  id,
  className,
  htmlProps,
  direction = "row",
  buttonSize = "medium",
  role = "group",
  ...rest
}) => /* @__PURE__ */ jsx203(ButtonGroupContext, { value: { size: buttonSize, purpose: "secondary" }, children: /* @__PURE__ */ jsx203(
  "div",
  {
    role,
    ...getBaseHTMLProps(
      id,
      cn(className, ButtonGroup_default.group, ButtonGroup_default[`group--${direction}`]),
      htmlProps,
      rest
    ),
    children
  }
) });
ButtonGroup.displayName = "ButtonGroup";

// src/components/Card/Card.module.css
var Card_default = {
  container: "Card_container",
  "container--filled": "Card_container--filled",
  "container--border": "Card_container--border",
  "container--navigation": "Card_container--navigation",
  "container--selection-control": "Card_container--selection-control",
  "container--selection-control--disabled": "Card_container--selection-control--disabled",
  "container--selection-control--readonly": "Card_container--selection-control--readonly",
  "container--selection-control--error": "Card_container--selection-control--error",
  "container--expandable": "Card_container--expandable"
};

// src/components/Card/Card.tsx
import { jsx as jsx204 } from "react/jsx-runtime";
var Card = (props) => {
  const {
    appearance = "filled",
    cardType,
    cardRef,
    id,
    className,
    htmlProps,
    ...rest
  } = props;
  const classNames = cn(
    className,
    Card_default.container,
    Card_default[`container--${appearance}`],
    cardType !== "info" && Card_default[`container--${cardType}`]
  );
  if (cardType === "navigation") {
    const { href, target } = props;
    return /* @__PURE__ */ jsx204(
      "a",
      {
        ...getBaseHTMLProps(
          id,
          cn(classNames, focus_default.focusable),
          htmlProps,
          rest
        ),
        ref: cardRef,
        href,
        target
      }
    );
  }
  return /* @__PURE__ */ jsx204("div", { ...getBaseHTMLProps(id, classNames, htmlProps, rest), ref: cardRef });
};
Card.displayName = "Card";

// src/components/Card/CardExpandable/CardExpandable.module.css
var CardExpandable_default = {
  container: "CardExpandable_container",
  "header-button": "CardExpandable_header-button",
  "header-container": "CardExpandable_header-container",
  "header-container__chevron": "CardExpandable_header-container__chevron",
  body: "CardExpandable_body",
  body__content: "CardExpandable_body__content"
};

// src/components/Card/CardExpandable/CardExpandable.tsx
import { jsx as jsx205 } from "react/jsx-runtime";
var CardExpandable = ({
  isExpanded = false,
  onChange,
  id,
  children,
  className,
  htmlProps,
  ...rest
}) => {
  const {
    id: accordionId,
    isExpanded: expanded,
    toggleExpanded,
    bodyContentRef,
    headerProps,
    bodyProps
  } = useAccordion({ initiallyExpanded: isExpanded, onChange, id });
  return /* @__PURE__ */ jsx205(
    "div",
    {
      ...getBaseHTMLProps(
        accordionId,
        cn(className, CardExpandable_default["container"]),
        htmlProps,
        rest
      ),
      children: /* @__PURE__ */ jsx205(
        AccordionContextProvider,
        {
          headerProps,
          bodyProps,
          isExpanded: expanded,
          toggleExpanded,
          bodyContentRef,
          children
        }
      )
    }
  );
};
CardExpandable.displayName = "CardExpandable";

// src/components/Card/CardExpandable/CardExpandableHeader.tsx
import { jsx as jsx206, jsxs as jsxs32 } from "react/jsx-runtime";
var CardExpandableHeader = ({
  children,
  className,
  htmlProps,
  padding,
  typographyType = "headingLarge",
  bold,
  ...rest
}) => {
  const { isExpanded, headerProps } = useAccordionContext();
  const containerStyleVariables = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-card-accordion-header-container-padding"]: padding != null ? padding : "var(--dds-spacing-x1) var(--dds-spacing-x0-75) var(--dds-spacing-x1) var(--dds-spacing-x1-5)"
  };
  const { id, ...restHeaderProps } = headerProps != null ? headerProps : {};
  return /* @__PURE__ */ jsx206(
    "button",
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          CardExpandable_default["header-button"],
          AccordionBase_default["header-button"],
          utilStyles_default["normalize-button"],
          utilStyles_default["remove-button-styling"],
          focusable
        ),
        htmlProps,
        rest
      ),
      ...restHeaderProps,
      type: "button",
      children: /* @__PURE__ */ jsxs32(
        "div",
        {
          style: containerStyleVariables,
          className: cn(
            AccordionBase_default["header-container"],
            CardExpandable_default["header-container"],
            typographyStyles_default[getTypographyCn(typographyType)],
            bold && typographyStyles_default.bold
          ),
          children: [
            /* @__PURE__ */ jsx206("div", { className: AccordionBase_default.header__content, children }),
            /* @__PURE__ */ jsx206(
              "span",
              {
                className: cn(
                  AccordionBase_default.header__chevron,
                  CardExpandable_default["header-container__chevron"]
                ),
                children: /* @__PURE__ */ jsx206(
                  AnimatedChevronUpDown,
                  {
                    width: "var(--dds-icon-size-medium)",
                    height: "var(--dds-spacing-x0-5)",
                    isUp: isExpanded
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
};
CardExpandableHeader.displayName = "CardExpandableHeader";

// src/components/Card/CardExpandable/CardExpandableBody.tsx
import { jsx as jsx207 } from "react/jsx-runtime";
var CardExpandableBody = ({
  children,
  className,
  htmlProps,
  padding,
  ...rest
}) => {
  const { bodyContentRef, bodyProps } = useAccordionContext();
  const {
    className: bodyContextCn,
    id,
    height,
    ...restBodyProps
  } = bodyProps != null ? bodyProps : {};
  const styleVariables = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-card-accordion-body-height"]: height + "px"
  };
  const contentStyleVariables = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-card-accordion-body-content-padding"]: padding != null ? padding : "var(--dds-spacing-x1) calc(var(--dds-spacing-x2) + var(--dds-spacing-x0-75)) var(--dds-spacing-x2) var(--dds-spacing-x1-5)"
  };
  return /* @__PURE__ */ jsx207(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, AccordionBase_default.body, CardExpandable_default.body, bodyContextCn),
        htmlProps,
        rest
      ),
      ...restBodyProps,
      style: { ...htmlProps == null ? void 0 : htmlProps.style, ...styleVariables },
      children: /* @__PURE__ */ jsx207(
        "div",
        {
          ref: bodyContentRef,
          className: CardExpandable_default.body__content,
          style: contentStyleVariables,
          children
        }
      )
    }
  );
};
CardExpandableBody.displayName = "CardExpandableBody";

// src/components/SelectionControl/Checkbox/Checkbox.tsx
import { useId as useId5 } from "react";

// src/components/SelectionControl/Checkbox/CheckboxGroupContext.tsx
import { createContext as createContext4, useContext as useContext4 } from "react";
var CheckboxGroupContext = createContext4(null);
var useCheckboxGroup = () => {
  return useContext4(CheckboxGroupContext);
};

// src/components/SelectionControl/SelectionControl.module.css
var SelectionControl_default = {
  container: "SelectionControl_container",
  group: "SelectionControl_group",
  "group--row": "SelectionControl_group--row",
  "group--column": "SelectionControl_group--column",
  label: "SelectionControl_label",
  "selection-control": "SelectionControl_selection-control",
  "label--readonly": "SelectionControl_label--readonly",
  "label--checkbox": "SelectionControl_label--checkbox",
  "label--radio": "SelectionControl_label--radio",
  "label--disabled": "SelectionControl_label--disabled",
  "label--error": "SelectionControl_label--error",
  "label--no-text": "SelectionControl_label--no-text",
  "selection-control--radio": "SelectionControl_selection-control--radio"
};

// src/components/SelectionControl/SelectionControl.styles.tsx
import { jsx as jsx208, jsxs as jsxs33 } from "react/jsx-runtime";
var SelectionControl = ({
  controlType,
  className,
  ...rest
}) => /* @__PURE__ */ jsx208(
  "span",
  {
    className: cn(
      className,
      SelectionControl_default["selection-control"],
      controlType === "radio" && SelectionControl_default["selection-control--radio"]
    ),
    ...rest
  }
);
var Label2 = ({
  disabled,
  readOnly,
  hasError,
  hasText,
  controlType,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx208(
    Box,
    {
      as: "label",
      position: "relative",
      display: "flex",
      alignItems: "center",
      width: "fit-content",
      paddingInline: "calc(var(--dds-selection-control-height) + var(--dds-spacing-x0-5)) 0",
      className: cn(
        className,
        SelectionControl_default.label,
        SelectionControl_default[`label--${controlType}`],
        !hasText && SelectionControl_default["label--no-text"],
        typographyStyles_default["text-color--default"],
        disabled && SelectionControl_default["label--disabled"],
        disabled && typographyStyles_default["text-color--subtle"],
        readOnly && SelectionControl_default["label--readonly"],
        hasError && SelectionControl_default["label--error"]
      ),
      ...rest
    }
  );
};
var GroupLabel = ({
  id,
  showRequiredMarker,
  readOnly,
  children
}) => {
  return /* @__PURE__ */ jsxs33(
    Typography,
    {
      as: "span",
      typographyType: "labelMedium",
      id,
      className: readOnly ? Label_default["read-only"] : void 0,
      children: [
        readOnly && /* @__PURE__ */ jsx208(
          Icon,
          {
            icon: LockIcon,
            className: Label_default["read-only__icon"],
            iconSize: "small"
          }
        ),
        children,
        " ",
        showRequiredMarker && /* @__PURE__ */ jsx208(RequiredMarker, {})
      ]
    }
  );
};

// src/components/SelectionControl/SelectionControl.utils.tsx
var selectionControlSizeNumberPx = 18;
var selectionControlSize = `${selectionControlSizeNumberPx}px`;
var selectionControlTypographyProps = {
  color: "inherit",
  typographyType: "bodyMedium",
  as: "span"
};

// src/components/SelectionControl/Checkbox/Checkbox.tsx
import { jsx as jsx209, jsxs as jsxs34 } from "react/jsx-runtime";
var Checkbox = ({
  id,
  name,
  label,
  error = false,
  disabled,
  readOnly,
  indeterminate,
  "aria-describedby": ariaDescribedby,
  className,
  htmlProps = {},
  children,
  ...rest
}) => {
  const generatedId = useId5();
  const uniqueId = id != null ? id : `${generatedId}-checkbox`;
  const checkboxGroup = useCheckboxGroup();
  const hasLabel = !!label;
  const hasChildren = !!children;
  const { style, className: htmlPropsClassName, ...restHtmlProps } = htmlProps;
  const isReadOnly = readOnly || (checkboxGroup == null ? void 0 : checkboxGroup.readOnly);
  const hasError = error || (checkboxGroup == null ? void 0 : checkboxGroup.error);
  const isDisabled = disabled || (checkboxGroup == null ? void 0 : checkboxGroup.disabled);
  return /* @__PURE__ */ jsxs34(
    Label2,
    {
      hasError,
      disabled: isDisabled,
      readOnly: isReadOnly,
      htmlFor: uniqueId,
      hasText: hasLabel || hasChildren,
      controlType: "checkbox",
      className: cn(className, htmlPropsClassName),
      style,
      children: [
        /* @__PURE__ */ jsx209(
          "input",
          {
            ...getBaseHTMLProps(uniqueId, restHtmlProps, rest),
            name,
            disabled: isDisabled,
            "aria-describedby": spaceSeparatedIdListGenerator([
              checkboxGroup == null ? void 0 : checkboxGroup.tipId,
              checkboxGroup == null ? void 0 : checkboxGroup.errorMessageId,
              ariaDescribedby
            ]),
            "aria-invalid": hasError ? true : void 0,
            "aria-labelledby": checkboxGroup == null ? void 0 : checkboxGroup.uniqueGroupId,
            "aria-checked": indeterminate ? "mixed" : void 0,
            "aria-readonly": isReadOnly,
            type: "checkbox",
            "data-indeterminate": indeterminate,
            className: cn(
              utilStyles_default["hide-input"],
              focus_default["focusable-sibling"]
            ),
            onKeyDown: readOnlyKeyDownHandler(
              "selectionControl",
              isReadOnly,
              htmlProps.onKeyDown
            ),
            onClick: readOnlyClickHandler(isReadOnly, htmlProps.onClick)
          }
        ),
        /* @__PURE__ */ jsx209(
          SelectionControl,
          {
            controlType: "checkbox",
            className: focus_default["focus-styled-sibling"]
          }
        ),
        hasChildren ? children : hasLabel ? /* @__PURE__ */ jsx209(Typography, { ...selectionControlTypographyProps, children: label }) : null
      ]
    }
  );
};
Checkbox.displayName = "Checkbox";

// src/components/SelectionControl/Checkbox/CheckboxGroup.tsx
import { useId as useId6 } from "react";

// src/types/Booleanish.ts
function convertBooleanishToBoolean(value) {
  if (value === "true") {
    return true;
  } else if (value === "false") {
    return false;
  } else {
    return value;
  }
}

// src/components/InputMessage/InputMessage.module.css
var InputMessage_default = {
  container: "InputMessage_container",
  "container--error": "InputMessage_container--error",
  icon: "InputMessage_icon"
};

// src/components/InputMessage/InputMessage.tsx
import { Fragment as Fragment3, jsx as jsx210, jsxs as jsxs35 } from "react/jsx-runtime";
var InputMessage = ({
  message,
  messageType,
  id,
  className,
  htmlProps,
  ...rest
}) => {
  const isError = messageType === "error";
  return /* @__PURE__ */ jsxs35(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, InputMessage_default.container, isError && InputMessage_default["container--error"]),
        htmlProps,
        rest
      ),
      children: [
        isError && /* @__PURE__ */ jsx210(Icon, { icon: ErrorIcon, iconSize: "small", className: InputMessage_default.icon }),
        /* @__PURE__ */ jsx210(
          Typography,
          {
            typographyType: isError ? "bodySmall" : "bodyXsmall",
            color: isError ? "textDefault" : "textSubtle",
            as: "span",
            children: message
          }
        )
      ]
    }
  );
};
InputMessage.displayName = "InputMessage";
var renderInputMessage = (tip, tipId, errorMessage, errorMessageId) => /* @__PURE__ */ jsxs35(Fragment3, { children: [
  errorMessage && errorMessageId && /* @__PURE__ */ jsx210(
    InputMessage,
    {
      message: errorMessage,
      messageType: "error",
      id: errorMessageId
    }
  ),
  tip && tipId && !errorMessage && /* @__PURE__ */ jsx210(InputMessage, { message: tip, messageType: "tip", id: tipId })
] });

// src/components/SelectionControl/Checkbox/CheckboxGroup.tsx
import { jsx as jsx211, jsxs as jsxs36 } from "react/jsx-runtime";
var CheckboxGroup = (props) => {
  const {
    label,
    direction = "row",
    errorMessage,
    tip,
    required = false,
    disabled = false,
    readOnly = false,
    groupId,
    children,
    id,
    className,
    htmlProps = {},
    ...rest
  } = props;
  const { "aria-required": ariaRequired } = htmlProps;
  const generatedId = useId6();
  const uniqueGroupId = groupId != null ? groupId : `${generatedId}-checkboxGroup`;
  const hasErrorMessage = !!errorMessage;
  const showRequiredMarker = required || convertBooleanishToBoolean(ariaRequired);
  const errorMessageId = derivativeIdGenerator(uniqueGroupId, "errorMessage");
  const tipId = derivativeIdGenerator(uniqueGroupId, "tip");
  const contextProps = {
    error: hasErrorMessage,
    errorMessageId: errorMessage ? errorMessageId : void 0,
    uniqueGroupId,
    tipId: tip ? tipId : void 0,
    disabled,
    readOnly
  };
  return /* @__PURE__ */ jsxs36(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, SelectionControl_default.container),
        { ...htmlProps, "aria-required": ariaRequired },
        rest
      ),
      children: [
        label !== void 0 ? /* @__PURE__ */ jsx211(
          GroupLabel,
          {
            id: uniqueGroupId,
            readOnly,
            showRequiredMarker,
            children: label
          }
        ) : null,
        renderInputMessage(tip, tipId),
        /* @__PURE__ */ jsx211(CheckboxGroupContext, { value: { ...contextProps }, children: /* @__PURE__ */ jsx211(
          "div",
          {
            role: "group",
            "aria-labelledby": uniqueGroupId,
            "aria-describedby": tip ? tipId : void 0,
            className: cn(SelectionControl_default.group, SelectionControl_default[`group--${direction}`]),
            children
          }
        ) }),
        renderInputMessage(void 0, void 0, errorMessage, errorMessageId)
      ]
    }
  );
};
CheckboxGroup.displayName = "CheckboxGroup";

// src/components/SelectionControl/RadioButton/RadioButton.tsx
import { useId as useId7 } from "react";

// src/components/SelectionControl/RadioButton/RadioButtonGroupContext.tsx
import { createContext as createContext5, useContext as useContext5 } from "react";
var RadioButtonGroupContext = createContext5(null);
var useRadioButtonGroup = () => {
  return useContext5(RadioButtonGroupContext);
};

// src/components/SelectionControl/RadioButton/RadioButton.tsx
import { jsx as jsx212, jsxs as jsxs37 } from "react/jsx-runtime";
var getIsChecked = ({
  value,
  groupValue,
  checked
}) => {
  if (checked !== void 0) return checked;
  if (typeof value !== "undefined" && value !== null && groupValue !== null) {
    if (typeof value === "number") {
      return value === Number(groupValue);
    }
    return value === groupValue;
  }
  return !!value;
};
var RadioButton = ({
  id,
  name,
  label,
  disabled = false,
  readOnly = false,
  error = false,
  checked,
  value,
  children,
  required = false,
  onChange,
  "aria-describedby": ariaDescribedby,
  className,
  htmlProps = {},
  ...rest
}) => {
  const { className: htmlPropsClassName, style, ...restHtmlProps } = htmlProps;
  const generatedId = useId7();
  const uniqueId = id != null ? id : `${generatedId}-radioButton`;
  const hasChildren = !!children;
  const hasLabel = !!label;
  const radioButtonGroup = useRadioButtonGroup();
  const handleChange = (event) => {
    var _a;
    onChange && onChange(event);
    (_a = radioButtonGroup == null ? void 0 : radioButtonGroup.onChange) == null ? void 0 : _a.call(radioButtonGroup, event, event.target.value);
  };
  const describedByIds = [];
  if (radioButtonGroup == null ? void 0 : radioButtonGroup.errorMessageId)
    describedByIds.push(radioButtonGroup == null ? void 0 : radioButtonGroup.errorMessageId);
  if (ariaDescribedby) describedByIds.push(ariaDescribedby);
  const isReadOnly = readOnly || (radioButtonGroup == null ? void 0 : radioButtonGroup.readOnly);
  const isDisabled = disabled || (radioButtonGroup == null ? void 0 : radioButtonGroup.disabled);
  const hasError = error || (radioButtonGroup == null ? void 0 : radioButtonGroup.error);
  const isChecked = getIsChecked({
    value,
    groupValue: radioButtonGroup == null ? void 0 : radioButtonGroup.value,
    checked
  });
  return /* @__PURE__ */ jsxs37(
    Label2,
    {
      hasError,
      disabled: isDisabled,
      readOnly: isReadOnly,
      style,
      className: cn(className, htmlPropsClassName),
      hasText: hasLabel || hasChildren,
      htmlFor: uniqueId,
      controlType: "radio",
      children: [
        /* @__PURE__ */ jsx212(
          "input",
          {
            ...getBaseHTMLProps(uniqueId, restHtmlProps, rest),
            type: "radio",
            name: name != null ? name : radioButtonGroup == null ? void 0 : radioButtonGroup.name,
            disabled: isDisabled,
            required: required || !!(radioButtonGroup == null ? void 0 : radioButtonGroup.required),
            checked: isChecked,
            onChange: readOnlyChangeHandler(isReadOnly, handleChange),
            value,
            "aria-describedby": describedByIds.length > 0 ? describedByIds.join(" ") : void 0,
            "aria-invalid": hasError ? true : void 0,
            "aria-readonly": isReadOnly,
            className: cn(
              utilStyles_default["hide-input"],
              focus_default["focusable-sibling"]
            ),
            onKeyDown: readOnlyKeyDownHandler(
              "selectionControl",
              isReadOnly,
              htmlProps.onKeyDown
            ),
            onClick: readOnlyClickHandler(isReadOnly, htmlProps.onClick)
          }
        ),
        /* @__PURE__ */ jsx212(
          SelectionControl,
          {
            controlType: "radio",
            className: focus_default["focus-styled-sibling"]
          }
        ),
        hasChildren ? children : hasLabel ? /* @__PURE__ */ jsx212(Typography, { ...selectionControlTypographyProps, children: label }) : null
      ]
    }
  );
};
RadioButton.displayName = "RadioButton";

// src/components/SelectionControl/RadioButton/RadioButtonGroup.tsx
import { useId as useId8 } from "react";

// src/hooks/useControllableState.ts
import {
  useState as useState9
} from "react";

// src/hooks/useCallbackRef.ts
import { useCallback as useCallback5, useEffect as useEffect16, useRef as useRef9 } from "react";
function useCallbackRef(callback, deps = []) {
  const callbackRef = useRef9(callback);
  useEffect16(() => {
    callbackRef.current = callback;
  });
  return useCallback5((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}

// src/hooks/useControllableState.ts
function useControllableState(props) {
  const { value: valueProp, defaultValue, onChange } = props;
  const onChangeProp = useCallbackRef(onChange);
  const [uncontrolledState, setUncontrolledState] = useState9(defaultValue);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolledState;
  const setValue = useCallbackRef(
    (next) => {
      const setter = next;
      const nextValue = typeof next === "function" ? setter(value) : next;
      if (!controlled) {
        setUncontrolledState(nextValue);
      }
      onChangeProp(nextValue);
    },
    [controlled, onChangeProp, value]
  );
  return [value, setValue];
}
function useControllableGroupState(props) {
  const { value, defaultValue, onChange } = props;
  const [uncontrolledValue, setUncontrolledValue] = useState9(
    defaultValue
  );
  const isControlled = value !== void 0;
  const groupValue = isControlled ? value : uncontrolledValue;
  const handleChange = (e) => {
    const newValue = e.target.value;
    if (!isControlled) {
      setUncontrolledValue(newValue);
    }
    if (onChange) {
      onChange(e, newValue);
    }
  };
  return { groupValue, handleChange };
}

// src/components/SelectionControl/RadioButton/RadioButtonGroup.tsx
import { jsx as jsx213, jsxs as jsxs38 } from "react/jsx-runtime";
var RadioButtonGroup = ({
  name,
  label,
  groupId,
  errorMessage,
  tip,
  disabled = false,
  readOnly = false,
  direction = "row",
  value,
  defaultValue,
  children,
  required = false,
  onChange,
  id,
  className,
  htmlProps = {},
  ...rest
}) => {
  const { "aria-required": ariaRequired = false } = htmlProps;
  const generatedId = useId8();
  const uniqueGroupId = groupId != null ? groupId : `${generatedId}-radioButtonGroup`;
  const { groupValue, handleChange } = useControllableGroupState({
    value,
    defaultValue,
    onChange
  });
  const hasErrorMessage = !!errorMessage;
  const showRequiredMarker = required || convertBooleanishToBoolean(ariaRequired);
  const tipId = tip && `${uniqueGroupId}-tip`;
  const errorMessageId = errorMessage && `${uniqueGroupId}-errorMessage`;
  const contextProps = {
    name,
    disabled,
    defaultValue,
    error: hasErrorMessage,
    errorMessageId,
    required,
    readOnly,
    value: groupValue,
    onChange: handleChange
  };
  return /* @__PURE__ */ jsxs38(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, SelectionControl_default.container),
        { ...htmlProps, "aria-required": ariaRequired },
        rest
      ),
      children: [
        label !== void 0 ? /* @__PURE__ */ jsx213(
          GroupLabel,
          {
            id: uniqueGroupId,
            readOnly,
            showRequiredMarker,
            children: label
          }
        ) : null,
        renderInputMessage(tip, tipId),
        /* @__PURE__ */ jsx213(RadioButtonGroupContext, { value: { ...contextProps }, children: /* @__PURE__ */ jsx213(
          "div",
          {
            role: "radiogroup",
            "aria-labelledby": uniqueGroupId,
            "aria-describedby": tipId,
            "aria-errormessage": errorMessageId,
            className: cn(SelectionControl_default.group, SelectionControl_default[`group--${direction}`]),
            children
          }
        ) }),
        renderInputMessage(void 0, void 0, errorMessage, errorMessageId)
      ]
    }
  );
};
RadioButtonGroup.displayName = "RadioButtonGroup";

// src/components/Card/CardSelectionControl/CardSelectable.context.tsx
import { createContext as createContext6, useContext as useContext6 } from "react";
var CardSelectableContext = createContext6({});
var useCardSelectableContext = () => useContext6(CardSelectableContext);

// src/components/Card/CardSelectionControl/CardSelectable.tsx
import { jsx as jsx214 } from "react/jsx-runtime";
var CardSelectable = (props) => {
  const {
    appearance = "filled",
    cardType: cardTypeProp,
    id,
    padding,
    controlPlacementProps = {},
    "aria-describedby": ariaDescribedby,
    className,
    htmlProps,
    ...rest
  } = props;
  const { left, top } = controlPlacementProps;
  const radioGroup = useRadioButtonGroup();
  const checkboxGroup = useCheckboxGroup();
  const { cardType: cardTypeContext, tipId } = useCardSelectableContext();
  const cardType = cardTypeProp != null ? cardTypeProp : cardTypeContext;
  const group = cardTypeContext === "radio" ? radioGroup : checkboxGroup;
  const {
    disabled = group == null ? void 0 : group.disabled,
    readOnly = group == null ? void 0 : group.readOnly,
    error = group == null ? void 0 : group.error,
    name = radioGroup == null ? void 0 : radioGroup.name,
    value = radioGroup == null ? void 0 : radioGroup.value,
    defaultValue = radioGroup == null ? void 0 : radioGroup.defaultValue,
    required = radioGroup == null ? void 0 : radioGroup.required
  } = { ...group, ...rest };
  const classNames = cn(
    className,
    Card_default.container,
    Card_default[`container--${appearance}`],
    Card_default[`container--selection-control`],
    readOnly && Card_default[`container--selection-control--readonly`],
    disabled && Card_default[`container--selection-control--disabled`],
    error && Card_default[`container--selection-control--error`],
    focus_default["has-focusable-input"]
  );
  const radioContextProps = {
    name,
    required,
    value,
    defaultValue
  };
  const customStyles = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-selection-control-card-padding"]: padding != null ? padding : "var(--dds-spacing-x1-5) var(--dds-spacing-x1-5) var(--dds-spacing-x1-5) calc(var(--dds-selection-control-height) + var(--dds-spacing-x0-5) + var(--dds-spacing-x1-5))",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-selection-control-card-control-top"]: top != null ? top : `calc(
        (var(--dds-font-lineheight-x1) * 1em - var(--dds-icon-size-small)) / 2 -
        1px + var(--dds-spacing-x1-5)
        )`,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-selection-control-card-control-left"]: left != null ? left : `var(--dds-spacing-x1-5)`
  };
  const sharedProps = {
    ...getBaseHTMLProps(id, classNames, htmlProps, rest),
    htmlProps: {
      ...htmlProps,
      style: {
        ...htmlProps == null ? void 0 : htmlProps.style,
        ...customStyles
      }
    },
    disabled,
    readOnly,
    error,
    "aria-describedby": spaceSeparatedIdListGenerator([tipId, ariaDescribedby])
  };
  return cardType === "radio" ? /* @__PURE__ */ jsx214(RadioButton, { ...sharedProps, ...radioContextProps }) : cardType === "checkbox" ? /* @__PURE__ */ jsx214(Checkbox, { ...sharedProps }) : null;
};
CardSelectable.displayName = "CardSelectable";

// src/components/Card/CardSelectionControl/CardSelectableGroup.tsx
import { useId as useId9 } from "react";
import { jsx as jsx215, jsxs as jsxs39 } from "react/jsx-runtime";
var CardSelectableGroup = ({
  name,
  cardType,
  errorMessage,
  disabled,
  readOnly,
  value,
  defaultValue,
  children,
  required,
  onChange,
  id,
  tipId,
  className,
  htmlProps = {},
  "aria-describedby": ariaDescribedby,
  ...rest
}) => {
  const { "aria-required": ariaRequired = false } = htmlProps;
  const generatedId = useId9();
  const uniqueGroupId = id != null ? id : `${generatedId}-cardSelectableGroup`;
  const { groupValue, handleChange } = useControllableGroupState({
    value,
    defaultValue,
    onChange: (e, v) => onChange == null ? void 0 : onChange(v)
  });
  const hasErrorMessage = !!errorMessage;
  const errorMessageId = errorMessage && `${uniqueGroupId}-errorMessage`;
  const contextProps = {
    name,
    disabled,
    defaultValue,
    error: hasErrorMessage,
    errorMessageId,
    required,
    readOnly,
    value: groupValue,
    onChange: handleChange
  };
  const generalContextProps = {
    cardType,
    tipId
  };
  const mainContent = /* @__PURE__ */ jsx215(
    Box,
    {
      ...getBaseHTMLProps(
        uniqueGroupId,
        className,
        { ...htmlProps, "aria-required": ariaRequired },
        rest
      ),
      role: cardType === "radio" ? "radiogroup" : "group",
      "aria-describedby": spaceSeparatedIdListGenerator([tipId, ariaDescribedby]),
      "aria-errormessage": errorMessageId,
      children: /* @__PURE__ */ jsx215(CardSelectableContext, { value: generalContextProps, children: cardType === "radio" ? /* @__PURE__ */ jsx215(RadioButtonGroupContext, { value: contextProps, children }) : cardType === "checkbox" ? /* @__PURE__ */ jsx215(CheckboxGroupContext, { value: contextProps, children }) : null })
    }
  );
  return hasErrorMessage ? /* @__PURE__ */ jsxs39("div", { children: [
    mainContent,
    renderInputMessage(void 0, void 0, errorMessage, errorMessageId)
  ] }) : mainContent;
};
CardSelectableGroup.displayName = "CardSelectableGroup";

// src/components/Chip/Chip.tsx
import { useState as useState10 } from "react";

// src/components/Chip/Chip.module.css
var Chip_default = {
  container: "Chip_container"
};

// src/components/Chip/Chip.tsx
import { jsx as jsx216, jsxs as jsxs40 } from "react/jsx-runtime";
var Chip = ({
  text,
  onClose,
  id,
  className,
  htmlProps = {},
  ...rest
}) => {
  const { "aria-label": ariaLabel, ...restHTMLprops } = htmlProps;
  const [isOpen, setIsOpen] = useState10(true);
  const onClick = () => {
    setIsOpen(false);
    onClose && onClose();
  };
  return isOpen ? /* @__PURE__ */ jsxs40(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, Chip_default.container),
        restHTMLprops,
        rest
      ),
      children: [
        /* @__PURE__ */ jsx216(TextOverflowEllipsisInner, { className: cn(typographyStyles_default["body-small"]), children: text }),
        /* @__PURE__ */ jsx216(
          Button,
          {
            size: "xsmall",
            icon: CloseSmallIcon,
            purpose: "tertiary",
            onClick,
            "aria-label": ariaLabel != null ? ariaLabel : `Fjern ${text ? `chip ${text}` : "chip"}`
          }
        )
      ]
    }
  ) : null;
};
Chip.displayName = "Chip";

// src/components/Chip/ChipGroup.tsx
import { Children as Children2 } from "react";
import { jsx as jsx217 } from "react/jsx-runtime";
var ChipGroup = ({ children, ...rest }) => {
  const childrenArray = Children2.toArray(children);
  return /* @__PURE__ */ jsx217(HStack, { as: StylelessList, ...rest, gap: "x0.75", children: childrenArray.map((item, index) => /* @__PURE__ */ jsx217("li", { children: item }, `chip-${index}`)) });
};
ChipGroup.displayName = "ChipGroup";

// src/components/Contrast/Contrast.module.css
var Contrast_default = {
  container: "Contrast_container"
};

// src/components/Contrast/Contrast.tsx
import { jsx as jsx218 } from "react/jsx-runtime";
var Contrast = ({
  className,
  as = "div",
  ...rest
}) => {
  return /* @__PURE__ */ jsx218(
    ElementAs,
    {
      as,
      className: cn(className, typographyStyles_default.contrast, Contrast_default.container),
      ...rest
    }
  );
};

// src/components/CookieBanner/CookieBanner.module.css
var CookieBanner_default = {
  "checkbox-label": "CookieBanner_checkbox-label"
};

// src/components/CookieBanner/CookieBannerCheckbox.tsx
import { jsx as jsx219, jsxs as jsxs41 } from "react/jsx-runtime";
function CookieBannerCheckbox({
  headerText,
  description,
  id,
  className,
  htmlProps,
  ...rest
}) {
  return /* @__PURE__ */ jsx219(
    Checkbox,
    {
      ...getBaseHTMLProps(
        id,
        cn(className, CookieBanner_default["checkbox-label"]),
        htmlProps,
        rest
      ),
      children: /* @__PURE__ */ jsxs41(VStack, { gap: "x0.5", children: [
        /* @__PURE__ */ jsx219(Typography, { as: "span", typographyType: "headingSmall", children: headerText }),
        /* @__PURE__ */ jsxs41(Typography, { as: "span", children: [
          " ",
          description,
          " "
        ] })
      ] })
    }
  );
}
CookieBannerCheckbox.displayName = "CookieBannerCheckbox";

// src/components/CookieBanner/CookieBanner.tsx
import { jsx as jsx220, jsxs as jsxs42 } from "react/jsx-runtime";
function CookieBanner({
  headerText,
  description,
  buttons,
  checkboxes,
  id,
  className,
  htmlProps,
  "aria-label": ariaLabel = "Samtykke for bruk av informasjonskapsler",
  maxHeight = "calc(100vh - 100px)",
  width = "fit-content",
  children,
  ...rest
}) {
  return /* @__PURE__ */ jsx220(
    Paper,
    {
      ...getBaseHTMLProps(
        id,
        cn(className, utilStyles_default.scrollbar, utilStyles_default["scrollable-y"]),
        htmlProps,
        rest
      ),
      role: "region",
      "aria-label": ariaLabel,
      padding: applyResponsiveStyle("x1", "sm", "x1.5"),
      width,
      maxHeight,
      border: "border-default",
      background: "brand-tertiary-medium",
      children: /* @__PURE__ */ jsxs42(VStack, { maxWidth: "70ch", gap: "x1", children: [
        headerText && /* @__PURE__ */ jsx220(Heading, { level: 2, typographyType: "headingMedium", children: headerText }),
        children,
        description && /* @__PURE__ */ jsx220("div", { children: description }),
        checkboxes && /* @__PURE__ */ jsx220(VStack, { gap: "x1", children: checkboxes.map((props) => /* @__PURE__ */ jsx220(CookieBannerCheckbox, { ...props })) }),
        buttons && /* @__PURE__ */ jsx220(
          HStack,
          {
            gap: applyResponsiveStyle("x1", "sm", "x1.5"),
            flexWrap: "wrap",
            paddingBlock: "x0.25 0",
            children: buttons.map((props) => /* @__PURE__ */ jsx220(Button, { ...props, size: "medium", purpose: "secondary" }))
          }
        )
      ] })
    }
  );
}
CookieBanner.displayName = "CookieBanner";

// src/components/date-inputs/DatePicker/Calendar/Calendar.tsx
import { GregorianCalendar } from "@internationalized/date";
import {
  useCalendar
} from "@react-aria/calendar";
import { useLocale as useLocale2 } from "@react-aria/i18n";
import { useCalendarState } from "@react-stately/calendar";
import {
  useContext as useContext10
} from "react";

// src/components/date-inputs/DatePicker/Calendar/CalendarGrid.tsx
import { getWeeksInMonth } from "@internationalized/date";
import {
  useCalendarGrid
} from "@react-aria/calendar";
import { useLocale } from "@react-aria/i18n";
import { useContext as useContext9 } from "react";

// src/components/date-inputs/DatePicker/Calendar/CalendarCell.tsx
import { isToday } from "@internationalized/date";
import {
  useCalendarCell
} from "@react-aria/calendar";
import { useRef as useRef10 } from "react";

// src/components/date-inputs/common/DateInput.module.css
var DateInput_default = {
  "date-input": "DateInput_date-input",
  "date-input--medium": "DateInput_date-input--medium",
  "date-input--small": "DateInput_date-input--small",
  "date-input--xsmall": "DateInput_date-input--xsmall",
  "date-segment-container": "DateInput_date-segment-container",
  segment: "DateInput_segment",
  segment__placeholder: "DateInput_segment__placeholder",
  "segment__placeholder--invisible": "DateInput_segment__placeholder--invisible",
  "icon-wrapper": "DateInput_icon-wrapper",
  "icon-wrapper--disabled": "DateInput_icon-wrapper--disabled",
  "icon-wrapper--readonly": "DateInput_icon-wrapper--readonly",
  "icon-wrapper--small": "DateInput_icon-wrapper--small",
  "icon-wrapper--medium": "DateInput_icon-wrapper--medium",
  "popover-button": "DateInput_popover-button",
  disabled: "DateInput_disabled",
  "popover-button--readonly": "DateInput_popover-button--readonly",
  popover: "DateInput_popover",
  "modal-close-button-wrapper": "DateInput_modal-close-button-wrapper",
  calendar: "DateInput_calendar",
  calendar__header__month: "DateInput_calendar__header__month",
  "calendar__month-button": "DateInput_calendar__month-button",
  "calendar__grid-element": "DateInput_calendar__grid-element",
  "calendar__week-number": "DateInput_calendar__week-number",
  "calendar__cell-button": "DateInput_calendar__cell-button",
  "calendar__cell-button--today": "DateInput_calendar__cell-button--today",
  "calendar__cell-button--default": "DateInput_calendar__cell-button--default",
  "calendar__cell-button--selected": "DateInput_calendar__cell-button--selected",
  "calendar__cell-button--unavailable": "DateInput_calendar__cell-button--unavailable",
  "calendar__cell-button--unavailable--today": "DateInput_calendar__cell-button--unavailable--today"
};

// src/components/date-inputs/DatePicker/constants.ts
var locale = "no-NO";
var timezone = "Europe/Oslo";

// src/components/date-inputs/DatePicker/Calendar/CalendarCell.tsx
import { jsx as jsx221 } from "react/jsx-runtime";
function CalendarCell({ date, state, onClose }) {
  const ref = useRef10(null);
  const {
    buttonProps,
    cellProps,
    isOutsideVisibleRange,
    formattedDate,
    isSelected,
    isDisabled,
    isUnavailable
  } = useCalendarCell({ date }, state, ref);
  if (isDisabled) {
    return /* @__PURE__ */ jsx221("td", { ...cellProps });
  }
  const variant = isSelected ? "selected" : isUnavailable || isDisabled ? "unavailable" : "default";
  const closeOnKeyboardBlurForward = (event) => {
    if (event.key === "Tab" && event.shiftKey === false) {
      onClose();
    }
  };
  return /* @__PURE__ */ jsx221("td", { ...cellProps, children: /* @__PURE__ */ jsx221(
    "button",
    {
      ...buttonProps,
      type: "button",
      ref,
      hidden: isOutsideVisibleRange,
      onKeyDown: closeOnKeyboardBlurForward,
      className: cn(
        DateInput_default["calendar__grid-element"],
        DateInput_default["calendar__cell-button"],
        isToday(date, timezone) && DateInput_default["calendar__cell-button--today"],
        DateInput_default[`calendar__cell-button--${variant}`],
        typographyStyles_default["body-small"],
        focusable
      ),
      children: formattedDate
    }
  ) });
}
CalendarCell.displayName = "CalendarCell";

// src/components/VisuallyHidden/VisuallyHidden.tsx
import { jsx as jsx222 } from "react/jsx-runtime";
var VisuallyHidden = (props) => {
  const { id, className, htmlProps, as, ...rest } = props;
  const cl = cn(className, utilStyles_default["visually-hidden"]);
  if (as === "div") {
    return /* @__PURE__ */ jsx222("div", { ...getBaseHTMLProps(id, cl, htmlProps, rest) });
  }
  return /* @__PURE__ */ jsx222("span", { ...getBaseHTMLProps(id, cl, htmlProps, rest) });
};
VisuallyHidden.displayName = "VisuallyHidden";

// src/components/date-inputs/utils/getWeekNumber.ts
import {
  endOfYear,
  startOfWeek,
  startOfYear
} from "@internationalized/date";
function getWeekNumber(date) {
  const dayOfWeek = getDayOfWeek(date);
  const dayOfYear = getDayOfYear(date);
  const jan1DayOfWeek = getDayOfWeek(startOfYear(date));
  const isPartOfLastWeekOfPreviousYear = dayOfYear <= 8 - jan1DayOfWeek && jan1DayOfWeek > 4;
  if (isPartOfLastWeekOfPreviousYear) {
    if (jan1DayOfWeek === 5 || jan1DayOfWeek === 6 && isLeapYear(date.subtract({ years: 1 }))) {
      return 53;
    }
    return 52;
  }
  const daysInYear = getDayOfYear(endOfYear(date));
  if (daysInYear - dayOfYear < 4 - dayOfWeek) {
    return 1;
  }
  const weekNum = (dayOfYear + (7 - dayOfWeek) + (jan1DayOfWeek - 1)) / 7;
  if (jan1DayOfWeek > 4) {
    return weekNum - 1;
  }
  return weekNum;
}
function getDayOfWeek(date) {
  const weekStart = startOfWeek(date, "no-NO");
  return date.calendar.toJulianDay(date) - weekStart.calendar.toJulianDay(weekStart) + 1;
}
function getDayOfYear(date) {
  const yearStart = startOfYear(date);
  return date.calendar.toJulianDay(date) - yearStart.calendar.toJulianDay(yearStart) + 1;
}
function isLeapYear(date) {
  return date.year % 4 === 0 && date.year % 100 !== 0 || date.year % 400 === 0;
}

// src/components/date-inputs/DatePicker/CalendarPopover.tsx
import {
  createContext as createContext8,
  useContext as useContext8,
  useEffect as useEffect18,
  useRef as useRef12
} from "react";
import { createPortal } from "react-dom";

// src/components/ThemeProvider/ThemeProvider.tsx
import { ddsTokens } from "@norges-domstoler/dds-design-tokens";
import {
  createContext as createContext7,
  useContext as useContext7,
  useEffect as useEffect17,
  useRef as useRef11,
  useState as useState11
} from "react";

// src/components/ThemeProvider/ThemeProvider.module.css
var ThemeProvider_default = {
  "global-variables": "ThemeProvider_global-variables",
  "global-styles": "ThemeProvider_global-styles"
};

// src/components/ThemeProvider/ThemeProvider.tsx
import { jsx as jsx223 } from "react/jsx-runtime";
var defaultTheme = "core";
var ThemeContext = createContext7(
  void 0
);
function ThemeProvider({
  theme = defaultTheme,
  children
}) {
  const themeRef = useRef11(null);
  const [element, setElement] = useState11(null);
  useEffect17(() => {
    setElement(themeRef.current);
  }, []);
  return /* @__PURE__ */ jsx223(
    "div",
    {
      ref: themeRef,
      className: cn(
        `dds-${theme}`,
        ThemeProvider_default["global-variables"],
        ThemeProvider_default["global-styles"],
        "dds-themed"
      ),
      children: /* @__PURE__ */ jsx223(ThemeContext, { value: { theme, el: element }, children })
    }
  );
}
function useTheme() {
  var _a;
  const themeName = (_a = useContext7(ThemeContext)) == null ? void 0 : _a.theme;
  if (!themeName) {
    throw new Error("useTheme must be used inside a ThemeProvider");
  }
  const theme = ddsTokens[themeName];
  return { theme, themeName };
}

// src/components/date-inputs/DatePicker/CalendarPopover.tsx
import { Fragment as Fragment4, jsx as jsx224, jsxs as jsxs43 } from "react/jsx-runtime";
var CalendarPopoverContext = createContext8({
  anchorRef: null,
  closeButtonRef: null,
  isOpen: false,
  onClose: () => null,
  showWeekNumbers: true
});
var CalendarPopover = ({
  children,
  onClose,
  ...props
}) => {
  const anchorRef = useRef12(null);
  const closeButtonRef = useRef12(null);
  useOnKeyDown("Escape", onClose);
  return /* @__PURE__ */ jsx224(
    CalendarPopoverContext,
    {
      value: { anchorRef, closeButtonRef, onClose, ...props },
      children
    }
  );
};
var CalendarPopoverAnchor = ({
  children
}) => {
  const { anchorRef } = useContext8(CalendarPopoverContext);
  return /* @__PURE__ */ jsx224("div", { ref: anchorRef != null ? anchorRef : void 0, children });
};
var CalendarPopoverContent = ({
  children,
  className,
  smallScreenBreakpoint
}) => {
  const ref = useRef12(null);
  const modalRef = useRef12(null);
  const { refs, styles: floatingStyles } = useFloatPosition(null, {
    placement: "bottom-start"
  });
  const themeContext = useContext8(ThemeContext);
  if (!themeContext) {
    throw new Error("DatePicker must be used within a ThemeProvider");
  }
  const portalTarget = themeContext.el;
  const { isOpen, onClose, anchorRef, closeButtonRef } = useContext8(
    CalendarPopoverContext
  );
  const hasTransitionedIn = useMountTransition(isOpen, 500);
  const isMounted = isOpen && hasTransitionedIn;
  const combinedRef = useCombinedRef(refs.setFloating, ref);
  useOnClickOutside([ref.current, modalRef.current], onClose);
  useEffect18(() => {
    var _a;
    refs.setReference((_a = anchorRef == null ? void 0 : anchorRef.current) != null ? _a : null);
  }, []);
  const hasBreakpoint = !!smallScreenBreakpoint;
  useEffect18(() => {
    var _a;
    if (hasBreakpoint && ((_a = modalRef.current) == null ? void 0 : _a.checkVisibility())) {
      if (isOpen) {
        handleElementWithBackdropMount(document.body);
      } else {
        handleElementWithBackdropUnmount(document.body);
      }
      return () => handleElementWithBackdropUnmount(document.body);
    }
  }, [isOpen, hasBreakpoint]);
  const closeOnKeyboardBlurBack = (event) => {
    if (event.key === "Tab" && event.shiftKey === true) {
      onClose();
    }
  };
  if (!isOpen) return null;
  const paperStyleProps = {
    elevation: 2,
    border: "border-default",
    padding: "x0.75"
  };
  return /* @__PURE__ */ jsxs43(Fragment4, { children: [
    portalTarget && hasBreakpoint && createPortal(
      /* @__PURE__ */ jsx224(ShowHide, { showBelow: smallScreenBreakpoint, children: /* @__PURE__ */ jsx224(Backdrop, { zIndex: "modal", isMounted, children: /* @__PURE__ */ jsxs43(
        Paper,
        {
          ref: modalRef,
          className: cn(DateInput_default.popover, className),
          ...paperStyleProps,
          children: [
            /* @__PURE__ */ jsx224("div", { className: DateInput_default["modal-close-button-wrapper"], children: /* @__PURE__ */ jsx224(
              Button,
              {
                ref: closeButtonRef,
                icon: CloseIcon,
                size: "small",
                purpose: "tertiary",
                "aria-label": "Lukk",
                onClick: onClose,
                htmlProps: { onKeyDown: closeOnKeyboardBlurBack }
              }
            ) }),
            children
          ]
        }
      ) }) }),
      portalTarget
    ),
    /* @__PURE__ */ jsx224(
      Paper,
      {
        ref: combinedRef,
        hideBelow: hasBreakpoint ? smallScreenBreakpoint : void 0,
        className: cn(DateInput_default.popover, className),
        style: floatingStyles.floating,
        ...paperStyleProps,
        children
      }
    )
  ] });
};

// src/components/date-inputs/DatePicker/Calendar/CalendarGrid.tsx
import { jsx as jsx225, jsxs as jsxs44 } from "react/jsx-runtime";
function CalendarGrid({ state, ...props }) {
  const { locale: locale2 } = useLocale();
  const {
    gridProps: { onKeyDown, ...gridProps },
    headerProps
  } = useCalendarGrid(props, state);
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale2);
  const weekDays = ["Ma", "Ti", "On", "To", "Fr", "L\xF8", "S\xF8"];
  const { showWeekNumbers, onClose } = useContext9(CalendarPopoverContext);
  const typographyCn = [
    typographyStyles_default["body-xsmall"],
    typographyStyles_default["text-color--subtle"]
  ];
  return /* @__PURE__ */ jsxs44(
    "table",
    {
      ...gridProps,
      onKeyDown: (e) => {
        if ((e.key === "Enter" || e.key === " ") && state.isCellUnavailable(state.focusedDate)) {
          return;
        }
        onKeyDown == null ? void 0 : onKeyDown(e);
      },
      cellPadding: "0",
      children: [
        /* @__PURE__ */ jsx225("thead", { ...headerProps, children: /* @__PURE__ */ jsxs44("tr", { children: [
          showWeekNumbers && /* @__PURE__ */ jsxs44(
            "th",
            {
              className: cn(DateInput_default["calendar__grid-element"], ...typographyCn),
              children: [
                "# ",
                /* @__PURE__ */ jsx225(VisuallyHidden, { as: "span", children: "Ukenummer" })
              ]
            }
          ),
          weekDays.map((day, index) => /* @__PURE__ */ jsx225("th", { className: cn(...typographyCn), children: day }, index))
        ] }) }),
        /* @__PURE__ */ jsx225("tbody", { children: [...new Array(weeksInMonth).keys()].map((weekIndex) => {
          const datesInWeek = state.getDatesInWeek(weekIndex);
          const firstExistingDay = datesInWeek.find(Boolean);
          const weekNumber = firstExistingDay ? getWeekNumber(firstExistingDay) : "";
          return /* @__PURE__ */ jsxs44("tr", { children: [
            showWeekNumbers && /* @__PURE__ */ jsx225(
              "td",
              {
                className: cn(
                  DateInput_default["calendar__grid-element"],
                  DateInput_default["calendar__week-number"],
                  ...typographyCn
                ),
                children: weekNumber
              }
            ),
            datesInWeek.map(
              (date, i) => date ? /* @__PURE__ */ jsx225(
                CalendarCell,
                {
                  state,
                  date,
                  onClose
                },
                i
              ) : /* @__PURE__ */ jsx225("td", {}, i)
            )
          ] }, weekIndex);
        }) })
      ]
    }
  );
}
CalendarGrid.displayName = "CalendarGrid";

// src/components/date-inputs/DatePicker/Calendar/Calendar.tsx
import { jsx as jsx226, jsxs as jsxs45 } from "react/jsx-runtime";
function createCalendar(identifier) {
  switch (identifier) {
    case "gregory":
      return new GregorianCalendar();
    default:
      throw new Error(`Unsupported calendar ${identifier}`);
  }
}
function Calendar(props) {
  const { locale: locale2 } = useLocale2();
  const state = useCalendarState({
    ...props,
    createCalendar,
    locale: locale2
  });
  const {
    calendarProps,
    prevButtonProps: { onPress: onPrev, "aria-label": prevAriaLabel },
    nextButtonProps: { onPress: onNext, "aria-label": nextAriaLabel },
    title
  } = useCalendar(props, state);
  const { onClose, closeButtonRef } = useContext10(CalendarPopoverContext);
  const closeOnKeyboardBlurBack = (event) => {
    var _a;
    if (event.key === "Tab" && event.shiftKey === true) {
      if (!((_a = closeButtonRef == null ? void 0 : closeButtonRef.current) == null ? void 0 : _a.checkVisibility())) {
        onClose();
      }
    }
  };
  return /* @__PURE__ */ jsxs45("div", { ...calendarProps, className: DateInput_default.calendar, children: [
    /* @__PURE__ */ jsxs45(HStack, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jsx226(
        Button,
        {
          type: "button",
          "aria-label": prevAriaLabel,
          onClick: (e) => onPrev == null ? void 0 : onPrev(e),
          size: "small",
          purpose: "tertiary",
          icon: ArrowLeftIcon,
          htmlProps: { onKeyDown: closeOnKeyboardBlurBack },
          className: DateInput_default["calendar__month-button"]
        }
      ),
      /* @__PURE__ */ jsx226(
        Heading,
        {
          level: 2,
          typographyType: "headingXsmall",
          className: DateInput_default.calendar__header__month,
          children: title
        }
      ),
      /* @__PURE__ */ jsx226(
        Button,
        {
          type: "button",
          "aria-label": nextAriaLabel,
          onClick: (e) => onNext == null ? void 0 : onNext(e),
          size: "small",
          purpose: "tertiary",
          icon: ArrowRightIcon,
          className: DateInput_default["calendar__month-button"]
        }
      )
    ] }),
    /* @__PURE__ */ jsx226(CalendarGrid, { state })
  ] });
}
Calendar.displayName = "Calendar";

// src/components/date-inputs/DatePicker/DatePicker.tsx
import { useDatePicker } from "@react-aria/datepicker";
import { I18nProvider } from "@react-aria/i18n";
import { useDatePickerState } from "@react-stately/datepicker";
import { useRef as useRef17 } from "react";

// src/components/date-inputs/DatePicker/DateField/DateField.tsx
import {
  createCalendar as createCalendar2
} from "@internationalized/date";
import {
  useDateField
} from "@react-aria/datepicker";
import { useLocale as useLocale3 } from "@react-aria/i18n";
import { useDateFieldState } from "@react-stately/datepicker";
import { useRef as useRef15 } from "react";

// src/components/date-inputs/DatePicker/DateField/CalendarButton.tsx
import { useButton } from "@react-aria/button";
import { useRef as useRef13 } from "react";
import { jsx as jsx227 } from "react/jsx-runtime";
function CalendarButton({
  componentSize,
  isReadOnly,
  ...props
}) {
  const ref = useRef13(null);
  const { buttonProps } = useButton(props, ref);
  const size2 = componentSize === "xsmall" ? "small" : "medium";
  return /* @__PURE__ */ jsx227(
    "button",
    {
      ...buttonProps,
      ref,
      type: "button",
      className: cn(
        buttonProps.className,
        DateInput_default["icon-wrapper"],
        DateInput_default[`icon-wrapper--${size2}`],
        DateInput_default["popover-button"],
        isReadOnly && DateInput_default["popover-button--readonly"],
        !props.isDisabled && focusable,
        props.isDisabled && "disabled"
      ),
      children: /* @__PURE__ */ jsx227(Icon, { icon: CalendarIcon, iconSize: size2 })
    }
  );
}

// src/components/date-inputs/DatePicker/DateField/DateSegment.tsx
import { useDateSegment } from "@react-aria/datepicker";
import { useRef as useRef14 } from "react";
import { jsx as jsx228, jsxs as jsxs46 } from "react/jsx-runtime";
var typographyTypes = {
  medium: "bodyMedium",
  small: "bodySmall",
  xsmall: "bodyXsmall"
};
function DateSegment({
  segment,
  state,
  componentSize
}) {
  var _a;
  const ref = useRef14(null);
  const { segmentProps } = useDateSegment(segment, state, ref);
  return /* @__PURE__ */ jsxs46(
    "div",
    {
      ...segmentProps,
      ref,
      className: cn(
        segmentProps.className,
        DateInput_default.segment,
        typographyStyles_default[getTypographyCn(typographyTypes[componentSize])]
      ),
      style: {
        ...segmentProps.style,
        minWidth: segment.maxValue != null ? String(segment.maxValue).length + "ch" : void 0
      },
      children: [
        /* @__PURE__ */ jsx228(
          "span",
          {
            "aria-hidden": "true",
            className: cn(
              DateInput_default.segment__placeholder,
              !segment.isPlaceholder && DateInput_default["segment__placeholder--invisible"],
              typographyStyles_default[getTypographyCn(typographyTypes[componentSize])]
            ),
            children: segment.placeholder
          }
        ),
        segment.isPlaceholder ? "" : segment.text.padStart(String((_a = segment.maxValue) != null ? _a : "").length, "0")
      ]
    }
  );
}
DateSegment.displayName = "DateSegment";

// src/components/date-inputs/common/DateInput.tsx
import { useContext as useContext11 } from "react";
import { jsx as jsx229, jsxs as jsxs47 } from "react/jsx-runtime";
function DateInput({
  errorMessage,
  tip,
  componentSize = "medium",
  style,
  className,
  disabled,
  active,
  internalRef,
  readOnly,
  required,
  children,
  prefix: button,
  labelProps,
  fieldProps,
  groupProps,
  width,
  ref,
  ...props
}) {
  var _a;
  const hasErrorMessage = !!errorMessage;
  const hasTip = !!tip;
  const hasLabel = props.label != null;
  const hasMessage = hasErrorMessage || hasTip;
  const { isOpen } = useContext11(CalendarPopoverContext);
  return /* @__PURE__ */ jsxs47(
    "div",
    {
      ...groupProps,
      className: cn(className, Input_default.container),
      ref,
      children: [
        hasLabel && /* @__PURE__ */ jsx229(
          Label,
          {
            ...labelProps,
            showRequiredStyling: required,
            className: Input_default.label,
            readOnly,
            children: props.label
          }
        ),
        /* @__PURE__ */ jsxs47(
          Box,
          {
            ...fieldProps,
            style,
            ref: internalRef,
            width: getInputWidth(width, "fit-content"),
            className: cn(
              Input_default.input,
              Input_default["input--stateful"],
              Input_default["input--hover"],
              Input_default[`input--${componentSize}`],
              hasErrorMessage && Input_default["input--stateful-danger"],
              DateInput_default["date-input"],
              DateInput_default[`date-input--${componentSize}`],
              focus_default["focusable-within"],
              isOpen && focus_default.focused,
              disabled && "disabled",
              disabled && Input_default.disabled,
              active && "active",
              readOnly && "read-only",
              readOnly && Input_default["read-only"]
            ),
            children: [
              button,
              /* @__PURE__ */ jsx229("div", { className: DateInput_default["date-segment-container"], children })
            ]
          }
        ),
        hasMessage && /* @__PURE__ */ jsx229(
          InputMessage,
          {
            messageType: hasErrorMessage ? "error" : "tip",
            message: (_a = errorMessage != null ? errorMessage : tip) != null ? _a : ""
          }
        )
      ]
    }
  );
}
DateInput.displayName = "DateInput";

// src/components/date-inputs/DatePicker/DateField/DateField.tsx
import { jsx as jsx230 } from "react/jsx-runtime";
function DateField({
  componentSize = "medium",
  buttonProps,
  groupProps,
  ref,
  ...props
}) {
  const { locale: locale2 } = useLocale3();
  const state = useDateFieldState({
    ...props,
    locale: locale2,
    createCalendar: createCalendar2
  });
  const internalRef = useRef15(null);
  const { labelProps, fieldProps } = useDateField(props, state, internalRef);
  const disabled = props.isDisabled || !!fieldProps["aria-disabled"];
  return /* @__PURE__ */ jsx230(
    DateInput,
    {
      ...props,
      groupProps,
      componentSize,
      label: props.label,
      disabled,
      required: props.isRequired,
      ref,
      internalRef,
      readOnly: props.isReadOnly,
      prefix: /* @__PURE__ */ jsx230(
        CalendarButton,
        {
          componentSize,
          ...buttonProps,
          isReadOnly: props.isReadOnly,
          isDisabled: disabled || props.isReadOnly
        }
      ),
      labelProps,
      fieldProps,
      children: state.segments.map((segment, i) => /* @__PURE__ */ jsx230(
        DateSegment,
        {
          "aria-readonly": props.isReadOnly,
          componentSize,
          segment,
          state
        },
        i
      ))
    }
  );
}
DateField.displayName = "DateField";

// src/components/date-inputs/utils/useFocusManagerRef.ts
import { createFocusManager } from "@react-aria/focus";
import { useImperativeHandle, useRef as useRef16 } from "react";
function useFocusManagerRef(ref) {
  const domRef = useRef16(null);
  useImperativeHandle(ref, () => ({
    ...createDOMRef(domRef),
    focus() {
      createFocusManager(domRef).focusFirst({ tabbable: true });
    }
  }));
  return domRef;
}
function createDOMRef(ref) {
  return {
    UNSAFE_getDOMNode() {
      return ref.current;
    }
  };
}

// src/components/date-inputs/DatePicker/DatePicker.tsx
import { jsx as jsx231, jsxs as jsxs48 } from "react/jsx-runtime";
var refIsFocusable = (ref) => {
  return typeof ref === "object" && ref !== null && "focus" in ref;
};
function DatePicker({
  errorMessage,
  componentSize,
  tip,
  style,
  width,
  smallScreenBreakpoint,
  showWeekNumbers = true,
  ref,
  ...props
}) {
  const state = useDatePickerState(props);
  const domRef = useFocusManagerRef(ref && refIsFocusable(ref) ? ref : null);
  const internalRef = useRef17(null);
  const combinedRef = useCombinedRef(internalRef, domRef);
  const { buttonProps, calendarProps, fieldProps, groupProps } = useDatePicker(
    { ...props, granularity: "day" },
    state,
    internalRef
  );
  return /* @__PURE__ */ jsx231(I18nProvider, { locale, children: /* @__PURE__ */ jsxs48(
    CalendarPopover,
    {
      isOpen: state.isOpen,
      onClose: state.close,
      showWeekNumbers,
      children: [
        /* @__PURE__ */ jsx231(CalendarPopoverAnchor, { children: /* @__PURE__ */ jsx231(
          DateField,
          {
            ...fieldProps,
            groupProps,
            ref: combinedRef,
            componentSize,
            tip,
            label: props.label,
            errorMessage,
            buttonProps,
            style,
            width
          }
        ) }),
        /* @__PURE__ */ jsx231(CalendarPopoverContent, { smallScreenBreakpoint, children: /* @__PURE__ */ jsx231(Calendar, { ...calendarProps }) })
      ]
    }
  ) });
}
DatePicker.displayName = "DatePicker";

// src/components/date-inputs/TimePicker/TimePicker.tsx
import { useTimeField } from "@react-aria/datepicker";
import { useTimeFieldState } from "@react-stately/datepicker";
import { useRef as useRef18 } from "react";
import { jsx as jsx232 } from "react/jsx-runtime";
function TimePicker({
  componentSize = "medium",
  width,
  ref,
  ...props
}) {
  const internalRef = useRef18(null);
  const state = useTimeFieldState({
    ...props,
    locale
  });
  const { labelProps, fieldProps } = useTimeField(
    { ...props, hideTimeZone: true, granularity: "hour" },
    state,
    internalRef
  );
  const iconSize = componentSize === "xsmall" ? "small" : "medium";
  const disabled = props.isDisabled || !!fieldProps["aria-disabled"];
  return /* @__PURE__ */ jsx232(
    DateInput,
    {
      ...props,
      width,
      disabled,
      required: props.isRequired,
      componentSize,
      ref,
      internalRef,
      readOnly: props.isReadOnly,
      labelProps,
      fieldProps,
      prefix: /* @__PURE__ */ jsx232(
        "span",
        {
          className: cn(
            DateInput_default["icon-wrapper"],
            disabled && DateInput_default["icon-wrapper--disabled"],
            props.isReadOnly && DateInput_default["icon-wrapper--readonly"],
            DateInput_default[`icon-wrapper--${iconSize}`]
          ),
          children: /* @__PURE__ */ jsx232(Icon, { icon: TimeIcon, iconSize })
        }
      ),
      children: state.segments.map((segment, i) => /* @__PURE__ */ jsx232(
        DateSegment,
        {
          componentSize,
          segment,
          state
        },
        i
      ))
    }
  );
}
TimePicker.displayName = "TimePicker";

// src/components/date-inputs/utils/transform.ts
import {
  CalendarDate,
  Time,
  fromDate
} from "@internationalized/date";
function nativeDateToDateValue(date, timeZone = "Europe/Oslo") {
  return fromDate(date, timeZone);
}
function dateValueToNativeDate(date, timeZone = "Europe/Oslo") {
  return date.toDate(timeZone);
}
function nativeDateToCalendarDate(date) {
  return new CalendarDate(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  );
}
function nativeDateToTime(date) {
  return new Time(date.getHours(), date.getMinutes(), date.getSeconds());
}
function calendarDateToNativeDate(date, time = new Time(12, 0, 0, 0)) {
  return new Date(
    date.year,
    date.month - 1,
    date.day,
    time.hour,
    time.minute,
    time.second
  );
}

// src/components/DescriptionList/DescriptionList.module.css
var DescriptionList_default = {
  list: "DescriptionList_list",
  "list--default": "DescriptionList_list--default",
  "list--subtle": "DescriptionList_list--subtle",
  "list--row": "DescriptionList_list--row",
  "list--column": "DescriptionList_list--column",
  desc: "DescriptionList_desc",
  group: "DescriptionList_group"
};

// src/components/DescriptionList/DescriptionList.tsx
import { jsx as jsx233 } from "react/jsx-runtime";
var DescriptionList = ({
  appearance = "default",
  direction = "column",
  children,
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsx233(
  VStack,
  {
    as: "dl",
    margin: "x0",
    flexWrap: "wrap",
    rowGap: "x0",
    columnGap: "x2",
    ...getBaseHTMLProps(
      id,
      cn(
        className,
        DescriptionList_default.list,
        DescriptionList_default[`list--${appearance}`],
        DescriptionList_default[`list--${direction}`]
      ),
      htmlProps,
      rest
    ),
    children
  }
);
DescriptionList.displayName = "DescriptionList";

// src/components/DescriptionList/DescriptionListTerm.tsx
import { jsx as jsx234 } from "react/jsx-runtime";
var DescriptionListTerm = (props) => {
  return /* @__PURE__ */ jsx234("dt", { ...props });
};
DescriptionListTerm.displayName = "DescriptionListTerm";

// src/components/DescriptionList/DescriptionListDesc.tsx
import { jsx as jsx235, jsxs as jsxs49 } from "react/jsx-runtime";
var DescriptionListDesc = ({
  children,
  icon,
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsxs49("dd", { ...getBaseHTMLProps(id, cn(className, DescriptionList_default.desc), htmlProps, rest), children: [
  icon && /* @__PURE__ */ jsx235(Icon, { icon }),
  " ",
  children
] });
DescriptionListDesc.displayName = "DescriptionListDesc";

// src/components/DescriptionList/DescriptionListGroup.tsx
import { jsx as jsx236 } from "react/jsx-runtime";
var DescriptionListGroup = ({
  children,
  margin,
  minWidth,
  maxWidth,
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsx236(
  "div",
  {
    ...getBaseHTMLProps(id, cn(className, DescriptionList_default.group), htmlProps, rest),
    style: { ...htmlProps == null ? void 0 : htmlProps.style, maxWidth, minWidth, margin },
    children
  }
);
DescriptionListGroup.displayName = "DescriptionListGroup";

// src/components/DetailList/DetailList.module.css
var DetailList_default = {
  list: "DetailList_list",
  "list--with-dividers": "DetailList_list--with-dividers",
  row: "DetailList_row",
  "list--striped": "DetailList_list--striped",
  "list--striped-with-bp": "DetailList_list--striped-with-bp",
  "list--small": "DetailList_list--small",
  cell: "DetailList_cell",
  "list--medium": "DetailList_list--medium",
  "list--large": "DetailList_list--large",
  column: "DetailList_column",
  term: "DetailList_term"
};

// src/components/DetailList/DetailList.context.tsx
import { createContext as createContext9, useContext as useContext12 } from "react";
var DetailListContext = createContext9({});
var useDetailListContext = () => useContext12(DetailListContext);

// src/components/DetailList/DetailList.tsx
import { jsx as jsx237 } from "react/jsx-runtime";
var DetailList = ({
  id,
  className,
  htmlProps,
  withDividers = true,
  striped = true,
  size: size2 = "medium",
  smallScreenBreakpoint,
  ...rest
}) => /* @__PURE__ */ jsx237(DetailListContext, { value: { smallScreenBreakpoint }, children: /* @__PURE__ */ jsx237(
  "dl",
  {
    ...getBaseHTMLProps(
      id,
      cn(
        className,
        DetailList_default.list,
        DetailList_default[`list--${size2}`],
        withDividers && DetailList_default["list--with-dividers"],
        striped && !smallScreenBreakpoint && DetailList_default["list--striped"],
        striped && smallScreenBreakpoint && DetailList_default["list--striped-with-bp"]
      ),
      htmlProps,
      rest
    )
  }
) });
DetailList.displayName = "DetailList";

// src/components/DetailList/DetailListDesc.tsx
import { jsx as jsx238 } from "react/jsx-runtime";
var DetailListDesc = ({ className, ...rest }) => /* @__PURE__ */ jsx238("dd", { className: cn(className, DetailList_default.cell), ...rest });
DetailListDesc.displayName = "DetailListDesc";

// src/components/DetailList/DetailListRow.tsx
import { Fragment as Fragment5, jsx as jsx239, jsxs as jsxs50 } from "react/jsx-runtime";
var DetailListRow = ({ className, ...rest }) => {
  const { smallScreenBreakpoint: bp } = useDetailListContext();
  const hasBp = !!bp;
  return /* @__PURE__ */ jsxs50(Fragment5, { children: [
    /* @__PURE__ */ jsx239(
      Box,
      {
        display: "table-row",
        hideBelow: hasBp ? bp : void 0,
        className: cn(className, DetailList_default.row),
        ...rest
      }
    ),
    hasBp && /* @__PURE__ */ jsx239(
      Box,
      {
        display: "flex",
        flexDirection: "column",
        showBelow: bp,
        className: cn(className, DetailList_default.row, DetailList_default.column),
        ...rest
      }
    )
  ] });
};
DetailListRow.displayName = "DetailListRow";

// src/components/DetailList/DetailListTerm.tsx
import { jsx as jsx240 } from "react/jsx-runtime";
var DetailListTerm = ({ className, ...rest }) => /* @__PURE__ */ jsx240("dt", { className: cn(className, DetailList_default.cell, DetailList_default.term), ...rest });
DetailListTerm.displayName = "DetailListTerm";

// src/components/Drawer/Drawer.tsx
import {
  useContext as useContext14,
  useEffect as useEffect19,
  useRef as useRef19
} from "react";
import { createPortal as createPortal2 } from "react-dom";

// src/components/Drawer/Drawer.module.css
var Drawer_default = {
  container: "Drawer_container",
  "container--left": "Drawer_container--left",
  "container--left-opened": "Drawer_container--left-opened",
  "container--left-closed": "Drawer_container--left-closed",
  "container--right": "Drawer_container--right",
  "container--right-opened": "Drawer_container--right-opened",
  "container--right-closed": "Drawer_container--right-closed",
  "content-container": "Drawer_content-container",
  "drawer-header": "Drawer_drawer-header",
  "button--close": "Drawer_button--close"
};

// src/components/Drawer/Drawer.context.tsx
import { createContext as createContext10, useContext as useContext13 } from "react";
var DrawerContext = createContext10({});
var useDrawerContext = () => useContext13(DrawerContext);

// src/components/Drawer/Drawer.tsx
import { jsx as jsx241, jsxs as jsxs51 } from "react/jsx-runtime";
var Drawer = ({
  children,
  header,
  placement = "right",
  parentElement,
  size: size2 = "small",
  className,
  htmlProps,
  widthProps = {},
  withBackdrop,
  ref,
  ...rest
}) => {
  const themeContext = useContext14(ThemeContext);
  if (!themeContext) {
    throw new Error("Drawer must be used within a ThemeProvider");
  }
  const portalTarget = parentElement != null ? parentElement : themeContext == null ? void 0 : themeContext.el;
  const { isOpen = false, onClose, drawerId, triggerEl } = useDrawerContext();
  const { minWidth, maxWidth, width } = widthProps;
  const hasHeader = !!header;
  const headerId = hasHeader ? `${drawerId}-header` : void 0;
  const drawerRef = useFocusTrap(isOpen);
  const combinedRef = useCombinedRef(ref, drawerRef);
  useEffect19(() => {
    if (withBackdrop) {
      if (isOpen) {
        handleElementWithBackdropMount(document.body);
      } else {
        handleElementWithBackdropUnmount(document.body);
      }
      return () => handleElementWithBackdropUnmount(document.body);
    }
  }, [isOpen]);
  const elements = [drawerRef.current];
  if (triggerEl) elements.push(triggerEl);
  useOnClickOutside(elements, () => {
    if (isOpen && !withBackdrop) {
      onClose == null ? void 0 : onClose();
    }
  });
  const backdropRef = useRef19(null);
  const onBackdropClick = (event) => {
    if (event.target === backdropRef.current && isOpen && withBackdrop) {
      onClose == null ? void 0 : onClose();
    }
  };
  const hasTransitionedIn = useMountTransition(isOpen, 500);
  const isMounted = hasTransitionedIn && isOpen;
  const isOpenCn = isMounted ? "opened" : "closed";
  const getMaxWidth = (size3) => {
    switch (size3) {
      case "small":
        return "400px";
      case "medium":
        return "600px";
      case "large":
        return "800px";
    }
  };
  const drawer = /* @__PURE__ */ jsxs51(
    Paper,
    {
      ref: combinedRef,
      role: "dialog",
      tabIndex: -1,
      position: "fixed",
      top: "0",
      height: "100%",
      minWidth: minWidth ? minWidth : "300px",
      maxWidth: maxWidth ? maxWidth : getMaxWidth(size2),
      width,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: "var(--dds-drawer-container-padding)",
      borderRadius: "0",
      ...getBaseHTMLProps(
        drawerId,
        cn(
          className,
          Drawer_default.container,
          Drawer_default[`container--${placement}`],
          Drawer_default[`container--${placement}-${isOpenCn}`],
          focus_default["focusable--inset"]
        ),
        htmlProps,
        rest
      ),
      elevation: 4,
      "aria-labelledby": headerId,
      children: [
        /* @__PURE__ */ jsxs51(
          HStack,
          {
            position: "sticky",
            top: "0",
            left: "0",
            width: "100%",
            paddingInline: "var(--dds-drawer-content-container-padding)",
            className: Drawer_default["drawer-header"],
            children: [
              hasHeader && /* @__PURE__ */ jsx241("div", { id: headerId, children: typeof header === "string" ? /* @__PURE__ */ jsx241(Heading, { level: 2, typographyType: "headingLarge", children: header }) : header }),
              /* @__PURE__ */ jsx241(
                Button,
                {
                  className: cn(Drawer_default["button--close"]),
                  "data-testid": "drawer-close-btn",
                  size: "small",
                  purpose: "tertiary",
                  onClick: onClose,
                  "aria-label": "Lukk",
                  icon: CloseIcon
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx241(
          VStack,
          {
            gap: "x1",
            overflowY: "auto",
            className: cn(Drawer_default["content-container"], utilStyles_default.scrollbar),
            children
          }
        )
      ]
    }
  );
  const component = withBackdrop ? /* @__PURE__ */ jsx241(
    Backdrop,
    {
      zIndex: "drawer",
      isMounted,
      ref: backdropRef,
      onClick: onBackdropClick,
      children: drawer
    }
  ) : drawer;
  return (isOpen || hasTransitionedIn) && portalTarget ? createPortal2(component, portalTarget) : null;
};
Drawer.displayName = "Drawer";

// src/components/Drawer/DrawerGroup.tsx
import {
  Children as ReactChildren2,
  cloneElement as cloneElement2,
  isValidElement as isValidElement3,
  useId as useId10,
  useRef as useRef20,
  useState as useState12
} from "react";
import { jsx as jsx242 } from "react/jsx-runtime";
var DrawerGroup = ({
  children,
  isInitiallyOpen,
  isOpen: propIsOpen,
  setIsOpen: propSetIsOpen,
  drawerId,
  onOpen,
  onClose
}) => {
  const [internalIsOpen, internalSetIsOpen] = useState12(isInitiallyOpen);
  const [isOpen, setIsOpen] = [
    propIsOpen != null ? propIsOpen : internalIsOpen,
    propSetIsOpen != null ? propSetIsOpen : internalSetIsOpen
  ];
  const generatedId = useId10();
  const uniqueDrawerId = drawerId != null ? drawerId : `${generatedId}-drawer`;
  const triggerRef = useRef20(null);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const handleOpen = () => {
    open();
    onOpen == null ? void 0 : onOpen();
  };
  const handleClose = () => {
    close();
    onClose == null ? void 0 : onClose();
  };
  useOnKeyDown(["Esc", "Escape"], () => {
    var _a;
    if (isOpen) {
      (_a = triggerRef == null ? void 0 : triggerRef.current) == null ? void 0 : _a.focus();
      handleClose();
    }
  });
  const Children7 = ReactChildren2.map(children, (child, childIndex) => {
    return isValidElement3(child) && (childIndex === 0 ? cloneElement2(child, {
      "aria-haspopup": "dialog",
      "aria-controls": uniqueDrawerId,
      "aria-expanded": isOpen,
      ref: triggerRef,
      onClick: handleOpen
    }) : child);
  });
  return /* @__PURE__ */ jsx242(
    DrawerContext,
    {
      value: {
        drawerId: uniqueDrawerId,
        isOpen,
        onClose: handleClose,
        triggerEl: triggerRef.current
      },
      children: Children7
    }
  );
};
DrawerGroup.displayName = "DrawerGroup";

// src/components/EmptyContent/EmptyContent.module.css
var EmptyContent_default = {
  message: "EmptyContent_message"
};

// src/components/EmptyContent/EmptyContent.tsx
import { jsx as jsx243, jsxs as jsxs52 } from "react/jsx-runtime";
function EmptyContent({
  headerText,
  message,
  headerHeadingLevel = 2,
  ...rest
}) {
  return /* @__PURE__ */ jsx243(
    Paper,
    {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "var(--dds-spacing-x10)",
      height: "100%",
      width: "100%",
      padding: "x1.5",
      background: "surface-subtle",
      borderRadius: "0",
      ...rest,
      children: /* @__PURE__ */ jsxs52(VStack, { maxWidth: "70ch", gap: "x1", textAlign: "center", children: [
        headerText && /* @__PURE__ */ jsx243(Heading, { level: headerHeadingLevel, typographyType: "headingMedium", children: headerText }),
        /* @__PURE__ */ jsx243(Paragraph, { className: EmptyContent_default.message, children: message })
      ] })
    }
  );
}
EmptyContent.displayName = "EmptyContent";

// src/components/FavStar/FavStar.tsx
import { useId as useId11 } from "react";

// src/components/FavStar/FavStar.module.css
var FavStar_default = {
  container: "FavStar_container",
  icon: "FavStar_icon",
  "container--medium": "FavStar_container--medium",
  "container--large": "FavStar_container--large",
  "icon--invisible": "FavStar_icon--invisible"
};

// src/components/FavStar/FavStar.tsx
import { jsx as jsx244, jsxs as jsxs53 } from "react/jsx-runtime";
var FavStar = ({
  id,
  className,
  onChange,
  checked: checkedProp,
  defaultChecked,
  size: size2 = "medium",
  htmlProps,
  ...rest
}) => {
  var _a;
  const { style, ...props } = getBaseHTMLProps(
    id,
    cn(className),
    htmlProps,
    rest
  );
  const generatedId = useId11();
  const [checked, setChecked] = useControllableState({
    value: checkedProp,
    defaultValue: defaultChecked != null ? defaultChecked : false,
    onChange
  });
  return /* @__PURE__ */ jsxs53(
    "label",
    {
      className: cn(
        className,
        FavStar_default.container,
        FavStar_default[`container--${size2}`],
        focus_default["has-focusable-input"]
      ),
      style,
      htmlFor: id != null ? id : generatedId,
      children: [
        /* @__PURE__ */ jsx244(
          "input",
          {
            ...props,
            id: id != null ? id : generatedId,
            checked,
            onChange: (e) => setChecked(e.target.checked),
            type: "checkbox",
            "aria-label": (_a = props["aria-label"]) != null ? _a : "Favoriser",
            className: utilStyles_default["hide-input"]
          }
        ),
        /* @__PURE__ */ jsx244(Icon, { iconSize: size2, icon: StarIcon, className: FavStar_default.icon }),
        /* @__PURE__ */ jsx244(
          Icon,
          {
            iconSize: size2,
            icon: StarFilledIcon,
            className: cn(FavStar_default.icon, !checked && FavStar_default["icon--invisible"])
          }
        )
      ]
    }
  );
};
FavStar.displayName = "FavStar";

// src/components/Feedback/Feedback.tsx
import { useEffect as useEffect22, useState as useState15 } from "react";

// src/components/Feedback/Feedback.module.css
var Feedback_default = {
  "rating-container": "Feedback_rating-container",
  "rating-container--horizontal": "Feedback_rating-container--horizontal",
  "rating-container--vertical": "Feedback_rating-container--vertical",
  "rating-submitted-title": "Feedback_rating-submitted-title",
  button: "Feedback_button",
  "button--horizontal": "Feedback_button--horizontal",
  "button--vertical": "Feedback_button--vertical"
};

// src/components/TextArea/TextArea.tsx
import {
  useEffect as useEffect20,
  useId as useId12,
  useRef as useRef21,
  useState as useState13
} from "react";

// src/components/TextArea/TextArea.module.css
var TextArea_default = {
  textarea: "TextArea_textarea"
};

// src/components/TextArea/TextArea.tsx
import { jsx as jsx245, jsxs as jsxs54 } from "react/jsx-runtime";
var TextArea = ({
  id,
  value,
  defaultValue,
  onChange,
  errorMessage,
  required = false,
  tip,
  label,
  readOnly,
  "aria-required": ariaRequired = false,
  "aria-describedby": ariaDescribedby,
  maxLength,
  withCharacterCounter = true,
  className,
  style,
  width,
  ref,
  ...rest
}) => {
  const generatedId = useId12();
  const uniqueId = id != null ? id : `${generatedId}-textArea`;
  const textAreaRef = useRef21(null);
  const multiRef = useCombinedRef(ref, textAreaRef);
  const [text, setText] = useState13(getDefaultText(value, defaultValue));
  useEffect20(() => {
    if (textAreaRef == null ? void 0 : textAreaRef.current) {
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight + 2}px`;
    }
  }, [text]);
  const onChangeHandler = (event) => {
    setText(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  const hasErrorMessage = !!errorMessage;
  const hasMessage = hasErrorMessage || !!tip;
  const hasLabel = !!label;
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const characterCounterId = derivativeIdGenerator(
    uniqueId,
    "characterCounter"
  );
  const showRequiredStyling = required || !!ariaRequired;
  const inputWidth = getInputWidth(width);
  return /* @__PURE__ */ jsxs54("div", { className: cn(className, Input_default.container), style: { ...style }, children: [
    hasLabel && /* @__PURE__ */ jsx245(
      Label,
      {
        showRequiredStyling,
        htmlFor: uniqueId,
        className: Input_default.label,
        readOnly,
        children: label
      }
    ),
    /* @__PURE__ */ jsx245(
      Box,
      {
        as: "textarea",
        width: inputWidth,
        ref: multiRef,
        id: uniqueId,
        onChange: onChangeHandler,
        value,
        defaultValue,
        maxLength,
        required,
        readOnly,
        "aria-required": ariaRequired,
        "aria-describedby": spaceSeparatedIdListGenerator([
          tip ? tipId : void 0,
          errorMessage ? errorMessageId : void 0,
          maxLength && withCharacterCounter ? characterCounterId : void 0,
          ariaDescribedby
        ]),
        "aria-invalid": hasErrorMessage ? true : void 0,
        className: cn(
          Input_default.input,
          Input_default["input--stateful"],
          hasErrorMessage && Input_default["input--stateful-danger"],
          TextArea_default.textarea,
          scrollbar,
          typographyStyles_default["body-medium"],
          focusable
        ),
        ...rest
      }
    ),
    /* @__PURE__ */ jsxs54(
      Box,
      {
        display: "flex",
        justifyContent: withCharacterCounter ? hasMessage ? "space-between" : "flex-end" : void 0,
        width: withCharacterCounter ? inputWidth : void 0,
        children: [
          renderInputMessage(tip, tipId, errorMessage, errorMessageId),
          renderCharCounter(
            characterCounterId,
            withCharacterCounter,
            text.length,
            maxLength
          )
        ]
      }
    )
  ] });
};
TextArea.displayName = "TextArea";

// src/components/Feedback/utils.tsx
import { jsx as jsx246 } from "react/jsx-runtime";
var getIconSize = (layout) => layout === "vertical" ? "large" : "medium";
var ThumbIcon = ({ rating, layout, type }) => type === "comment" ? /* @__PURE__ */ jsx246(
  Icon,
  {
    icon: rating === "positive" ? ThumbUpFilledIcon : ThumbDownFilledIcon,
    color: "iconActionResting",
    iconSize: getIconSize(layout)
  }
) : /* @__PURE__ */ jsx246(
  Icon,
  {
    icon: rating === "positive" ? ThumbUpIcon : ThumbDownIcon,
    color: "iconMedium",
    iconSize: getIconSize(layout)
  }
);

// src/components/Feedback/CommentComponent.tsx
import { jsx as jsx247, jsxs as jsxs55 } from "react/jsx-runtime";
var CommentComponent = ({
  layout,
  rating,
  feedbackText,
  positiveFeedbackLabel,
  negativeFeedbackLabel,
  ratingSubmittedTitle,
  textAreaTip,
  loading,
  handleSubmit,
  handleFeedbackTextChange
}) => {
  return /* @__PURE__ */ jsxs55(VStack, { gap: "x1", children: [
    /* @__PURE__ */ jsxs55("span", { className: Feedback_default["rating-submitted-title"], children: [
      ThumbIcon({ rating, layout, type: "comment" }),
      /* @__PURE__ */ jsxs55(Paragraph, { children: [
        ratingSubmittedTitle,
        " "
      ] })
    ] }),
    /* @__PURE__ */ jsx247(
      TextArea,
      {
        value: feedbackText,
        onChange: (e) => handleFeedbackTextChange(e.target.value),
        label: rating === "positive" ? positiveFeedbackLabel : negativeFeedbackLabel,
        tip: textAreaTip
      }
    ),
    /* @__PURE__ */ jsx247(
      Button,
      {
        purpose: "secondary",
        size: "small",
        onClick: handleSubmit,
        loading,
        children: "Send inn"
      }
    )
  ] });
};

// src/components/Tooltip/Tooltip.tsx
import {
  Children as ReactChildren3,
  cloneElement as cloneElement3,
  useEffect as useEffect21,
  useId as useId13,
  useRef as useRef22,
  useState as useState14
} from "react";

// src/components/Tooltip/Tooltip.module.css
var Tooltip_default = {
  container: "Tooltip_container",
  "svg-arrow__border": "Tooltip_svg-arrow__border",
  "svg-arrow__background": "Tooltip_svg-arrow__background",
  paper: "Tooltip_paper"
};

// src/components/Tooltip/Tooltip.tsx
import { jsx as jsx248, jsxs as jsxs56 } from "react/jsx-runtime";
var Tooltip = ({
  text,
  placement = "bottom",
  children,
  tooltipId,
  delay = 100,
  style,
  onMouseLeave,
  onMouseOver,
  id,
  ref,
  className,
  htmlProps,
  ...rest
}) => {
  const generatedId = useId13();
  const uniqueTooltipId = tooltipId != null ? tooltipId : `${generatedId}-tooltip`;
  const [open, setOpen] = useState14(false);
  const [inView, setInView] = useState14(false);
  const [arrowElement, setArrowElement] = useState14(null);
  const { refs, styles: positionStyles } = useFloatPosition(arrowElement, {
    placement
  });
  const tooltipRef = useRef22(null);
  const combinedRef = useCombinedRef(ref, refs.setFloating, tooltipRef);
  const closeWhenNotInView = (entries) => {
    const [entry] = entries;
    entry.isIntersecting ? setInView(true) : setInView(false);
  };
  useEffect21(() => {
    const options = {
      root: null,
      rootMargin: "0px"
    };
    const ref2 = tooltipRef.current;
    const observer = new IntersectionObserver(closeWhenNotInView, options);
    if (ref2) observer.observe(ref2);
    return () => {
      if (ref2) observer.unobserve(ref2);
    };
  }, [tooltipRef]);
  useEffect21(() => {
    if (tooltipRef.current) {
      window.addEventListener("scroll", () => {
        closeTooltip();
      });
    }
    return () => {
      if (tooltipRef.current) {
        window.removeEventListener("scroll", () => null);
      }
    };
  }, []);
  let timer;
  useEffect21(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);
  useOnKeyDown(["Escape", "Esc"], () => {
    if (open) setOpen(false);
  });
  const closeTooltip = () => {
    clearTimeout(timer);
    setOpen(false);
  };
  const openTooltip = () => {
    if (!open) {
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(true), delay);
    }
  };
  const anchorElement = ReactChildren3.only(
    cloneElement3(children, {
      ref: refs.setReference,
      onFocus: combineHandlers(openTooltip, children.props.onFocus),
      onBlur: combineHandlers(closeTooltip, children.props.onBlur),
      "aria-describedby": uniqueTooltipId
    })
  );
  const openCn = open && inView ? "open" : "closed";
  return /* @__PURE__ */ jsxs56(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(className, Tooltip_default.container),
        htmlProps,
        rest
      ),
      style,
      onMouseLeave: combineHandlers(closeTooltip, onMouseLeave),
      onMouseOver: combineHandlers(openTooltip, onMouseOver),
      children: [
        anchorElement,
        /* @__PURE__ */ jsxs56(
          Paper,
          {
            id: uniqueTooltipId,
            ref: combinedRef,
            role: "tooltip",
            "aria-hidden": !open,
            style: { ...positionStyles.floating },
            elevation: 1,
            border: "border-subtle",
            className: cn(
              Tooltip_default.paper,
              typographyStyles_default["body-medium"],
              utilStyles_default["visibility-transition"],
              utilStyles_default[`visibility-transition--${openCn}`]
            ),
            children: [
              text,
              /* @__PURE__ */ jsx248("div", { ref: setArrowElement, style: positionStyles.arrow, children: /* @__PURE__ */ jsxs56("svg", { width: "36", height: "9", children: [
                /* @__PURE__ */ jsx248(
                  "path",
                  {
                    d: "M16.586 6.586L10 0h16.154a.373.373 0 00-.263.11l-6.477 6.476a2 2 0 01-2.828 0z",
                    className: Tooltip_default["svg-arrow__background"]
                  }
                ),
                /* @__PURE__ */ jsx248(
                  "path",
                  {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M26.5.5l-6.732 6.94a2.5 2.5 0 01-3.536 0L9.5.5H11l5.94 6.232a1.5 1.5 0 002.12 0L25 .5h1.5z",
                    className: Tooltip_default["svg-arrow__border"]
                  }
                )
              ] }) })
            ]
          }
        )
      ]
    }
  );
};
Tooltip.displayName = "Tooltip";

// src/components/Feedback/RatingComponent.tsx
import { jsx as jsx249, jsxs as jsxs57 } from "react/jsx-runtime";
var RatingComponent = ({
  layout,
  ratingLabel,
  loading,
  thumbUpTooltip,
  thumbDownTooltip,
  handleRatingChange
}) => {
  const button = (rating, layout2, tooltip) => /* @__PURE__ */ jsx249(
    "button",
    {
      "aria-label": tooltip,
      onClick: () => handleRatingChange(rating),
      className: cn(
        utilStyles_default["remove-button-styling"],
        Feedback_default.button,
        Feedback_default[`button--${layout2}`],
        focusable
      ),
      children: ThumbIcon({ rating, layout: layout2, type: "rating" })
    }
  );
  return /* @__PURE__ */ jsxs57(
    "div",
    {
      className: cn(
        Feedback_default["rating-container"],
        Feedback_default[`rating-container--${layout}`]
      ),
      children: [
        /* @__PURE__ */ jsx249("h2", { className: typographyStyles_default["label-medium"], children: ratingLabel }),
        loading ? /* @__PURE__ */ jsx249(Spinner, { tooltip: "Laster opp tilbakemelding ..." }) : /* @__PURE__ */ jsxs57(HStack, { gap: "x1", children: [
          /* @__PURE__ */ jsx249(Tooltip, { text: thumbUpTooltip, children: button("positive", layout, thumbUpTooltip) }),
          /* @__PURE__ */ jsx249(Tooltip, { text: thumbDownTooltip, children: /* @__PURE__ */ jsx249("div", { children: button("negative", layout, thumbDownTooltip) }) })
        ] })
      ]
    }
  );
};

// src/components/Feedback/Feedback.tsx
import { jsx as jsx250 } from "react/jsx-runtime";
var Feedback = ({
  layout = "vertical",
  ratingLabel = "Hva syns du om tjenesten?",
  positiveFeedbackLabel = "Hva kan vi forbedre? (valgfritt)",
  negativeFeedbackLabel = "Hva kan vi forbedre? (valgfritt)",
  ratingSubmittedTitle = "Tusen takk! Tilbakemeldingen din hjelper oss \xE5 forbedre l\xF8sningen",
  submittedTitle = "Tusen takk! Tilbakemeldingen din hjelper oss \xE5 forbedre l\xF8sningen",
  textAreaTip = "Ikke send inn personopplysninger eller annen sensitiv informasjon",
  ratingValue: ratingProp,
  feedbackTextValue: feedbackTextProp,
  thumbUpTooltip = "Bra",
  thumbDownTooltip = "D\xE5rlig",
  feedbackTextAreaExcluded = false,
  loading = false,
  isSubmitted: isSubmittedProp,
  onRating,
  onFeedbackTextChange,
  onSubmit
}) => {
  const [rating, setRating] = useState15(null);
  const [feedbackText, setFeedbackText] = useState15();
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState15(false);
  useEffect22(() => {
    ratingProp !== void 0 && setRating(ratingProp);
  }, [ratingProp]);
  useEffect22(() => {
    feedbackTextProp !== void 0 && setFeedbackText(feedbackTextProp);
  }, [feedbackTextProp]);
  useEffect22(() => {
    isSubmittedProp !== void 0 && setIsFeedbackSubmitted(isSubmittedProp);
  }, [isSubmittedProp]);
  const handleRatingChange = (newRating) => {
    onRating && onRating(newRating);
    onSubmit && feedbackTextAreaExcluded && onSubmit(newRating, "");
    ratingProp === void 0 && setRating(newRating);
  };
  const handleFeedbackTextChange = (newFeedbackText) => {
    onFeedbackTextChange && onFeedbackTextChange(newFeedbackText);
    feedbackTextProp === void 0 && setFeedbackText(newFeedbackText);
  };
  const handleSubmit = () => {
    onSubmit && onSubmit(rating, feedbackText != null ? feedbackText : "");
    isSubmittedProp === void 0 && setIsFeedbackSubmitted(true);
  };
  if (rating === null && !isFeedbackSubmitted) {
    return /* @__PURE__ */ jsx250(
      RatingComponent,
      {
        layout,
        ratingLabel,
        loading,
        thumbUpTooltip,
        thumbDownTooltip,
        handleRatingChange
      }
    );
  }
  if (!feedbackTextAreaExcluded && !isFeedbackSubmitted) {
    return /* @__PURE__ */ jsx250(
      CommentComponent,
      {
        layout,
        rating,
        feedbackText,
        positiveFeedbackLabel,
        negativeFeedbackLabel,
        ratingSubmittedTitle,
        textAreaTip,
        loading,
        handleSubmit,
        handleFeedbackTextChange
      }
    );
  }
  return /* @__PURE__ */ jsx250(Paragraph, { children: submittedTitle });
};

// src/components/Fieldset/Fieldset.module.css
var container = "Fieldset_container";

// src/components/Fieldset/Fieldset.tsx
import { jsx as jsx251 } from "react/jsx-runtime";
var Fieldset = ({
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsx251(
  "fieldset",
  {
    ...getBaseHTMLProps(id, cn(className, container), htmlProps, rest)
  }
);
Fieldset.displayName = "Fieldset";

// src/components/Fieldset/FieldsetGroup.tsx
import { jsx as jsx252 } from "react/jsx-runtime";
var FieldsetGroup = ({
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsx252(VStack, { gap: "x1.5", ...getBaseHTMLProps(id, className, htmlProps, rest) });
FieldsetGroup.displayName = "FieldsetGroup";

// src/components/FileUploader/FileUploader.tsx
import { useId as useId14 } from "react";

// src/components/FileUploader/ErrorList.tsx
import { jsx as jsx253 } from "react/jsx-runtime";
var ErrorList = (props) => {
  const { errors } = props;
  if (errors.length < 1) {
    return null;
  }
  if (errors.length === 1) {
    return /* @__PURE__ */ jsx253(
      InputMessage,
      {
        id: errors[0].id,
        message: errors[0].message,
        messageType: "error"
      }
    );
  }
  return /* @__PURE__ */ jsx253(StylelessList, { children: errors.map(({ id, message }) => {
    return /* @__PURE__ */ jsx253("li", { children: /* @__PURE__ */ jsx253(
      InputMessage,
      {
        id,
        message,
        messageType: "error"
      },
      id
    ) });
  }) });
};

// src/components/FileUploader/FileUploader.module.css
var FileUploader_default = {
  "input-container": "FileUploader_input-container",
  "input-container--with-errors": "FileUploader_input-container--with-errors",
  "input-container--drag-active": "FileUploader_input-container--drag-active",
  "input-container--no-drag-zone": "FileUploader_input-container--no-drag-zone",
  "file--invalid": "FileUploader_file--invalid",
  "file__icon--invalid": "FileUploader_file__icon--invalid",
  "file__icon--valid": "FileUploader_file__icon--valid",
  file__name: "FileUploader_file__name"
};

// src/components/FileUploader/File.tsx
import { jsx as jsx254, jsxs as jsxs58 } from "react/jsx-runtime";
var File = (props) => {
  const { parentId, index, file: stateFile, removeFile, isValid } = props;
  const errorsList = stateFile.errors.map((e, errorIndex) => ({
    id: derivativeIdGenerator(parentId, `file-${index}-error-${errorIndex}`),
    message: e
  }));
  return /* @__PURE__ */ jsxs58("li", { children: [
    /* @__PURE__ */ jsxs58(
      Paper,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "x0.75",
        marginBlock: "x0.5 0",
        padding: "x0.5 x1",
        border: isValid ? "border-default" : "border-danger",
        background: "surface-subtle",
        className: cn(!isValid && FileUploader_default["file--invalid"]),
        children: [
          /* @__PURE__ */ jsx254(
            "span",
            {
              className: cn(FileUploader_default.file__name, typographyStyles_default["body-medium"]),
              children: stateFile.file.name
            }
          ),
          /* @__PURE__ */ jsx254(
            Icon,
            {
              icon: isValid ? CheckCircledIcon : ErrorIcon,
              className: FileUploader_default[`file__icon--${isValid ? "valid" : "invalid"}`]
            }
          ),
          /* @__PURE__ */ jsx254(
            Button,
            {
              size: "small",
              purpose: "tertiary",
              type: "button",
              onClick: removeFile,
              icon: CloseIcon,
              htmlProps: {
                "aria-label": `Fjern fil ${stateFile.file.name}`,
                "aria-invalid": !isValid ? true : void 0,
                "aria-errormessage": !isValid ? "Ugyldig fil" : void 0,
                "aria-describedby": spaceSeparatedIdListGenerator(
                  errorsList.map((e) => e.id)
                )
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx254(ErrorList, { errors: errorsList })
  ] });
};

// src/components/FileUploader/useFileUploader.ts
import {
  fromEvent as getFilesFromEvent
} from "file-selector";
import { useCallback as useCallback6, useEffect as useEffect23, useMemo, useReducer, useRef as useRef23 } from "react";

// src/components/FileUploader/fileUploaderReducer.ts
var fileUploaderReducer = (state, action) => {
  switch (action.type) {
    case "focus":
      return { ...state, isFocused: true };
    case "blur":
      return { ...state, isFocused: false };
    case "dragEnter":
      return {
        ...state,
        isDragActive: true
      };
    case "dragLeave":
      return { ...state, isDragActive: false };
    case "onSetFiles":
      return {
        ...state,
        isDragActive: false,
        files: action.payload
      };
    case "onRemoveFile":
      return {
        ...state,
        files: action.payload
      };
    case "setRootErrors":
      return {
        ...state,
        rootErrors: action.payload
      };
    default:
      return state;
  }
};

// src/components/FileUploader/attr-accept.ts
function isAccepted(file, acceptedFiles) {
  if (file && acceptedFiles) {
    const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    const fileName = file.name || "";
    const mimeType = (file.type || "").toLowerCase();
    const baseMimeType = mimeType.split("/")[0] || "";
    return acceptedFilesArray.some((type) => {
      const validType = type.trim().toLowerCase();
      if (validType.charAt(0) === ".") {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith("/*")) {
        return baseMimeType === validType.slice(0, -2);
      }
      return mimeType === validType;
    });
  }
  return true;
}

// src/components/FileUploader/utils.ts
var preventDefaults = (event) => {
  event.preventDefault();
  event.stopPropagation();
};
var isDragEvent = (event) => {
  const asDragEvent = event;
  return asDragEvent.dataTransfer !== void 0;
};
var isEventWithFiles = (event) => {
  if (!isDragEvent(event)) {
    return event.target.files !== null && event.target.files !== void 0;
  }
  return event.dataTransfer.types.includes("Files") || event.dataTransfer.types.includes("application/x-moz-file");
};
var isFileAccepted = (file, accept) => {
  return accept !== void 0 ? isAccepted(file, accept) : true;
};
var getTooManyFilesErrorMessage = (maxFiles) => `For mange filer, maks ${maxFiles}stk`;
var getInvalidFileTypeErrorMessage = () => "Ugyldig filtype";

// src/components/FileUploader/useFileUploader.ts
var calcRootErrors = (files, maxFiles, errorMessage) => {
  const errors = [];
  if (maxFiles && maxFiles >= 1 && files.length > maxFiles) {
    errors.push(getTooManyFilesErrorMessage(maxFiles));
  }
  if (errorMessage) {
    errors.push(errorMessage);
  }
  return errors;
};
var useFileUploader = (props) => {
  const {
    initialFiles,
    value,
    onChange,
    accept,
    maxFiles,
    disabled,
    errorMessage
  } = props;
  const rootRef = useRef23(null);
  const inputRef = useRef23(null);
  const buttonRef = useRef23(null);
  const isControlled = !!value;
  const initialFileUploaderFiles = useMemo(
    () => (initialFiles != null ? initialFiles : []).map((f) => ({
      file: f,
      errors: []
    })),
    [initialFiles]
  );
  const [state, dispatch] = useReducer(fileUploaderReducer, {
    files: initialFileUploaderFiles,
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    rootErrors: calcRootErrors(
      initialFileUploaderFiles,
      maxFiles,
      errorMessage
    )
  });
  const { files: stateFiles } = state;
  useEffect23(() => {
    if (isControlled) {
      const files = value.map((file) => {
        const accepted = isFileAccepted(file, accept);
        return {
          file,
          errors: accepted ? [] : [getInvalidFileTypeErrorMessage()]
        };
      });
      dispatch({
        type: "onSetFiles",
        payload: files
      });
    }
  }, [value, isControlled, accept, dispatch]);
  useEffect23(() => {
    dispatch({
      type: "setRootErrors",
      payload: calcRootErrors(stateFiles, maxFiles, errorMessage)
    });
  }, [dispatch, stateFiles, maxFiles, errorMessage]);
  const onRootFocus = useCallback6(
    () => dispatch({ type: "focus" }),
    [dispatch]
  );
  const onRootBlur = useCallback6(() => dispatch({ type: "blur" }), [dispatch]);
  const onRootDragEnter = useCallback6(
    async (evt) => {
      preventDefaults(evt);
      if (isEventWithFiles(evt)) {
        const files = await getFilesFromEvent(evt);
        const fileCount = files.length;
        if (fileCount === 0) return;
        dispatch({ type: "dragEnter" });
      }
    },
    [dispatch, accept, maxFiles]
  );
  const onRootDragOver = useCallback6((evt) => {
    preventDefaults(evt);
    const hasFiles = isEventWithFiles(evt);
    if (hasFiles && evt.dataTransfer) {
      try {
        evt.dataTransfer.dropEffect = "copy";
      } catch {
      }
    }
  }, []);
  const onRootDragLeave = useCallback6(
    (evt) => {
      preventDefaults(evt);
      if (evt.currentTarget.contains(evt.relatedTarget)) return;
      dispatch({ type: "dragLeave" });
    },
    [dispatch]
  );
  const setFiles = useCallback6(
    async (evt) => {
      evt.preventDefault();
      if (isEventWithFiles(evt)) {
        const existingFileNames = stateFiles.map((f) => f.file.name);
        const filesFromEvent = await getFilesFromEvent(
          evt
        );
        const newFiles = filesFromEvent.filter((f) => !existingFileNames.includes(f.name)).map((file) => {
          const accepted = isFileAccepted(file, accept);
          return {
            file,
            errors: accepted ? [] : [getInvalidFileTypeErrorMessage()]
          };
        }).concat(stateFiles);
        onChange(newFiles.map((f) => f.file));
        if (!isControlled) {
          dispatch({
            type: "onSetFiles",
            payload: newFiles
          });
        }
      }
    },
    [
      stateFiles,
      isControlled,
      accept,
      errorMessage,
      maxFiles,
      onChange,
      dispatch
    ]
  );
  const openFileDialog = useCallback6(() => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  }, [inputRef]);
  const removeFile = useCallback6(
    (file) => {
      const newFiles = [...stateFiles];
      newFiles.splice(stateFiles.indexOf(file), 1);
      onChange(newFiles.map((f) => f.file));
      if (!isControlled) {
        dispatch({
          type: "onRemoveFile",
          payload: newFiles
        });
      }
    },
    [stateFiles, isControlled, maxFiles, errorMessage, onChange, dispatch]
  );
  const getRootProps = useCallback6(
    () => ({
      onBlur: onRootBlur,
      onFocus: onRootFocus,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onDragEnter: onRootDragEnter,
      onDragOver: onRootDragOver,
      onDragLeave: onRootDragLeave,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onDrop: setFiles,
      ref: rootRef
    }),
    [
      onRootBlur,
      onRootFocus,
      onRootDragEnter,
      onRootDragOver,
      setFiles,
      rootRef,
      disabled
    ]
  );
  const getButtonProps = useCallback6(
    () => ({
      onClick: openFileDialog,
      ref: buttonRef
    }),
    [openFileDialog, buttonRef]
  );
  const getInputProps = useCallback6(
    () => ({
      type: "file",
      style: { display: "none" },
      tabIndex: -1,
      ref: inputRef,
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onChange: setFiles,
      multiple: !maxFiles || maxFiles > 1,
      ...accept ? { accept: accept.join(",") } : {}
    }),
    [inputRef, setFiles, maxFiles, accept]
  );
  return {
    state,
    getRootProps,
    getInputProps,
    getButtonProps,
    removeFile
  };
};

// src/components/FileUploader/FileUploader.tsx
import { jsx as jsx255, jsxs as jsxs59 } from "react/jsx-runtime";
var FileUploader = (props) => {
  const {
    id,
    label,
    dropAreaLabel = "Dra og slipp filer her eller",
    btnLabel = "Velg fil",
    tip,
    required = false,
    withDragAndDrop = true,
    initialFiles,
    value,
    accept,
    maxFiles,
    disabled,
    onChange,
    width = "var(--dds-input-default-width)",
    errorMessage,
    hideFileList,
    className,
    ...rest
  } = props;
  const generatedId = useId14();
  const uniqueId = id != null ? id : `${generatedId}-fileUploader`;
  const {
    state: { files: stateFiles, isDragActive, rootErrors },
    getRootProps,
    getInputProps,
    getButtonProps,
    removeFile
  } = useFileUploader({
    id,
    initialFiles,
    value,
    onChange,
    accept,
    disabled,
    maxFiles,
    errorMessage
  });
  const hasLabel = label !== void 0;
  const hasTip = tip !== void 0;
  const hasRootErrors = rootErrors.length > 0;
  const showRequiredMarker = required;
  const labelId = derivativeIdGenerator(uniqueId, "label");
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const buttonId = derivativeIdGenerator(uniqueId, "button");
  const inputId = derivativeIdGenerator(uniqueId, "input");
  const fileListElements = stateFiles.map((stateFile, index) => /* @__PURE__ */ jsx255(
    File,
    {
      parentId: uniqueId,
      index,
      file: stateFile,
      isValid: stateFile.errors.length === 0,
      removeFile: () => removeFile(stateFile)
    },
    stateFile.file.name
  ));
  const rootErrorsList = rootErrors.map((e, index) => ({
    id: derivativeIdGenerator(uniqueId, `error-${index}`),
    message: e
  }));
  const button = /* @__PURE__ */ jsx255(
    Button,
    {
      ...getButtonProps(),
      id: buttonId,
      size: "medium",
      type: "button",
      purpose: "secondary",
      icon: UploadIcon,
      htmlProps: {
        "aria-invalid": hasRootErrors ? true : void 0,
        "aria-describedby": spaceSeparatedIdListGenerator([
          hasLabel ? labelId : void 0,
          hasTip ? tipId : void 0,
          ...rootErrorsList.map((e) => e.id)
        ])
      },
      children: btnLabel
    }
  );
  return /* @__PURE__ */ jsxs59(
    Box,
    {
      id: uniqueId,
      className: cn(className, typographyStyles_default["body-medium"]),
      width,
      ...rest,
      children: [
        hasLabel && /* @__PURE__ */ jsx255(
          Label,
          {
            id: labelId,
            showRequiredStyling: showRequiredMarker,
            htmlFor: inputId,
            children: label
          }
        ),
        hasTip && /* @__PURE__ */ jsx255(InputMessage, { id: tipId, message: tip, messageType: "tip" }),
        withDragAndDrop ? /* @__PURE__ */ jsxs59(
          VStack,
          {
            gap: "x1",
            padding: "x1.5 x1.5 x2 x1.5",
            ...getRootProps(),
            className: cn(
              FileUploader_default["input-container"],
              hasRootErrors && FileUploader_default["input-container--with-errors"],
              isDragActive && FileUploader_default["input-container--drag-active"]
            ),
            children: [
              /* @__PURE__ */ jsx255(
                "input",
                {
                  ...getInputProps(),
                  id: inputId,
                  "data-testid": "file-uploader-input"
                }
              ),
              dropAreaLabel,
              /* @__PURE__ */ jsx255(VisuallyHidden, { as: "span", children: "velg fil med p\xE5f\xF8lgende knapp" }),
              button
            ]
          }
        ) : /* @__PURE__ */ jsxs59("div", { className: FileUploader_default["input-container--no-drag-zone"], children: [
          /* @__PURE__ */ jsx255("input", { ...getInputProps(), id: inputId }),
          button
        ] }),
        /* @__PURE__ */ jsx255(ErrorList, { errors: rootErrorsList }),
        !hideFileList && /* @__PURE__ */ jsx255(StylelessList, { children: fileListElements })
      ]
    }
  );
};
FileUploader.displayName = "FileUploader";

// src/components/Footer/Footer.module.css
var Footer_default = {
  container: "Footer_container",
  left: "Footer_left",
  list: "Footer_list",
  "list-group": "Footer_list-group",
  "socials-group": "Footer_socials-group",
  "socials-list": "Footer_socials-list"
};

// src/components/Footer/Footer.tsx
import { jsx as jsx256 } from "react/jsx-runtime";
var Footer = ({ className, ...rest }) => /* @__PURE__ */ jsx256(Contrast, { as: "footer", className: cn(className, Footer_default.container), ...rest });

// src/components/Footer/FooterListHeader.tsx
import { jsx as jsx257 } from "react/jsx-runtime";
var FooterListHeader = (props) => /* @__PURE__ */ jsx257(Heading, { level: 2, typographyType: "headingSmall", ...props });

// src/components/Footer/norges_domstoler_logo.svg
var norges_domstoler_logo_default = 'data:image/svg+xml,<svg width="151" height="80" viewBox="0 0 151 80" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g id="Logo" clip-path="url(%23clip0_18254_1882)">%0A<path id="Vector" d="M0 19.5721V0.38501H3.50998L9.51314 13.2128C10.169 14.6541 10.6734 16.1596 11.0182 17.7051H11.1848C10.9502 16.2655 10.8311 14.8093 10.8287 13.3507V0.38501H13.0174V19.5721H9.51314L3.50998 6.77306C2.84978 5.3389 2.34334 3.83883 1.99914 2.29798H1.83829C2.07013 3.73991 2.18921 5.19772 2.19446 6.65817V19.5721H0Z" fill="white"/>%0A<path id="Vector_2" d="M19.2848 17.4063C17.9942 15.7059 17.3489 13.2299 17.3489 9.97846C17.3489 6.72699 17.9942 4.25104 19.2848 2.55062C20.5716 0.850208 22.4118 0 24.8054 0C27.199 0 29.0488 0.844463 30.3548 2.53339C31.6416 4.25679 32.2907 6.70401 32.2907 10.0014C32.2907 13.2989 31.6416 15.7461 30.3548 17.4695C29.068 19.1929 27.2182 20.0029 24.8054 20.0029C22.3927 20.0029 20.5716 19.101 19.2848 17.4063ZM21.3357 4.05572C20.6003 5.31955 20.2308 7.29379 20.2269 9.97846C20.2231 12.6631 20.5927 14.6355 21.3357 15.8954C21.6776 16.4998 22.1813 16.9969 22.7902 17.3307C23.3991 17.6646 24.089 17.8221 24.7825 17.7854C25.4832 17.8288 26.182 17.6747 26.7994 17.3406C27.4169 17.0064 27.9282 16.5058 28.2752 15.8954C29.0143 14.6355 29.3858 12.6631 29.3897 9.97846C29.3935 7.29379 29.0297 5.31955 28.2982 4.05572C27.9502 3.44633 27.4387 2.9464 26.8215 2.61242C26.2042 2.27844 25.5059 2.12372 24.8054 2.16573C24.1083 2.12541 23.4138 2.28107 22.8006 2.6151C22.1874 2.94912 21.6799 3.44817 21.3357 4.05572Z" fill="white"/>%0A<path id="Vector_3" d="M48.594 15.5968C48.8111 16.9446 49.1318 18.2737 49.5534 19.5721H46.5317C46.4288 19.2619 46.3463 18.9453 46.2847 18.6243C46.21 18.2681 46.1238 17.7856 46.0376 17.1709C45.9515 16.5562 45.8825 16.1254 45.8423 15.8668C45.5513 13.9903 45.1415 12.7207 44.613 12.0581C44.0845 11.3956 43.2151 11.0681 42.0049 11.0758H39.1326V19.5721H36.4556V0.38501H43.0045C44.7968 0.38501 46.1813 0.815859 47.1693 1.6833C47.6677 2.13766 48.0592 2.69689 48.3154 3.32072C48.5717 3.94454 48.6865 4.61743 48.6515 5.29094C48.6898 5.93617 48.5867 6.58197 48.3496 7.18326C48.1125 7.78455 47.7469 8.32682 47.2785 8.7722C46.2192 9.64565 44.8691 10.0868 43.4985 10.0073H42.7287V10.1681L43.5272 10.1969C44.1017 10.2313 44.4866 10.2658 44.7566 10.2945C45.102 10.3329 45.4427 10.4061 45.7734 10.5128C46.1234 10.601 46.4442 10.7792 46.704 11.0298C46.968 11.3147 47.2064 11.6223 47.4164 11.949C47.7076 12.4082 47.9301 12.9075 48.077 13.4311C48.2551 14.0343 48.4332 14.7581 48.594 15.5968ZM39.167 9.09964H42.43C42.8862 9.13106 43.3441 9.06822 43.775 8.91503C44.2059 8.76184 44.6006 8.52159 44.9347 8.20922C45.241 7.86617 45.4755 7.4653 45.6245 7.03021C45.7734 6.59512 45.8338 6.13462 45.8021 5.67583C45.8021 3.48138 44.6781 2.38415 42.43 2.38415H39.167V9.09964Z" fill="white"/>%0A<path id="Vector_4" d="M63.8634 6.27892C63.8374 5.16647 63.448 4.0931 62.7547 3.22277C62.4351 2.8708 62.0419 2.59361 61.6031 2.41091C61.1642 2.22821 60.6904 2.14451 60.2155 2.16575C59.518 2.12433 58.8231 2.28288 58.2125 2.62276C57.6019 2.96264 57.1011 3.46974 56.7688 4.08447C56.0334 5.36744 55.6658 7.33211 55.6658 9.97848C55.6658 12.6248 56.0315 14.5933 56.763 15.884C57.0847 16.4915 57.5726 16.995 58.1697 17.3358C58.7668 17.6765 59.4484 17.8404 60.1351 17.8084C62.8581 17.8084 64.2196 15.974 64.2196 12.3051V11.6214H59.9168V9.64529H66.7415V19.572H64.5757V17.6246C64.5824 16.3521 64.6552 15.0808 64.794 13.8159H64.6274C64.4283 15.9338 63.9132 17.4867 63.0821 18.4748C62.2491 19.4629 61.0198 19.9512 59.3941 19.9512C58.4312 19.9882 57.4753 19.7741 56.6202 19.3299C55.7651 18.8857 55.0403 18.2268 54.5169 17.4178C53.3679 15.7289 52.7935 13.2759 52.7935 10.0589C52.7935 6.77296 53.4292 4.28361 54.7007 2.59086C55.9722 0.898101 57.8009 0.0344883 60.1868 2.04411e-05C61.7689 -0.0690547 63.3242 0.425623 64.5757 1.39597C65.1677 1.92295 65.6473 2.56392 65.9859 3.28052C66.3244 3.99712 66.515 4.77464 66.5461 5.56659L63.8634 6.27892Z" fill="white"/>%0A<path id="Vector_5" d="M74.824 17.5673H82.8034V19.5721H72.1125V0.38501H82.6368V2.38415H74.824V8.66305H82.0048V10.6622H74.824V17.5673Z" fill="white"/>%0A<path id="Vector_6" d="M93.0633 19.9512C90.9953 19.9512 89.3695 19.4342 88.1804 18.3887C87.5786 17.8382 87.1032 17.164 86.7869 16.4123C86.4705 15.6606 86.3207 14.8493 86.3478 14.0342L89.0421 13.2645C89.1876 16.3283 90.5491 17.8602 93.1265 17.8602C94.0518 17.9146 94.9669 17.6422 95.7116 17.0904C96.0388 16.8086 96.2951 16.4538 96.4598 16.0546C96.6245 15.6554 96.6929 15.2231 96.6595 14.7925C96.6595 13.3334 95.838 12.284 94.195 11.6445L91.0699 10.3806C88.4159 9.32362 87.0908 7.55236 87.0947 5.06684C87.054 4.35555 87.1815 3.64468 87.467 2.99192C87.7524 2.33915 88.1878 1.76287 88.7376 1.30984C90.0484 0.449859 91.5818 -0.00830078 93.1495 -0.00830078C94.7172 -0.00830078 96.2507 0.449859 97.5614 1.30984C98.139 1.77201 98.6034 2.36008 98.919 3.02914C99.2346 3.6982 99.3931 4.43055 99.3825 5.17024L96.7801 5.9113C96.6155 3.36451 95.4014 2.09302 93.138 2.09685C92.2848 2.02806 91.4347 2.26195 90.7368 2.75749C90.4435 3.00371 90.2126 3.31574 90.0629 3.66814C89.9131 4.02055 89.8488 4.40335 89.8751 4.78535C89.835 5.48253 90.0539 6.16994 90.4897 6.71555C91.0398 7.27423 91.7096 7.70051 92.4487 7.96214L95.3612 9.15703C98.042 10.2294 99.3825 12.0006 99.3825 14.4708C99.4281 15.2308 99.2996 15.9911 99.0069 16.694C98.7143 17.3968 98.2651 18.0236 97.6935 18.5266C96.602 19.4802 95.051 19.9512 93.0633 19.9512Z" fill="white"/>%0A<path id="Vector_7" d="M5.2104 35.4617C7.95251 35.4617 9.98037 36.308 11.294 38.0008C12.6076 39.6936 13.2644 42.045 13.2644 45.0552C13.2644 48.0884 12.6076 50.4456 11.294 52.1269C9.98037 53.8082 7.95251 54.6488 5.2104 54.6488H0V35.4617H5.2104ZM4.96338 52.6497C6.97401 52.6497 8.3757 52.0063 9.17995 50.7195C9.9842 49.4327 10.3863 47.5427 10.3863 45.0552C10.3863 42.5678 9.9842 40.6836 9.17995 39.3968C8.3757 38.11 6.97401 37.4666 4.96338 37.4666H2.71148V52.6497H4.96338Z" fill="white"/>%0A<path id="Vector_8" d="M18.5954 52.4831C17.3047 50.7903 16.6594 48.3144 16.6594 45.0552C16.6594 41.7961 17.3047 39.3202 18.5954 37.6274C19.8898 35.9308 21.732 35.0825 24.1217 35.0825C26.5115 35.0825 28.3613 35.927 29.6711 37.6159C30.954 39.3048 31.5955 41.7846 31.5955 45.0552C31.5955 48.3259 30.9521 50.8152 29.6653 52.5233C28.3823 54.1969 26.5364 55.0337 24.1275 55.0337C21.7185 55.0337 19.8745 54.1835 18.5954 52.4831ZM20.6807 39.1382C19.9147 40.3944 19.5317 42.3667 19.5317 45.0552C19.5317 47.7437 19.9147 49.718 20.6807 50.978C21.0254 51.5787 21.5302 52.0719 22.1388 52.4025C22.7474 52.7332 23.4359 52.8884 24.1275 52.8507C24.8279 52.8921 25.5259 52.7371 26.143 52.4031C26.7601 52.0692 27.2717 51.5697 27.6202 50.9607C28.3555 49.7084 28.7232 47.7399 28.7232 45.0552C28.7232 42.3706 28.3536 40.3982 27.6145 39.1382C27.2674 38.5293 26.7569 38.0296 26.1407 37.6956C25.5245 37.3616 24.8271 37.2067 24.1275 37.2483C23.434 37.2116 22.7441 37.3691 22.1352 37.703C21.5264 38.0368 21.0226 38.5339 20.6807 39.1382Z" fill="white"/>%0A<path id="Vector_9" d="M35.7661 54.6488V35.4617H39.7414L42.8148 46.1237C43.5024 48.2936 43.9079 50.5429 44.0212 52.8163H44.2337C44.2993 50.5424 44.6861 48.2893 45.3827 46.1237L48.5939 35.4617H52.2762V54.6488H49.6911V43.7684C49.6911 41.5223 49.7773 39.414 49.9382 37.4493H49.7486C49.4555 39.2625 49.0527 41.0562 48.5422 42.8206L45.0954 54.6603H42.6827L39.121 42.5965C38.6304 40.9144 38.2467 39.2029 37.9721 37.4723H37.7767C37.9261 39.2417 38.0008 41.2638 38.0008 43.5272V54.6488H35.7661Z" fill="white"/>%0A<path id="Vector_10" d="M63.2314 55.0338C61.171 55.0338 59.5452 54.513 58.3542 53.4713C57.7505 52.9221 57.2734 52.2482 56.9559 51.4963C56.6385 50.7444 56.4884 49.9325 56.5159 49.1168L59.1699 48.3471C59.3155 51.4109 60.6769 52.9428 63.2544 52.9428C64.1809 52.9928 65.0963 52.7208 65.8452 52.173C66.1703 51.8898 66.4248 51.5346 66.5883 51.1356C66.7519 50.7367 66.82 50.3051 66.7873 49.8751C66.7873 48.416 65.9659 47.3647 64.3229 46.7213L61.1978 45.4632C58.5476 44.3986 57.2225 42.6254 57.2225 40.1437C57.1827 39.4334 57.3107 38.7236 57.5962 38.0719C57.8816 37.4202 58.3164 36.8449 58.8655 36.3924C60.1497 35.4549 61.7185 34.9902 63.3061 35.0769C64.8757 35.0068 66.4227 35.4705 67.695 36.3924C68.2714 36.8566 68.7344 37.4461 69.0489 38.116C69.3635 38.7859 69.5213 39.5186 69.5103 40.2586L66.9022 40.9997C66.7414 38.4605 65.5273 37.1909 63.2601 37.1909C62.4071 37.1241 61.5576 37.3578 60.8589 37.8516C60.5656 38.0978 60.3347 38.4098 60.185 38.7622C60.0352 39.1146 59.9709 39.4974 59.9972 39.8794C59.9571 40.5766 60.176 41.264 60.6118 41.8096C61.1632 42.3762 61.8346 42.812 62.5765 43.085L65.535 44.2339C68.2158 45.3139 69.5563 47.0871 69.5563 49.5534C69.6008 50.3128 69.4725 51.0723 69.181 51.7748C68.8894 52.4773 68.4422 53.1045 67.8731 53.6092C66.7529 54.5743 65.2076 55.0338 63.2314 55.0338Z" fill="white"/>%0A<path id="Vector_11" d="M85.8997 35.4617V37.6274H80.6376V54.6488H77.9491V37.6274H72.687V35.4617H85.8997Z" fill="white"/>%0A<path id="Vector_12" d="M90.4092 52.4831C89.1148 50.7903 88.4675 48.3144 88.4675 45.0552C88.4675 41.7961 89.1128 39.3202 90.4035 37.6274C91.6903 35.9308 93.5305 35.0825 95.9241 35.0825C98.3177 35.0825 100.167 35.927 101.473 37.6159C102.76 39.3048 103.404 41.7942 103.404 45.084C103.404 48.3737 102.76 50.8631 101.473 52.552C100.19 54.2065 98.3445 55.0337 95.9356 55.0337C93.5267 55.0337 91.6845 54.1835 90.4092 52.4831ZM92.4888 39.1382C91.7228 40.3944 91.3399 42.3667 91.3399 45.0552C91.3399 47.7437 91.7228 49.718 92.4888 50.978C92.866 51.5576 93.382 52.034 93.9899 52.3637C94.5978 52.6934 95.2785 52.8661 95.97 52.8661C96.6616 52.8661 97.3423 52.6934 97.9502 52.3637C98.5581 52.034 99.0741 51.5576 99.4513 50.978C100.171 49.7141 100.531 47.7399 100.531 45.0552C100.531 42.3706 100.162 40.3982 99.4226 39.1382C99.0454 38.5586 98.5294 38.0823 97.9215 37.7525C97.3136 37.4228 96.6329 37.2501 95.9413 37.2501C95.2497 37.2501 94.5691 37.4228 93.9612 37.7525C93.3532 38.0823 92.8373 38.5586 92.4601 39.1382H92.4888Z" fill="white"/>%0A<path id="Vector_13" d="M107.58 35.4617H110.297V52.4831H117.915V54.6488H107.574L107.58 35.4617Z" fill="white"/>%0A<path id="Vector_14" d="M124.544 52.6497H132.518V54.6488H121.833V35.4617H132.357V37.4666H124.544V43.7397H131.725V45.7446H124.544V52.6497Z" fill="white"/>%0A<path id="Vector_15" d="M149.321 50.6735C149.534 52.022 149.855 53.3513 150.28 54.6488H147.264C147.163 54.3399 147.081 54.0253 147.017 53.7067C146.942 53.3505 146.862 52.8622 146.77 52.2533C146.678 51.6444 146.615 51.2078 146.581 50.9493C146.289 49.0688 145.878 47.7993 145.345 47.1405C144.817 46.4857 143.949 46.1525 142.743 46.1525H139.871V54.6488H137.154V35.4617H143.731C145.52 35.4617 146.908 35.8963 147.896 36.7657C148.392 37.2209 148.781 37.7807 149.034 38.4047C149.288 39.0286 149.399 39.701 149.361 40.3733C149.394 41.0129 149.289 41.6521 149.052 42.247C148.815 42.8419 148.452 43.3786 147.988 43.8201C146.93 44.6951 145.579 45.1365 144.208 45.0552H143.438V45.2218H144.231C144.805 45.2563 145.19 45.285 145.466 45.3137C145.811 45.3579 146.151 45.4309 146.483 45.532C146.833 45.6236 147.153 45.8036 147.413 46.0548C147.676 46.3411 147.914 46.6485 148.126 46.9739C148.422 47.451 148.645 47.97 148.786 48.5135C148.982 49.1167 149.154 49.8348 149.321 50.6735ZM139.894 44.1821H143.151C143.608 44.2136 144.067 44.1508 144.499 43.9976C144.931 43.8445 145.326 43.6042 145.661 43.2916C146.273 42.5923 146.583 41.6795 146.523 40.7525C146.523 38.5638 145.403 37.4666 143.151 37.4666H139.894V44.1821Z" fill="white"/>%0A<path id="Vector_16" d="M150.389 75.0137H0V80H150.389V75.0137Z" fill="white"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_18254_1882">%0A<rect width="150.389" height="80" fill="white"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/components/Footer/FooterLogo.tsx
import { jsx as jsx258 } from "react/jsx-runtime";
var FooterLogo = ({ hideBreakpoint, ...rest }) => {
  return /* @__PURE__ */ jsx258(
    Box,
    {
      hideBelow: hideBreakpoint ? hideBreakpoint : void 0,
      width: "fit-content",
      children: /* @__PURE__ */ jsx258(
        "img",
        {
          height: 80,
          width: 151,
          alt: "norges domstoler",
          src: norges_domstoler_logo_default,
          ...rest
        }
      )
    }
  );
};

// src/components/Footer/FooterList.tsx
import { jsx as jsx259 } from "react/jsx-runtime";
var FooterList = ({ className, ...rest }) => /* @__PURE__ */ jsx259(StylelessList, { className: cn(className, Footer_default.list), ...rest });

// src/components/Footer/FooterSocialsList.tsx
import { jsx as jsx260 } from "react/jsx-runtime";
var FooterSocialsList = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx260(StylelessList, { className: cn(className, Footer_default["socials-list"]), ...rest });

// src/components/Footer/FooterSocialsGroup.tsx
import { jsx as jsx261 } from "react/jsx-runtime";
var FooterSocialsGroup = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx261("div", { className: cn(className, Footer_default["socials-group"]), ...rest });

// src/components/Footer/FooterListGroup.tsx
import { jsx as jsx262 } from "react/jsx-runtime";
var FooterListGroup = ({
  className,
  ...rest
}) => /* @__PURE__ */ jsx262("div", { className: cn(className, Footer_default["list-group"]), ...rest });

// src/components/Footer/FooterLeft.tsx
import { jsx as jsx263 } from "react/jsx-runtime";
var FooterLeft = ({ className, ...rest }) => /* @__PURE__ */ jsx263("div", { className: cn(className, Footer_default["left"]), ...rest });

// src/components/GlobalMessage/GlobalMessage.tsx
import { useState as useState16 } from "react";

// src/components/GlobalMessage/GlobalMessage.module.css
var GlobalMessage_default = {
  container: "GlobalMessage_container",
  "container--info": "GlobalMessage_container--info",
  icon: "GlobalMessage_icon",
  "container--danger": "GlobalMessage_container--danger",
  "container--warning": "GlobalMessage_container--warning",
  content: "GlobalMessage_content",
  "content--closable": "GlobalMessage_content--closable"
};

// src/components/GlobalMessage/GlobalMessage.tsx
import { jsx as jsx264, jsxs as jsxs60 } from "react/jsx-runtime";
var icons = {
  info: InfoIcon,
  danger: ErrorIcon,
  warning: WarningIcon
};
var GlobalMessage = ({
  message,
  purpose = "info",
  closable,
  onClose,
  children,
  id,
  className,
  htmlProps,
  ...rest
}) => {
  const [isClosed, setClosed] = useState16(false);
  return !isClosed ? /* @__PURE__ */ jsxs60(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          GlobalMessage_default.container,
          GlobalMessage_default[`container--${purpose}`],
          typographyStyles_default["body-medium"]
        ),
        htmlProps,
        rest
      ),
      children: [
        /* @__PURE__ */ jsxs60(
          "div",
          {
            className: cn(GlobalMessage_default.content, closable && GlobalMessage_default["content--closable"]),
            children: [
              /* @__PURE__ */ jsx264(Icon, { icon: icons[purpose], className: GlobalMessage_default.icon }),
              children != null ? children : /* @__PURE__ */ jsx264("span", { children: message })
            ]
          }
        ),
        closable && /* @__PURE__ */ jsx264(
          Button,
          {
            icon: CloseIcon,
            purpose: "tertiary",
            onClick: () => {
              setClosed(true);
              onClose && onClose();
            },
            size: "small",
            "aria-label": "Lukk melding"
          }
        )
      ]
    }
  ) : null;
};
GlobalMessage.displayName = "GlobalMessage";

// src/components/InlineButton/InlineButton.module.css
var InlineButton_default = {
  button: "InlineButton_button"
};

// src/components/InlineButton/InlineButton.tsx
import { jsx as jsx265 } from "react/jsx-runtime";
var InlineButton = ({ className, ...rest }) => /* @__PURE__ */ jsx265(
  "button",
  {
    className: cn(
      className,
      utilStyles_default["normalize-button"],
      utilStyles_default["remove-button-styling"],
      focus_default.focusable,
      typographyStyles_default.a,
      InlineButton_default.button
    ),
    ...rest
  }
);

// src/components/InlineEdit/InlineEditTextArea.tsx
import { useRef as useRef25 } from "react";

// src/components/InlineEdit/InlineEdit.context.tsx
import {
  createContext as createContext11,
  useContext as useContext15,
  useState as useState17
} from "react";
import { jsx as jsx266 } from "react/jsx-runtime";
var InlineEditContext = createContext11(
  {}
);
var useInlineEditContext = () => useContext15(InlineEditContext);
var InlineEditContextProvider = (props) => {
  const {
    emptiable,
    value,
    onSetValue,
    onChange,
    onFocus,
    onBlur,
    inputRef,
    children
  } = props;
  const [editingValue, setEditingValue] = useState17(value != null ? value : "");
  const [isEditing, setIsEditing] = useState17(false);
  const onChangeHandler = (e) => {
    setEditingValue(e.target.value);
    onChange == null ? void 0 : onChange(e);
  };
  const onFocusHandler = (e) => {
    setIsEditing(true);
    onFocus == null ? void 0 : onFocus(e);
  };
  const onBlurHandler = (e) => {
    if (!emptiable && e.target.value.trim() === "") {
      setEditingValue(value);
    } else {
      onSetValue == null ? void 0 : onSetValue(e.target.value);
    }
    setIsEditing(false);
    onBlur == null ? void 0 : onBlur(e);
  };
  const onExitHandler = () => {
    if ((inputRef == null ? void 0 : inputRef.current) === document.activeElement && document.activeElement instanceof HTMLElement) {
      setIsEditing(false);
      document.activeElement.blur();
    }
  };
  useOnKeyDown(["Enter"], () => onExitHandler());
  useOnKeyDown(["Escape"], () => onExitHandler());
  useOnClickOutside(inputRef == null ? void 0 : inputRef.current, () => onExitHandler());
  return /* @__PURE__ */ jsx266(
    InlineEditContext,
    {
      value: {
        onChange: onChangeHandler,
        onBlur: onBlurHandler,
        onFocus: onFocusHandler,
        isEditing,
        value: editingValue,
        emptiable
      },
      children
    }
  );
};
InlineEditContextProvider.displayName = "InlineEditContextProvider";

// src/components/InlineEdit/InlineTextArea.tsx
import { useId as useId15, useRef as useRef24 } from "react";

// src/components/InlineEdit/InlineEdit.module.css
var InlineEdit_default = {
  "inline-input": "InlineEdit_inline-input",
  "inline-input--with-icon": "InlineEdit_inline-input--with-icon",
  "inline-textarea": "InlineEdit_inline-textarea",
  "icon-wrapper": "InlineEdit_icon-wrapper"
};

// src/components/InlineEdit/InlineEdit.utils.tsx
import { jsxs as jsxs61 } from "react/jsx-runtime";
var inlineEditVisuallyHidden = (id, emptiable) => /* @__PURE__ */ jsxs61(VisuallyHidden, { id, as: "span", children: [
  "Escape, Enter eller Tab for \xE5 lagre.",
  " ",
  !emptiable && "Inputfeltet er ikke t\xF8mmbar."
] });

// src/components/InlineEdit/InlineTextArea.tsx
import { jsx as jsx267, jsxs as jsxs62 } from "react/jsx-runtime";
var InlineTextArea = ({
  id,
  error,
  errorMessage,
  width = "140px",
  "aria-describedby": ariaDescribedby,
  hideIcon,
  ref,
  ...rest
}) => {
  const { onBlur, onChange, onFocus, isEditing, value, emptiable } = useInlineEditContext();
  const genereatedId = useId15();
  const uniqueId = id != null ? id : `${genereatedId}-InlineTextArea`;
  const hasErrorMessage = !!errorMessage;
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const hasError = !!error;
  const hasErrorState = hasError || hasErrorMessage;
  const descId = derivativeIdGenerator(uniqueId, "desc");
  const inputRef = useRef24(null);
  const combinedRef = useCombinedRef(ref, inputRef);
  return /* @__PURE__ */ jsxs62(Box, { position: "relative", width, children: [
    /* @__PURE__ */ jsxs62("div", { className: Input_default["input-group"], children: [
      !isEditing && !hideIcon && /* @__PURE__ */ jsx267(
        "span",
        {
          onClick: () => {
            var _a;
            (_a = inputRef.current) == null ? void 0 : _a.focus();
          },
          className: InlineEdit_default["icon-wrapper"],
          children: /* @__PURE__ */ jsx267(Icon, { icon: EditIcon, iconSize: "small" })
        }
      ),
      /* @__PURE__ */ jsx267(
        "textarea",
        {
          ...rest,
          value,
          onChange,
          onBlur,
          onFocus,
          id: uniqueId,
          ref: combinedRef,
          "aria-describedby": spaceSeparatedIdListGenerator([
            hasErrorMessage ? errorMessageId : void 0,
            descId,
            ariaDescribedby
          ]),
          className: cn(
            InlineEdit_default["inline-input"],
            !hideIcon && !isEditing && InlineEdit_default["inline-input--with-icon"],
            InlineEdit_default["inline-textarea"],
            Input_default["input--stateful"],
            hasErrorState && Input_default["input--stateful-danger"],
            typographyStyles_default["body-medium"],
            utilStyles_default.scrollbar,
            focusable
          )
        }
      )
    ] }),
    inlineEditVisuallyHidden(descId, emptiable),
    renderInputMessage(void 0, void 0, errorMessage, errorMessageId)
  ] });
};
InlineTextArea.displayName = "InlineTextArea";

// src/components/InlineEdit/InlineEditTextArea.tsx
import { jsx as jsx268 } from "react/jsx-runtime";
var InlineEditTextArea = ({
  onSetValue,
  emptiable,
  value,
  onFocus,
  onChange,
  onBlur,
  ref,
  ...rest
}) => {
  const textareaRef = useRef25(null);
  const combinedRef = useCombinedRef(ref, textareaRef);
  return /* @__PURE__ */ jsx268(
    InlineEditContextProvider,
    {
      onSetValue,
      emptiable,
      inputRef: textareaRef,
      value,
      onFocus,
      onChange,
      onBlur,
      children: /* @__PURE__ */ jsx268(InlineTextArea, { ref: combinedRef, ...rest })
    }
  );
};

// src/components/InlineEdit/InlineEditInput.tsx
import { useRef as useRef27 } from "react";

// src/components/InlineEdit/InlineInput.tsx
import { useId as useId16, useRef as useRef26 } from "react";
import { jsx as jsx269, jsxs as jsxs63 } from "react/jsx-runtime";
var InlineInput = ({
  id,
  error,
  errorMessage,
  width = "140px",
  "aria-describedby": ariaDescribedby,
  hideIcon,
  ref,
  ...rest
}) => {
  const { onBlur, onChange, onFocus, isEditing, value, emptiable } = useInlineEditContext();
  const genereatedId = useId16();
  const uniqueId = id != null ? id : `${genereatedId}-InlineInput`;
  const hasErrorMessage = !!errorMessage;
  const hasError = !!error;
  const hasErrorState = hasError || hasErrorMessage;
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const descId = derivativeIdGenerator(uniqueId, "desc");
  const inputRef = useRef26(null);
  const combinedRef = useCombinedRef(ref, inputRef);
  return /* @__PURE__ */ jsxs63(Box, { position: "relative", width, children: [
    /* @__PURE__ */ jsxs63("div", { className: Input_default["input-group"], children: [
      !isEditing && !hideIcon && /* @__PURE__ */ jsx269(
        "span",
        {
          onClick: () => {
            var _a;
            (_a = inputRef.current) == null ? void 0 : _a.focus();
          },
          className: InlineEdit_default["icon-wrapper"],
          children: /* @__PURE__ */ jsx269(Icon, { icon: EditIcon, iconSize: "small" })
        }
      ),
      /* @__PURE__ */ jsx269(
        "input",
        {
          ...rest,
          value,
          onChange,
          onBlur,
          onFocus,
          id: uniqueId,
          ref: combinedRef,
          "aria-describedby": spaceSeparatedIdListGenerator([
            hasErrorMessage ? errorMessageId : void 0,
            descId,
            ariaDescribedby
          ]),
          "aria-invalid": hasErrorState,
          className: cn(
            InlineEdit_default["inline-input"],
            !hideIcon && !isEditing && InlineEdit_default["inline-input--with-icon"],
            typographyStyles_default["body-medium"],
            hasErrorState && Input_default["input--stateful-danger"],
            focusable
          )
        }
      )
    ] }),
    inlineEditVisuallyHidden(descId, emptiable),
    renderInputMessage(void 0, void 0, errorMessage, errorMessageId)
  ] });
};
InlineInput.displayName = "InlineInput";

// src/components/InlineEdit/InlineEditInput.tsx
import { jsx as jsx270 } from "react/jsx-runtime";
var InlineEditInput = ({
  onSetValue,
  emptiable,
  value,
  onFocus,
  onChange,
  onBlur,
  ref,
  ...rest
}) => {
  const inputRef = useRef27(null);
  const combinedRef = useCombinedRef(ref, inputRef);
  return /* @__PURE__ */ jsx270(
    InlineEditContextProvider,
    {
      onSetValue,
      emptiable,
      inputRef,
      value,
      onFocus,
      onChange,
      onBlur,
      children: /* @__PURE__ */ jsx270(InlineInput, { ...rest, ref: combinedRef })
    }
  );
};

// src/components/InternalHeader/InternalHeader.tsx
import { useState as useState18 } from "react";

// src/components/InternalHeader/InternalHeader.module.css
var InternalHeader_default = {
  bar: "InternalHeader_bar",
  "bar-separator": "InternalHeader_bar-separator",
  "bar--with-nav": "InternalHeader_bar--with-nav",
  "context-menu-group": "InternalHeader_context-menu-group",
  "nav-list": "InternalHeader_nav-list",
  "nav-list__item": "InternalHeader_nav-list__item",
  "nav-list__item__link": "InternalHeader_nav-list__item__link",
  "nav-list__item__link--active": "InternalHeader_nav-list__item__link--active",
  "context-menu": "InternalHeader_context-menu"
};

// src/components/InternalHeader/NavigationItem.tsx
import { jsx as jsx271 } from "react/jsx-runtime";
var NavigationItem = ({ isCurrent, ...rest }) => /* @__PURE__ */ jsx271(
  "a",
  {
    ...rest,
    "aria-current": isCurrent ? "page" : void 0,
    className: cn(
      InternalHeader_default["nav-list__item__link"],
      isCurrent && InternalHeader_default["nav-list__item__link--active"],
      typographyStyles_default["body-medium"],
      focusable
    )
  }
);

// src/components/InternalHeader/InternalHeader.tsx
import { jsx as jsx272, jsxs as jsxs64 } from "react/jsx-runtime";
var InternalHeader = (props) => {
  const {
    applicationDesc,
    applicationName,
    applicationHref,
    smallScreenBreakpoint,
    navItems,
    contextMenuItems,
    currentPageHref,
    user,
    onCurrentPageChange,
    id,
    className,
    htmlProps,
    ...rest
  } = props;
  const [currentPage, setCurrentPage] = useState18(
    currentPageHref
  );
  const handleCurrentPageChange = (href) => {
    setCurrentPage(href);
    onCurrentPageChange == null ? void 0 : onCurrentPageChange();
  };
  const hasNavigationElements = !!navItems && navItems.length > 0;
  const hasContextMenuElements = !!contextMenuItems && contextMenuItems.length > 0;
  const hasSmallScreenBreakpoint = !!smallScreenBreakpoint;
  const hasNavInContextMenu = hasSmallScreenBreakpoint && hasNavigationElements;
  const navigation = hasNavigationElements ? /* @__PURE__ */ jsx272("nav", { "aria-label": "sidenavigasjon", children: /* @__PURE__ */ jsx272(
    ShowHide,
    {
      as: StylelessList,
      hideBelow: hasSmallScreenBreakpoint ? smallScreenBreakpoint : void 0,
      className: cn(InternalHeader_default["nav-list"]),
      children: navItems.map((item, index) => {
        const { href, ...rest2 } = item;
        const isCurrent = href === currentPage;
        return /* @__PURE__ */ jsx272("li", { className: InternalHeader_default["nav-list__item"], children: /* @__PURE__ */ jsx272(
          NavigationItem,
          {
            href,
            ...rest2,
            isCurrent,
            onClick: () => handleCurrentPageChange(href)
          }
        ) }, index);
      })
    }
  ) }) : null;
  const hasContextMenu = hasContextMenuElements || !!user || hasNavInContextMenu;
  const hasContextMenuLargeScreen = hasContextMenuElements || !!user;
  return /* @__PURE__ */ jsxs64(
    Box,
    {
      display: "flex",
      alignItems: "center",
      gap: applyResponsiveStyle("x1.5", smallScreenBreakpoint, "x1"),
      paddingInline: applyResponsiveStyle(
        "x1.5",
        smallScreenBreakpoint,
        "x1 x0.5"
      ),
      ...getBaseHTMLProps(
        id,
        cn(className, InternalHeader_default.bar, !!navigation && InternalHeader_default["bar--with-nav"]),
        htmlProps,
        rest
      ),
      children: [
        /* @__PURE__ */ jsx272(Typography, { typographyType: "headingSmall", bold: true, as: "span", children: applicationHref ? /* @__PURE__ */ jsx272(
          "a",
          {
            href: applicationHref,
            rel: "noopener noreferrer",
            className: cn(utilStyles_default["inherit-link-styling"], focusable),
            children: applicationName
          }
        ) : applicationName }),
        /* @__PURE__ */ jsx272(Typography, { typographyType: "bodyMedium", as: "span", children: applicationDesc }),
        (hasContextMenu || navigation !== null) && /* @__PURE__ */ jsx272("div", { className: InternalHeader_default["bar-separator"] }),
        navigation,
        hasContextMenu && /* @__PURE__ */ jsx272(
          ShowHide,
          {
            showBelow: !hasContextMenuLargeScreen && hasSmallScreenBreakpoint ? smallScreenBreakpoint : void 0,
            className: cn(InternalHeader_default["context-menu-group"]),
            children: /* @__PURE__ */ jsxs64(OverflowMenuGroup, { children: [
              /* @__PURE__ */ jsx272(
                Button,
                {
                  icon: hasNavInContextMenu ? MenuIcon : MoreVerticalIcon,
                  purpose: "tertiary",
                  "aria-label": "\xE5pne meny"
                }
              ),
              /* @__PURE__ */ jsxs64(OverflowMenu, { className: InternalHeader_default["context-menu"], children: [
                user && /* @__PURE__ */ jsx272(OverflowMenuList, { children: user.href ? /* @__PURE__ */ jsx272(OverflowMenuLink, { icon: PersonIcon, ...user }) : /* @__PURE__ */ jsx272(OverflowMenuSpan, { icon: PersonIcon, ...user }) }),
                hasNavInContextMenu && /* @__PURE__ */ jsx272(
                  ShowHide,
                  {
                    as: "nav",
                    "aria-label": "sidenavigasjon",
                    showBelow: smallScreenBreakpoint,
                    children: /* @__PURE__ */ jsx272(OverflowMenuList, { children: navItems.map((item) => /* @__PURE__ */ jsx272(OverflowMenuLink, { ...item })) })
                  }
                ),
                hasNavInContextMenu && hasContextMenuElements && /* @__PURE__ */ jsx272(
                  ShowHide,
                  {
                    as: OverflowMenuDivider,
                    showBelow: smallScreenBreakpoint
                  }
                ),
                hasContextMenuElements && /* @__PURE__ */ jsx272(OverflowMenuList, { children: contextMenuItems.map((item) => {
                  return item.href ? /* @__PURE__ */ jsx272(OverflowMenuLink, { ...item }) : /* @__PURE__ */ jsx272(
                    OverflowMenuButton,
                    {
                      ...item
                    }
                  );
                }) })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
InternalHeader.displayName = "InternalHeader";

// src/components/List/List.module.css
var List_default = {
  list: "List_list",
  "list--inherit": "List_list--inherit",
  "list--unordered": "List_list--unordered",
  "list--ordered": "List_list--ordered",
  li: "List_li"
};

// src/components/List/List.tsx
import { jsx as jsx273 } from "react/jsx-runtime";
var List = ({
  listType = "unordered",
  typographyType = "inherit",
  children,
  id,
  className,
  htmlProps,
  ...rest
}) => {
  const List2 = listType === "ordered" ? "ol" : "ul";
  return /* @__PURE__ */ jsx273(
    List2,
    {
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      className: cn(
        List_default.list,
        List_default[`list--${listType}`],
        typographyType === "inherit" ? List_default["list--inherit"] : typographyStyles_default[getTypographyCn(typographyType)]
      ),
      children
    }
  );
};
List.displayName = "List";

// src/components/List/ListItem.tsx
import { jsx as jsx274 } from "react/jsx-runtime";
var ListItem = ({ className, ...rest }) => /* @__PURE__ */ jsx274("li", { ...rest, className: cn(className, List_default.li) });
ListItem.displayName = "ListItem";

// src/components/LocalMessage/LocalMessage.tsx
import { useState as useState19 } from "react";

// src/components/LocalMessage/LocalMessage.module.css
var LocalMessage_default = {
  container: "LocalMessage_container",
  "container--info": "LocalMessage_container--info",
  icon: "LocalMessage_icon",
  "container--warning": "LocalMessage_container--warning",
  "container--danger": "LocalMessage_container--danger",
  "container--success": "LocalMessage_container--success",
  "container--tips": "LocalMessage_container--tips",
  "container--horisontal": "LocalMessage_container--horisontal",
  "container--horisontal--closable": "LocalMessage_container--horisontal--closable",
  "container--vertical": "LocalMessage_container--vertical",
  "container--vertical--closable": "LocalMessage_container--vertical--closable",
  container__text: "LocalMessage_container__text",
  container__icon: "LocalMessage_container__icon",
  container__button: "LocalMessage_container__button"
};

// src/components/LocalMessage/LocalMessage.tsx
import { Fragment as Fragment6, jsx as jsx275, jsxs as jsxs65 } from "react/jsx-runtime";
var icons2 = {
  info: InfoIcon,
  danger: ErrorIcon,
  warning: WarningIcon,
  success: CheckCircledIcon,
  tips: TipIcon
};
var LocalMessage = ({
  message,
  purpose = "info",
  closable,
  onClose,
  width,
  layout = "horisontal",
  children,
  id,
  className,
  htmlProps,
  ...rest
}) => {
  const [isClosed, setClosed] = useState19(false);
  if (isClosed) {
    return /* @__PURE__ */ jsx275(Fragment6, {});
  }
  return /* @__PURE__ */ jsxs65(
    Box,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          typographyStyles_default["body-medium"],
          LocalMessage_default.container,
          LocalMessage_default[`container--${layout}`],
          closable && LocalMessage_default[`container--${layout}--closable`],
          LocalMessage_default[`container--${purpose}`]
        ),
        htmlProps,
        rest
      ),
      width,
      display: "grid",
      padding: "x0.75 x0.75 x0.75 x0.5",
      gap: "x0.5",
      children: [
        /* @__PURE__ */ jsx275(
          Icon,
          {
            icon: icons2[purpose],
            className: cn(LocalMessage_default.icon, LocalMessage_default.container__icon)
          }
        ),
        /* @__PURE__ */ jsx275("div", { className: LocalMessage_default.container__text, children: children != null ? children : /* @__PURE__ */ jsx275("span", { children: message }) }),
        closable && /* @__PURE__ */ jsx275(
          Button,
          {
            icon: CloseIcon,
            purpose: "tertiary",
            onClick: () => {
              setClosed(true);
              onClose && onClose();
            },
            size: "xsmall",
            "aria-label": "Lukk melding",
            className: LocalMessage_default.container__button
          }
        )
      ]
    }
  );
};
LocalMessage.displayName = "LocalMessage";

// src/components/Modal/Modal.tsx
import {
  useContext as useContext16,
  useEffect as useEffect24,
  useId as useId17,
  useRef as useRef28
} from "react";
import { createPortal as createPortal3 } from "react-dom";

// src/components/Modal/Modal.module.css
var Modal_default = {
  container: "Modal_container",
  "container-scrollable": "Modal_container-scrollable",
  "header-container": "Modal_header-container",
  "close-button": "Modal_close-button",
  content: "Modal_content",
  body: "Modal_body"
};

// src/components/Modal/Modal.tsx
import { jsx as jsx276, jsxs as jsxs66 } from "react/jsx-runtime";
var Modal = ({
  isOpen = false,
  parentElement,
  children,
  header,
  onClose,
  id,
  triggerRef,
  initialFocusRef,
  scrollable,
  className,
  htmlProps,
  ref,
  ...rest
}) => {
  const generatedId = useId17();
  const modalId = id != null ? id : `${generatedId}-modal`;
  const headerId = `${modalId}-header`;
  const modalRef = useFocusTrap(isOpen, initialFocusRef);
  const combinedRef = useCombinedRef(ref, modalRef);
  const handleClose = () => {
    var _a;
    if (onClose && isOpen) {
      (_a = triggerRef == null ? void 0 : triggerRef.current) == null ? void 0 : _a.focus();
      onClose();
    }
  };
  const themeContext = useContext16(ThemeContext);
  if (!themeContext) {
    throw new Error("Modal must be used within a ThemeProvider");
  }
  const portalTarget = parentElement != null ? parentElement : themeContext == null ? void 0 : themeContext.el;
  useEffect24(() => {
    if (isOpen) {
      handleElementWithBackdropMount(document.body);
    } else {
      handleElementWithBackdropUnmount(document.body);
    }
    return () => handleElementWithBackdropUnmount(document.body);
  }, [isOpen]);
  const backdropRef = useRef28(null);
  const onBackdropClick = (event) => {
    if (event.target === backdropRef.current && isOpen) {
      handleClose();
    }
  };
  useOnKeyDown(["Escape", "Esc"], () => handleClose());
  const hasTransitionedIn = useMountTransition(isOpen, 200);
  return (isOpen || hasTransitionedIn) && portalTarget ? createPortal3(
    /* @__PURE__ */ jsx276(
      Backdrop,
      {
        zIndex: "modal",
        isMounted: isOpen && hasTransitionedIn,
        ref: backdropRef,
        onClick: onBackdropClick,
        children: /* @__PURE__ */ jsxs66(
          Paper,
          {
            display: "flex",
            flexDirection: "column",
            minWidth: "200px",
            ...getBaseHTMLProps(
              id,
              cn(
                className,
                Modal_default.container,
                focusable,
                scrollable && Modal_default["container-scrollable"],
                utilStyles_default.scrollbar
              ),
              htmlProps,
              rest
            ),
            ref: combinedRef,
            role: "dialog",
            "aria-modal": true,
            "aria-hidden": !isOpen,
            tabIndex: -1,
            "aria-labelledby": headerId,
            id: modalId,
            elevation: 4,
            children: [
              /* @__PURE__ */ jsxs66(
                HStack,
                {
                  paddingBlock: "0 x0.75",
                  position: "sticky",
                  top: "0",
                  left: "0",
                  width: "100%",
                  className: Modal_default["header-container"],
                  children: [
                    !!header && /* @__PURE__ */ jsx276("div", { id: headerId, children: typeof header === "string" ? /* @__PURE__ */ jsx276(Heading, { level: 2, typographyType: "headingLarge", children: header }) : header }),
                    onClose && /* @__PURE__ */ jsx276(
                      Button,
                      {
                        size: "small",
                        purpose: "tertiary",
                        icon: CloseIcon,
                        onClick: handleClose,
                        "aria-label": "Lukk dialog",
                        className: Modal_default["close-button"]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx276(Box, { display: "grid", gap: "x1", children })
            ]
          }
        )
      }
    ),
    portalTarget
  ) : null;
};
Modal.displayName = "Modal";

// src/components/Modal/ModalBody.tsx
import { jsx as jsx277 } from "react/jsx-runtime";
var ModalBody = ({
  children,
  id,
  className,
  scrollable,
  htmlProps,
  height,
  ...rest
}) => {
  return /* @__PURE__ */ jsx277(
    "div",
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          utilStyles_default.scrollbar,
          scrollable && utilStyles_default["scrollable-y"],
          Modal_default.body
        ),
        htmlProps,
        rest
      ),
      style: { ...htmlProps == null ? void 0 : htmlProps.style, height },
      children
    }
  );
};
ModalBody.displayName = "ModalBody";

// src/components/Modal/ModalActions.tsx
import { jsx as jsx278 } from "react/jsx-runtime";
var ModalActions = (props) => /* @__PURE__ */ jsx278(Box, { display: "flex", flexWrap: "wrap", gap: "x1", ...props });
ModalActions.displayName = "ModalActions";

// src/components/Pagination/Pagination.tsx
import { useState as useState20 } from "react";

// src/components/Pagination/Pagination.module.css
var Pagination_default = {
  list: "Pagination_list",
  list__item: "Pagination_list__item",
  "list__item--hidden": "Pagination_list__item--hidden",
  indicators: "Pagination_indicators",
  "truncation-icon": "Pagination_truncation-icon"
};

// src/components/Pagination/paginationGenerator.tsx
var arrayRange = (start, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};
function PaginationGenerator(pagesAmount, activePage) {
  const siblingsCount = 1;
  const maxPagesShown = 7;
  const pagesBeforeTruncator = 5;
  const truncator = "truncator";
  let pageRange;
  if (pagesAmount > 4) {
    const middleStartPage = Math.max(
      1,
      activePage < pagesBeforeTruncator || pagesAmount <= maxPagesShown ? 1 : activePage + siblingsCount + 1 >= pagesAmount ? pagesAmount - 4 : activePage > 4 && pagesAmount > maxPagesShown ? activePage - siblingsCount : 1
    );
    const middleEndOffset = activePage < pagesBeforeTruncator && pagesAmount > maxPagesShown ? pagesBeforeTruncator : activePage < pagesBeforeTruncator && pagesAmount <= maxPagesShown ? pagesAmount : activePage + siblingsCount + 1 < pagesAmount - 1 ? activePage + siblingsCount : activePage + siblingsCount + 1 === pagesAmount - 1 ? pagesAmount : pagesAmount;
    const middleEndPage = Math.min(pagesAmount, middleEndOffset);
    pageRange = arrayRange(middleStartPage, middleEndPage);
    const truncatedLeft = middleStartPage > 2 && pagesAmount > maxPagesShown;
    const truncatedRight = pagesAmount - middleEndPage > 1 && pagesAmount > maxPagesShown;
    if (truncatedLeft && truncatedRight) {
      pageRange = [1, truncator, ...pageRange, truncator, pagesAmount];
    } else if (truncatedLeft && !truncatedRight) {
      pageRange = [1, truncator, ...pageRange];
    } else if (!truncatedLeft && truncatedRight) {
      pageRange = [...pageRange, truncator, pagesAmount];
    }
    return [...pageRange];
  }
  return arrayRange(1, pagesAmount);
}

// src/components/Select/Select.tsx
import {
  useContext as useContext17,
  useId as useId18
} from "react";
import {
  default as ReactSelect
} from "react-select";

// src/components/Select/Select.module.css
var Select_default = {
  "container--disabled": "Select_container--disabled",
  "container--readonly": "Select_container--readonly",
  "inner-single-value": "Select_inner-single-value",
  "icon--medium": "Select_icon--medium",
  "icon--small": "Select_icon--small",
  "icon--xsmall": "Select_icon--xsmall",
  control: "Select_control",
  "control--readonly": "Select_control--readonly",
  "dropdown-indicator": "Select_dropdown-indicator",
  "control--disabled": "Select_control--disabled"
};

// src/components/Select/Select.styles.ts
var optionTypography = {
  medium: {
    font: "var(--dds-font-body-medium)",
    letterSpacing: "var(--dds-font-body-medium-letter-spacing)"
  },
  small: {
    font: "var(--dds-font-body-small)",
    letterSpacing: "var(--dds-font-body-small-letter-spacing)"
  },
  xsmall: {
    font: "var(--dds-font-body-xsmall)",
    letterSpacing: "var(--dds-font-body-xsmall-letter-spacing)"
  }
};
var multiValueLabelTypography = {
  medium: {
    font: "var(--dds-font-body-small)",
    letterSpacing: "var(--dds-font-body-small-letter-spacing)"
  },
  small: {
    font: "var(--dds-font-body-small)",
    letterSpacing: "var(--dds-font-body-small-letter-spacing)"
  },
  xsmall: {
    font: "var(--dds-font-body-xsmall)",
    letterSpacing: "var(--dds-font-body-xsmall-letter-spacing)"
  }
};
var groupHeadingTypography = {
  font: "var(--dds-font-body-xsmall)",
  letterSpacing: "var(--dds-font-body-xsmall-letter-spacing)"
};
var typography = {
  option: optionTypography,
  multiValueLabel: multiValueLabelTypography,
  groupHeading: groupHeadingTypography
};
var prefix = "dds-select";
var control = {
  medium: {
    base: {
      paddingBlock: "var(--dds-spacing-x0-75)",
      paddingLeft: "var(--dds-spacing-x0-75)",
      ...optionTypography.medium
    },
    hasIcon: {
      paddingLeft: "calc(var(--dds-spacing-x0-75) + var(--dds-icon-size-medium) + var(--dds-spacing-x0-5))"
    }
  },
  small: {
    base: {
      paddingBlock: "var(--dds-spacing-x0-5)",
      paddingLeft: "var(--dds-spacing-x0-75)",
      ...optionTypography.small
    },
    hasIcon: {
      paddingLeft: "calc(var(--dds-spacing-x0-75) + var(--dds-icon-size-medium) + var(--dds-spacing-x0-5))"
    }
  },
  xsmall: {
    base: {
      paddingBlock: "var(--dds-spacing-x0-25)",
      paddingLeft: "var(--dds-spacing-x0-5)",
      ...optionTypography.xsmall
    },
    hasIcon: {
      paddingLeft: "calc(var(--dds-spacing-x0-5) + var(--dds-icon-size-small) + var(--dds-spacing-x0-5))"
    }
  }
};
var getCustomStyles = (size2, hasError, hasIcon, isReadOnly) => ({
  control: (provided, state) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    cursor: "pointer",
    borderRadius: "var(--dds-border-radius-input)",
    border: "1px solid",
    borderColor: "var(--dds-color-border-default)",
    backgroundColor: "var(--dds-color-surface-default)",
    transition: `box-shadow 0.2s, border-color 0.2s, ${focusVisibleTransitionValue}`,
    paddingRight: "var(--dds-spacing-x0-5)",
    ...control[size2].base,
    ...hasIcon && control[size2].hasIcon,
    "&:hover": {
      ...!isReadOnly && {
        borderColor: "var(--dds-color-border-action-hover)",
        boxShadow: "0 0 0 1px var(--dds-color-border-action-hover)"
      }
    },
    ...hasError && {
      borderColor: "var(--dds-color-border-danger)",
      boxShadow: "0 0 0 1px var(--dds-color-border-danger)",
      "&:hover": {
        borderColor: "var(--dds-color-border-danger)",
        boxShadow: "0 0 0 1px var(--dds-color-border-danger)"
      }
    },
    "&:focus-within": {
      ...focusVisible
    },
    ...state.selectProps.isDisabled && {
      borderColor: "var(--dds-color-border-subtle)",
      backgroundColor: "var(--dds-color-surface-field-disabled)",
      color: "var(--dds-color-text-subtle)",
      pointerEvents: "none"
    },
    ...isReadOnly && {
      borderColor: "var(--dds-color-border-default)",
      backgroundColor: "var(--dds-color-surface-field-disabled)",
      color: "var(--dds-color-text-medium)",
      boxShadow: "none",
      cursor: "default"
    }
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--dds-color-text-subtle)",
    margin: 0
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0
  }),
  indicatorSeparator: () => ({}),
  dropdownIndicator: (provided, state) => ({
    display: "inline-flex",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "",
    "@media (prefers-reduced-motion: no-preference)": {
      transition: "color 0.2s, transform 0.2s"
    },
    padding: 0,
    color: "var(--dds-color-icon-default)",
    ...state.selectProps.isDisabled && {
      color: "var(--dds-color-icon-subtle)"
    },
    ...isReadOnly && { color: "var(--dds-color-icon-subtle)" }
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    ...state.selectProps.isMulti && {
      gap: "var(--dds-spacing-x0-25)"
    },
    padding: 0
  }),
  singleValue: () => ({
    gridArea: "1/1/2/3",
    overflow: "hidden",
    boxSizing: "border-box"
  }),
  multiValue: () => ({
    boxSizing: "border-box",
    minWidth: 0,
    display: "flex",
    borderRadius: "var(--dds-border-radius-surface)",
    backgroundColor: "var(--dds-color-surface-medium)"
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    padding: "0 var(--dds-spacing-x0-25)",
    ...typography.multiValueLabel[size2],
    color: "var(--dds-color-text-default)",
    ...state.selectProps.isDisabled && {
      color: "var(--dds-color-text-subtle)"
    },
    ...isReadOnly && {
      color: "var(--dds-color-text-medium)"
    }
  }),
  multiValueRemove: (provided, state) => state.selectProps.isDisabled || isReadOnly ? {
    display: "none"
  } : {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    "@media (prefers-reduced-motion: no-preference)": {
      transition: "color 0.2s, background-color 0.2s, box-shadow 0.2s"
    },
    color: "var(--dds-color-icon-default)",
    padding: "0 var(--dds-spacing-x0-25)"
  },
  menu: () => ({
    boxSizing: "border-box",
    position: "absolute",
    width: "100%",
    boxShadow: "var(--dds-shadow-2)",
    zIndex: 100,
    transition: "0.2s",
    border: "1px solid var(--dds-color-border-default)",
    backgroundColor: "var(--dds-color-surface-default)",
    borderRadius: "var(--dds-border-radius-surface)",
    marginBlock: "var(--dds-spacing-x0-25)"
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 99999
  }),
  group: () => ({
    boxSizing: "border-box"
  }),
  groupHeading: () => ({
    ...typography.groupHeading,
    color: "var(--dds-color-text-medium)",
    paddingInline: "var(--dds-spacing-x0-75)",
    paddingBlock: "var(--dds-spacing-x0-5) var(--dds-spacing-x0-125)"
  }),
  menuList: () => ({
    maxHeight: "300px",
    overflowY: "auto",
    position: "relative",
    boxSizing: "border-box",
    ...scrollbarStyling
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "var(--dds-spacing-x0-5)",
    padding: "var(--dds-spacing-x0-75)",
    backgroundColor: "var(--dds-color-surface-default)",
    ...typography.option[size2],
    color: "var(--dds-color-text-default)",
    "@media (prefers-reduced-motion: no-preference)": {
      transition: "color 0.2s, background-color 0.2s"
    },
    "&:hover": {
      color: "var(--dds-color-text-default)",
      backgroundColor: "var(--dds-color-surface-hover-default)"
    },
    // egen stil siden react-select bruker focus-state og hover-styling samtidig; ikke nødvendig hvis de kan skilles.
    ...state.isFocused && {
      outline: "var(--dds-color-border-action-hover) 2px solid",
      outlineOffset: "calc(var(--dds-spacing-x0-125) * -1)"
    }
  }),
  noOptionsMessage: () => ({
    ...typography.option[size2],
    padding: "var(--dds-spacing-x0-5) var(--dds-spacing-x1)",
    color: "var(--dds-color-text-medium)"
  }),
  clearIndicator: () => isReadOnly ? { display: "none" } : {
    display: "inline-flex",
    color: "var(--dds-color-icon-default)",
    borderRadius: "var(--dds-border-radius-button)",
    "@media (prefers-reduced-motion: no-preference)": {
      transition: "background-color 0.2s"
    },
    "&:hover": {
      backgroundColor: "var(--dds-color-surface-hover-default)"
    }
  },
  loadingIndicator: (provided) => ({
    ...provided,
    padding: 0,
    color: "var(--dds-color-icon-default)"
  })
});

// src/components/Select/SelectComponents.tsx
import {
  components
} from "react-select";
import { jsx as jsx279, jsxs as jsxs67 } from "react/jsx-runtime";
var {
  Option,
  NoOptionsMessage,
  Input: Input2,
  SingleValue,
  ClearIndicator,
  DropdownIndicator,
  MultiValueRemove,
  Control
} = components;
var getIndicatorIconSize = (componentSize) => {
  switch (componentSize) {
    case "medium":
      return "medium";
    case "small":
      return "small";
    case "xsmall":
      return "small";
  }
};
var DDSOption = (props, componentSize) => /* @__PURE__ */ jsxs67(Option, { ...props, children: [
  props.isSelected && /* @__PURE__ */ jsx279(Icon, { icon: CheckIcon, iconSize: getFormInputIconSize(componentSize) }),
  props.children
] });
var CustomOption = (props, Element) => /* @__PURE__ */ jsx279(Option, { ...props, children: /* @__PURE__ */ jsx279(Element, { ...props }) });
var CustomSingleValue = (props, id, Element) => /* @__PURE__ */ jsx279(SingleValue, { ...props, children: /* @__PURE__ */ jsx279("div", { id, className: Select_default["inner-single-value"], children: Element ? /* @__PURE__ */ jsx279(Element, { ...props }) : props.children }) });
var DDSNoOptionsMessage = (props) => /* @__PURE__ */ jsx279(NoOptionsMessage, { ...props, children: "Ingen treff" });
var DDSClearIndicator = (props, size2) => /* @__PURE__ */ jsx279(ClearIndicator, { ...props, children: /* @__PURE__ */ jsx279(Icon, { icon: CloseSmallIcon, iconSize: getIndicatorIconSize(size2) }) });
var DDSMultiValueRemove = (props) => /* @__PURE__ */ jsx279(MultiValueRemove, { ...props, children: /* @__PURE__ */ jsx279(Icon, { icon: CloseSmallIcon, iconSize: "small" }) });
var DDSDropdownIndicator = (props, size2) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx279(
    DropdownIndicator,
    {
      ...rest,
      className: cn(className, Select_default["dropdown-indicator"]),
      children: /* @__PURE__ */ jsx279(Icon, { icon: ChevronDownIcon, iconSize: getIndicatorIconSize(size2) })
    }
  );
};
var DDSInput = (props, ariaInvalid, ariaDescribedby) => /* @__PURE__ */ jsx279(
  Input2,
  {
    ...props,
    "aria-invalid": ariaInvalid,
    "aria-describedby": ariaDescribedby
  }
);
var DDSControl = (props, componentSize, readOnly, icon, dataTestId) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx279("div", { "data-testid": dataTestId ? dataTestId + "-control" : void 0, children: /* @__PURE__ */ jsxs67(
    Control,
    {
      ...rest,
      className: cn(
        className,
        Select_default.control,
        rest.isDisabled && Select_default["control--disabled"],
        readOnly && Select_default["control--readonly"]
      ),
      children: [
        icon && /* @__PURE__ */ jsx279(
          Icon,
          {
            icon,
            iconSize: getFormInputIconSize(componentSize),
            className: cn(
              Input_default["input-group__absolute-element"],
              Select_default[`icon--${componentSize}`]
            )
          }
        ),
        props.children
      ]
    }
  ) });
};

// src/components/Select/Select.tsx
import { jsx as jsx280, jsxs as jsxs68 } from "react/jsx-runtime";
function Select({
  id,
  label,
  componentSize = "medium",
  errorMessage,
  tip,
  required,
  "aria-required": ariaRequired,
  readOnly,
  options,
  isMulti,
  value,
  icon,
  defaultValue,
  width,
  closeMenuOnSelect,
  className,
  style,
  isDisabled,
  isClearable = true,
  placeholder,
  menuPortalTarget,
  customOptionElement,
  customSingleValueElement,
  "data-testid": dataTestId,
  onKeyDown,
  openMenuOnClick,
  ref,
  ...rest
}) {
  const themeContext = useContext17(ThemeContext);
  if (!themeContext) {
    throw new Error("Select must be used within a ThemeProvider");
  }
  const portalTarget = menuPortalTarget != null ? menuPortalTarget : themeContext == null ? void 0 : themeContext.el;
  const generatedId = useId18();
  const uniqueId = id != null ? id : `${generatedId}-select`;
  const singleValueId = !isMulti ? `${uniqueId}-singleValue` : void 0;
  const hasLabel = !!label;
  const hasErrorMessage = !!errorMessage;
  const hasIcon = !!icon;
  const showRequiredStyling = !!(required || ariaRequired);
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const inputWidth = getInputWidth(
    width,
    componentSize === "xsmall" && "var(--dds-input-default-width-xsmall)"
  );
  const reactSelectProps = {
    options,
    value,
    defaultValue,
    isDisabled: !!isDisabled,
    isClearable,
    placeholder: placeholder ? placeholder : "",
    closeMenuOnSelect: closeMenuOnSelect ? closeMenuOnSelect : isMulti ? false : true,
    isMulti,
    inputId: uniqueId,
    name: uniqueId,
    menuPortalTarget: portalTarget,
    classNamePrefix: prefix,
    styles: getCustomStyles(
      componentSize,
      hasErrorMessage,
      hasIcon,
      readOnly
    ),
    filterOption: (option, inputValue) => {
      const { label: label2 } = option;
      return searchFilter(label2, inputValue) || inputValue === "";
    },
    components: {
      Option: customOptionElement ? (props) => CustomOption(props, customOptionElement) : (props) => DDSOption(props, componentSize),
      NoOptionsMessage: DDSNoOptionsMessage,
      Input: (props) => DDSInput(
        {
          ...props,
          readOnly,
          "aria-required": ariaRequired
        },
        hasErrorMessage,
        spaceSeparatedIdListGenerator([
          singleValueId,
          tip ? tipId : void 0,
          errorMessage ? errorMessageId : void 0
        ])
      ),
      SingleValue: (props) => CustomSingleValue(props, singleValueId, customSingleValueElement),
      ClearIndicator: (props) => DDSClearIndicator(props, componentSize),
      DropdownIndicator: (props) => DDSDropdownIndicator(props, componentSize),
      MultiValueRemove: DDSMultiValueRemove,
      Control: (props) => DDSControl(props, componentSize, readOnly, icon, dataTestId)
    },
    "aria-invalid": hasErrorMessage ? true : void 0,
    required,
    onKeyDown: readOnlyKeyDownHandler("select", readOnly, onKeyDown),
    openMenuOnClick: readOnly ? false : openMenuOnClick ? openMenuOnClick : void 0,
    ...rest
  };
  return /* @__PURE__ */ jsxs68(
    Box,
    {
      width: inputWidth,
      position: "relative",
      margin: "0",
      className: cn(
        className,
        isDisabled && Select_default["container--disabled"],
        readOnly && Select_default["container--readonly"]
      ),
      style,
      children: [
        hasLabel && /* @__PURE__ */ jsx280(
          Label,
          {
            htmlFor: uniqueId,
            showRequiredStyling,
            className: Input_default.label,
            readOnly,
            children: label
          }
        ),
        /* @__PURE__ */ jsx280(ReactSelect, { ...reactSelectProps, ref }),
        renderInputMessage(tip, tipId, errorMessage, errorMessageId)
      ]
    }
  );
}
Select.displayName = "Select";

// src/components/Select/NativeSelect/NativeSelect.tsx
import { useId as useId19 } from "react";

// src/components/Select/NativeSelect/NativeSelect.module.css
var NativeSelect_default = {
  select: "NativeSelect_select",
  "select--readonly": "NativeSelect_select--readonly",
  "select--medium": "NativeSelect_select--medium",
  "select--small": "NativeSelect_select--small",
  "select--xsmall": "NativeSelect_select--xsmall",
  "select--multiple": "NativeSelect_select--multiple",
  icon: "NativeSelect_icon"
};

// src/components/Select/NativeSelect/NativeSelect.tsx
import { jsx as jsx281, jsxs as jsxs69 } from "react/jsx-runtime";
var NativeSelect = ({
  id,
  children,
  componentSize = "medium",
  label,
  multiple,
  readOnly,
  errorMessage,
  tip,
  required,
  "aria-required": ariaRequired,
  "aria-describedby": ariaDescribedby,
  width,
  className,
  style,
  onKeyDown,
  onMouseDown,
  ...rest
}) => {
  const generatedId = useId19();
  const uniqueId = id != null ? id : `${generatedId}-native-select`;
  const hasErrorMessage = !!errorMessage;
  const hasTip = !!tip;
  const hasLabel = !!label;
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const showRequiredStyling = !!(required || ariaRequired);
  const inputWidth = getInputWidth(
    width,
    componentSize === "xsmall" && "var(--dds-input-default-width-xsmall)"
  );
  return /* @__PURE__ */ jsxs69("div", { className, style, children: [
    hasLabel && /* @__PURE__ */ jsx281(
      Label,
      {
        className: Input_default.label,
        htmlFor: uniqueId,
        showRequiredStyling,
        readOnly,
        children: label
      }
    ),
    /* @__PURE__ */ jsxs69(Box, { position: "relative", width: inputWidth, children: [
      /* @__PURE__ */ jsx281(
        "select",
        {
          id: uniqueId,
          multiple,
          className: cn(
            NativeSelect_default.select,
            readOnly && NativeSelect_default["select--readonly"],
            Input_default.input,
            Input_default[`input--${componentSize}`],
            NativeSelect_default[`select--${componentSize}`],
            scrollbar,
            focusable,
            typographyStyles_default[`body-${componentSize}`],
            hasErrorMessage && Input_default["input--stateful-danger"],
            multiple && NativeSelect_default["select--multiple"]
          ),
          "aria-readonly": readOnly,
          "aria-invalid": hasErrorMessage,
          "aria-describedby": spaceSeparatedIdListGenerator([
            hasTip ? tipId : void 0,
            hasErrorMessage ? errorMessageId : void 0,
            ariaDescribedby
          ]),
          required,
          onKeyDown: readOnlyKeyDownHandler("select", readOnly, onKeyDown),
          onMouseDown: readOnlyMouseDownHandler(readOnly, onMouseDown),
          ...rest,
          children
        }
      ),
      !multiple && /* @__PURE__ */ jsx281(
        Icon,
        {
          icon: ChevronDownIcon,
          iconSize: componentSize === "xsmall" ? "small" : "medium",
          className: NativeSelect_default.icon
        }
      )
    ] }),
    renderInputMessage(tip, tipId, errorMessage, errorMessageId)
  ] });
};
var NativeSelectPlaceholder = ({
  children = "-- Velg fra listen --",
  value,
  ...rest
}) => /* @__PURE__ */ jsx281("option", { value: value != null ? value : "", selected: true, ...rest, children });
NativeSelectPlaceholder.displayName = "NativeSelectPlaceholder";

// src/components/Select/utils.ts
var createSelectOptions = (...args) => args.map((v) => ({ label: v, value: v }));

// src/components/Pagination/Pagination.tsx
import { jsx as jsx282, jsxs as jsxs70 } from "react/jsx-runtime";
var Pagination = ({
  itemsAmount,
  defaultItemsPerPage = 10,
  defaultActivePage = 1,
  withPagination = true,
  withCounter,
  withSelect,
  selectOptions = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "Alle", value: itemsAmount }
  ],
  smallScreenBreakpoint,
  onChange,
  onSelectOptionChange,
  id,
  className,
  htmlProps,
  ref,
  ...rest
}) => {
  const [activePage, setActivePage] = useState20(defaultActivePage);
  const [itemsPerPage, setItemsPerPage] = useState20(defaultItemsPerPage);
  const pagesLength = Math.ceil(itemsAmount / itemsPerPage);
  const items = PaginationGenerator(pagesLength, activePage);
  const onPageChange = (event, page) => {
    page && setActivePage(page);
    if (event && onChange) {
      onChange(event, page);
    }
  };
  const handleSelectChange = (option) => {
    if (option !== null) {
      setItemsPerPage(option.value);
    }
    if (onSelectOptionChange) {
      onSelectOptionChange(option);
    }
  };
  const listItems = items.length > 0 ? items.map((item, i) => {
    const isActive = item === activePage;
    return /* @__PURE__ */ jsx282("li", { className: Pagination_default.list__item, children: item !== "truncator" && typeof item === "number" ? /* @__PURE__ */ jsx282(
      Button,
      {
        purpose: isActive ? "primary" : "secondary",
        size: "small",
        onClick: (event) => {
          onPageChange(event, item);
        },
        "aria-label": isActive ? `N\xE5v\xE6rende side (side ${item})` : `G\xE5 til side ${item}`,
        children: item
      }
    ) : /* @__PURE__ */ jsx282(
      Icon,
      {
        icon: MoreHorizontalIcon,
        className: Pagination_default["truncation-icon"]
      }
    ) }, `pagination-item-${i}`);
  }) : void 0;
  const previousPageButton = /* @__PURE__ */ jsx282(
    Button,
    {
      purpose: "secondary",
      size: "small",
      icon: ChevronLeftIcon,
      onClick: (event) => {
        onPageChange(event, activePage - 1);
      },
      "aria-label": "G\xE5 til forrige siden"
    }
  );
  const nextPageButton = /* @__PURE__ */ jsx282(
    Button,
    {
      purpose: "secondary",
      size: "small",
      icon: ChevronRightIcon,
      onClick: (event) => {
        onPageChange(event, activePage + 1);
      },
      "aria-label": "G\xE5 til neste siden"
    }
  );
  const isOnFirstPage = activePage === 1;
  const isOnLastPage = activePage === pagesLength;
  const navigation = withPagination ? /* @__PURE__ */ jsxs70(
    Box,
    {
      as: "nav",
      ref,
      "aria-label": "paginering",
      display: "flex",
      alignItems: "center",
      ...!withSelect && !withCounter && {
        ...getBaseHTMLProps(id, className, htmlProps, rest)
      },
      children: [
        /* @__PURE__ */ jsxs70(
          ShowHide,
          {
            as: "ol",
            hideBelow: smallScreenBreakpoint,
            className: Pagination_default.list,
            children: [
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnFirstPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnFirstPage,
                  children: previousPageButton
                }
              ),
              listItems,
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnLastPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnLastPage,
                  children: nextPageButton
                }
              )
            ]
          }
        ),
        !!smallScreenBreakpoint && /* @__PURE__ */ jsxs70(
          ShowHide,
          {
            as: "ol",
            showBelow: smallScreenBreakpoint,
            className: Pagination_default.list,
            children: [
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnFirstPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnFirstPage,
                  children: /* @__PURE__ */ jsx282(
                    Button,
                    {
                      purpose: "secondary",
                      size: "small",
                      icon: ChevronFirstIcon,
                      onClick: (event) => {
                        onPageChange(event, 1);
                      },
                      "aria-label": "G\xE5 til f\xF8rste siden"
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnFirstPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnFirstPage,
                  children: previousPageButton
                }
              ),
              /* @__PURE__ */ jsx282("li", { className: Pagination_default.list__item, children: /* @__PURE__ */ jsx282(
                Button,
                {
                  size: "small",
                  onClick: (event) => {
                    onPageChange(event, activePage);
                  },
                  children: activePage
                }
              ) }),
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnLastPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnLastPage,
                  children: nextPageButton
                }
              ),
              /* @__PURE__ */ jsx282(
                "li",
                {
                  className: cn(
                    Pagination_default.list__item,
                    isOnLastPage && Pagination_default["list__item--hidden"]
                  ),
                  "aria-hidden": isOnLastPage,
                  children: /* @__PURE__ */ jsx282(
                    Button,
                    {
                      purpose: "secondary",
                      size: "small",
                      icon: ChevronLastIcon,
                      onClick: (event) => {
                        onPageChange(event, pagesLength);
                      },
                      "aria-label": "G\xE5 til siste siden"
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  ) : null;
  const activePageFirstItem = activePage === 1 ? 1 : activePage * itemsPerPage - itemsPerPage + 1;
  const activePageLastItem = activePage === pagesLength ? itemsAmount : activePage * itemsPerPage;
  return !withCounter && !withSelect ? navigation : /* @__PURE__ */ jsxs70(
    Box,
    {
      display: "flex",
      gap: "x0.75",
      justifyContent: "space-between",
      flexWrap: "wrap",
      flexDirection: applyResponsiveStyle("column", smallScreenBreakpoint),
      alignItems: applyResponsiveStyle("center", smallScreenBreakpoint),
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      children: [
        /* @__PURE__ */ jsxs70("div", { className: Pagination_default.indicators, children: [
          withSelect && /* @__PURE__ */ jsx282(
            Select,
            {
              options: selectOptions,
              isSearchable: false,
              width: "74px",
              defaultValue: {
                label: itemsPerPage.toString(),
                value: itemsPerPage
              },
              isClearable: false,
              onChange: handleSelectChange,
              componentSize: "small",
              "aria-label": "Antall elementer per side"
            }
          ),
          withCounter && /* @__PURE__ */ jsxs70(Paragraph, { children: [
            "Viser ",
            activePageFirstItem,
            "-",
            activePageLastItem,
            " av ",
            itemsAmount
          ] })
        ] }),
        navigation
      ]
    }
  );
};
Pagination.displayName = "Pagination";

// src/components/PhoneInput/PhoneInput.tsx
import {
  useEffect as useEffect25,
  useId as useId20,
  useLayoutEffect as useLayoutEffect2,
  useRef as useRef29,
  useState as useState21
} from "react";

// src/components/PhoneInput/constants.ts
var COUNTRIES = {
  AF: { name: "Afghanistan (\u202B\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646\u202C\u200E)", id: "AF", dialCode: "+93" },
  AL: { name: "Albania (Shqip\xEBri)", id: "AL", dialCode: "+355" },
  DZ: { name: "Algerie (\u202B\u0627\u0644\u062C\u0632\u0627\u0626\u0631\u202C\u200E)", id: "DZ", dialCode: "+213" },
  AS: {
    name: "Amerikansk Samoa (American Samoa)",
    id: "AS",
    dialCode: "+1684"
  },
  AD: { name: "Andorra", id: "AD", dialCode: "+376" },
  AO: { name: "Angola", id: "AO", dialCode: "+244" },
  AI: { name: "Anguilla", id: "AI", dialCode: "+1264" },
  AG: {
    name: "Antigua og Barbuda (Antigua and Barbuda)",
    id: "AG",
    dialCode: "+1268"
  },
  AR: { name: "Argentina", id: "AR", dialCode: "+54" },
  AM: { name: "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)", id: "AM", dialCode: "+374" },
  AW: { name: "Aruba", id: "AW", dialCode: "+297" },
  AU: { name: "Australia", id: "AU", dialCode: "+61" },
  AT: { name: "\xD8sterrike (\xD6sterreich)", id: "AT", dialCode: "+43" },
  AZ: { name: "Aserbajdsjan (Az\u0259rbaycan)", id: "AZ", dialCode: "+994" },
  BS: { name: "Bahamas", id: "BS", dialCode: "+1242" },
  BH: { name: "Bahrain (\u202B\u0627\u0644\u0628\u062D\u0631\u064A\u0646\u202C\u200E)", id: "BH", dialCode: "+973" },
  BD: { name: "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)", id: "BD", dialCode: "+880" },
  BB: { name: "Barbados", id: "BB", dialCode: "+1246" },
  BY: { name: "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)", id: "BY", dialCode: "+375" },
  BE: { name: "Belgium (Belgi\xEB)", id: "BE", dialCode: "+32" },
  BZ: { name: "Belize", id: "BZ", dialCode: "+501" },
  BJ: { name: "Benin (B\xE9nin)", id: "BJ", dialCode: "+229" },
  BM: { name: "Bermuda", id: "BM", dialCode: "+1441" },
  BT: { name: "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)", id: "BT", dialCode: "+975" },
  BO: { name: "Bolivia", id: "BO", dialCode: "+591" },
  BA: {
    name: "Bosnia-Hercegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
    id: "BA",
    dialCode: "+387"
  },
  BW: { name: "Botswana", id: "BW", dialCode: "+267" },
  BR: { name: "Brasil", id: "BR", dialCode: "+55" },
  IO: {
    name: "Det britiske territoriet i Indiahavet (British Indian Ocean Territory)",
    id: "IO",
    dialCode: "+246"
  },
  VG: {
    name: "Britiske Jomfru\xF8yer (British Virgin Islands)",
    id: "VG",
    dialCode: "+1284"
  },
  BN: { name: "Brunei", id: "BN", dialCode: "+673" },
  BG: { name: "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)", id: "BG", dialCode: "+359" },
  BF: { name: "Burkina Faso", id: "BF", dialCode: "+226" },
  BI: { name: "Burundi (Uburundi)", id: "BI", dialCode: "+257" },
  KH: { name: "Kambodsja (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)", id: "KH", dialCode: "+855" },
  CM: { name: "Kamerun (Cameroun)", id: "CM", dialCode: "+237" },
  CA: { name: "Canada", id: "CA", dialCode: "+1" },
  CV: { name: "Kapp Verde (Kabu Verdi)", id: "CV", dialCode: "+238" },
  KY: { name: "Cayman\xF8yene (Cayman Islands)", id: "KY", dialCode: "+1345" },
  CF: {
    name: "Den sentralafrikanske republikk (R\xE9publique centrafricaine)",
    id: "CF",
    dialCode: "+236"
  },
  TD: { name: "Tsjad (Tchad)", id: "TD", dialCode: "+235" },
  CL: { name: "Chile", id: "CL", dialCode: "+56" },
  CN: { name: "Kina (\u4E2D\u56FD)", id: "CN", dialCode: "+86" },
  CX: { name: "Christmas\xF8ya (Christmas Island)", id: "CX", dialCode: "+61" },
  CC: {
    name: "Kokos\xF8yene (Cocos (Keeling) Islands)",
    id: "CC",
    dialCode: "+61"
  },
  CO: { name: "Colombia", id: "CO", dialCode: "+57" },
  KM: { name: "Komorene (\u202B\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631\u202C\u200E)", id: "KM", dialCode: "+269" },
  CD: {
    name: "Kongo (DR) (Jamhuri ya Kisoemokrasia ya Kongo)",
    id: "CD",
    dialCode: "+243"
  },
  CG: {
    name: "Kongo (Republikken) (Congo-Brazzaville)",
    id: "CG",
    dialCode: "+242"
  },
  CK: { name: "Cook\xF8yene (Cook Islands)", id: "CK", dialCode: "+682" },
  CR: { name: "Costa Rica", id: "CR", dialCode: "+506" },
  CI: { name: "Elfenbenskysten (C\xF4te d\u2019Ivoire)", id: "CI", dialCode: "+225" },
  HR: { name: "Kroatia (Hrvatska)", id: "HR", dialCode: "+385" },
  CU: { name: "Cuba", id: "CU", dialCode: "+53" },
  CW: { name: "Cura\xE7ao", id: "CW", dialCode: "+599" },
  CY: { name: "Kypros (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)", id: "CY", dialCode: "+357" },
  CZ: { name: "Tsjekkia (\u010Cesk\xE1 republika)", id: "CZ", dialCode: "+420" },
  DK: { name: "Danmark", id: "DK", dialCode: "+45" },
  DJ: { name: "Djibouti", id: "DJ", dialCode: "+253" },
  DM: { name: "Dominica", id: "DM", dialCode: "+1767" },
  DO: {
    name: "Den dominikanske republikk (Rep\xFAblica Dominicana)",
    id: "DO",
    dialCode: "+1"
  },
  EC: { name: "Ecuador", id: "EC", dialCode: "+593" },
  EG: { name: "Egypt (\u202B\u0645\u0635\u0631\u202C\u200E)", id: "EG", dialCode: "+20" },
  SV: { name: "El Salvador", id: "SV", dialCode: "+503" },
  GQ: {
    name: "Ekvatorial-Guinea (Guinea Ecuatorial)",
    id: "GQ",
    dialCode: "+240"
  },
  ER: { name: "Eritrea", id: "ER", dialCode: "+291" },
  EE: { name: "Estland (Eesti)", id: "EE", dialCode: "+372" },
  ET: { name: "Etiopia (\u12A2\u1275\u12EE\u1335\u12EB)", id: "ET", dialCode: "+251" },
  FK: { name: "Falklands\xF8yene (Islas Malvinas)", id: "FK", dialCode: "+500" },
  FO: { name: "F\xE6r\xF8yene (F\xF8royar)", id: "FO", dialCode: "+298" },
  FJ: { name: "Fiji", id: "FJ", dialCode: "+679" },
  FI: { name: "Finland (Suomi)", id: "FI", dialCode: "+358" },
  FR: { name: "Frankrike (France)", id: "FR", dialCode: "+33" },
  GF: { name: "Fransk Guyana (Guyane fran\xE7aise)", id: "GF", dialCode: "+594" },
  PF: {
    name: "Fransk Polynesia (Polyn\xE9sie fran\xE7aise)",
    id: "PF",
    dialCode: "+689"
  },
  GA: { name: "Gabon", id: "GA", dialCode: "+241" },
  GM: { name: "Gambia", id: "GM", dialCode: "+220" },
  GE: { name: "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)", id: "GE", dialCode: "+995" },
  DE: { name: "Tyskland (Deutschland)", id: "DE", dialCode: "+49" },
  GH: { name: "Ghana (Gaana)", id: "GH", dialCode: "+233" },
  GI: { name: "Gibraltar", id: "GI", dialCode: "+350" },
  GR: { name: "Hellas (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)", id: "GR", dialCode: "+30" },
  GL: { name: "Gr\xF8nland  (Kalaallit Nunaat)", id: "GL", dialCode: "+299" },
  GD: { name: "Grenada", id: "GD", dialCode: "+1473" },
  GP: { name: "Guadeloupe", id: "GP", dialCode: "+590" },
  GU: { name: "Guam", id: "GU", dialCode: "+1671" },
  GT: { name: "Guatemala", id: "GT", dialCode: "+502" },
  GG: { name: "Guernsey", id: "GG", dialCode: "+44" },
  GN: { name: "Guinea (Guin\xE9e)", id: "GN", dialCode: "+224" },
  GW: { name: "Guinea-Bissau (Guin\xE9-Bissau)", id: "GW", dialCode: "+245" },
  GY: { name: "Guyana", id: "GY", dialCode: "+592" },
  HT: { name: "Haiti", id: "HT", dialCode: "+509" },
  HM: {
    name: "Heard- og McDonald\xF8yene (Heard Island and McDonald Islands)",
    id: "HM",
    dialCode: "+672"
  },
  VA: {
    name: "Vatikanstaten (Citt\xE0 del Vaticano)",
    id: "VA",
    dialCode: "+379"
  },
  HN: { name: "Honduras", id: "HN", dialCode: "+504" },
  HK: { name: "Hongkong (\u9999\u6E2F)", id: "HK", dialCode: "+852" },
  HU: { name: "Ungarn (Magyarorsz\xE1g)", id: "HU", dialCode: "+36" },
  IS: { name: "Island (\xCDsland)", id: "IS", dialCode: "+354" },
  IN: { name: "India (\u092D\u093E\u0930\u0924)", id: "IN", dialCode: "+91" },
  ID: { name: "Indonesia", id: "ID", dialCode: "+62" },
  IR: { name: "Iran (\u202B\u0627\u06CC\u0631\u0627\u0646\u202C\u200E)", id: "IR", dialCode: "+98" },
  IQ: { name: "Irak (\u202B\u0627\u0644\u0639\u0631\u0627\u0642\u202C\u200E)", id: "IQ", dialCode: "+964" },
  IE: { name: "Irland (\xC9ire)", id: "IE", dialCode: "+353" },
  IM: { name: "Isle of Man", id: "IM", dialCode: "+44" },
  IL: { name: "Israel (\u202B\u05D9\u05E9\u05E8\u05D0\u05DC\u202C\u200E)", id: "IL", dialCode: "+972" },
  IT: { name: "Italia", id: "IT", dialCode: "+39" },
  JM: { name: "Jamaica", id: "JM", dialCode: "+1" },
  JP: { name: "Japan (\u65E5\u672C)", id: "JP", dialCode: "+81" },
  JE: { name: "Jersey", id: "JE", dialCode: "+44" },
  JO: { name: "Jordan (\u202B\u0627\u0644\u0623\u0631\u062F\u0646\u202C\u200E)", id: "JO", dialCode: "+962" },
  KZ: { name: "Kasakhstan (\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D)", id: "KZ", dialCode: "+7" },
  KE: { name: "Kenya", id: "KE", dialCode: "+254" },
  KI: { name: "Kiribati", id: "KI", dialCode: "+686" },
  XK: { name: "Kosovo", id: "XK", dialCode: "+383" },
  KW: { name: "Kuwait (\u202B\u0627\u0644\u0643\u0648\u064A\u062A\u202C\u200E)", id: "KW", dialCode: "+965" },
  KG: { name: "Kirgisistan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)", id: "KG", dialCode: "+996" },
  LA: { name: "Laos (\u0EA5\u0EB2\u0EA7)", id: "LA", dialCode: "+856" },
  LV: { name: "Latvia (Latvija)", id: "LV", dialCode: "+371" },
  LB: { name: "Libanon (\u202B\u0644\u0628\u0646\u0627\u0646\u202C\u200E)", id: "LB", dialCode: "+961" },
  LS: { name: "Lesotho", id: "LS", dialCode: "+266" },
  LR: { name: "Liberia", id: "LR", dialCode: "+231" },
  LY: { name: "Libya (\u202B\u0644\u064A\u0628\u064A\u0627\u202C\u200E)", id: "LY", dialCode: "+218" },
  LI: { name: "Liechtenstein", id: "LI", dialCode: "+423" },
  LT: { name: "Litauen (Lietuva)", id: "LT", dialCode: "+370" },
  LU: { name: "Luxembourg", id: "LU", dialCode: "+352" },
  MO: { name: "Macao (\u6FB3\u9580)", id: "MO", dialCode: "+853" },
  MK: {
    name: "Nord-Makedonia (FYROM) (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
    id: "MK",
    dialCode: "+389"
  },
  MG: { name: "Madagaskar (Madagasikara)", id: "MG", dialCode: "+261" },
  MW: { name: "Malawi", id: "MW", dialCode: "+265" },
  MY: { name: "Malaysia", id: "MY", dialCode: "+60" },
  MV: {
    name: "Maldivene (\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC \u0796\u07AA\u0789\u07B0\u0780\u07AB\u0783\u07A8\u0787\u07B0\u0794\u07A7)",
    id: "MV",
    dialCode: "+960"
  },
  ML: { name: "Mali", id: "ML", dialCode: "+223" },
  MT: { name: "Malta", id: "MT", dialCode: "+356" },
  MH: { name: "Marshall\xF8yene (Marshall Islands)", id: "MH", dialCode: "+692" },
  MQ: { name: "Martinique", id: "MQ", dialCode: "+596" },
  MR: { name: "Mauritania (\u202B\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627\u202C\u200E)", id: "MR", dialCode: "+222" },
  MU: { name: "Mauritius (Moris)", id: "MU", dialCode: "+230" },
  YT: { name: "Mayotte", id: "YT", dialCode: "+262" },
  MX: { name: "Mexico (M\xE9xico)", id: "MX", dialCode: "+52" },
  FM: { name: "Mikronesia (Micronesia)", id: "FM", dialCode: "+691" },
  MD: { name: "Moldova (Republica Moldova)", id: "MD", dialCode: "+373" },
  MC: { name: "Monaco", id: "MC", dialCode: "+377" },
  MN: { name: "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)", id: "MN", dialCode: "+976" },
  ME: { name: "Montenegro (Crna Gora)", id: "ME", dialCode: "+382" },
  MS: { name: "Montserrat", id: "MS", dialCode: "+1664" },
  MA: { name: "Marokko (\u202B\u0627\u0644\u0645\u063A\u0631\u0628\u202C\u200E)", id: "MA", dialCode: "+212" },
  MZ: { name: "Mosambik (Mo\xE7ambique)", id: "MZ", dialCode: "+258" },
  MM: { name: "Myanmar (\u1019\u103C\u1014\u103A\u1019\u102C)", id: "MM", dialCode: "+95" },
  NA: { name: "Namibia", id: "NA", dialCode: "+264" },
  NR: { name: "Nauru", id: "NR", dialCode: "+674" },
  NP: { name: "Nepal (\u0928\u0947\u092A\u093E\u0932)", id: "NP", dialCode: "+977" },
  NL: { name: "Nederland", id: "NL", dialCode: "+31" },
  NC: { name: "Ny-Caledonia (Nouvelle-Cal\xE9donie)", id: "NC", dialCode: "+687" },
  NZ: { name: "New Zealand", id: "NZ", dialCode: "+64" },
  NI: { name: "Nicaragua", id: "NI", dialCode: "+505" },
  NE: { name: "Niger (Nijar)", id: "NE", dialCode: "+227" },
  NG: { name: "Nigeria", id: "NG", dialCode: "+234" },
  NU: { name: "Niue", id: "NU", dialCode: "+683" },
  NF: { name: "Norfolk Island", id: "NF", dialCode: "+672" },
  KP: {
    name: "Nord-Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
    id: "KP",
    dialCode: "+850"
  },
  MP: {
    name: "Nord-Marianene (Northern Mariana Islands)",
    id: "MP",
    dialCode: "+1670"
  },
  NO: { name: "Norge", id: "NO", dialCode: "+47" },
  OM: { name: "Oman (\u202B\u0639\u064F\u0645\u0627\u0646\u202C\u200E)", id: "OM", dialCode: "+968" },
  PK: { name: "Pakistan (\u202B\u067E\u0627\u06A9\u0633\u062A\u0627\u0646\u202C\u200E)", id: "PK", dialCode: "+92" },
  PW: { name: "Palau", id: "PW", dialCode: "+680" },
  PS: {
    name: "Palestina (\u202B\u0641\u0644\u0633\u0637\u064A\u0646\u202C\u200E)",
    id: "PS",
    dialCode: "+970"
  },
  PA: { name: "Panama (Panam\xE1)", id: "PA", dialCode: "+507" },
  PG: {
    name: "Papua Ny-Guinea (Papua New Guinea)",
    id: "PG",
    dialCode: "+675"
  },
  PY: { name: "Paraguay", id: "PY", dialCode: "+595" },
  PE: { name: "Peru (Per\xFA)", id: "PE", dialCode: "+51" },
  PH: { name: "Filippinene (Philippines)", id: "PH", dialCode: "+63" },
  PL: { name: "Polen (Polska)", id: "PL", dialCode: "+48" },
  PT: { name: "Portugal", id: "PT", dialCode: "+351" },
  PR: { name: "Puerto Rico", id: "PR", dialCode: "+1" },
  QA: { name: "Qatar (\u202B\u0642\u0637\u0631\u202C\u200E)", id: "QA", dialCode: "+974" },
  RE: { name: "R\xE9union", id: "RE", dialCode: "+262" },
  RO: { name: "Romania (Rom\xE2nia)", id: "RO", dialCode: "+40" },
  RU: { name: "Russland (\u0420\u043E\u0441\u0441\u0438\u044F)", id: "RU", dialCode: "+7" },
  RW: { name: "Rwanda", id: "RW", dialCode: "+250" },
  BL: {
    name: "Saint Barth\xE9lemy",
    id: "BL",
    dialCode: "+590"
  },
  SH: { name: "St. Helena (Saint Helena)", id: "SH", dialCode: "+290" },
  KN: {
    name: "Saint Kitts og Nevis (Saint Kitts and Nevis)",
    id: "KN",
    dialCode: "+1869"
  },
  LC: { name: "Saint Lucia", id: "LC", dialCode: "+1758" },
  MF: {
    name: "Saint Martin (Saint-Martin (partie fran\xE7aise))",
    id: "MF",
    dialCode: "+590"
  },
  PM: {
    name: "Saint Pierre og Miquelon (Saint-Pierre-et-Miquelon)",
    id: "PM",
    dialCode: "+508"
  },
  VC: {
    name: "Saint Vincent og Grenadinene (Saint Vincent and the Grenadines)",
    id: "VC",
    dialCode: "+1784"
  },
  WS: { name: "Samoa", id: "WS", dialCode: "+685" },
  SM: { name: "San Marino", id: "SM", dialCode: "+378" },
  ST: {
    name: "S\xE3o Tom\xE9 og Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)",
    id: "ST",
    dialCode: "+239"
  },
  SA: {
    name: "Saudi-Arabia (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)",
    id: "SA",
    dialCode: "+966"
  },
  SN: { name: "Senegal (S\xE9n\xE9gal)", id: "SN", dialCode: "+221" },
  RS: { name: "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)", id: "RS", dialCode: "+381" },
  SC: { name: "Seychellene (Seychelles)", id: "SC", dialCode: "+248" },
  SL: { name: "Sierra Leone", id: "SL", dialCode: "+232" },
  SG: { name: "Singapore", id: "SG", dialCode: "+65" },
  SX: { name: "Sint Maarten", id: "SX", dialCode: "+1721" },
  SK: { name: "Slovakia (Slovensko)", id: "SK", dialCode: "+421" },
  SI: { name: "Slovenia (Slovenija)", id: "SI", dialCode: "+386" },
  SB: { name: "Salomon\xF8yene (Solomon Islands)", id: "SB", dialCode: "+677" },
  SO: { name: "Somalia (Soomaaliya)", id: "SO", dialCode: "+252" },
  ZA: { name: "S\xF8r-Afrika (South Africa)", id: "ZA", dialCode: "+27" },
  GS: {
    name: "S\xF8r-Georgia og S\xF8r-Sandwich\xF8yene (South Georgia and the South Sandwich Islands)",
    id: "GS",
    dialCode: "+500"
  },
  KR: {
    name: "S\xF8r-Korea (\uB300\uD55C\uBBFC\uAD6D)",
    id: "KR",
    dialCode: "+82"
  },
  SS: { name: "S\xF8r-Sudan  (\u202B\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)", id: "SS", dialCode: "+211" },
  ES: { name: "Spania (Espa\xF1a)", id: "ES", dialCode: "+34" },
  LK: { name: "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)", id: "LK", dialCode: "+94" },
  SD: { name: "Sudan (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)", id: "SD", dialCode: "+249" },
  SR: { name: "Surinam (Suriname)", id: "SR", dialCode: "+597" },
  SJ: { name: "Svalbard og Jan Mayen", id: "SJ", dialCode: "+47" },
  SZ: { name: "Eswatini", id: "SZ", dialCode: "+268" },
  SE: { name: "Sverige", id: "SE", dialCode: "+46" },
  CH: { name: "Sveits (Schweiz)", id: "CH", dialCode: "+41" },
  SY: { name: "Syria (\u202B\u0633\u0648\u0631\u064A\u0627\u202C\u200E)", id: "SY", dialCode: "+963" },
  TW: { name: "Taiwan (\u53F0\u7063)", id: "TW", dialCode: "+886" },
  TJ: { name: "Tadsjikistan (\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D)", id: "TJ", dialCode: "+992" },
  TZ: { name: "Tanzania", id: "TZ", dialCode: "+255" },
  TH: { name: "Thailand (\u0E44\u0E17\u0E22)", id: "TH", dialCode: "+66" },
  TL: { name: "\xD8st-Timor (Timor-Leste)", id: "TL", dialCode: "+670" },
  TG: { name: "Togo", id: "TG", dialCode: "+228" },
  TK: { name: "Tokelau", id: "TK", dialCode: "+690" },
  TO: { name: "Tonga", id: "TO", dialCode: "+676" },
  TT: {
    name: "Trinidad og Tobago (Trinidad and Tobago)",
    id: "TT",
    dialCode: "+1868"
  },
  TN: { name: "Tunisia (\u202B\u062A\u0648\u0646\u0633\u202C\u200E)", id: "TN", dialCode: "+216" },
  TR: { name: "Tyrkia (T\xFCrkiye)", id: "TR", dialCode: "+90" },
  TM: { name: "Turkmenistan", id: "TM", dialCode: "+993" },
  TC: {
    name: "Turks- og Caicos\xF8yene (Turks and Caicos Islands)",
    id: "TC",
    dialCode: "+1649"
  },
  TV: { name: "Tuvalu", id: "TV", dialCode: "+688" },
  VI: {
    name: "De amerikanske Jomfru\xF8yer (U.S. Virgin Islands)",
    id: "VI",
    dialCode: "+1340"
  },
  UG: { name: "Uganda", id: "UG", dialCode: "+256" },
  UA: { name: "Ukraina (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)", id: "UA", dialCode: "+380" },
  AE: {
    name: "De forente arabiske emirater (\u202B\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u202C\u200E)",
    id: "AE",
    dialCode: "+971"
  },
  GB: { name: "Storbritannia (United Kingdom)", id: "GB", dialCode: "+44" },
  US: { name: "USA (United States)", id: "US", dialCode: "+1" },
  UY: { name: "Uruguay", id: "UY", dialCode: "+598" },
  UZ: { name: "Usbekistan (\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D)", id: "UZ", dialCode: "+998" },
  VU: { name: "Vanuatu", id: "VU", dialCode: "+678" },
  VE: { name: "Venezuela", id: "VE", dialCode: "+58" },
  VN: { name: "Vietnam (Vi\u1EC7t Nam)", id: "VN", dialCode: "+84" },
  EH: { name: "Vest-Sahara (Western Sahara)", id: "EH", dialCode: "+212" },
  WF: {
    name: "Wallis- og Futuna\xF8yene  (Wallis-et-Futuna)",
    id: "WF",
    dialCode: "+681"
  },
  YE: { name: "Yemen (\u202B\u0627\u0644\u064A\u0645\u0646\u202C\u200E)", id: "YE", dialCode: "+967" },
  ZM: { name: "Zambia", id: "ZM", dialCode: "+260" },
  ZW: { name: "Zimbabwe", id: "ZW", dialCode: "+263" },
  AX: { name: "\xC5land", id: "AX", dialCode: "+358" }
};

// src/components/PhoneInput/PhoneInput.module.css
var PhoneInput_default = {
  "inputs-container": "PhoneInput_inputs-container",
  input: "PhoneInput_input",
  select: "PhoneInput_select",
  "inputs-container--small-screen-xs": "PhoneInput_inputs-container--small-screen-xs",
  "inputs-container--small-screen-sm": "PhoneInput_inputs-container--small-screen-sm",
  "inputs-container--small-screen-md": "PhoneInput_inputs-container--small-screen-md",
  "inputs-container--small-screen-lg": "PhoneInput_inputs-container--small-screen-lg",
  "inputs-container--small-screen-xl": "PhoneInput_inputs-container--small-screen-xl",
  "calling-code": "PhoneInput_calling-code"
};

// src/components/PhoneInput/PhoneInput.tsx
import { jsx as jsx283, jsxs as jsxs71 } from "react/jsx-runtime";
var prioritizedCountries = [
  COUNTRIES.NO,
  COUNTRIES.SE,
  COUNTRIES.DK,
  COUNTRIES.FI
];
var prioritizedCountryOptions = prioritizedCountries.map((country) => {
  return {
    label: `${country.name} ${country.dialCode}`,
    countryCode: country.id
  };
});
var sortedCountryOptions = Object.values(
  COUNTRIES
).sort((a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}).map((country) => ({
  countryCode: country.id,
  label: `${country.name} ${country.dialCode}`
})).filter(
  (country) => !prioritizedCountryOptions.some(
    (pCountry) => pCountry.countryCode === country.countryCode
  )
);
var countryOptions = [
  ...prioritizedCountryOptions,
  ...sortedCountryOptions
];
var PhoneInput = ({
  label,
  readOnly,
  errorMessage,
  tip,
  required,
  width,
  componentSize = "medium",
  name,
  className,
  style,
  value,
  selectLabel = "Landskode",
  selectRef,
  onChange,
  defaultValue,
  "aria-required": ariaRequired,
  "aria-describedby": ariaDescribedby,
  groupLabel = "Landskode og telefonnummer",
  ref,
  ...props
}) => {
  var _a;
  const generatedId = useId20();
  const uniqueId = (_a = props.id) != null ? _a : generatedId;
  const phoneInputId = `${uniqueId}-phone-input`;
  const phoneNumberId = `${uniqueId}-phone-number`;
  const selectId = `${uniqueId}-country-code`;
  const hasErrorMessage = !!errorMessage;
  const hasTip = !!tip;
  const hasLabel = !!label;
  const hasMessage = hasErrorMessage || hasTip;
  const tipId = derivativeIdGenerator(phoneInputId, "tip");
  const errorMessageId = derivativeIdGenerator(phoneInputId, "errorMessage");
  const [callingCode, setCallingCode] = useState21("");
  const [selectedCountryCodeText, setSelectedCountryCodeText] = useState21("");
  const [internalValue, setInternalValue] = useState21(
    defaultValue != null ? defaultValue : {
      countryCode: "",
      phoneNumber: ""
    }
  );
  const isControlled = value !== void 0;
  const [callingCodeWidth, setCallingCodeWidth] = useState21(0);
  const callingCodeRef = useRef29(null);
  useLayoutEffect2(() => {
    if (callingCodeRef.current) {
      setCallingCodeWidth(callingCodeRef.current.offsetWidth);
    }
  }, [callingCode]);
  const callingCodeInlineStart = callingCodeWidth ? `calc(var(--dds-spacing-x1) + ${callingCodeWidth}px)` : void 0;
  const internalSelectRef = useRef29(null);
  const combinedSelectRef = useCombinedRef(selectRef, internalSelectRef);
  const displayedValue = isControlled ? value : internalValue;
  useEffect25(() => {
    const selectEl = internalSelectRef.current;
    if (selectEl && selectEl.value) {
      const { options, selectedIndex } = selectEl;
      const content = options[selectedIndex].innerHTML;
      setSelectedCountryCodeText(content);
      setCallingCode(getCallingCode(content));
    }
  }, [displayedValue == null ? void 0 : displayedValue.countryCode]);
  const handleCountryCodeChange = (e) => {
    var _a2;
    const newValue = {
      countryCode: e.target.value,
      phoneNumber: (_a2 = displayedValue == null ? void 0 : displayedValue.phoneNumber) != null ? _a2 : ""
    };
    const { options, selectedIndex } = e.target;
    const content = options[selectedIndex].innerHTML;
    setCallingCode(getCallingCode(content));
    if (isControlled && onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };
  const handlePhoneNumberChange = (e) => {
    var _a2;
    const newValue = {
      countryCode: (_a2 = displayedValue == null ? void 0 : displayedValue.countryCode) != null ? _a2 : "",
      phoneNumber: e.target.value
    };
    if (isControlled && onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };
  const commonProps = {
    required,
    "aria-required": ariaRequired,
    disabled: props.disabled,
    readOnly,
    componentSize
  };
  const showRequiredStyling = !!(required || ariaRequired);
  const bp = props.smallScreenBreakpoint;
  const widthDefault = componentSize === "xsmall" && "var(--dds-input-default-width-xsmall)";
  return /* @__PURE__ */ jsxs71("div", { className: cn(className, Input_default.container), style, children: [
    hasLabel && /* @__PURE__ */ jsx283(
      Label,
      {
        htmlFor: phoneNumberId,
        showRequiredStyling,
        className: Input_default.label,
        readOnly,
        children: label
      }
    ),
    /* @__PURE__ */ jsxs71(
      Box,
      {
        display: "flex",
        flexDirection: applyResponsiveStyle("column", bp, "row"),
        className: cn(
          PhoneInput_default["inputs-container"],
          !!bp && PhoneInput_default[`inputs-container--small-screen-${bp}`]
        ),
        width: getInputWidth(width, widthDefault),
        role: "group",
        "aria-label": groupLabel,
        children: [
          /* @__PURE__ */ jsx283("label", { className: utilStyles_default["visually-hidden"], htmlFor: selectId, children: selectLabel }),
          /* @__PURE__ */ jsx283(
            NativeSelect,
            {
              width: applyResponsiveStyle(
                "100%",
                bp,
                componentSize === "xsmall" ? "5rem" : "8rem"
              ),
              ...commonProps,
              ref: combinedSelectRef,
              id: selectId,
              className: cn(PhoneInput_default.select),
              onChange: handleCountryCodeChange,
              defaultValue: defaultValue == null ? void 0 : defaultValue.countryCode,
              value: (displayedValue == null ? void 0 : displayedValue.countryCode) || "",
              title: selectedCountryCodeText,
              name: `${name}-country-code`,
              "aria-describedby": spaceSeparatedIdListGenerator([
                hasTip ? tipId : void 0,
                ariaDescribedby
              ]),
              children: countryOptions.map((item, index) => /* @__PURE__ */ jsx283("option", { value: item.countryCode, children: item.label }, index))
            }
          ),
          /* @__PURE__ */ jsxs71(Box, { width: "100%", className: Input_default["input-group"], children: [
            /* @__PURE__ */ jsx283(
              "span",
              {
                className: cn(
                  typographyStyles_default[`body-${componentSize}`],
                  Input_default["input-group__absolute-element"],
                  PhoneInput_default["calling-code"]
                ),
                ref: callingCodeRef,
                children: callingCode
              }
            ),
            /* @__PURE__ */ jsx283(
              Box,
              {
                as: StatefulInput,
                ref,
                type: "tel",
                ...commonProps,
                id: phoneNumberId,
                value: (displayedValue == null ? void 0 : displayedValue.phoneNumber) || "",
                defaultValue: defaultValue == null ? void 0 : defaultValue.phoneNumber,
                name: `${name}-phone-number`,
                onChange: handlePhoneNumberChange,
                width: "100%",
                style: {
                  paddingInlineStart: callingCodeInlineStart
                },
                className: PhoneInput_default.input,
                hasErrorMessage,
                "aria-invalid": hasErrorMessage ? true : void 0,
                "aria-describedby": spaceSeparatedIdListGenerator([
                  hasTip ? tipId : void 0,
                  hasErrorMessage ? errorMessageId : void 0,
                  ariaDescribedby
                ])
              }
            )
          ] })
        ]
      }
    ),
    hasMessage && renderInputMessage(tip, tipId, errorMessage, errorMessageId)
  ] });
};
PhoneInput.displayName = "PhoneInput";
var getCallingCode = (s) => {
  var _a;
  return (_a = s.substring(s.indexOf("+"), s.length)) != null ? _a : "";
};

// src/components/Popover/Popover.tsx
import {
  useContext as useContext19,
  useEffect as useEffect26,
  useId as useId21
} from "react";
import { createPortal as createPortal4 } from "react-dom";

// src/components/Popover/Popover.module.css
var Popover_default = {
  container: "Popover_container",
  "content--closable--no-header": "Popover_content--closable--no-header",
  header: "Popover_header",
  "close-button": "Popover_close-button"
};

// src/components/Popover/Popover.context.tsx
import {
  createContext as createContext12,
  useContext as useContext18
} from "react";
var PopoverContext = createContext12({});
var usePopoverContext = () => useContext18(PopoverContext);

// src/components/Popover/Popover.tsx
import { jsx as jsx284, jsxs as jsxs72 } from "react/jsx-runtime";
var Popover = ({
  id,
  header,
  withCloseButton = true,
  onBlur,
  children,
  placement = "bottom",
  parentElement,
  portal = false,
  offset = 8,
  sizeProps = {},
  returnFocusOnBlur = true,
  className,
  htmlProps = {},
  anchorRef,
  isOpen: propIsOpen,
  onClose: propOnClose,
  ref,
  ...rest
}) => {
  const { refs, styles: positionStyles } = useFloatPosition(null, {
    offset,
    placement
  });
  const { maxHeight, maxWidth, minHeight, minWidth, height, width } = sizeProps;
  const context = usePopoverContext();
  const themeContext = useContext19(ThemeContext);
  const portalTarget = parentElement != null ? parentElement : themeContext == null ? void 0 : themeContext.el;
  const {
    floatStyling: contextFloatStyling,
    setFloatOptions,
    floatingRef: contextFloatingRef,
    popoverId: contextPopoverId,
    onClose: contextOnClose,
    isOpen: contextIsOpen,
    anchorEl: contextAnchorEl
  } = context;
  const hasContext = !isEmpty(context);
  const generatedId = useId21();
  const uniquePopoverId = id != null ? id : `${generatedId}-popover`;
  const [
    popoverId,
    anchorEl,
    isOpen = false,
    floatingRef,
    floatStyling,
    onClose
  ] = hasContext ? [
    contextPopoverId,
    contextAnchorEl,
    contextIsOpen,
    contextFloatingRef,
    contextFloatStyling,
    contextOnClose
  ] : [
    uniquePopoverId,
    (anchorRef == null ? void 0 : anchorRef.current) && anchorRef.current,
    propIsOpen,
    refs.setFloating,
    positionStyles.floating,
    propOnClose
  ];
  if (!hasContext) {
    refs.setReference(anchorEl || null);
  }
  const hasTransitionedIn = useMountTransition(isOpen, 400);
  const popoverRef = useReturnFocusOnBlur(
    isOpen && hasTransitionedIn && returnFocusOnBlur,
    () => {
      onClose == null ? void 0 : onClose();
      onBlur == null ? void 0 : onBlur();
    },
    anchorEl && anchorEl
  );
  const multiRef = useCombinedRef(ref, popoverRef, floatingRef);
  useEffect26(() => {
    setFloatOptions && setFloatOptions({ placement, offset });
  }, [placement, offset]);
  useOnClickOutside([popoverRef.current, anchorEl], () => {
    if (isOpen && !hasContext) onClose == null ? void 0 : onClose();
  });
  useOnKeyDown("Escape", () => {
    if (isOpen && !hasContext) onClose == null ? void 0 : onClose();
  });
  const hasTitle = !!header;
  const openCn = hasTransitionedIn && isOpen ? "open" : "closed";
  const popover = /* @__PURE__ */ jsxs72(
    Paper,
    {
      ...getBaseHTMLProps(
        popoverId,
        cn(
          className,
          Popover_default.container,
          utilStyles_default["visibility-transition"],
          utilStyles_default[`visibility-transition--${openCn}`],
          focus_default.focusable
        ),
        htmlProps,
        rest
      ),
      ref: multiRef,
      tabIndex: -1,
      height,
      maxHeight,
      minHeight,
      width,
      maxWidth,
      minWidth,
      style: {
        ...htmlProps.style,
        ...floatStyling
      },
      role: "dialog",
      elevation: 3,
      border: "border-subtle",
      children: [
        header && /* @__PURE__ */ jsx284("div", { className: Popover_default.header, children: typeof header === "string" ? /* @__PURE__ */ jsx284(Heading, { level: 2, typographyType: "headingMedium", children: header }) : header }),
        /* @__PURE__ */ jsx284(
          "div",
          {
            className: !hasTitle && withCloseButton ? Popover_default["content--closable--no-header"] : "",
            children
          }
        ),
        withCloseButton && /* @__PURE__ */ jsx284(
          Button,
          {
            icon: CloseIcon,
            purpose: "tertiary",
            size: "small",
            onClick: onClose,
            "aria-label": "Lukk",
            className: Popover_default["close-button"]
          }
        )
      ]
    }
  );
  return isOpen || hasTransitionedIn ? portal && portalTarget ? createPortal4(popover, portalTarget) : popover : null;
};
Popover.displayName = "Popover";

// src/components/Popover/PopoverGroup.tsx
import {
  Children as ReactChildren4,
  cloneElement as cloneElement4,
  isValidElement as isValidElement4,
  useId as useId22,
  useRef as useRef30,
  useState as useState22
} from "react";
import { jsx as jsx285 } from "react/jsx-runtime";
var PopoverGroup = ({
  isOpen: propIsOpen,
  setIsOpen: propSetIsOpen,
  onClose,
  onOpen,
  isInitiallyOpen = false,
  children,
  popoverId
}) => {
  var _a;
  const [internalIsOpen, internalSetIsOpen] = useState22(isInitiallyOpen);
  const open = propIsOpen != null ? propIsOpen : internalIsOpen;
  const setOpen = propSetIsOpen != null ? propSetIsOpen : internalSetIsOpen;
  const generatedId = useId22();
  const uniquePopoverId = popoverId != null ? popoverId : `${generatedId}-popover`;
  const [floatOptions, setFloatOptions] = useState22();
  const { refs, styles: positionStyles } = useFloatPosition(null, floatOptions);
  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };
  const handleOpen = () => {
    setOpen(true);
    onOpen && onOpen();
  };
  const handleToggle = () => {
    if (open) {
      handleClose();
    } else {
      handleOpen();
    }
  };
  const buttonRef = useRef30(null);
  const anchorRef = refs.setReference;
  const combinedAnchorRef = useCombinedRef(buttonRef, anchorRef);
  const popoverRef = useRef30(null);
  const floatingRef = refs.setFloating;
  const combinedPopoverRef = useCombinedRef(popoverRef, floatingRef);
  useOnKeyDown(["Esc", "Escape"], () => {
    var _a2;
    if (open) {
      handleClose();
      (_a2 = buttonRef.current) == null ? void 0 : _a2.focus();
    }
  });
  const elements = [popoverRef.current];
  if (buttonRef.current) elements.push(buttonRef.current);
  useOnClickOutside(elements, () => {
    if (open) handleClose();
  });
  const isAnchorChild = (i) => i === 0;
  const Children7 = ReactChildren4.map(children, (child, childIndex) => {
    return isValidElement4(child) && (isAnchorChild(childIndex) ? cloneElement4(child, {
      "aria-haspopup": "dialog",
      "aria-controls": uniquePopoverId,
      "aria-expanded": open,
      onClick: handleToggle,
      ref: combinedAnchorRef
    }) : child);
  });
  return /* @__PURE__ */ jsx285(
    PopoverContext,
    {
      value: {
        floatStyling: positionStyles.floating,
        setFloatOptions,
        floatingRef: combinedPopoverRef,
        popoverId: uniquePopoverId,
        onClose: handleClose,
        isOpen: open,
        anchorEl: (_a = buttonRef.current) != null ? _a : void 0
      },
      children: Children7
    }
  );
};
PopoverGroup.displayName = "PopoverGroup";

// src/components/ProgressTracker/ProgressTracker.tsx
import {
  Children as Children3,
  cloneElement as cloneElement5,
  isValidElement as isValidElement5,
  useEffect as useEffect27,
  useMemo as useMemo3,
  useState as useState23
} from "react";

// src/components/ProgressTracker/ProgressTracker.context.tsx
import { createContext as createContext13, useContext as useContext20 } from "react";
var ProgressTrackerContext = createContext13(
  {
    activeStep: 0,
    direction: "column"
  }
);
var useProgressTrackerContext = () => useContext20(ProgressTrackerContext);

// src/components/ProgressTracker/ProgressTracker.module.css
var ProgressTracker_default = {
  list: "ProgressTracker_list",
  "list-item": "ProgressTracker_list-item",
  "list-item--column": "ProgressTracker_list-item--column",
  "list-item--row": "ProgressTracker_list-item--row",
  "item-button": "ProgressTracker_item-button",
  "item-number--active-incomplete": "ProgressTracker_item-number--active-incomplete",
  "item-number--inactive-incomplete": "ProgressTracker_item-number--inactive-incomplete",
  "item-number--active-completed": "ProgressTracker_item-number--active-completed",
  "item-number--inactive-completed": "ProgressTracker_item-number--inactive-completed",
  "item-text--active-completed": "ProgressTracker_item-text--active-completed",
  "item-text--active-incomplete": "ProgressTracker_item-text--active-incomplete",
  "item-text--inactive-completed": "ProgressTracker_item-text--inactive-completed",
  "item-text--inactive-incomplete": "ProgressTracker_item-text--inactive-incomplete",
  "item-div": "ProgressTracker_item-div",
  "item-number": "ProgressTracker_item-number",
  "item-number--disabled": "ProgressTracker_item-number--disabled",
  "item-text": "ProgressTracker_item-text",
  "item-text--disabled": "ProgressTracker_item-text--disabled"
};

// src/components/ProgressTracker/ProgressTrackerItem.tsx
import { useMemo as useMemo2 } from "react";
import { Fragment as Fragment7, jsx as jsx286, jsxs as jsxs73 } from "react/jsx-runtime";
var toItemState = (active, completed, disabled) => {
  if (disabled) {
    return "disabled";
  }
  if (active) {
    return completed ? "activeCompleted" : "activeIncomplete";
  } else {
    return completed ? "inactiveCompleted" : "inactiveIncomplete";
  }
};
var itemStateCn = {
  disabled: "disabled",
  activeCompleted: "active-completed",
  activeIncomplete: "active-incomplete",
  inactiveCompleted: "inactive-completed",
  inactiveIncomplete: "inactive-incomplete"
};
var getVisuallyHiddenTextBefore = (index) => `${index + 1}. trinn, `;
var getVisuallyHiddenTextAfter = (completed) => `, ${completed ? "ferdig" : "ikke ferdig"}`;
var ProgressTrackerItem = (props) => {
  const {
    id,
    className,
    htmlProps,
    index = 0,
    completed = false,
    disabled = false,
    onClick,
    icon,
    children,
    ...rest
  } = props;
  const { activeStep, handleStepChange, direction } = useProgressTrackerContext();
  const active = activeStep === index;
  const itemState = toItemState(active, completed, disabled);
  const handleClick = () => {
    if (!disabled) {
      onClick && onClick(index);
      handleStepChange && handleStepChange(index);
    }
  };
  const stepNumberContent = useMemo2(() => {
    if (completed) {
      return /* @__PURE__ */ jsx286(Icon, { icon: CheckIcon, iconSize: "small" });
    }
    if (icon !== void 0) {
      return /* @__PURE__ */ jsx286(Icon, { icon, iconSize: "small" });
    }
    return index + 1;
  }, [completed, icon, index]);
  const stepContent = /* @__PURE__ */ jsxs73(Fragment7, { children: [
    /* @__PURE__ */ jsx286(
      Box,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "aria-hidden": true,
        className: cn(
          ProgressTracker_default["item-number"],
          ProgressTracker_default[`item-number--${itemStateCn[itemState]}`],
          typographyStyles_default["body-small"]
        ),
        children: stepNumberContent
      }
    ),
    /* @__PURE__ */ jsxs73(
      "div",
      {
        className: cn(
          ProgressTracker_default["item-text"],
          ProgressTracker_default[`item-text--${itemStateCn[itemState]}`],
          typographyStyles_default["body-medium"]
        ),
        children: [
          /* @__PURE__ */ jsx286(VisuallyHidden, { as: "span", children: getVisuallyHiddenTextBefore(index) }),
          children,
          /* @__PURE__ */ jsx286(VisuallyHidden, { as: "span", children: getVisuallyHiddenTextAfter(completed) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ jsx286(
    Box,
    {
      as: "li",
      display: direction === "row" ? "flex" : void 0,
      "aria-current": active ? "step" : void 0,
      className: cn(ProgressTracker_default["list-item"], ProgressTracker_default[`list-item--${direction}`]),
      children: handleStepChange ? /* @__PURE__ */ jsx286(
        "button",
        {
          ...getBaseHTMLProps(
            id,
            cn(className, ProgressTracker_default["item-button"], focusable),
            htmlProps,
            rest
          ),
          onClick: () => handleClick(),
          disabled,
          children: stepContent
        }
      ) : /* @__PURE__ */ jsx286(
        "div",
        {
          ...getBaseHTMLProps(
            id,
            cn(className, cn(ProgressTracker_default["item-button"], ProgressTracker_default["item-div"])),
            htmlProps,
            rest
          ),
          children: stepContent
        }
      )
    }
  );
};
ProgressTrackerItem.displayName = "ProgressTracker.Item";

// src/components/ProgressTracker/ProgressTracker.tsx
import { jsx as jsx287 } from "react/jsx-runtime";
var ProgressTracker = (() => {
  const Res = ({
    id,
    activeStep = 0,
    onStepChange,
    direction = "column",
    children,
    className,
    htmlProps = {},
    ...rest
  }) => {
    const [thisActiveStep, setActiveStep] = useState23(activeStep);
    const handleChange = (step) => {
      setActiveStep(step);
      onStepChange && onStepChange(step);
    };
    useEffect27(() => {
      if (activeStep !== void 0 && activeStep != thisActiveStep) {
        setActiveStep(activeStep);
      }
    }, [activeStep, thisActiveStep]);
    const steps = useMemo3(() => {
      const validChildren = removeInvalidChildren(children);
      const itemsWithIndex = passIndexPropToProgressTrackerItem(validChildren);
      return itemsWithIndex;
    }, [children]);
    const isRow = direction === "row";
    const { "aria-label": ariaLabel } = htmlProps;
    return /* @__PURE__ */ jsx287(
      ProgressTrackerContext,
      {
        value: {
          activeStep: thisActiveStep,
          handleStepChange: handleChange,
          direction
        },
        children: /* @__PURE__ */ jsx287(
          "nav",
          {
            "aria-label": ariaLabel != null ? ariaLabel : "stegprogresjon",
            ...getBaseHTMLProps(id, className, htmlProps, rest),
            children: /* @__PURE__ */ jsx287(
              Box,
              {
                as: StylelessOList,
                display: "flex",
                flexDirection: direction,
                alignItems: "start",
                gap: isRow ? "x0.5" : "x0.125",
                overflowX: isRow ? "auto" : void 0,
                margin: "0",
                padding: isRow ? "x0.25" : "0",
                className: cn(ProgressTracker_default.list, scrollbar),
                children: steps
              }
            )
          }
        )
      }
    );
  };
  Res.Item = ProgressTrackerItem;
  Res.displayName = "ProgressTracker";
  return Res;
})();
function removeInvalidChildren(children) {
  return Children3.toArray(children).filter(isValidElement5);
}
function passIndexPropToProgressTrackerItem(children) {
  return Children3.map(
    children,
    (item, index) => cloneElement5(item, {
      ...item.props,
      index
    })
  );
}

// src/components/ProgressBar/ProgressBar.tsx
import { useId as useId23 } from "react";

// src/components/ProgressBar/ProgressBar.module.css
var ProgressBar_default = {
  progress: "ProgressBar_progress",
  fill: "ProgressBar_fill",
  "fill--done": "ProgressBar_fill--done",
  "fill--error": "ProgressBar_fill--error",
  "fill--indeterminate": "ProgressBar_fill--indeterminate",
  indeterminate: "ProgressBar_indeterminate"
};

// src/components/ProgressBar/ProgressBar.tsx
import { jsx as jsx288, jsxs as jsxs74 } from "react/jsx-runtime";
var ProgressBar = ({
  label,
  tip,
  errorMessage,
  size: size2 = "medium",
  "aria-describedby": ariaDescribedby,
  value,
  width,
  max,
  id,
  className,
  style,
  ...rest
}) => {
  const generatedId = useId23();
  const uniqueId = id != null ? id : `${generatedId}-searchInput`;
  const hasErrorMessage = !!errorMessage;
  const hasTip = !!tip;
  const hasLabel = !!label;
  const hasValidMax = !!max && max > 0;
  const hasValidValue = !!value && value > 0 && (max !== void 0 && value <= max || max === void 0 && value <= 1);
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const fillPrecentage = hasValidValue && value / (max != null ? max : 1) * 100 + "%";
  const isIndeterminate = !hasValidValue && !hasErrorMessage;
  return /* @__PURE__ */ jsxs74(Box, { width: "100%", className, style, children: [
    hasLabel ? /* @__PURE__ */ jsx288(Label, { htmlFor: uniqueId, children: label }) : void 0,
    /* @__PURE__ */ jsx288(
      "progress",
      {
        id: uniqueId,
        className: utilStyles_default["visually-hidden"],
        value: hasValidValue ? value : void 0,
        max: hasValidMax ? max : void 0,
        "aria-describedby": spaceSeparatedIdListGenerator([
          hasTip ? tipId : void 0,
          hasErrorMessage ? errorMessageId : void 0,
          ariaDescribedby
        ]),
        ...rest,
        children: fillPrecentage
      }
    ),
    /* @__PURE__ */ jsx288(
      Box,
      {
        width: getInputWidth(width),
        height: size2 === "small" ? "x0.75" : "x1.5",
        className: cn(ProgressBar_default.progress),
        children: /* @__PURE__ */ jsx288(
          Box,
          {
            height: "100%",
            width: isIndeterminate ? "25%" : fillPrecentage ? fillPrecentage : 0,
            className: cn(
              ProgressBar_default.fill,
              isIndeterminate && ProgressBar_default["fill--indeterminate"],
              fillPrecentage === "100%" && ProgressBar_default["fill--done"],
              errorMessage && ProgressBar_default["fill--error"]
            )
          }
        )
      }
    ),
    renderInputMessage(tip, tipId, errorMessage, errorMessageId)
  ] });
};
ProgressBar.displayName = "ProgressBar";

// src/components/Search/Search.tsx
import {
  useId as useId24,
  useState as useState24
} from "react";

// src/components/Search/AutocompleteSearch.context.tsx
import {
  createContext as createContext14,
  useContext as useContext21
} from "react";
var AutocompleteSearchContext = createContext14({});
var useAutocompleteSearch = () => {
  return useContext21(AutocompleteSearchContext);
};

// src/components/Search/Search.module.css
var Search_default = {
  "with-button-container": "Search_with-button-container",
  input: "Search_input",
  "search-icon": "Search_search-icon",
  "clear-button": "Search_clear-button",
  suggestions: "Search_suggestions"
};

// src/components/Search/Search.utils.ts
var typographyTypes2 = {
  small: "bodySmall",
  medium: "bodyMedium",
  large: "bodyLarge"
};
function createEmptyChangeEvent(inputElementId) {
  const inputElement = document.getElementById(
    inputElementId
  );
  inputElement.value = "";
  const emptyChangeEvent = {
    target: inputElement,
    currentTarget: inputElement,
    bubbles: true,
    cancelable: false,
    defaultPrevented: false,
    eventPhase: 0,
    isTrusted: false,
    preventDefault: () => null,
    stopPropagation: () => null,
    nativeEvent: new Event("input"),
    persist: () => null,
    type: "change",
    timeStamp: Date.now(),
    isDefaultPrevented: () => false,
    isPropagationStopped: () => false
  };
  return emptyChangeEvent;
}

// src/components/Search/SearchSuggestionItem.tsx
import { useEffect as useEffect28, useRef as useRef31 } from "react";
import { jsx as jsx289 } from "react/jsx-runtime";
var SearchSuggestionItem = ({
  focus,
  className,
  ref,
  ...rest
}) => {
  const itemRef = useRef31(null);
  const combinedRef = useCombinedRef(ref, itemRef);
  useEffect28(() => {
    var _a;
    if (focus) {
      (_a = itemRef.current) == null ? void 0 : _a.focus();
    }
  }, [focus]);
  return /* @__PURE__ */ jsx289(
    "button",
    {
      ref: combinedRef,
      className: cn(
        className,
        OverflowMenu_default.list__item,
        OverflowMenu_default["list__item--link"],
        focus_default["focusable--inset"],
        utilStyles_default["normalize-button"]
      ),
      ...rest,
      tabIndex: focus ? 0 : -1
    }
  );
};
SearchSuggestionItem.displayName = "SearchSuggestionItem";

// src/components/Search/SearchSuggestions.tsx
import { jsx as jsx290, jsxs as jsxs75 } from "react/jsx-runtime";
var SearchSuggestions = ({
  id,
  searchId,
  className,
  htmlProps,
  suggestions = [],
  showSuggestions,
  componentSize = "medium",
  onSuggestionClick,
  maxSuggestions,
  ...rest
}) => {
  const suggestionsHeaderId = derivativeIdGenerator(
    searchId,
    "suggestions-header"
  );
  const [focus] = useRoveFocus(suggestions == null ? void 0 : suggestions.length, showSuggestions);
  const suggestionsToRender = maxSuggestions ? suggestions == null ? void 0 : suggestions.slice(maxSuggestions) : suggestions;
  return /* @__PURE__ */ jsxs75(
    Paper,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Search_default.suggestions,
          utilStyles_default.scrollbar,
          utilStyles_default["visibility-transition"],
          showSuggestions ? utilStyles_default["visibility-transition--open"] : utilStyles_default["visibility-transition--closed"]
        ),
        htmlProps,
        rest
      ),
      "aria-hidden": !showSuggestions,
      border: "border-default",
      position: "absolute",
      top: "100%",
      width: "100%",
      maxHeight: "300px",
      overflowY: "scroll",
      marginBlock: "x0.25 0",
      children: [
        /* @__PURE__ */ jsx290(
          Box,
          {
            as: "h2",
            paddingInline: "0 x1",
            id: suggestionsHeaderId,
            className: typographyStyles_default["body-xsmall"],
            children: "S\xF8keforslag"
          }
        ),
        /* @__PURE__ */ jsx290(StylelessList, { role: "listbox", "aria-labelledby": suggestionsHeaderId, children: suggestionsToRender.map((suggestion, index) => {
          return /* @__PURE__ */ jsx290("li", { role: "option", children: /* @__PURE__ */ jsx290(
            SearchSuggestionItem,
            {
              index,
              focus: focus === index && showSuggestions,
              "aria-label": `s\xF8k p\xE5 ${suggestion}`,
              onClick: onSuggestionClick,
              "aria-setsize": suggestionsToRender.length,
              "aria-posinset": index,
              className: typographyStyles_default[getTypographyCn(typographyTypes2[componentSize])],
              children: suggestion
            }
          ) }, index);
        }) })
      ]
    }
  );
};
SearchSuggestions.displayName = "SearchSuggestions";

// src/components/Search/Search.tsx
import { Fragment as Fragment8, jsx as jsx291, jsxs as jsxs76 } from "react/jsx-runtime";
var getIconSize2 = (size2) => {
  switch (size2) {
    case "large":
      return "medium";
    case "medium":
      return "medium";
    case "small":
      return "small";
  }
};
var getPadding = (size2, showIcon) => {
  const paddingRight = (textSize) => `calc(
 var(--dds-spacing-x1) + ${textSize} * 1.5 + var(--dds-spacing-x0-5)
 )`;
  const paddingLeft = (iconSize) => `calc(
 var(--dds-spacing-x0-75) + ${iconSize} + var(--dds-spacing-x0-5)
 )`;
  const pRSmallButton = paddingRight("0.875rem");
  const pRMediumButton = paddingRight("1rem");
  const pLSmallIcon = paddingLeft("var(--dds-icon-size-small)");
  const pLMediumIcon = paddingLeft("var(--dds-icon-size-medium)");
  const paddingMap = {
    large: `x1 ${pRMediumButton} x1 ${showIcon ? pLMediumIcon : "x0.75"}`,
    medium: `x0.75 ${pRSmallButton} x0.75 ${showIcon ? pLMediumIcon : "x0.75"}`,
    small: `x0.5 ${pRSmallButton} x0.5 ${showIcon ? pLSmallIcon : "x0.75"}`
  };
  return paddingMap[size2];
};
var Search = ({
  componentSize = "medium",
  buttonProps,
  showIcon = true,
  name,
  label,
  tip,
  id,
  value,
  width,
  onChange,
  className,
  style,
  "aria-describedby": ariaDescribedby,
  ref,
  ...rest
}) => {
  var _a;
  const generatedId = useId24();
  const uniqueId = id != null ? id : `${generatedId}-searchInput`;
  const hasLabel = !!label;
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const suggestionsId = derivativeIdGenerator(uniqueId, "suggestions");
  const suggestionsDescriptionId = derivativeIdGenerator(
    uniqueId,
    "suggestions-description"
  );
  const [hasValue, setHasValue] = useState24(!!value);
  const context = useAutocompleteSearch();
  const combinedRef = context.inputRef ? useCombinedRef(context.inputRef, ref) : ref;
  const handleChange = (e) => {
    setHasValue(e.target.value !== "");
    context.onValueChange && context.onValueChange(e);
    onChange && onChange(e);
  };
  const clearInput = () => {
    const emptyChangeEvent = createEmptyChangeEvent(uniqueId);
    handleChange(emptyChangeEvent);
  };
  const {
    label: buttonLabel,
    onClick,
    ...otherButtonProps
  } = buttonProps != null ? buttonProps : {};
  const hasSuggestions = !!context.suggestions;
  const showSearchButton = !!buttonProps && !!onClick;
  const inputGroup = /* @__PURE__ */ jsxs76(
    HStack,
    {
      position: "relative",
      width: !showSearchButton ? width : void 0,
      className: !showSearchButton ? className : void 0,
      children: [
        showIcon && /* @__PURE__ */ jsx291(
          Icon,
          {
            icon: SearchIcon,
            iconSize: getIconSize2(componentSize),
            className: cn(
              Input_default["input-group__absolute-element"],
              Search_default["search-icon"]
            )
          }
        ),
        /* @__PURE__ */ jsx291(
          Box,
          {
            as: Input,
            ...rest,
            ref: combinedRef,
            name,
            type: "search",
            id: uniqueId,
            "aria-describedby": spaceSeparatedIdListGenerator([
              tip ? tipId : void 0,
              context.suggestions ? suggestionsDescriptionId : void 0,
              ariaDescribedby
            ]),
            value: (_a = context.inputValue) != null ? _a : value,
            onChange: handleChange,
            autoComplete: "off",
            "aria-autocomplete": hasSuggestions ? "list" : void 0,
            "aria-controls": hasSuggestions ? suggestionsId : void 0,
            "aria-expanded": context.showSuggestions,
            role: hasSuggestions ? "combobox" : void 0,
            width: "100%",
            padding: getPadding(componentSize, showIcon),
            className: cn(
              Search_default.input,
              typographyStyles_default[getTypographyCn(typographyTypes2[componentSize])]
            )
          }
        ),
        hasSuggestions && /* @__PURE__ */ jsxs76(Fragment8, { children: [
          /* @__PURE__ */ jsx291(
            SearchSuggestions,
            {
              id: suggestionsId,
              ref: context.suggestionsRef,
              searchId: uniqueId,
              onSuggestionClick: context.onSugggestionClick,
              suggestions: context.suggestions,
              showSuggestions: context.showSuggestions,
              componentSize
            }
          ),
          /* @__PURE__ */ jsx291(VisuallyHidden, { id: suggestionsDescriptionId, as: "span", children: "Bla i s\xF8keforslag med piltaster n\xE5r listen er utvidet." })
        ] }),
        hasValue && /* @__PURE__ */ jsx291(
          Button,
          {
            icon: CloseSmallIcon,
            size: componentSize === "large" ? "medium" : "small",
            purpose: "tertiary",
            "aria-label": "T\xF8m",
            onClick: clearInput,
            className: Search_default["clear-button"]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ jsxs76(VStack, { gap: "x0.125", children: [
    hasLabel && /* @__PURE__ */ jsx291(Label, { htmlFor: uniqueId, children: label }),
    /* @__PURE__ */ jsxs76("div", { children: [
      showSearchButton ? /* @__PURE__ */ jsxs76(
        Grid,
        {
          className,
          width,
          columnGap: "x0.5",
          rowGap: "0",
          marginInline: "0",
          gridTemplateColumns: "1fr auto",
          style,
          children: [
            inputGroup,
            /* @__PURE__ */ jsx291(
              Button,
              {
                size: componentSize,
                onClick,
                ...otherButtonProps,
                children: buttonLabel != null ? buttonLabel : "S\xF8k"
              }
            )
          ]
        }
      ) : inputGroup,
      renderInputMessage(tip, tipId)
    ] })
  ] });
};
Search.displayName = "Search";

// src/components/Search/SearchAutocompleteWrapper.tsx
import {
  useEffect as useEffect29,
  useRef as useRef32,
  useState as useState25
} from "react";
import { jsx as jsx292 } from "react/jsx-runtime";
var SearchAutocompleteWrapper = (props) => {
  const {
    value,
    data,
    filter,
    queryLength = 2,
    onChange,
    onSuggestionSelection,
    children
  } = props;
  const [inputValue, setInputValue] = useState25(value != null ? value : "");
  const [suggestions, setSuggestions] = useState25([]);
  const [showSuggestions, setShowSuggestions] = useState25(false);
  const closeSuggestions = () => showSuggestions === true && setShowSuggestions(false);
  const openSuggestions = () => showSuggestions === false && setShowSuggestions(true);
  useEffect29(() => {
    if (suggestions.length > 0) {
      openSuggestions();
    } else {
      closeSuggestions();
    }
  }, [suggestions]);
  const isWeightedValueData = (data2) => data2.array[0].relevance !== void 0;
  const handleChange = (e) => {
    const query = e.target.value;
    handleSetInputValue(query);
    let finalSuggestions = [];
    if (query.length >= queryLength) {
      if (data) {
        if (isWeightedValueData(data)) {
          const { sortFunction, array } = data;
          const filteredSuggestions = array.filter(
            (suggestion) => filter ? filter(suggestion.text, query) : searchFilter(suggestion.text, query)
          );
          finalSuggestions = filteredSuggestions.sort(sortFunction ? (a, b) => sortFunction(a, b) : void 0).map((item) => item.text);
        } else {
          const { sortFunction, array } = data;
          const filteredSuggestions = array.filter(
            (suggestion) => filter ? filter(suggestion, query) : searchFilter(suggestion, query)
          );
          finalSuggestions = filteredSuggestions.sort(
            sortFunction ? (a, b) => sortFunction(a, b) : void 0
          );
        }
      }
      setSuggestions(finalSuggestions);
    } else {
      setSuggestions([]);
    }
    onChange && onChange(e);
  };
  const handleSuggestionClick = (e) => {
    setSuggestions([]);
    handleSetInputValue(e.target.innerText);
    onSuggestionSelection && onSuggestionSelection();
    closeSuggestions();
  };
  const handleSetInputValue = (value2) => {
    setInputValue(value2 != null ? value2 : "");
  };
  const inputRef = useRef32(null);
  const suggestionsRef = useRef32(null);
  useOnClickOutside([inputRef.current, suggestionsRef.current], () => {
    closeSuggestions();
  });
  useOnKeyDown("Tab", () => closeSuggestions());
  const contextProps = {
    showSuggestions,
    inputRef,
    suggestionsRef,
    suggestions,
    onValueChange: handleChange,
    inputValue,
    onSugggestionClick: handleSuggestionClick
  };
  return /* @__PURE__ */ jsx292(AutocompleteSearchContext, { value: contextProps, children });
};
SearchAutocompleteWrapper.displayName = "SearchAutocompleteWrapper";

// src/components/Search/index.ts
var Search2 = Search;
Search2.AutocompleteWrapper = SearchAutocompleteWrapper;
Search2.Suggestions = SearchSuggestions;

// src/components/Skeleton/Skeleton.module.css
var Skeleton_default = {
  ddsSkeletonAnimation: "Skeleton_ddsSkeletonAnimation",
  container: "Skeleton_container"
};

// src/components/Skeleton/Skeleton.tsx
import { jsx as jsx293 } from "react/jsx-runtime";
var Skeleton = ({
  width,
  height,
  borderRadius = "var(--dds-border-radius-surface)",
  className,
  style,
  ref,
  ...rest
}) => {
  return /* @__PURE__ */ jsx293(
    Box,
    {
      width,
      height,
      ref,
      className: cn(className, Skeleton_default.container),
      style: { ...style, borderRadius },
      ...rest
    }
  );
};
Skeleton.displayName = "Skeleton";

// src/components/SkipToContent/SkipToContent.module.css
var SkipToContent_default = {
  wrapper: "SkipToContent_wrapper"
};

// src/components/SkipToContent/SkipToContent.tsx
import { jsx as jsx294 } from "react/jsx-runtime";
var SkipToContent = ({
  text = "Til hovedinnhold",
  top = 0,
  id,
  className,
  htmlProps = {},
  ...rest
}) => {
  const { className: htmlPropsClassName, style, ...restHtmlProps } = htmlProps;
  return /* @__PURE__ */ jsx294(
    Contrast,
    {
      className: cn(className, htmlPropsClassName, SkipToContent_default.wrapper),
      style: { ...style, top },
      children: /* @__PURE__ */ jsx294(Link, { ...getBaseHTMLProps(id, restHtmlProps, rest), children: text })
    }
  );
};
SkipToContent.displayName = "SkipToContent";

// src/components/SplitButton/SplitButton.tsx
import { useState as useState26 } from "react";

// src/components/SplitButton/SplitButton.module.css
var SplitButton_default = {
  container: "SplitButton_container",
  main: "SplitButton_main",
  option: "SplitButton_option",
  "option--primary": "SplitButton_option--primary"
};

// src/components/SplitButton/SplitButton.tsx
import { jsx as jsx295, jsxs as jsxs77 } from "react/jsx-runtime";
var SplitButton = ({
  size: size2,
  primaryAction,
  secondaryActions,
  purpose = "primary",
  className,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState26(false);
  const buttonStyleProps = {
    purpose,
    size: size2
  };
  return /* @__PURE__ */ jsxs77("div", { className: cn(className, SplitButton_default.container), ...rest, children: [
    /* @__PURE__ */ jsx295(
      Button,
      {
        ...buttonStyleProps,
        ...primaryAction,
        iconPosition: "left",
        className: SplitButton_default.main
      }
    ),
    /* @__PURE__ */ jsxs77(OverflowMenuGroup, { isOpen, setIsOpen, children: [
      /* @__PURE__ */ jsx295(
        Button,
        {
          ...buttonStyleProps,
          icon: isOpen ? ChevronUpIcon : ChevronDownIcon,
          "aria-label": "\xC5pne liste med flere valg",
          purpose,
          className: cn(
            SplitButton_default.option,
            purpose === "primary" && SplitButton_default["option--primary"]
          ),
          type: "button"
        }
      ),
      /* @__PURE__ */ jsx295(OverflowMenu, { placement: "bottom-end", children: /* @__PURE__ */ jsx295(OverflowMenuList, { children: secondaryActions.map((item, index) => /* @__PURE__ */ jsx295(OverflowMenuButton, { ...item, children: item.children }, index)) }) })
    ] })
  ] });
};
SplitButton.displayName = "SplitButton";

// src/components/Table/collapsible/CollapsibleRow.tsx
import {
  Children as Children4,
  Fragment as Fragment9,
  cloneElement as cloneElement6,
  isValidElement as isValidElement6,
  useEffect as useEffect31,
  useState as useState28
} from "react";

// src/components/Table/collapsible/Table.context.tsx
import { createContext as createContext15, useContext as useContext22 } from "react";
var CollapsibleTableContext = createContext15({
  headerValues: [],
  definingColumnIndex: [0]
});
var useCollapsibleTableContext = () => useContext22(CollapsibleTableContext);

// src/components/Table/normal/Body.tsx
import { jsx as jsx296 } from "react/jsx-runtime";
var Body = (props) => /* @__PURE__ */ jsx296("tbody", { ...props });
Body.displayName = "Table.Body";

// src/components/Table/normal/Head.tsx
import { createContext as createContext16, useContext as useContext23 } from "react";
import { jsx as jsx297 } from "react/jsx-runtime";
var Head = ({ children, ...rest }) => /* @__PURE__ */ jsx297("thead", { ...rest, children: /* @__PURE__ */ jsx297(HeadContext, { value: true, children }) });
var HeadContext = createContext16(false);
function useIsInTableHead() {
  const isInTableHead = useContext23(HeadContext);
  return isInTableHead;
}

// src/components/Table/normal/Table.module.css
var Table_default = {
  wrapper: "Table_wrapper",
  "wrapper--scrollable": "Table_wrapper--scrollable",
  table: "Table_table",
  "table--with-dividers": "Table_table--with-dividers",
  "row--body": "Table_row--body",
  "row--colapsible-header--open": "Table_row--colapsible-header--open",
  "table--sticky-header": "Table_table--sticky-header",
  "table--small": "Table_table--small",
  "table--medium": "Table_table--medium",
  "table--large": "Table_table--large",
  row: "Table_row",
  "row--sum": "Table_row--sum",
  "row--selected": "Table_row--selected",
  "row--hoverable": "Table_row--hoverable",
  "cell--head": "Table_cell--head",
  "cell--left": "Table_cell--left",
  "cell--right": "Table_cell--right",
  "cell--center": "Table_cell--center",
  cell__inner: "Table_cell__inner",
  "sort-button": "Table_sort-button",
  "collapse-button": "Table_collapse-button"
};

// src/components/Table/normal/Cell.tsx
import { jsx as jsx298 } from "react/jsx-runtime";
var Cell = ({
  children,
  type: _type,
  layout = "left",
  collapsibleProps,
  className,
  ...rest
}) => {
  const isInHead = useIsInTableHead();
  const type = _type != null ? _type : isInHead ? "head" : "data";
  const { isCollapsibleChild } = collapsibleProps != null ? collapsibleProps : {};
  const isComplexLayout = layout === "text and icon";
  return isCollapsibleChild ? /* @__PURE__ */ jsx298(DescriptionListDesc, { children }) : type === "head" ? /* @__PURE__ */ jsx298(
    "th",
    {
      ...rest,
      className: cn(
        className,
        !isComplexLayout && Table_default[`cell--${layout}`],
        Table_default["cell--head"]
      ),
      children: isComplexLayout ? /* @__PURE__ */ jsx298("div", { className: Table_default.cell__inner, children }) : children
    }
  ) : /* @__PURE__ */ jsx298(
    "td",
    {
      ...rest,
      className: cn(className, !isComplexLayout && Table_default[`cell--${layout}`]),
      children: isComplexLayout ? /* @__PURE__ */ jsx298("div", { className: Table_default.cell__inner, children }) : children
    }
  );
};
Cell.displayName = "Table.Cell";

// src/components/Table/normal/Foot.tsx
import { jsx as jsx299 } from "react/jsx-runtime";
var Foot = (props) => /* @__PURE__ */ jsx299("tfoot", { ...props });
Foot.displayName = "Table.Foot";

// src/components/Table/normal/Row.tsx
import { jsx as jsx300 } from "react/jsx-runtime";
var Row = ({
  type: _type,
  mode = "normal",
  hoverable,
  selected,
  className,
  ...rest
}) => {
  const isInHeader = useIsInTableHead();
  const type = _type != null ? _type : isInHeader ? "head" : "body";
  return /* @__PURE__ */ jsx300(
    "tr",
    {
      className: cn(
        className,
        Table_default.row,
        type === "body" && Table_default["row--body"],
        mode === "sum" && Table_default["row--sum"],
        selected && Table_default["row--selected"],
        hoverable && Table_default["row--hoverable"],
        (type === "head" || mode === "sum") && typographyStyles_default.bold,
        focusable
      ),
      ...rest
    }
  );
};
Row.displayName = "Table.Row";

// src/components/Table/normal/SortCell.tsx
import { jsx as jsx301, jsxs as jsxs78 } from "react/jsx-runtime";
var makeSortIcon = (isSorted, sortOrder) => {
  if (!isSorted || !sortOrder) {
    return /* @__PURE__ */ jsx301(Icon, { icon: UnfoldMoreIcon, iconSize: "inherit" });
  }
  return sortOrder === "ascending" ? /* @__PURE__ */ jsx301(Icon, { icon: ChevronDownIcon, iconSize: "inherit" }) : /* @__PURE__ */ jsx301(Icon, { icon: ChevronUpIcon, iconSize: "inherit" });
};
var SortCell = ({
  isSorted,
  sortOrder,
  onClick,
  children,
  ...rest
}) => /* @__PURE__ */ jsx301(
  Cell,
  {
    type: "head",
    "aria-sort": isSorted && sortOrder ? sortOrder : void 0,
    ...rest,
    children: /* @__PURE__ */ jsxs78(
      "button",
      {
        onClick,
        "aria-description": "Aktiver for \xE5 endre sorteringsrekkef\xF8lge",
        className: cn(
          utilStyles_default["normalize-button"],
          utilStyles_default["remove-button-styling"],
          Table_default["sort-button"],
          focusable
        ),
        children: [
          children,
          " ",
          makeSortIcon(isSorted, sortOrder)
        ]
      }
    )
  }
);
SortCell.displayName = "Table.SortCell";

// src/components/Table/normal/Table.tsx
import { jsx as jsx302 } from "react/jsx-runtime";
var Table = ({
  size: size2 = "medium",
  stickyHeader,
  withDividers,
  className,
  children,
  ...rest
}) => /* @__PURE__ */ jsx302(
  "table",
  {
    ...rest,
    className: cn(
      className,
      Table_default.table,
      Table_default[`table--${size2}`],
      withDividers && Table_default["table--with-dividers"],
      stickyHeader && Table_default["table--sticky-header"],
      scrollbar
    ),
    children
  }
);
Table.displayName = "Table";

// src/components/Table/normal/TableWrapper.tsx
import {
  useContext as useContext24,
  useEffect as useEffect30,
  useRef as useRef33,
  useState as useState27
} from "react";
import { jsx as jsx303 } from "react/jsx-runtime";
var TableWrapper = ({ className, ...rest }) => {
  const themeContext = useContext24(ThemeContext);
  const container2 = themeContext == null ? void 0 : themeContext.el;
  const containerWidth = container2 ? container2.clientWidth : 0;
  const [overflowX, setOverflowX] = useState27(false);
  const [themeContainerWidth, setThemeContainerWidth] = useState27(containerWidth);
  function isOverflowingX(event) {
    return event.offsetWidth < event.scrollWidth;
  }
  const wrapperRef = useRef33(null);
  useEffect30(() => {
    if ((wrapperRef == null ? void 0 : wrapperRef.current) && isOverflowingX(wrapperRef.current)) {
      setOverflowX(true);
      return;
    }
    setOverflowX(false);
  }, [themeContainerWidth]);
  useEffect30(() => {
    function handleResize() {
      setThemeContainerWidth(containerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return /* @__PURE__ */ jsx303(
    "div",
    {
      ref: wrapperRef,
      ...rest,
      className: cn(
        className,
        scrollbar,
        Table_default.wrapper,
        overflowX && Table_default["wrapper--scrollable"]
      )
    }
  );
};
TableWrapper.displayName = "Table.Wrapper";

// src/components/Table/normal/index.ts
var Table2 = Table;
Table2.Wrapper = TableWrapper;
Table2.Head = Head;
Table2.Body = Body;
Table2.Cell = Cell;
Table2.SortCell = SortCell;
Table2.Row = Row;
Table2.Foot = Foot;

// src/components/Table/collapsible/CollapsibleRow.tsx
import { Fragment as Fragment10, jsx as jsx304, jsxs as jsxs79 } from "react/jsx-runtime";
var CollapsibleRow = ({
  type: _type,
  className,
  mode = "normal",
  selected,
  hoverable,
  children,
  ref,
  ...rest
}) => {
  const isInHead = useIsInTableHead();
  const type = _type != null ? _type : isInHead ? "head" : "body";
  const { isCollapsed, headerValues, definingColumnIndex } = useCollapsibleTableContext();
  const [childrenCollapsed, setChildrenCollapsed] = useState28(true);
  useEffect31(() => {
    !isCollapsed && setChildrenCollapsed(true);
  }, [isCollapsed]);
  const rowProps = (isOpenCollapsibleHeader) => {
    return {
      mode,
      selected,
      hoverable,
      className: cn(
        className,
        isOpenCollapsibleHeader && Table_default["row--colapsible-header--open"]
      ),
      ...rest
    };
  };
  const collapsedHeaderValues = headerValues.filter(
    (column, index) => definingColumnIndex.indexOf(index) === -1
  );
  const childrenArray = Children4.toArray(children);
  const collapsedChildren = childrenArray.filter(
    (column, index) => definingColumnIndex.indexOf(index) === -1
  );
  const prefix2 = "collapsibleRow";
  const collapsibleIds = [];
  const collapsedRenderedChildren = isCollapsed && collapsedHeaderValues.length > 0 ? collapsedChildren.map(function(child, index) {
    const id = derivativeIdGenerator(prefix2, index.toString());
    collapsibleIds.push(id);
    return /* @__PURE__ */ jsxs79(Fragment9, { children: [
      /* @__PURE__ */ jsx304(DescriptionListTerm, { children: collapsedHeaderValues[index].content }),
      isValidElement6(child) && cloneElement6(child, {
        collapsibleProps: { isCollapsibleChild: true }
      })
    ] }, `DL-${index}`);
  }) : null;
  const collapsedRows = collapsedRenderedChildren && collapsedRenderedChildren.length > 0 ? /* @__PURE__ */ jsx304(Row, { ...rowProps(), children: /* @__PURE__ */ jsx304(Cell, { colSpan: definingColumnIndex.length + 1, children: /* @__PURE__ */ jsx304(DescriptionList, { children: collapsedRenderedChildren }) }) }) : null;
  const definingColumnCells = childrenArray.slice().filter((column, index) => definingColumnIndex.indexOf(index) > -1).sort((a, b) => {
    return definingColumnIndex.indexOf(childrenArray.indexOf(a)) - definingColumnIndex.indexOf(childrenArray.indexOf(b));
  });
  const headerRow = () => {
    if (type !== "head" || !isCollapsed) return null;
    return /* @__PURE__ */ jsx304(Row, { ref, ...rowProps(), children: /* @__PURE__ */ jsxs79(Fragment10, { children: [
      definingColumnCells,
      /* @__PURE__ */ jsxs79(Table2.Cell, { type: "head", layout: "center", children: [
        "Utvid",
        /* @__PURE__ */ jsx304(VisuallyHidden, { as: "span", children: "raden" })
      ] })
    ] }) });
  };
  const idList = spaceSeparatedIdListGenerator(collapsibleIds);
  const rowWithChevron = () => {
    if (type !== "body" || !isCollapsed) return null;
    return /* @__PURE__ */ jsxs79(Row, { ref, ...rowProps(!childrenCollapsed && true), children: [
      definingColumnCells,
      /* @__PURE__ */ jsx304(Table2.Cell, { children: /* @__PURE__ */ jsx304(
        "button",
        {
          onClick: () => setChildrenCollapsed(!childrenCollapsed),
          "aria-expanded": !childrenCollapsed,
          "aria-controls": idList,
          className: cn(
            Table_default["collapse-button"],
            utilStyles_default["normalize-button"],
            utilStyles_default["remove-button-styling"],
            focusable
          ),
          children: /* @__PURE__ */ jsx304(
            AnimatedChevronUpDown,
            {
              isUp: childrenCollapsed ? false : true,
              height: "8px",
              width: "12px"
            }
          )
        }
      ) })
    ] });
  };
  return isCollapsed && collapsedRenderedChildren && collapsedRenderedChildren.length > 0 ? /* @__PURE__ */ jsxs79(Fragment10, { children: [
    headerRow(),
    type === "body" && /* @__PURE__ */ jsxs79(Fragment10, { children: [
      rowWithChevron(),
      childrenCollapsed ? null : collapsedRows
    ] })
  ] }) : /* @__PURE__ */ jsx304(Row, { ref, ...rowProps(), children });
};
CollapsibleRow.displayName = "CollapsibleTable.Row";

// src/components/Table/collapsible/CollapsibleTable.tsx
import { jsx as jsx305 } from "react/jsx-runtime";
var CollapsibleTable = ({
  isCollapsed,
  headerValues,
  definingColumnIndex = [0],
  ...rest
}) => {
  return /* @__PURE__ */ jsx305(
    CollapsibleTableContext,
    {
      value: {
        isCollapsed,
        headerValues,
        definingColumnIndex
      },
      children: /* @__PURE__ */ jsx305(Table2, { ...rest })
    }
  );
};
CollapsibleTable.displayName = "CollapsibleTable";

// src/components/Table/collapsible/index.ts
var CollapsibleTable2 = CollapsibleTable;
CollapsibleTable2.Row = CollapsibleRow;

// src/components/Tabs/AddTabButton.tsx
import { useRef as useRef34 } from "react";

// src/components/Tabs/Tabs.context.tsx
import { createContext as createContext17, useContext as useContext25 } from "react";
var TabsContext = createContext17({
  activeTab: 0,
  tabsId: "",
  size: "small",
  handleTabChange: () => null,
  tabListRef: null,
  tabPanelsRef: null,
  hasTabFocus: false,
  setHasTabFocus: () => null,
  tabContentDirection: "row",
  addTabButtonProps: void 0
});
var useTabsContext = () => useContext25(TabsContext);

// src/components/Tabs/Tabs.module.css
var Tabs_default = {
  tabs: "Tabs_tabs",
  "tab-row": "Tabs_tab-row",
  "tab-row--standard-widths": "Tabs_tab-row--standard-widths",
  "tab-row--custom-widths": "Tabs_tab-row--custom-widths",
  tab: "Tabs_tab",
  "tab--medium--row": "Tabs_tab--medium--row",
  "tab--small--row": "Tabs_tab--small--row",
  "tab--medium--column": "Tabs_tab--medium--column",
  "tab--small--column": "Tabs_tab--small--column",
  "tab--row": "Tabs_tab--row",
  "tab--column": "Tabs_tab--column",
  "tab--active": "Tabs_tab--active"
};

// src/components/Tabs/TabWidthContext.tsx
import {
  createContext as createContext18,
  useContext as useContext26,
  useLayoutEffect as useLayoutEffect3
} from "react";
import { jsx as jsx306 } from "react/jsx-runtime";
var TabContext = createContext18(null);
function TabWidthContextProvider({
  children,
  onChangeWidths
}) {
  return /* @__PURE__ */ jsx306(
    TabContext,
    {
      value: {
        updateWidth: (index, newWidth) => {
          onChangeWidths((prev) => {
            const newValue = [...prev];
            newValue[index] = newWidth;
            return newValue;
          });
        },
        removeTab: (index) => {
          onChangeWidths((prev) => {
            const newValue = [...prev];
            newValue.splice(index, 1);
            return newValue;
          });
        }
      },
      children
    }
  );
}
function useSetTabWidth(index, width) {
  const context = useContext26(TabContext);
  useLayoutEffect3(() => {
    context == null ? void 0 : context.updateWidth(index, width);
    return () => context == null ? void 0 : context.removeTab(index);
  }, [index, width]);
}

// src/components/Tabs/AddTabButton.tsx
import { jsx as jsx307, jsxs as jsxs80 } from "react/jsx-runtime";
var AddTabButton = ({
  ref,
  children,
  index,
  className,
  width = "1fr",
  ...rest
}) => {
  useSetTabWidth(index, width);
  const buttonRef = useRef34(null);
  const combinedRef = useCombinedRef(ref, buttonRef);
  const { tabContentDirection, size: size2 } = useTabsContext();
  return /* @__PURE__ */ jsxs80(
    "button",
    {
      ...rest,
      ref: combinedRef,
      className: cn(
        className,
        Tabs_default.tab,
        Tabs_default[`tab--${tabContentDirection}`],
        typographyStyles_default[`body-${size2}`],
        focus_default["focusable--inset"]
      ),
      children: [
        /* @__PURE__ */ jsx307(Icon, { icon: PlusIcon, iconSize: "inherit" }),
        /* @__PURE__ */ jsx307("span", { children })
      ]
    }
  );
};
AddTabButton.displayName = "AddTabButton";

// src/components/Tabs/Tabs.tsx
import { useEffect as useEffect32, useId as useId25, useRef as useRef35, useState as useState29 } from "react";
import { jsx as jsx308 } from "react/jsx-runtime";
var Tabs = ({
  id,
  activeTab,
  onChange,
  tabContentDirection = "row",
  size: size2 = "small",
  addTabButtonProps,
  width,
  children,
  className,
  htmlProps,
  ...rest
}) => {
  const generatedId = useId25();
  const uniqueId = id != null ? id : `${generatedId}-tabs`;
  const [thisActiveTab, setActiveTab] = useState29(activeTab != null ? activeTab : 0);
  const [hasTabFocus, setHasTabFocus] = useState29(false);
  const tabListRef = useRef35(null);
  const tabPanelsRef = useRef35(null);
  const handleTabChange = (index) => {
    setActiveTab(index);
    onChange && onChange(index);
  };
  useEffect32(() => {
    if (activeTab !== void 0 && activeTab !== thisActiveTab) {
      setActiveTab(activeTab);
    }
  }, [activeTab, thisActiveTab]);
  return /* @__PURE__ */ jsx308(
    TabsContext,
    {
      value: {
        tabsId: uniqueId,
        activeTab: thisActiveTab,
        size: size2,
        handleTabChange,
        tabListRef,
        tabPanelsRef,
        hasTabFocus,
        setHasTabFocus,
        tabContentDirection,
        addTabButtonProps
      },
      children: /* @__PURE__ */ jsx308(
        Box,
        {
          ...getBaseHTMLProps(
            uniqueId,
            cn(className, Tabs_default.tabs),
            htmlProps,
            rest
          ),
          width,
          children
        }
      )
    }
  );
};
Tabs.displayName = "Tabs";

// src/components/Tabs/Tab.tsx
import {
  useCallback as useCallback7,
  useEffect as useEffect33,
  useRef as useRef36
} from "react";
import { jsx as jsx309, jsxs as jsxs81 } from "react/jsx-runtime";
var Tab = ({
  active = false,
  icon,
  children,
  focus,
  setFocus,
  index,
  onClick,
  onKeyDown,
  id,
  className,
  htmlProps = {},
  width = "1fr",
  ref,
  ...rest
}) => {
  useSetTabWidth(index, width);
  const itemRef = useRef36(null);
  const combinedRef = useCombinedRef(ref, itemRef);
  const { tabContentDirection, size: size2 } = useTabsContext();
  const { type = "button", ...restHtmlProps } = htmlProps;
  const fixedHtmlProps = { type, ...restHtmlProps };
  useEffect33(() => {
    var _a;
    if (focus) {
      (_a = itemRef.current) == null ? void 0 : _a.focus();
    }
  }, [focus]);
  const handleSelect = useCallback7(() => {
    if (setFocus && index) {
      setFocus(index);
    }
  }, [index, setFocus]);
  const handleOnClick = (e) => {
    handleSelect();
    onClick == null ? void 0 : onClick(e);
  };
  const handleOnKeyDown = (e) => {
    handleSelect();
    onKeyDown == null ? void 0 : onKeyDown(e);
  };
  return /* @__PURE__ */ jsxs81(
    "button",
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          Tabs_default.tab,
          Tabs_default[`tab--${size2}--${tabContentDirection}`],
          active && Tabs_default["tab--active"],
          Tabs_default[`tab--${tabContentDirection}`],
          typographyStyles_default[`body-${size2}`],
          focus_default["focusable--inset"]
        ),
        fixedHtmlProps,
        rest
      ),
      ref: combinedRef,
      "aria-selected": active,
      role: "tab",
      onClick: handleOnClick,
      onKeyDown: handleOnKeyDown,
      tabIndex: focus ? 0 : -1,
      children: [
        icon && /* @__PURE__ */ jsx309(Icon, { icon, iconSize: "inherit" }),
        /* @__PURE__ */ jsx309("span", { children })
      ]
    }
  );
};
Tab.displayName = "Tab";

// src/components/Tabs/TabList.tsx
import {
  Children as Children5,
  cloneElement as cloneElement7,
  isValidElement as isValidElement7,
  useState as useState30
} from "react";
import { jsx as jsx310, jsxs as jsxs82 } from "react/jsx-runtime";
var TabList = ({
  children,
  id,
  style,
  onFocus,
  ref,
  ...rest
}) => {
  const {
    activeTab,
    tabsId,
    handleTabChange,
    tabListRef,
    hasTabFocus,
    setHasTabFocus,
    addTabButtonProps
  } = useTabsContext();
  const uniqueId = id != null ? id : `${tabsId}-tablist`;
  const childrenArray = Children5.toArray(children).length;
  const [focus, setFocus] = useRoveFocus(childrenArray, hasTabFocus, "row");
  const combinedRef = useCombinedRef(ref, tabListRef);
  const hasButton = addTabButtonProps ? true : false;
  const tabListChildren = Children5 ? Children5.map(children, (child, index) => {
    const handleThisTabChange = () => {
      handleTabChange(index);
    };
    return isValidElement7(child) && cloneElement7(child, {
      id: `${tabsId}-tab-${index}`,
      htmlProps: {
        ...child.props.htmlProps,
        "aria-controls": `${tabsId}-panel-${index}`
      },
      active: activeTab === index,
      index,
      focus: focus === index && hasTabFocus,
      setFocus,
      onClick: combineHandlers(handleThisTabChange, child.props.onClick)
    });
  }) : [];
  const [widths, setWidths] = useState30([]);
  const handleOnFocus = (event) => {
    setHasTabFocus(true);
    onFocus && onFocus(event);
  };
  const handleOnBlur = (event) => {
    var _a;
    if ((tabListRef == null ? void 0 : tabListRef.current) === event.relatedTarget) {
      setFocus(-1);
    }
    if (!((_a = tabListRef == null ? void 0 : tabListRef.current) == null ? void 0 : _a.contains(event.relatedTarget))) {
      setHasTabFocus(false);
    }
  };
  const customWidths = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ["--dds-tab-widths"]: widths.join(" ")
  };
  return /* @__PURE__ */ jsx310(TabWidthContextProvider, { onChangeWidths: setWidths, children: /* @__PURE__ */ jsxs82(
    "div",
    {
      ...rest,
      ref: combinedRef,
      role: "tablist",
      id: uniqueId,
      tabIndex: 0,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur,
      className: cn(
        Tabs_default["tab-row"],
        !widths && Tabs_default["tab-row--standard-widths"],
        Tabs_default["tab-row--custom-widths"],
        focusable,
        scrollbar
      ),
      style: { ...style, ...customWidths },
      children: [
        tabListChildren,
        hasButton && /* @__PURE__ */ jsx310(
          AddTabButton,
          {
            index: tabListChildren ? tabListChildren.length : 0,
            ...addTabButtonProps
          }
        )
      ]
    }
  ) });
};
TabList.displayName = "TabList";

// src/components/Tabs/TabPanel.tsx
import { jsx as jsx311 } from "react/jsx-runtime";
var TabPanel = ({
  active = false,
  children,
  id,
  className,
  htmlProps,
  ...rest
}) => /* @__PURE__ */ jsx311(
  Box,
  {
    padding: "x0.25",
    ...getBaseHTMLProps(id, cn(className, focusable), htmlProps, rest),
    tabIndex: 0,
    role: "tabpanel",
    hidden: !active,
    children
  }
);
TabPanel.displayName = "TabPanel";

// src/components/Tabs/TabPanels.tsx
import {
  Children as Children6,
  cloneElement as cloneElement8,
  isValidElement as isValidElement8
} from "react";
import { jsx as jsx312 } from "react/jsx-runtime";
var TabPanels = ({ children, ref, ...rest }) => {
  const { activeTab, tabsId, tabPanelsRef } = useTabsContext();
  const combinedRef = useCombinedRef(ref, tabPanelsRef);
  const panelChildren = Children6.map(children, (child, index) => {
    const active = index === activeTab;
    return isValidElement8(child) && cloneElement8(child, {
      id: `${tabsId}-panel-${index}`,
      active,
      htmlProps: {
        "aria-labelledby": `${tabsId}-tab-${index}`,
        "aria-expanded": active
      }
    });
  });
  return /* @__PURE__ */ jsx312("div", { ref: combinedRef, ...rest, children: panelChildren });
};
TabPanels.displayName = "TabPanels";

// src/components/Tag/Tag.module.css
var Tag_default = {
  container: "Tag_container",
  "container--with-icon": "Tag_container--with-icon",
  "container--default--default": "Tag_container--default--default",
  "container--default--strong": "Tag_container--default--strong",
  "container--success--default": "Tag_container--success--default",
  "container--success--strong": "Tag_container--success--strong",
  "container--danger--default": "Tag_container--danger--default",
  "container--danger--strong": "Tag_container--danger--strong",
  "container--warning--default": "Tag_container--warning--default",
  "container--warning--strong": "Tag_container--warning--strong",
  "container--info--default": "Tag_container--info--default",
  "container--info--strong": "Tag_container--info--strong"
};

// src/components/Tag/Tag.tsx
import { jsx as jsx313, jsxs as jsxs83 } from "react/jsx-runtime";
var icons3 = {
  info: InfoIcon,
  danger: ErrorIcon,
  warning: WarningIcon,
  success: CheckCircledIcon,
  default: void 0
};
var Tag = ({
  text,
  purpose = "default",
  appearance = "default",
  id,
  className,
  children,
  htmlProps,
  withIcon,
  ...rest
}) => {
  const icon = icons3[purpose];
  return /* @__PURE__ */ jsxs83(
    TextOverflowEllipsisWrapper,
    {
      ...getBaseHTMLProps(
        id,
        cn(
          className,
          typographyStyles_default["body-small"],
          Tag_default.container,
          withIcon && icon && Tag_default["container--with-icon"],
          Tag_default[`container--${purpose}--${appearance}`]
        ),
        htmlProps,
        rest
      ),
      children: [
        withIcon && icon && /* @__PURE__ */ jsx313(Icon, { icon, iconSize: "small" }),
        /* @__PURE__ */ jsx313(TextOverflowEllipsisInner, { children: children != null ? children : text })
      ]
    }
  );
};
Tag.displayName = "Tag";

// src/components/TextInput/TextInput.tsx
import { useId as useId26, useLayoutEffect as useLayoutEffect4, useRef as useRef37, useState as useState31 } from "react";

// src/components/TextInput/TextInput.module.css
var TextInput_default = {
  container: "TextInput_container",
  "container--readonly": "TextInput_container--readonly",
  "container--disabled": "TextInput_container--disabled",
  "input-width": "TextInput_input-width",
  input: "TextInput_input",
  "with-icon--medium": "TextInput_with-icon--medium",
  "with-icon--small": "TextInput_with-icon--small",
  "with-icon--xsmall": "TextInput_with-icon--xsmall",
  "input--extended": "TextInput_input--extended",
  "icon--medium": "TextInput_icon--medium",
  "icon--small": "TextInput_icon--small",
  "icon--xsmall": "TextInput_icon--xsmall",
  affix: "TextInput_affix",
  prefix: "TextInput_prefix",
  suffix: "TextInput_suffix",
  "affix--disabled": "TextInput_affix--disabled"
};

// src/components/TextInput/TextInput.tsx
import { jsx as jsx314, jsxs as jsxs84 } from "react/jsx-runtime";
var TextInput = ({
  label,
  disabled,
  readOnly,
  errorMessage,
  tip,
  required,
  maxLength,
  onChange,
  id,
  width,
  componentSize = "medium",
  type = "text",
  withCharacterCounter = true,
  className,
  style,
  value,
  defaultValue,
  "aria-required": ariaRequired,
  "aria-describedby": ariaDescribedby,
  icon,
  prefix: prefix2,
  suffix,
  ref,
  ...rest
}) => {
  const [text, setText] = useState31(getDefaultText(value, defaultValue));
  const prefixRef = useRef37(null);
  const suffixRef = useRef37(null);
  const [prefixLength, setPrefixLength] = useState31(0);
  const [suffixLength, setSuffixLength] = useState31(0);
  useLayoutEffect4(() => {
    if (prefixRef.current) {
      setPrefixLength(prefixRef.current.offsetWidth);
    }
    if (suffixRef.current) {
      setSuffixLength(suffixRef.current.offsetWidth);
    }
  }, [prefix2, suffix]);
  const onChangeHandler = (event) => {
    setText(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  const generatedId = useId26();
  const uniqueId = id != null ? id : `${generatedId}-textInput`;
  const hasErrorMessage = !!errorMessage;
  const hasTip = !!tip;
  const hasLabel = !!label;
  const hasMessage = hasErrorMessage || hasTip;
  const hasBottomContainer = hasErrorMessage || hasTip || !!maxLength;
  const hasIcon = !!icon;
  const hasAffix = !!(prefix2 != null ? prefix2 : suffix);
  const characterCounterId = derivativeIdGenerator(
    uniqueId,
    "characterCounter"
  );
  const tipId = derivativeIdGenerator(uniqueId, "tip");
  const errorMessageId = derivativeIdGenerator(uniqueId, "errorMessage");
  const inputWidth = getInputWidth(
    width,
    componentSize === "xsmall" && "var(--dds-input-default-width-xsmall)"
  );
  const generalInputProps = {
    ref,
    type,
    onChange: onChangeHandler,
    componentSize,
    id: uniqueId,
    hasErrorMessage,
    required,
    disabled,
    readOnly,
    maxLength,
    value,
    defaultValue,
    "aria-required": ariaRequired,
    "aria-describedby": spaceSeparatedIdListGenerator([
      hasTip ? tipId : void 0,
      hasErrorMessage ? errorMessageId : void 0,
      maxLength && withCharacterCounter ? characterCounterId : void 0,
      ariaDescribedby
    ]),
    "aria-invalid": hasErrorMessage ? true : void 0,
    ...rest
  };
  const showRequiredStyling = !!(required || ariaRequired);
  const preffixPaddingInlineStart = prefixLength ? `calc(var(--dds-spacing-x1) + ${prefixLength}px)` : void 0;
  const suffixPaddingInlineEnd = suffixLength ? `calc(var(--dds-spacing-x1) + ${suffixLength}px)` : void 0;
  let extendedInput = null;
  if (hasIcon) {
    extendedInput = /* @__PURE__ */ jsxs84(Box, { className: Input_default["input-group"], width: inputWidth, children: [
      /* @__PURE__ */ jsx314(
        Icon,
        {
          icon,
          iconSize: getFormInputIconSize(componentSize),
          className: cn(
            Input_default["input-group__absolute-element"],
            TextInput_default[`icon--${componentSize}`]
          )
        }
      ),
      /* @__PURE__ */ jsx314(
        StatefulInput,
        {
          className: cn(
            TextInput_default.input,
            TextInput_default[`with-icon--${componentSize}`],
            TextInput_default["input--extended"]
          ),
          ...generalInputProps
        }
      )
    ] });
  } else if (hasAffix) {
    extendedInput = /* @__PURE__ */ jsxs84(
      Box,
      {
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: inputWidth,
        children: [
          prefix2 && /* @__PURE__ */ jsx314(
            "span",
            {
              ref: prefixRef,
              "aria-hidden": true,
              className: cn(
                TextInput_default.affix,
                TextInput_default.prefix,
                disabled && TextInput_default["affix--disabled"]
              ),
              children: prefix2
            }
          ),
          /* @__PURE__ */ jsx314(
            StatefulInput,
            {
              style: {
                paddingInlineStart: preffixPaddingInlineStart,
                paddingInlineEnd: suffixPaddingInlineEnd
              },
              className: TextInput_default["input--extended"],
              ...generalInputProps
            }
          ),
          suffix && /* @__PURE__ */ jsx314(
            "span",
            {
              ref: suffixRef,
              "aria-hidden": true,
              className: cn(
                TextInput_default.affix,
                TextInput_default.suffix,
                disabled && TextInput_default["affix--disabled"]
              ),
              children: suffix
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs84(
    "div",
    {
      className: cn(
        className,
        Input_default.container,
        TextInput_default.container,
        readOnly && TextInput_default["container--readonly"],
        disabled && TextInput_default["container--disabled"]
      ),
      style,
      children: [
        hasLabel && /* @__PURE__ */ jsx314(
          Box,
          {
            as: Label,
            display: "block",
            htmlFor: uniqueId,
            showRequiredStyling,
            readOnly,
            children: label
          }
        ),
        extendedInput ? extendedInput : /* @__PURE__ */ jsx314(Box, { as: StatefulInput, width: inputWidth, ...generalInputProps }),
        hasBottomContainer && /* @__PURE__ */ jsxs84(
          Box,
          {
            display: "flex",
            justifyContent: withCharacterCounter ? hasMessage ? "space-between" : "flex-end" : void 0,
            gap: "x0.5",
            width: withCharacterCounter ? inputWidth : void 0,
            children: [
              renderInputMessage(tip, tipId, errorMessage, errorMessageId),
              renderCharCounter(
                characterCounterId,
                withCharacterCounter,
                text.length,
                maxLength
              )
            ]
          }
        )
      ]
    }
  );
};
TextInput.displayName = "TextInput";

// src/components/Toggle/Toggle.tsx
import { useId as useId27 } from "react";

// src/components/Toggle/Toggle.module.css
var Toggle_default = {
  label: "Toggle_label",
  track: "Toggle_track",
  thumb: "Toggle_thumb",
  checkmark: "Toggle_checkmark",
  "labeltext--readonly": "Toggle_labeltext--readonly",
  "icon--read-only": "Toggle_icon--read-only",
  medium: "Toggle_medium",
  large: "Toggle_large",
  "label--is-loading": "Toggle_label--is-loading",
  "label--disabled": "Toggle_label--disabled",
  "label--read-only": "Toggle_label--read-only"
};

// src/components/Toggle/Toggle.tsx
import { jsx as jsx315, jsxs as jsxs85 } from "react/jsx-runtime";
var Toggle = ({
  id,
  children,
  size: size2 = "medium",
  checked: checkedProp,
  defaultChecked,
  onChange,
  disabled,
  readOnly,
  isLoading,
  className,
  htmlProps = {},
  ...rest
}) => {
  const generatedId = useId27();
  const uniqueId = id != null ? id : `${generatedId}-toggle`;
  const iconSize = size2 === "large" ? "medium" : "small";
  const [checked, setChecked] = useControllableState({
    value: checkedProp,
    defaultValue: defaultChecked != null ? defaultChecked : false,
    onChange
  });
  return /* @__PURE__ */ jsxs85(
    "label",
    {
      htmlFor: uniqueId,
      className: cn(
        Toggle_default.label,
        Toggle_default[size2],
        isLoading && Toggle_default["label--is-loading"],
        disabled && Toggle_default["label--disabled"],
        readOnly && Toggle_default["label--read-only"]
      ),
      children: [
        /* @__PURE__ */ jsx315(
          "input",
          {
            ...getBaseHTMLProps(
              uniqueId,
              cn(
                className,
                focus_default["focusable-sibling"],
                utilStyles_default["hide-input"]
              ),
              htmlProps,
              rest
            ),
            type: "checkbox",
            checked,
            onChange: (e) => setChecked(e.target.checked),
            disabled,
            "aria-disabled": isLoading,
            "aria-readonly": readOnly,
            onKeyDown: readOnlyKeyDownHandler(
              "selectionControl",
              readOnly || isLoading,
              htmlProps.onKeyDown
            ),
            onClick: readOnlyClickHandler(readOnly || isLoading, htmlProps.onClick)
          }
        ),
        /* @__PURE__ */ jsx315("span", { className: cn(Toggle_default.track, focus_default["focus-styled-sibling"]), children: /* @__PURE__ */ jsx315("span", { className: Toggle_default.thumb, children: isLoading ? /* @__PURE__ */ jsx315(Spinner, { size: `var(--dds-icon-size-${size2})` }) : /* @__PURE__ */ jsx315(
          Icon,
          {
            className: Toggle_default.checkmark,
            icon: CheckIcon,
            iconSize
          }
        ) }) }),
        /* @__PURE__ */ jsxs85("span", { className: cn(readOnly && Toggle_default["labeltext--readonly"]), children: [
          readOnly && /* @__PURE__ */ jsx315(
            Icon,
            {
              icon: LockIcon,
              iconSize: "small",
              className: Toggle_default["icon--read-only"]
            }
          ),
          children,
          " ",
          isLoading && /* @__PURE__ */ jsx315(VisuallyHidden, { as: "span", children: "Innlastning p\xE5g\xE5r" })
        ] })
      ]
    }
  );
};
Toggle.displayName = "Toggle";

// src/components/ToggleBar/ToggleBar.tsx
import { useId as useId28, useState as useState32 } from "react";

// src/components/ToggleBar/ToggleBar.context.tsx
import { createContext as createContext19, useContext as useContext27 } from "react";
var ToggleBarContext = createContext19({
  size: "medium"
});
var useToggleBarContext = () => useContext27(ToggleBarContext);

// src/components/ToggleBar/ToggleBar.module.css
var ToggleBar_default = {
  bar: "ToggleBar_bar",
  content: "ToggleBar_content",
  "content--large--just-icon": "ToggleBar_content--large--just-icon",
  "content--large--with-text": "ToggleBar_content--large--with-text",
  "content--medium--just-icon": "ToggleBar_content--medium--just-icon",
  "content--medium--with-text": "ToggleBar_content--medium--with-text",
  "content--small--just-icon": "ToggleBar_content--small--just-icon",
  "content--small--with-text": "ToggleBar_content--small--with-text",
  "content--xsmall--just-icon": "ToggleBar_content--xsmall--just-icon",
  "content--xsmall--with-text": "ToggleBar_content--xsmall--with-text",
  label: "ToggleBar_label"
};

// src/components/ToggleBar/ToggleBar.tsx
import { jsx as jsx316, jsxs as jsxs86 } from "react/jsx-runtime";
var ToggleBar = (props) => {
  const {
    children,
    size: size2 = "medium",
    label,
    onChange,
    value,
    name,
    width,
    htmlProps,
    className,
    id,
    ...rest
  } = props;
  const generatedId = useId28();
  const uniqueId = id != null ? id : `${generatedId}-ToggleBar`;
  const [groupValue, setGroupValue] = useState32(value);
  const handleChange = combineHandlers(
    (e) => setGroupValue(e.target.value),
    (e) => onChange && onChange(e, e.target.value)
  );
  const labelId = label && `${uniqueId}-label`;
  return /* @__PURE__ */ jsx316(
    ToggleBarContext,
    {
      value: {
        size: size2,
        onChange: handleChange,
        name,
        value: groupValue
      },
      children: /* @__PURE__ */ jsxs86(
        VStack,
        {
          ...getBaseHTMLProps(id, className, htmlProps, rest),
          width,
          gap: "x0.125",
          role: "radiogroup",
          "aria-labelledby": labelId != null ? labelId : htmlProps == null ? void 0 : htmlProps["aria-labelledby"],
          children: [
            label && /* @__PURE__ */ jsx316(Typography, { id: labelId, as: "span", typographyType: "labelMedium", children: label }),
            /* @__PURE__ */ jsx316("div", { className: ToggleBar_default.bar, children })
          ]
        }
      )
    }
  );
};
ToggleBar.displayName = "ToggleBar";

// src/components/ToggleBar/ToggleRadio.tsx
import { useId as useId29 } from "react";
import { jsx as jsx317, jsxs as jsxs87 } from "react/jsx-runtime";
var typographyTypes3 = {
  large: "bodyLarge",
  medium: "bodyMedium",
  small: "bodySmall",
  xsmall: "bodyXsmall"
};
var calculateChecked = (value, group, checked) => {
  if (typeof checked !== "undefined") return checked;
  if (typeof value !== "undefined" && value !== null && group) {
    if (typeof value === "number") {
      return value === Number(group == null ? void 0 : group.value);
    }
    return value === (group == null ? void 0 : group.value);
  }
  return !!value;
};
var ToggleRadio = ({
  value,
  name,
  onChange,
  checked,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  icon,
  label,
  htmlProps,
  className,
  id,
  ...rest
}) => {
  const generatedId = useId29();
  const uniqueId = id != null ? id : `${generatedId}-ToggleRadio`;
  const group = useToggleBarContext();
  const handleChange = (event) => {
    onChange && onChange(event);
    (group == null ? void 0 : group.onChange) && group.onChange(event);
  };
  const contentTypeCn = label ? "with-text" : "just-icon";
  return /* @__PURE__ */ jsxs87("label", { htmlFor: uniqueId, className: ToggleBar_default.label, children: [
    /* @__PURE__ */ jsx317(
      "input",
      {
        ...getBaseHTMLProps(
          uniqueId,
          cn(
            className,
            focus_default["focusable-sibling"],
            utilStyles_default["hide-input"]
          ),
          htmlProps,
          rest
        ),
        type: "radio",
        name: name != null ? name : group.name,
        onChange: handleChange,
        value,
        checked: calculateChecked(value, group, checked),
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
      }
    ),
    /* @__PURE__ */ jsxs87(
      Typography,
      {
        as: "span",
        typographyType: typographyTypes3[group.size],
        className: cn(
          ToggleBar_default.content,
          ToggleBar_default[`content--${group.size}--${contentTypeCn}`],
          focus_default["focus-styled-sibling"]
        ),
        children: [
          icon && /* @__PURE__ */ jsx317(Icon, { icon, iconSize: "inherit" }),
          label && /* @__PURE__ */ jsx317("span", { children: label })
        ]
      }
    )
  ] });
};
ToggleRadio.displayName = "ToggleRadio";

// src/components/ToggleButton/ToggleButton.tsx
import { useId as useId30 } from "react";

// src/components/ToggleButton/ToggleButton.module.css
var ToggleButton_default = {
  content: "ToggleButton_content",
  small: "ToggleButton_small",
  xsmall: "ToggleButton_xsmall",
  "content--with-icon": "ToggleButton_content--with-icon"
};

// src/components/ToggleButton/ToggleButton.tsx
import { jsx as jsx318, jsxs as jsxs88 } from "react/jsx-runtime";
var ToggleButton = ({
  id,
  label,
  icon,
  size: size2 = "small",
  className,
  htmlProps,
  ...rest
}) => {
  const generatedId = useId30();
  const uniqueId = id != null ? id : `${generatedId}-toggleButton`;
  const hasIcon = !!icon;
  return /* @__PURE__ */ jsxs88(Box, { as: "label", htmlFor: uniqueId, width: "fit-content", children: [
    /* @__PURE__ */ jsx318(
      "input",
      {
        ...getBaseHTMLProps(
          uniqueId,
          cn(
            className,
            focus_default["focusable-sibling"],
            utilStyles_default["hide-input"]
          ),
          htmlProps,
          rest
        ),
        type: "checkbox"
      }
    ),
    /* @__PURE__ */ jsxs88(
      "span",
      {
        className: cn(
          ToggleButton_default.content,
          ToggleButton_default[size2],
          hasIcon && ToggleButton_default["content--with-icon"],
          typographyStyles_default[`body-${size2}`],
          focus_default["focus-styled-sibling"]
        ),
        children: [
          hasIcon && /* @__PURE__ */ jsx318(Icon, { icon, iconSize: "inherit" }),
          " ",
          label
        ]
      }
    )
  ] });
};
ToggleButton.displayName = "ToggleButton";

// src/components/ToggleButton/ToggleButtonGroup.tsx
import { useId as useId31 } from "react";
import { jsx as jsx319, jsxs as jsxs89 } from "react/jsx-runtime";
var ToggleButtonGroup = (props) => {
  const {
    children,
    direction = "row",
    label,
    labelId,
    id,
    className,
    htmlProps,
    ...rest
  } = props;
  const generatedId = useId31();
  const uniqueLabelId = labelId != null ? labelId : `${generatedId}-ToggleButtonGroupLabel`;
  return /* @__PURE__ */ jsxs89(
    VStack,
    {
      gap: "x0.5",
      ...getBaseHTMLProps(id, className, htmlProps, rest),
      role: "group",
      "aria-labelledby": label ? uniqueLabelId : void 0,
      children: [
        !!label && /* @__PURE__ */ jsx319(Typography, { as: "span", typographyType: "labelMedium", id: uniqueLabelId, children: label }),
        /* @__PURE__ */ jsx319(Box, { display: "flex", flexWrap: "wrap", gap: "x0.75", flexDirection: direction, children })
      ]
    }
  );
};
ToggleButtonGroup.displayName = "ToggleButtonGroup";
export {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AddTabButton,
  AddressShieldedIcon,
  AgreementIcon,
  AnimatedChevronUpDown,
  AppsIcon,
  ArchiveIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AttachmentIcon,
  BORDER_COLORS,
  BORDER_RADII,
  BackLink,
  Backdrop,
  BarChartBoxedIcon,
  BarChartIcon,
  BlockIcon,
  BookIcon,
  Box,
  Breadcrumb,
  Breadcrumbs,
  BuildCircledIcon,
  BuildIcon,
  Button,
  ButtonGroup,
  Calendar,
  CalendarIcon,
  CalendarMonthIcon,
  CalendarViewDayIcon,
  CalendarViewMonthIcon,
  CalendarViewWeekIcon,
  CallIcon,
  Caption,
  Card,
  CardExpandable,
  CardExpandableBody,
  CardExpandableHeader,
  CardSelectable,
  CardSelectableGroup,
  CaringIcon,
  CharCounter,
  ChatIcon,
  CheckCircledIcon,
  CheckIcon,
  Checkbox,
  CheckboxGroup,
  ChecklistIcon,
  ChevronDownIcon,
  ChevronFirstIcon,
  ChevronLargeLeftIcon,
  ChevronLargeRightIcon,
  ChevronLastIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  Chip,
  ChipGroup,
  CloseCircledIcon,
  CloseIcon,
  CloseSmallIcon,
  CloudIcon,
  CollapseIcon,
  CollapsibleTable2 as CollapsibleTable,
  CollapsibleRow as CollapsibleTableRow,
  CommentIcon,
  Contrast,
  CookieBanner,
  CookieBannerCheckbox,
  CopyIcon,
  CourtIcon,
  DatePicker,
  DateRangeIcon,
  DeathsIcon,
  DescriptionList,
  DescriptionListDesc,
  DescriptionListGroup,
  DescriptionListTerm,
  DetailList,
  DetailListDesc,
  DetailListRow,
  DetailListTerm,
  Divider,
  DoubleChevronLeftIcon,
  DoubleChevronRightIcon,
  DownloadDoneIcon,
  DownloadIcon,
  DragHandleIcon,
  Drawer,
  DrawerGroup,
  ELEVATIONS,
  EditIcon,
  ElementAs,
  EmptyContent,
  ErrorIcon,
  ExclaimIcon,
  ExpandIcon,
  FacebookIcon,
  FamilyIcon,
  FavStar,
  Feedback,
  FeedbackIcon,
  Fieldset,
  FieldsetGroup,
  FileAddIcon,
  FileIcon,
  FileShieldedIcon,
  FileTextIcon,
  FileUploader,
  FilterIcon,
  FilterListIcon,
  FilterListOffIcon,
  FilterOffIcon,
  FindInPageIcon,
  FlickrIcon,
  FolderAddIcon,
  FolderIcon,
  FolderShieldedIcon,
  Footer,
  FooterLeft,
  FooterList,
  FooterListGroup,
  FooterListHeader,
  FooterLogo,
  FooterSocialsGroup,
  FooterSocialsList,
  FullscreenExitIcon,
  FullscreenIcon,
  GavelIcon,
  GlobalMessage,
  Grid,
  GridChild,
  GuardianIcon,
  HStack,
  Heading,
  HelpFilledIcon,
  HelpIcon,
  HelpSimpleIcon,
  HiddenInput,
  HomeIcon,
  HourglassBottomIcon,
  HourglassDisabledIcon,
  HourglassEmptyIcon,
  HourglassFullIcon,
  HourglassTopIcon,
  Icon,
  ImageIcon,
  InfoIcon,
  InlineButton,
  InlineEditInput,
  InlineEditTextArea,
  Input,
  InputMessage,
  InstagramIcon,
  InternalHeader,
  JordskifterettIcon,
  JordskiftesakIcon,
  KeyIcon,
  Label,
  LagmannsrettIcon,
  LanguageIcon,
  Legend,
  LibraryAddIcon,
  LineChartIcon,
  Link,
  LinkIcon,
  LinkOffIcon,
  LinkedInIcon,
  List,
  ListAltIcon,
  ListIcon,
  ListItem,
  LocalMessage,
  LocationIcon,
  LockIcon,
  LockOpenIcon,
  LoginIcon,
  LogoutIcon,
  MailIcon,
  MailOpenIcon,
  MenuIcon,
  MinusCirledIcon,
  MinusIcon,
  Modal,
  ModalActions,
  ModalBody,
  MoreHorizontalIcon,
  MoreVerticalIcon,
  NativeSelect,
  NativeSelectPlaceholder,
  NotarialIcon,
  NotificationsIcon,
  NotificationsOffIcon,
  OnlineMeetingIcon,
  OpenExternalIcon,
  OverflowMenu,
  OverflowMenuButton,
  OverflowMenuDivider,
  OverflowMenuGroup,
  OverflowMenuLink,
  OverflowMenuList,
  OverflowMenuListHeader,
  OverflowMenuSpan,
  Pagination,
  Paper,
  Paragraph,
  PayoutIcon,
  PdfIcon,
  PersonAddIcon,
  PersonIcon,
  PersonShieldedIcon,
  PhoneInput,
  PinIcon,
  PlusCircledIcon,
  PlusIcon,
  Popover,
  PopoverGroup,
  PowerOfAttorneyIcon,
  PrintIcon,
  ProgressBar,
  ProgressTracker,
  ProgressTrackerItem,
  PropertyIcon,
  PublishIcon,
  QuestionAnswerIcon,
  RadioButton,
  RadioButtonGroup,
  ReceiptIcon,
  RedoIcon,
  RefreshIcon,
  ReplayIcon,
  ScreenSize,
  Search2 as Search,
  SearchAutocompleteWrapper,
  SearchIcon,
  SearchSuggestions,
  Select,
  SettingsIcon,
  ShowHide,
  Skeleton,
  SkipToContent,
  SmsIcon,
  Spinner,
  SplitButton,
  StarFilledIcon,
  StarHalfFilled,
  StarIcon,
  StatefulInput,
  StylelessList,
  StylelessOList,
  SvgWrapper,
  SyncIcon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table2 as Table,
  Body as TableBody,
  Cell as TableCell,
  Foot as TableFoot,
  Head as TableHead,
  Row as TableRow,
  SortCell as TableSortCell,
  TableWrapper,
  Tabs,
  Tag,
  TextArea,
  TextInput,
  TextOverflowEllipsisInner,
  TextOverflowEllipsisWrapper,
  ThemeContext,
  ThemeProvider,
  ThumbDownFilledIcon,
  ThumbDownIcon,
  ThumbUpFilledIcon,
  ThumbUpIcon,
  TimeIcon,
  TimePicker,
  TingrettIcon,
  TipIcon,
  Toggle,
  ToggleBar,
  ToggleButton,
  ToggleButtonGroup,
  ToggleRadio,
  Tooltip,
  TrashIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  Typography,
  UndoIcon,
  UnfoldLessIcon,
  UnfoldMoreIcon,
  UploadIcon,
  VStack,
  VisibilityOffIcon,
  VisibilityOnIcon,
  VisuallyHidden,
  WarningIcon,
  WebexIcon,
  XIcon,
  ZoomInIcon,
  ZoomOutIcon,
  calendarDateToNativeDate,
  cn,
  countryOptions,
  createSelectOptions,
  dateValueToNativeDate,
  defaultTypographyType,
  defaultTypographyTypeClassName,
  focusVisible,
  focusVisibleInset,
  focusVisibleTransitionValue,
  getBaseHTMLProps,
  getDefaultText,
  getElementType,
  getInputWidth,
  getLiteralScreenSize,
  getTypographyCn,
  handleElementWithBackdropMount,
  handleElementWithBackdropUnmount,
  hideInput,
  icons_exports as icons,
  inheritLinkStyling,
  inlineElements,
  isAnchorTypographyProps,
  isBorderColor,
  isBorderRadius,
  isCaption,
  isElevation,
  isHeading,
  isInlineElement,
  isKeyboardEvent,
  isLegend,
  isPaperBackground,
  nativeDateToCalendarDate,
  nativeDateToDateValue,
  nativeDateToTime,
  normalizeButton,
  outlineInset,
  outlineOffset,
  removeButtonStyling,
  removeListStyling,
  renderCharCounter,
  renderInputMessage,
  scrollbarStyling,
  typographyTypes3 as typographyTypes,
  useCombinedRef,
  useFloatPosition,
  useFocusTrap,
  useIsMounted,
  useMountTransition,
  useOnClickOutside,
  useOnKeyDown,
  useReturnFocusOnBlur,
  useRoveFocus,
  useScreenSize,
  useTheme,
  useWindowResize,
  visibilityTransition
};
//# sourceMappingURL=index.mjs.map